/* eslint-disable */
// @ts-nocheck
import type * as z from 'zod';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: string; output: string };
  Float32: { input: number; output: number };
  Float64: { input: number; output: number };
  Int32: { input: number; output: number };
  Int64: { input: bigint; output: bigint };
  JSON: { input: z.util.JSONType; output: z.util.JSONType };
  JSONObject: { input: z.util.JSONType; output: z.util.JSONType };
  Timestamp: { input: Date; output: Date };
};

/** Configuration of production and surveillance alarms in the iPSO solution. This view defines how alarms are grouped, prioritized, sourced, and mapped into workflows and tickets used for monitoring and optimization. */
export type AlarmDefinition = {
  /** High-level category grouping similar alarms (for example production, network, or equipment alarms), used to filter, analyze, and report alarms consistently across dashboards and workflows. */
  alarmCategory?: Maybe<Scalars['String']['output']>;
  /** Number of alarm occurrences or counter threshold that must be reached before a ticket or workflow is automatically created, used to avoid noise and focus on persistent issues. */
  alarmCounterToTicket?: Maybe<Scalars['Int']['output']>;
  /** Business and operational criticality of the alarm (for example low, medium, high), capturing the potential impact on production, integrity, and HSE and driving escalation rules. */
  alarmCriticality?: Maybe<Scalars['String']['output']>;
  /** Primary data source or system that generates the alarm signal, such as a SCADA tag, historian time series, or calculated KPI within the iPSO solution. */
  alarmDataSource?: Maybe<Scalars['String']['output']>;
  /** Free-text engineering description explaining the intent, trigger logic, and operational meaning of the alarm, used by operators and engineers to understand why it exists. */
  alarmDescription?: Maybe<Scalars['String']['output']>;
  /** Message text presented to end users when the alarm is triggered, typically appearing in alarm lists, dashboards, and ticketing systems. */
  alarmMessage?: Maybe<Scalars['String']['output']>;
  /** Optional dynamic parameter or placeholder value (for example the breached limit or tag name) that can be injected into the alarm message at runtime. */
  alarmMsgParameter?: Maybe<Scalars['String']['output']>;
  /** Unique name of the alarm configuration in iPSO, used as the primary label when referencing the alarm in dashboards, rules, and integration mappings. */
  alarmName?: Maybe<Scalars['String']['output']>;
  /** Operational priority assigned to the alarm, typically used to drive sorting, notification urgency, and required response times for operations teams. */
  alarmPriority?: Maybe<Scalars['String']['output']>;
  /** Type of alarm, for example limit breach, model mismatch, data quality issue, or equipment state, describing how the alarm is triggered and interpreted. */
  alarmType?: Maybe<Scalars['String']['output']>;
  /** Higher-level grouping of alarm types, used to organize alarms into major families (for example flow assurance, production loss, data quality) for analysis and reporting. */
  alarmTypeCategory?: Maybe<Scalars['String']['output']>;
  /** More granular subcategory within the alarm type family, enabling detailed root-cause tagging and more targeted reporting. */
  alarmTypeSubCategory?: Maybe<Scalars['String']['output']>;
  /** Standardized code or identifier used to uniquely reference this alarm across systems and integrations, enabling consistent reporting and analytics. */
  alarmUnifiedCode?: Maybe<Scalars['String']['output']>;
  /** Boolean flag indicating whether this alarm should automatically create a ticket or workflow action when it is triggered and persists. */
  isAlarmTicket?: Maybe<Scalars['String']['output']>;
  /** Additional subcategory used to further organize alarms within the main category, often aligned with specific equipment types, subsystems, or operational areas. */
  subCategory?: Maybe<Scalars['String']['output']>;
  /** Name of the sub-workflow or child process configuration that is executed when this alarm triggers and enters the workflow engine. */
  subWorkflowName?: Maybe<Scalars['String']['output']>;
  /** Default asset (for example well, network segment, facility, or equipment) that tickets generated from this alarm should be attached to for context and ownership. */
  ticketAsset?: Maybe<Scalars['String']['output']>;
  /** Default support group or team that tickets generated by this alarm should be routed to, such as production engineers, flow assurance, or maintenance. */
  ticketAssignedGroup?: Maybe<Scalars['String']['output']>;
  /** Default individual, role, or placeholder to which tickets from this alarm should initially be assigned, used to streamline triage. */
  ticketAssignedTo?: Maybe<Scalars['String']['output']>;
  /** Owning department responsible for resolving tickets created from this alarm, used for reporting and accountability. */
  ticketDept?: Maybe<Scalars['String']['output']>;
  /** Standard recommendation text capturing suggested troubleshooting steps or remedial actions that should be included in tickets generated from this alarm. */
  ticketRecommedation?: Maybe<Scalars['String']['output']>;
  /** Internal code or identifier referencing the workflow template associated with this alarm in the workflow engine. */
  workflowCode?: Maybe<Scalars['String']['output']>;
  /** Human-readable name of the workflow that is executed when this alarm is triggered and enters the ticketing or workflow system. */
  workflowName?: Maybe<Scalars['String']['output']>;
};

/**
 * Allocated injection volumes per well string for water and gas (WF15).
 *
 * Daily and monthly allocated gas and water injection, active hours/days per type.
 * Use for injection performance, reporting, and trend analysis. For measured rates see MeasuredInjection_String_Agent.
 *
 * Use for: Water or Gas Injection Monitoring (WF15), Production Allocation (WF5).
 */
export type AllocatedInjectionStringAgent = {
  /** Number of hours (0-24) the string was actively injecting gas during the day. */
  dayGasInjActiveHours?: Maybe<TimeSeries>;
  /**
   * Daily allocated gas injection volume (MSCF/d). Use for Day/Week time ranges.
   * The string's allocated share of total metered gas injection.
   */
  dayGasInjGasInjVolume?: Maybe<TimeSeries>;
  /** Number of hours (0-24) the string was actively injecting water during the day. */
  dayWaterInjActiveHours?: Maybe<TimeSeries>;
  /**
   * Daily allocated water injection volume (stb/d). Use for Day/Week time ranges.
   * The string's allocated share of total metered water injection.
   */
  dayWaterInjWaterInjVolume?: Maybe<TimeSeries>;
  /** Number of days (0-31) the string was actively injecting gas during the month. */
  monthGasInjActiveDays?: Maybe<TimeSeries>;
  /**
   * Monthly allocated gas injection volume (MSCF). Use for Month/Quarter/Year queries.
   * Sum of daily gas injection for the calendar month.
   */
  monthGasInjGasInjVolume?: Maybe<TimeSeries>;
  /** Number of days (0-31) the string was actively injecting water during the month. */
  monthWaterInjActiveDays?: Maybe<TimeSeries>;
  /**
   * Monthly allocated water injection volume (stb). Use for Month/Quarter/Year queries.
   * Sum of daily water injection for the calendar month.
   */
  monthWaterInjWaterInjVolume?: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
};

/**
 * ALLOCATED PRODUCTION AND INJECTION DATA for well strings. Contains daily and monthly
 * volumes that have been allocated from metered totals down to individual completions.
 *
 * KEY CONCEPTS:
 * - "Allocated" means volumes have been distributed from facility meters to strings
 *   based on well tests, prorated rates, or other allocation methods
 * - Daily (dayAllocProd*) vs Monthly (monthAllocProd*) aggregations available
 * - Production (AllocProd) vs Injection (GasInj, WaterInj) categories
 *
 * COMMON QUERIES:
 * - Daily allocated oil for a string: dayAllocProdAllocatedOil
 * - Monthly gas injection volume: monthGasInjGasInjVolume
 * - Check if string is producing or injecting: dayAllocProdFlowDirection
 */
export type AllocatedPropertiesString = {
  /**
   * Number of hours (0-24) the string was actively producing during the day. Used to
   * calculate onstream efficiency and to convert daily volumes to average hourly rates.
   * A value less than 24 indicates partial-day production or downtime.
   */
  dayAllocProdActiveHours?: Maybe<TimeSeries>;
  /**
   * Daily allocated gas production volume (MSCF/d or km³/d). The string's share of
   * total metered gas after allocation. Includes both solution gas and free gas.
   * Used for gas sales accounting and GOR calculations.
   */
  dayAllocProdAllocatedGas?: Maybe<TimeSeries>;
  /**
   * Daily allocated oil production volume (stb/d or m³/d). This is the string's share
   * of total metered oil after allocation, used for production accounting, reserves
   * tracking, and regulatory reporting. Represents the official "book" volume.
   */
  dayAllocProdAllocatedOil?: Maybe<TimeSeries>;
  /**
   * Daily allocated water production volume (stb/d or m³/d). The string's share of
   * total metered water after allocation. Used for water cut calculations, water
   * handling capacity planning, and injection targets.
   */
  dayAllocProdAllocatedWater?: Maybe<TimeSeries>;
  /**
   * Flow direction indicator for daily production allocation: 'PRODUCTION' for fluids
   * flowing from reservoir to surface, 'INJECTION' for fluids going into the reservoir,
   * or 'CIRCULATION' for through-tubing operations.
   */
  dayAllocProdFlowDirection?: Maybe<TimeSeries>;
  /**
   * Artificial lift method in use for daily production (e.g., 'NATURAL_FLOW', 'ESP',
   * 'GAS_LIFT', 'ROD_PUMP', 'JET_PUMP'). Affects allocation factors and rate
   * calculation methods. Critical for lift optimization analysis.
   */
  dayAllocProdProdMethod?: Maybe<TimeSeries>;
  /**
   * Operating mode during production (e.g., 'NORMAL', 'CLEANUP', 'TEST', 'RAMP_UP',
   * 'CONSTRAINED'). Affects how volumes are interpreted and whether they count
   * toward targets. Test mode data may use different allocation rules.
   */
  dayAllocProdProdMode?: Maybe<TimeSeries>;
  /**
   * Functional role of the string for allocation purposes (e.g., 'PRODUCER', 'INJECTOR',
   * 'DISPOSAL', 'OBSERVATION'). Determines which allocation category the string's
   * volumes contribute to.
   */
  dayAllocProdStringFunction?: Maybe<TimeSeries>;
  /**
   * Number of hours (0-24) contributing to gas plant allocation for this string.
   * May differ from production active hours if gas plant was down.
   */
  dayGPAllocVolActiveHours?: Maybe<TimeSeries>;
  /**
   * Daily gas volume allocated using gas plant (GP) metering and allocation factors.
   * May differ from dayAllocProdAllocatedGas if multiple allocation methods exist.
   * Used for gas plant feed tracking and sales gas accounting.
   */
  dayGPAllocVolAllocatedGas?: Maybe<TimeSeries>;
  /**
   * Flow direction for gas plant allocation. Typically 'PRODUCTION' for strings
   * contributing gas to the plant.
   */
  dayGPAllocVolFlowDirection?: Maybe<TimeSeries>;
  /**
   * Production method applicable to gas plant allocation (e.g., 'NATURAL_FLOW',
   * 'GAS_LIFT'). May affect allocation factors applied.
   */
  dayGPAllocVolProdMethod?: Maybe<TimeSeries>;
  /**
   * Operating mode for gas plant allocation (e.g., 'NORMAL', 'TEST').
   * Affects whether volumes count toward plant feed targets.
   */
  dayGPAllocVolProdMode?: Maybe<TimeSeries>;
  /**
   * Functional role of the string for gas plant volume allocation (e.g., 'PRODUCER',
   * 'GAS_PRODUCER'). Determines which allocation tier applies.
   */
  dayGPAllocVolStringFunction?: Maybe<TimeSeries>;
  /**
   * Number of hours (0-24) the string was actively injecting gas during the day.
   * Used to calculate injection efficiency and availability metrics.
   */
  dayGasInjActiveHours?: Maybe<TimeSeries>;
  /**
   * Flow direction for gas injection: typically 'INJECTION' indicating gas flowing
   * from surface into the reservoir. May be 'PRODUCTION' during blowback operations.
   */
  dayGasInjFlowDirection?: Maybe<TimeSeries>;
  /**
   * Daily allocated gas injection volume (MSCF/d or km³/d). The string's share of
   * injected gas for pressure maintenance, enhanced recovery, or gas storage.
   * Used for voidage replacement calculations and injection performance tracking.
   */
  dayGasInjGasInjVolume?: Maybe<TimeSeries>;
  /**
   * Type of gas being injected (e.g., 'HYDROCARBON_GAS', 'CO2', 'NITROGEN', 'FLUE_GAS').
   * Important for EOR tracking, emissions accounting, and PVT calculations.
   */
  dayGasInjMaterialType?: Maybe<TimeSeries>;
  /**
   * Operating mode for gas injection (e.g., 'NORMAL', 'TEST', 'STIMULATION').
   * Affects how injection volumes are categorized for reservoir management.
   */
  dayGasInjProdMode?: Maybe<TimeSeries>;
  /**
   * Functional role of the string for gas injection allocation (e.g., 'GAS_INJECTOR',
   * 'WAG_INJECTOR', 'DISPOSAL'). Determines injection category for accounting.
   */
  dayGasInjStringFunction?: Maybe<TimeSeries>;
  /**
   * Number of hours (0-24) the string was actively injecting water during the day.
   * Used to calculate injection efficiency and well availability metrics.
   */
  dayWaterInjActiveHours?: Maybe<TimeSeries>;
  /**
   * Flow direction for water injection: typically 'INJECTION' indicating water flowing
   * from surface into the reservoir. May be 'FLOWBACK' during cleanup operations.
   */
  dayWaterInjFlowDirection?: Maybe<TimeSeries>;
  /**
   * Type of water being injected (e.g., 'SEAWATER', 'PRODUCED_WATER', 'FRESH_WATER',
   * 'TREATED_WATER'). Important for injectivity tracking and water chemistry monitoring.
   */
  dayWaterInjMaterialType?: Maybe<TimeSeries>;
  /**
   * Operating mode for water injection (e.g., 'NORMAL', 'TEST', 'STIMULATION').
   * Affects how injection volumes are categorized for reservoir management.
   */
  dayWaterInjProdMode?: Maybe<TimeSeries>;
  /**
   * Functional role of the string for water injection allocation (e.g., 'WATER_INJECTOR',
   * 'DISPOSAL', 'WAG_INJECTOR'). Determines injection category for accounting.
   */
  dayWaterInjStringFunction?: Maybe<TimeSeries>;
  /**
   * Daily allocated water injection volume (stb/d or m³/d). The string's share of
   * injected water for pressure maintenance or waterflooding. Key metric for
   * voidage replacement ratio and sweep efficiency monitoring.
   */
  dayWaterInjWaterInjVolume?: Maybe<TimeSeries>;
  /**
   * Reference to the String_asset entity. Use this to join to the string master data
   * and retrieve the string name, or to navigate via FlatHierarchy to parent entities.
   */
  entityName?: Maybe<StringAsset>;
  /**
   * Number of days (0-31) the string was actively producing during the month.
   * Used to calculate monthly onstream efficiency and average daily rates.
   */
  monthAllocProdActiveDays?: Maybe<TimeSeries>;
  /**
   * Monthly allocated gas production volume (MSCF or km³). Sum of daily allocated
   * gas for the calendar month. Used for monthly gas accounting and GOR trending.
   */
  monthAllocProdAllocatedGas?: Maybe<TimeSeries>;
  /**
   * Monthly allocated oil production volume (stb or m³). Sum of daily allocated oil
   * for the calendar month. Used for monthly production reports, reserves updates,
   * and regulatory submissions.
   */
  monthAllocProdAllocatedOil?: Maybe<TimeSeries>;
  /**
   * Monthly allocated water production volume (stb or m³). Sum of daily allocated
   * water for the calendar month. Used for monthly water cut analysis and disposal
   * capacity planning.
   */
  monthAllocProdAllocatedWater?: Maybe<TimeSeries>;
  /**
   * Predominant flow direction for the month: 'PRODUCTION' or 'INJECTION'.
   * Used for monthly reporting categorization.
   */
  monthAllocProdFlowDirection?: Maybe<TimeSeries>;
  /**
   * Predominant artificial lift method during the month (e.g., 'NATURAL_FLOW', 'ESP',
   * 'GAS_LIFT'). Used for monthly performance benchmarking by lift type.
   */
  monthAllocProdProdMethod?: Maybe<TimeSeries>;
  /**
   * Predominant functional role of the string during the month (e.g., 'PRODUCER',
   * 'INJECTOR'). May change if string converted mid-month.
   */
  monthAllocProdStringFunction?: Maybe<TimeSeries>;
  /**
   * Total hours contributing to gas plant allocation for the month.
   * May be less than total production hours if plant had downtime.
   */
  monthGPAllocVolActiveHours?: Maybe<TimeSeries>;
  /**
   * Monthly gas volume allocated using gas plant metering (MSCF or km³). Sum of
   * daily gas plant allocations. May differ from monthAllocProdAllocatedGas.
   */
  monthGPAllocVolAllocatedGas?: Maybe<TimeSeries>;
  /** Predominant flow direction for monthly gas plant allocation: typically 'PRODUCTION'. */
  monthGPAllocVolFlowDirection?: Maybe<TimeSeries>;
  /** Production method for monthly gas plant allocation (e.g., 'NATURAL_FLOW', 'GAS_LIFT'). */
  monthGPAllocVolProdMethod?: Maybe<TimeSeries>;
  /** Operating mode for monthly gas plant allocation (e.g., 'NORMAL', 'TEST'). */
  monthGPAllocVolProdMode?: Maybe<TimeSeries>;
  /** Functional role for monthly gas plant allocation (e.g., 'PRODUCER', 'GAS_PRODUCER'). */
  monthGPAllocVolStringFunction?: Maybe<TimeSeries>;
  /**
   * Number of days (0-31) the string was actively injecting gas during the month.
   * Used to calculate monthly injection efficiency.
   */
  monthGasInjActiveDays?: Maybe<TimeSeries>;
  /** Predominant flow direction for monthly gas injection: typically 'INJECTION'. */
  monthGasInjFlowDirection?: Maybe<TimeSeries>;
  /**
   * Monthly allocated gas injection volume (MSCF or km³). Sum of daily gas injection
   * for the calendar month. Used for monthly voidage replacement and injection
   * performance reporting.
   */
  monthGasInjGasInjVolume?: Maybe<TimeSeries>;
  /** Predominant type of gas injected during the month (e.g., 'HYDROCARBON_GAS', 'CO2'). */
  monthGasInjMaterialType?: Maybe<TimeSeries>;
  /** Predominant operating mode for monthly gas injection (e.g., 'NORMAL', 'TEST'). */
  monthGasInjProdMode?: Maybe<TimeSeries>;
  /**
   * Functional role of the string for monthly gas injection (e.g., 'GAS_INJECTOR',
   * 'WAG_INJECTOR'). Used for monthly injection categorization.
   */
  monthGasInjStringFunction?: Maybe<TimeSeries>;
  /**
   * Number of days (0-31) the string was actively injecting water during the month.
   * Used to calculate monthly injection availability.
   */
  monthWaterInjActiveDays?: Maybe<TimeSeries>;
  /** Predominant flow direction for monthly water injection: typically 'INJECTION'. */
  monthWaterInjFlowDirection?: Maybe<TimeSeries>;
  /** Predominant type of water injected during the month (e.g., 'SEAWATER', 'PRODUCED_WATER'). */
  monthWaterInjMaterialType?: Maybe<TimeSeries>;
  /** Predominant operating mode for monthly water injection (e.g., 'NORMAL', 'TEST'). */
  monthWaterInjProdMode?: Maybe<TimeSeries>;
  /**
   * Functional role of the string for monthly water injection (e.g., 'WATER_INJECTOR',
   * 'DISPOSAL'). Used for monthly injection categorization.
   */
  monthWaterInjStringFunction?: Maybe<TimeSeries>;
  /**
   * Monthly allocated water injection volume (stb or m³). Sum of daily water injection
   * for the calendar month. Used for monthly voidage replacement ratio and waterflood
   * performance reporting.
   */
  monthWaterInjWaterInjVolume?: Maybe<TimeSeries>;
};

/**
 * Daily and monthly allocated production volumes per well string (WF5).
 *
 * Allocated oil, gas, water; active hours and days per string from reconciled
 * metered volumes. Use for production performance, uptime, and forecasting. For raw/unallocated data see other views.
 *
 * Use for: Production Allocation (WF5), Gas Lift Estimation and Allocation (WF13).
 *
 * @name Allocated Rates - Daily/Monthly (Agent)
 */
export type AllocatedRatesDailyStringAgent = {
  /**
   * Number of hours (0-24) the string was actively producing during the day.
   * Used to calculate onstream efficiency.
   */
  dayAllocProdActiveHours?: Maybe<TimeSeries>;
  /** Daily allocated gas production volume (MSCF/d). Use for Day/Week time ranges. */
  dayAllocProdAllocatedGas?: Maybe<TimeSeries>;
  /**
   * Daily allocated oil production volume (stb/d). Use for Day/Week time ranges.
   * This is the string's official allocated share of total metered oil.
   */
  dayAllocProdAllocatedOil?: Maybe<TimeSeries>;
  /**
   * Daily allocated water production volume (stb/d). Use for Day/Week time ranges.
   * Used for water cut analysis and water handling planning.
   */
  dayAllocProdAllocatedWater?: Maybe<TimeSeries>;
  /**
   * Number of days (0-31) the string was actively producing during the month.
   * Used to calculate monthly onstream efficiency.
   */
  monthAllocProdActiveDays?: Maybe<TimeSeries>;
  /**
   * Monthly allocated gas production volume (MSCF). Use for Month/Quarter/Year queries.
   * Sum of daily allocated gas for the calendar month.
   */
  monthAllocProdAllocatedGas?: Maybe<TimeSeries>;
  /**
   * Monthly allocated oil production volume (stb). Use for Month/Quarter/Year queries.
   * Sum of daily allocated oil for the calendar month.
   */
  monthAllocProdAllocatedOil?: Maybe<TimeSeries>;
  /**
   * Monthly allocated water production volume (stb). Use for Month/Quarter/Year queries.
   * Sum of daily allocated water for the calendar month.
   */
  monthAllocProdAllocatedWater?: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
};

/**
 * VFM-based allocation rates per well string from WF05 (WF5).
 *
 * Preferred and weighted-average VFM rates, per-method average oil rates. Use for
 * comparison of allocated rates across methods and preferred vs weighted average. Excludes raw production data.
 *
 * Use for: Production Allocation (WF5), Gas Lift Estimation and Allocation (WF13).
 *
 * @name Allocated Rates - VFM Reconciliation (Agent)
 */
export type AllocatedRatesVfmStringAgent = {
  /** Average gas injection rate (MSCF/d, TS). */
  averageGasInjectionRate?: Maybe<TimeSeries>;
  /** Average water injection rate (stb/d, TS). */
  averageWaterInjectionRate?: Maybe<TimeSeries>;
  /** Oil allocation workflow status. */
  oilProductionAllocationStatus?: Maybe<TimeSeries>;
  /** Preferred VFM method average associated gas rate (MSCF/d, TS). */
  preferredVFMAverageAssociatedGasRate?: Maybe<TimeSeries>;
  /** Preferred VFM method average non-associated gas rate (MSCF/d, TS). */
  preferredVFMAverageNonAssociatedGasRate?: Maybe<TimeSeries>;
  /** Preferred VFM method average oil rate (stb/d, TS). */
  preferredVFMAverageOilRate?: Maybe<TimeSeries>;
  /** Preferred VFM method average water rate (stb/d, TS). */
  preferredVFMAverageWaterRate?: Maybe<TimeSeries>;
  /** Which VFM method was selected as preferred. */
  preferredVFMDataSourceFlag?: Maybe<TimeSeries>;
  /** Estimated well oil volume from preferred VFM method (stb, TS). */
  preferredVFMEstimatedWellOilVolume?: Maybe<TimeSeries>;
  /** Estimated well water volume from preferred VFM method (stb, TS). */
  preferredVFMEstimatedWellWaterVolume?: Maybe<TimeSeries>;
  /** Choke analysis average oil rate (stb/d, TS). */
  vfmChokeAverageOilRate?: Maybe<TimeSeries>;
  /** Data-driven model average oil rate (stb/d, TS). */
  vfmDataDrivenAverageOilRate?: Maybe<TimeSeries>;
  /** ESP analysis average oil rate (stb/d, TS). */
  vfmESPAverageOilRate?: Maybe<TimeSeries>;
  /** IPR analysis average oil rate (stb/d, TS). */
  vfmIPRAverageOilRate?: Maybe<TimeSeries>;
  /** Allocated AG rate from preferred VFM method (MSCF/d, TS). */
  vfmPreferredMethodAssociatedGasAllocationRate?: Maybe<TimeSeries>;
  /** Allocated NAG rate from preferred VFM method (MSCF/d, TS). */
  vfmPreferredMethodNonAssociatedGasAllocationRate?: Maybe<TimeSeries>;
  /** Allocated oil rate from preferred VFM method (stb/d, TS). */
  vfmPreferredMethodOilAllocationRate?: Maybe<TimeSeries>;
  /** Allocated water rate from preferred VFM method (stb/d, TS). */
  vfmPreferredMethodWaterAllocationRate?: Maybe<TimeSeries>;
  /** System analysis average oil rate (stb/d, TS). */
  vfmSystemAnalysisAverageOilRate?: Maybe<TimeSeries>;
  /** VLP analysis average oil rate (stb/d, TS). */
  vfmVLPAverageOilRate?: Maybe<TimeSeries>;
  /** Allocated AG rate from weighted average method (MSCF/d, TS). */
  vfmWeightedAverageAssociatedGasAllocationRate?: Maybe<TimeSeries>;
  /** Allocated oil rate from weighted average method (stb/d, TS). */
  vfmWeightedAverageMethodOilAllocationRate?: Maybe<TimeSeries>;
  /** Allocated NAG rate from weighted average method (MSCF/d, TS). */
  vfmWeightedAverageNonAssociatedGasAllocationRate?: Maybe<TimeSeries>;
  /** Allocated water rate from weighted average method (stb/d, TS). */
  vfmWeightedAverageWaterAllocationRate?: Maybe<TimeSeries>;
  /** Data source flag for weighted average method. */
  weightedAverageDataSourceFlag?: Maybe<TimeSeries>;
  /** Weighted average associated gas rate across VFM methods (MSCF/d, TS). */
  weightedAverageVFMAssociatedGasRate?: Maybe<TimeSeries>;
  /** Estimated oil volume from weighted average method (stb, TS). */
  weightedAverageVFMEstimatedWellOilVolume?: Maybe<TimeSeries>;
  /** Weighted average non-associated gas rate (MSCF/d, TS). */
  weightedAverageVFMNonAssociatedGasRate?: Maybe<TimeSeries>;
  /** Weighted average oil rate across all VFM methods (stb/d, TS). */
  weightedAverageVFMOilRate?: Maybe<TimeSeries>;
  /** Weighted average water rate across VFM methods (stb/d, TS). */
  weightedAverageVFMWaterRate?: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
  /** Well uptime hours in allocation period (hrs, TS). */
  wellUptime?: Maybe<TimeSeries>;
};

/**
 * Field-level allocation factor time series (WF5).
 *
 * VFM-based allocation factors for oil, assoc/non-assoc gas, water production, and gas/water injection at field level. Use for allocation factor trends by period and field/reservoir/sector. Use with FlatHierarchy_Agent or DailyRollupField_Agent for context.
 *
 * Use for: Production Allocation (WF5), Gas Lift Estimation and Allocation (WF13).
 *
 * @name Allocation Factors - Field (Agent)
 */
export type AllocationFactorsFieldAgent = {
  /** Reference to field. Use for Field scope and to join to hierarchy views. */
  field?: Maybe<Field>;
  /**
   * Gas injection allocation factor for this field (fraction, TS).
   * Use for "Show injection gas Allocation Factor trend" over Day/Week/Month/Quarter/Year.
   */
  gasInjectionAllocationFactor?: Maybe<TimeSeries>;
  /**
   * Associated gas production allocation factor for this field (fraction, TS). Preferred VFM method.
   * Use for "Show associated gas Allocation Factor trend" over Day/Week/Month/Quarter/Year.
   */
  preferredVFMAssociatedGasAllocationFactor?: Maybe<TimeSeries>;
  /**
   * Non-associated gas production allocation factor for this field (fraction, TS). Preferred VFM method.
   * Use for "Show non associated gas Allocation Factor trend" over Day/Week/Month/Quarter/Year.
   */
  preferredVFMNonAssociatedGasAllocationFactor?: Maybe<TimeSeries>;
  /**
   * Oil production allocation factor for this field (fraction, TS). Preferred VFM method.
   * Use for "Show oil Allocation Factor trend" over Day/Week/Month/Quarter/Year.
   */
  preferredVFMOilAllocationFactor?: Maybe<TimeSeries>;
  /**
   * Water production allocation factor for this field (fraction, TS). Preferred VFM method.
   * Use for "Show water Allocation Factor trend" over Day/Week/Month/Quarter/Year.
   */
  preferredVFMWaterAllocationFactor?: Maybe<TimeSeries>;
  /**
   * Water injection allocation factor for this field (fraction, TS).
   * Use for "Show injection water Allocation Factor trend" over Day/Week/Month/Quarter/Year.
   */
  waterInjectionAllocationFactor?: Maybe<TimeSeries>;
  /** Weighted average VFM associated gas allocation factor for this field (fraction, TS). */
  weightedAverageVFMAssociatedGasAllocationFactor?: Maybe<TimeSeries>;
  /** Weighted average VFM non-associated gas allocation factor for this field (fraction, TS). */
  weightedAverageVFMNonAssociatedGasAllocationFactor?: Maybe<TimeSeries>;
  /** Weighted average VFM oil production allocation factor for this field (fraction, TS). */
  weightedAverageVFMOilAllocationFactor?: Maybe<TimeSeries>;
  /** Weighted average VFM water allocation factor for this field (fraction, TS). */
  weightedAverageVFMWaterAllocationFactor?: Maybe<TimeSeries>;
};

/**
 * REAL-TIME ALLOCATION ENGINE OUTPUTS for well strings. Contains instantaneous
 * allocated rates from the production allocation system, updated more frequently
 * than the daily/monthly volumes in AllocatedProperties_String.
 *
 * KEY DIFFERENCES FROM AllocatedProperties_String:
 * - This view has REAL-TIME allocated rates (updated continuously or hourly)
 * - AllocatedProperties has DAILY/MONTHLY aggregated volumes (end-of-day/month)
 *
 * USE CASES:
 * - Real-time surveillance dashboards
 * - Intra-day rate monitoring
 * - Allocation engine troubleshooting
 * - Comparing instantaneous vs daily allocated volumes
 */
export type AllocationOutputString = {
  /**
   * Cumulative injection active hours within the current allocation period.
   * Running count of hours the string has been injecting, used to calculate
   * period-to-date injection volumes and availability metrics.
   */
  allocInjActiveHours?: Maybe<TimeSeries>;
  /**
   * Cumulative production active hours within the current allocation period.
   * Running count of hours the string has been producing, used to calculate
   * period-to-date volumes and onstream efficiency.
   */
  allocProdActiveHours?: Maybe<TimeSeries>;
  /**
   * Real-time allocated gas injection rate (MSCF/d) from the allocation engine.
   * The string's instantaneous share of total metered gas injection, used for
   * real-time injection surveillance and EOR monitoring.
   */
  allocatedGasInjRate?: Maybe<TimeSeries>;
  /**
   * Real-time allocated gas production rate (MSCF/d) from the allocation engine.
   * Includes both solution gas and free gas. Used for real-time GOR monitoring
   * and gas handling capacity tracking.
   */
  allocatedGasRate?: Maybe<TimeSeries>;
  /**
   * Real-time allocated oil production rate (stb/d) from the allocation engine.
   * This is the string's instantaneous share of total metered oil, calculated
   * from current well test factors and prorated measurements. Used for real-time
   * surveillance and intra-day optimization.
   */
  allocatedOilRate?: Maybe<TimeSeries>;
  /**
   * Real-time allocated water injection rate (stb/d) from the allocation engine.
   * The string's instantaneous share of total metered water injection, used for
   * real-time voidage monitoring and injection surveillance.
   */
  allocatedWaterInjRate?: Maybe<TimeSeries>;
  /**
   * Real-time allocated water production rate (stb/d) from the allocation engine.
   * Used for real-time water cut monitoring and water handling capacity tracking.
   */
  allocatedWaterRate?: Maybe<TimeSeries>;
  /**
   * Reference to the String_asset entity. Use this to join to string master data
   * or navigate via FlatHierarchy to parent well, field, or reservoir.
   */
  entityName?: Maybe<StringAsset>;
};

/** Asphaltene precipitation curve data defining stability envelopes as a function of pressure, temperature, and composition, used in flow assurance, pigging, and production strategy decisions. */
export type AsphalteneCurve = {
  /** Numeric value storing asph p for this entity, used in calculations, reporting, or model configuration. */
  asphP?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing asph t for this entity, used in calculations, reporting, or model configuration. */
  asphT?: Maybe<Scalars['Float32']['output']>;
  /** Asph Table attribute describing this entity in more detail, often derived from master data or configuration tables. */
  asphTable?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing date for this entity in the production optimization context. */
  date?: Maybe<Scalars['Timestamp']['output']>;
  /** Numeric value storing sequence for this entity, used in calculations, reporting, or model configuration. */
  sequence?: Maybe<Scalars['Int']['output']>;
};

/** Typed view over 'Entity' showing assets only (where 'entityType' = 'asset'). Use this view to identify an asset by name, then navigate to its fields, reservoirs, wells or strings via the 'FlatHierarchy' navigation view. */
export type Asset = {
  /** Attribute capturing end date time for this asset in the production optimization context. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Entity Type attribute describing this asset in more detail, often derived from master data or configuration tables. */
  entityType?: Maybe<Scalars['String']['output']>;
  /** Name or label for this asset, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  name?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing start date time for this asset in the production optimization context. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
};

/** Choke performance curve information capturing the relationship between choke opening, pressure drop, and flow rate used to model constraints and optimize choke settings. */
export type ChokeCurveInfo = {
  /** Numeric value storing choke bean size for this entity, used in calculations, reporting, or model configuration. */
  chokeBeanSize?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing choke opening for this entity, used in calculations, reporting, or model configuration. */
  chokeOpening?: Maybe<Scalars['Float32']['output']>;
  /** Choke Type attribute describing this entity in more detail, often derived from master data or configuration tables. */
  chokeType?: Maybe<Scalars['String']['output']>;
};

export enum Cognite3DGroupGroupType {
  Station360 = 'Station360',
}

/** Groups revisions of 3D data of various kinds together (CAD, PointCloud, Image360) */
export type Cognite3DModel = {
  /** Alternative names for the node */
  aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Description of the instance */
  description?: Maybe<Scalars['String']['output']>;
  /** Name of the instance */
  name?: Maybe<Scalars['String']['output']>;
  /** Text based labels for generic use, limited to 1000 */
  tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Thumbnail of the 3D model */
  thumbnail?: Maybe<CogniteFile>;
  /** CAD, PointCloud or Image360 */
  type?: Maybe<Cognite3DModelType>;
};

export enum Cognite3DModelType {
  Cad = 'CAD',
  Image360 = 'Image360',
  PointCloud = 'PointCloud',
}

/** This is the virtual position representation of an object in the physical world, connecting an asset to one or more 3D resources */
export type Cognite3DObject = CogniteDescribable & {
  /** Alternative names for the node */
  aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Asset that is tied to this 3D object */
  asset?: Maybe<CogniteAsset>;
  /** List of up to 1000 CADNodes that represents the connected CogniteAsset */
  cadNodes?: Maybe<Maybe<CogniteCadNode>[]>;
  /** Description of the instance */
  description?: Maybe<Scalars['String']['output']>;
  /** Edge connection to Cognite360Image annotations that represents the connected CogniteAsset */
  images360?: Maybe<Maybe<Cognite360Image>[]>;
  /** Name of the instance */
  name?: Maybe<Scalars['String']['output']>;
  /** List of up to 1000 PointCloudVolumes that represents the connected CogniteAsset */
  pointCloudVolumes?: Maybe<Maybe<CognitePointCloudVolume>[]>;
  /** Text based labels for generic use, limited to 1000 */
  tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Highest X value in bounding box */
  xMax?: Maybe<Scalars['Float']['output']>;
  /** Lowest X value in bounding box */
  xMin?: Maybe<Scalars['Float']['output']>;
  /** Highest Y value in bounding box */
  yMax?: Maybe<Scalars['Float']['output']>;
  /** Lowest Y value in bounding box */
  yMin?: Maybe<Scalars['Float']['output']>;
  /** Highest Z value in bounding box */
  zMax?: Maybe<Scalars['Float']['output']>;
  /** Lowest Z value in bounding box */
  zMin?: Maybe<Scalars['Float']['output']>;
};

/** Shared revision information for various 3D data types. Normally not used directly, but through CognitePointCloudRevision, Image360Collection or CogniteCADRevision */
export type Cognite3DRevision = {
  model3D?: Maybe<Cognite3DModel>;
  published?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Cognite3DRevisionStatus>;
  type?: Maybe<Cognite3DRevisionType>;
};

export enum Cognite3DRevisionStatus {
  Done = 'Done',
  Failed = 'Failed',
  Processing = 'Processing',
  Queued = 'Queued',
}

export enum Cognite3DRevisionType {
  Cad = 'CAD',
  Image360 = 'Image360',
  PointCloud = 'PointCloud',
}

/** The Cognite3DTransformation object defines a comprehensive 3D transformation, enabling precise adjustments to an object's position, orientation, and size in the 3D coordinate system. It allows for the translation of objects along the three spatial axes, rotation around these axes using Euler angles, and scaling along each axis to modify the object's dimensions. The object's transformation is defined in "CDF space", a coordinate system where the positive Z axis is the up direction */
export type Cognite3DTransformation = {
  /** The rotation of the object around the X-axis in radians */
  eulerRotationX?: Maybe<Scalars['Float']['output']>;
  /** The rotation of the object around the Y-axis in radians */
  eulerRotationY?: Maybe<Scalars['Float']['output']>;
  /** The rotation of the object around the Z-axis in radians */
  eulerRotationZ?: Maybe<Scalars['Float']['output']>;
  /** The scaling factor applied to the object along the X-axis */
  scaleX?: Maybe<Scalars['Float']['output']>;
  /** The scaling factor applied to the object along the Y-axis */
  scaleY?: Maybe<Scalars['Float']['output']>;
  /** The scaling factor applied to the object along the Z-axis */
  scaleZ?: Maybe<Scalars['Float']['output']>;
  /** The displacement of the object along the X-axis in the 3D coordinate system */
  translationX?: Maybe<Scalars['Float']['output']>;
  /** The displacement of the object along the Y-axis in the 3D coordinate system */
  translationY?: Maybe<Scalars['Float']['output']>;
  /** The displacement of the object along the Z-axis in the 3D coordinate system */
  translationZ?: Maybe<Scalars['Float']['output']>;
};

export type Cognite360Image = Cognite3DTransformation &
  CogniteCubeMap & {
    /** Direct relation to a file holding the back projection of the cube map */
    back?: Maybe<CogniteFile>;
    /** Direct relation to a file holding the bottom projection of the cube map */
    bottom?: Maybe<CogniteFile>;
    /** Direct relation to Cognite360ImageCollection */
    collection360?: Maybe<Cognite360ImageCollection>;
    /** The rotation of the object around the X-axis in radians */
    eulerRotationX?: Maybe<Scalars['Float']['output']>;
    /** The rotation of the object around the Y-axis in radians */
    eulerRotationY?: Maybe<Scalars['Float']['output']>;
    /** The rotation of the object around the Z-axis in radians */
    eulerRotationZ?: Maybe<Scalars['Float']['output']>;
    /** Direct relation to a file holding the front projection of the cube map */
    front?: Maybe<CogniteFile>;
    /** Direct relation to a file holding the left projection of the cube map */
    left?: Maybe<CogniteFile>;
    /** Direct relation to a file holding the right projection of the cube map */
    right?: Maybe<CogniteFile>;
    /** The scaling factor applied to the object along the X-axis */
    scaleX?: Maybe<Scalars['Float']['output']>;
    /** The scaling factor applied to the object along the Y-axis */
    scaleY?: Maybe<Scalars['Float']['output']>;
    /** The scaling factor applied to the object along the Z-axis */
    scaleZ?: Maybe<Scalars['Float']['output']>;
    /** Direct relation to Cognite3DGroup instance that groups different Cognite360Image instances to the same station */
    station360?: Maybe<Cognite360ImageStation>;
    /** The timestamp when the 6 photos were taken */
    takenAt?: Maybe<Scalars['Timestamp']['output']>;
    /** Direct relation to a file holding the top projection of the cube map */
    top?: Maybe<CogniteFile>;
    /** The displacement of the object along the X-axis in the 3D coordinate system */
    translationX?: Maybe<Scalars['Float']['output']>;
    /** The displacement of the object along the Y-axis in the 3D coordinate system */
    translationY?: Maybe<Scalars['Float']['output']>;
    /** The displacement of the object along the Z-axis in the 3D coordinate system */
    translationZ?: Maybe<Scalars['Float']['output']>;
  };

export type Cognite360ImageAnnotation = CogniteAnnotation &
  CogniteDescribable &
  CogniteSourceable & {
    /** Alternative names for the node */
    aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /** The confidence that the annotation is a good match */
    confidence?: Maybe<Scalars['Float']['output']>;
    /** Description of the instance */
    description?: Maybe<Scalars['String']['output']>;
    /** Specifies the storage representation for the polygon */
    formatVersion?: Maybe<Scalars['String']['output']>;
    /** Name of the instance */
    name?: Maybe<Scalars['String']['output']>;
    /** List of floats representing the polygon. Format depends on formatVersion */
    polygon?: Maybe<Maybe<Scalars['Float']['output']>[]>;
    /** Direct relation to a source system */
    source?: Maybe<CogniteSourceSystem>;
    /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
    sourceContext?: Maybe<Scalars['String']['output']>;
    /** When the instance was created in source system (if available) */
    sourceCreatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceCreatedUser?: Maybe<Scalars['String']['output']>;
    /** Identifier from the source system */
    sourceId?: Maybe<Scalars['String']['output']>;
    /** When the instance was last updated in the source system (if available) */
    sourceUpdatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceUpdatedUser?: Maybe<Scalars['String']['output']>;
    /** The status of the annotation */
    status?: Maybe<CogniteAnnotationStatus>;
    /** Text based labels for generic use, limited to 1000 */
    tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
  };

/** Represents a logical collection of Cognite360Image instances */
export type Cognite360ImageCollection = Cognite3DRevision &
  CogniteDescribable & {
    /** Alternative names for the node */
    aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /** Description of the instance */
    description?: Maybe<Scalars['String']['output']>;
    model3D?: Maybe<Cognite360ImageModel>;
    /** Name of the instance */
    name?: Maybe<Scalars['String']['output']>;
    published?: Maybe<Scalars['Boolean']['output']>;
    status?: Maybe<Cognite3DRevisionStatus>;
    /** Text based labels for generic use, limited to 1000 */
    tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
    type?: Maybe<Cognite3DRevisionType>;
  };

/** Navigational aid for traversing Cognite360ImageModel instances */
export type Cognite360ImageModel = Cognite3DModel &
  CogniteDescribable & {
    /** Alternative names for the node */
    aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /** List Cognite360Image collections for this instance */
    collections?: Maybe<Maybe<Cognite360ImageCollection>[]>;
    /** Description of the instance */
    description?: Maybe<Scalars['String']['output']>;
    /** Name of the instance */
    name?: Maybe<Scalars['String']['output']>;
    /** Text based labels for generic use, limited to 1000 */
    tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /** Thumbnail of the 3D model */
    thumbnail?: Maybe<CogniteFile>;
    /** CAD, PointCloud or Image360 */
    type?: Maybe<Cognite3DModelType>;
  };

/** A way to group images across collections. Used for creating visual scan history */
export type Cognite360ImageStation = CogniteDescribable & {
  /** Alternative names for the node */
  aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Description of the instance */
  description?: Maybe<Scalars['String']['output']>;
  /** Type of group */
  groupType?: Maybe<Cognite3DGroupGroupType>;
  /** Name of the instance */
  name?: Maybe<Scalars['String']['output']>;
  /** Text based labels for generic use, limited to 1000 */
  tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
};

/**
 * Represents activities. Activities typically happen over a period and have a start and end time.
 * @name Activity
 */
export type CogniteActivity = CogniteDescribable &
  CogniteSchedulable &
  CogniteSourceable & {
    /** Alternative names for the node */
    aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * A list of assets the activity is related to.
     * @name Assets
     */
    assets?: Maybe<Maybe<CogniteAsset>[]>;
    /** Description of the instance */
    description?: Maybe<Scalars['String']['output']>;
    /** The actual end time of an activity (or similar that extends this) */
    endTime?: Maybe<Scalars['Timestamp']['output']>;
    /**
     * A list of equipment the activity is related to.
     * @name Equipment
     */
    equipment?: Maybe<Maybe<CogniteEquipment>[]>;
    /** Name of the instance */
    name?: Maybe<Scalars['String']['output']>;
    /** The planned end time of an activity (or similar that extends this) */
    scheduledEndTime?: Maybe<Scalars['Timestamp']['output']>;
    /** The planned start time of an activity (or similar that extends this) */
    scheduledStartTime?: Maybe<Scalars['Timestamp']['output']>;
    /** Direct relation to a source system */
    source?: Maybe<CogniteSourceSystem>;
    /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
    sourceContext?: Maybe<Scalars['String']['output']>;
    /** When the instance was created in source system (if available) */
    sourceCreatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceCreatedUser?: Maybe<Scalars['String']['output']>;
    /** Identifier from the source system */
    sourceId?: Maybe<Scalars['String']['output']>;
    /** When the instance was last updated in the source system (if available) */
    sourceUpdatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceUpdatedUser?: Maybe<Scalars['String']['output']>;
    /** The actual start time of an activity (or similar that extends this) */
    startTime?: Maybe<Scalars['Timestamp']['output']>;
    /** Text based labels for generic use, limited to 1000 */
    tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * A list of time series the activity is related to.
     * @name Time series
     */
    timeSeries?: Maybe<Maybe<CogniteTimeSeries>[]>;
  };

/** Annotation represents contextualization results or links */
export type CogniteAnnotation = {
  /** Alternative names for the node */
  aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** The confidence that the annotation is a good match */
  confidence?: Maybe<Scalars['Float']['output']>;
  /** Description of the instance */
  description?: Maybe<Scalars['String']['output']>;
  /** Name of the instance */
  name?: Maybe<Scalars['String']['output']>;
  /** Direct relation to a source system */
  source?: Maybe<CogniteSourceSystem>;
  /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
  sourceContext?: Maybe<Scalars['String']['output']>;
  /** When the instance was created in source system (if available) */
  sourceCreatedTime?: Maybe<Scalars['Timestamp']['output']>;
  /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
  sourceCreatedUser?: Maybe<Scalars['String']['output']>;
  /** Identifier from the source system */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** When the instance was last updated in the source system (if available) */
  sourceUpdatedTime?: Maybe<Scalars['Timestamp']['output']>;
  /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
  sourceUpdatedUser?: Maybe<Scalars['String']['output']>;
  /** The status of the annotation */
  status?: Maybe<CogniteAnnotationStatus>;
  /** Text based labels for generic use, limited to 1000 */
  tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
};

export enum CogniteAnnotationStatus {
  Approved = 'Approved',
  Rejected = 'Rejected',
  Suggested = 'Suggested',
}

/**
 * Assets represent systems that support industrial functions or processes. Assets are often called 'functional location'.
 * @name Asset
 */
export type CogniteAsset = CogniteDescribable &
  CogniteSourceable &
  CogniteVisualizable & {
    /**
     * An automatically updated list of activities related to the asset.
     * @name Activities
     */
    activities?: Maybe<Maybe<CogniteActivity>[]>;
    /** Alternative names for the node */
    aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * Specifies the class of the asset. It's a direct relation to CogniteAssetClass.
     * @name Asset class
     */
    assetClass?: Maybe<CogniteAssetClass>;
    /**
     * An automatically updated list of assets with this asset as their parent.
     * @name Children
     */
    children?: Maybe<Maybe<CogniteAsset>[]>;
    /** Description of the instance */
    description?: Maybe<Scalars['String']['output']>;
    /**
     * An automatically updated list of equipment related to the asset.
     * @name Equipment
     */
    equipment?: Maybe<Maybe<CogniteEquipment>[]>;
    /**
     * An automatically updated list of files related to the asset.
     * @name Files
     */
    files?: Maybe<Maybe<CogniteFile>[]>;
    /** Name of the instance */
    name?: Maybe<Scalars['String']['output']>;
    /** Direct relation to an Object3D instance representing the 3D resource */
    object3D?: Maybe<Cognite3DObject>;
    /**
     * The parent of the asset.
     * @name Parent
     */
    parent?: Maybe<CogniteAsset>;
    /**
     * An automatically updated ordered list of this asset's ancestors, starting with the root asset. Enables subtree filtering to find all assets under a parent.
     * @name Path
     */
    path?: Maybe<Maybe<CogniteAsset>[]>;
    /**
     * The last time the path was updated for this asset.
     * @name Path last updated time
     */
    pathLastUpdatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /**
     * An automatically updated reference to the top-level asset of the hierarchy.
     * @name Root
     */
    root?: Maybe<CogniteAsset>;
    /** Direct relation to a source system */
    source?: Maybe<CogniteSourceSystem>;
    /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
    sourceContext?: Maybe<Scalars['String']['output']>;
    /** When the instance was created in source system (if available) */
    sourceCreatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceCreatedUser?: Maybe<Scalars['String']['output']>;
    /** Identifier from the source system */
    sourceId?: Maybe<Scalars['String']['output']>;
    /** When the instance was last updated in the source system (if available) */
    sourceUpdatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceUpdatedUser?: Maybe<Scalars['String']['output']>;
    /** Text based labels for generic use, limited to 1000 */
    tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * An automatically updated list of time series related to the asset.
     * @name Time series
     */
    timeSeries?: Maybe<Maybe<CogniteTimeSeries>[]>;
    /**
     * Specifies the type of the asset. It's a direct relation to CogniteAssetType.
     * @name Asset type
     */
    type?: Maybe<CogniteAssetType>;
  };

/**
 * Represents the class of an asset.
 * @name Asset class
 */
export type CogniteAssetClass = CogniteDescribable & {
  /** Alternative names for the node */
  aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /**
   * A unique identifier for the class of asset.
   * @name Code
   */
  code?: Maybe<Scalars['String']['output']>;
  /** Description of the instance */
  description?: Maybe<Scalars['String']['output']>;
  /** Name of the instance */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * A text string to specify which standard the class is from.
   * @name Standard
   */
  standard?: Maybe<Scalars['String']['output']>;
  /** Text based labels for generic use, limited to 1000 */
  tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
};

/**
 * Represents the type of an asset.
 * @name Asset type
 */
export type CogniteAssetType = CogniteDescribable & {
  /** Alternative names for the node */
  aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /**
   * Specifies the class the type belongs to. It's a direct relation to CogniteAssetClass.
   * @name Asset class
   */
  assetClass?: Maybe<CogniteAssetClass>;
  /**
   * A unique identifier for the type of asset.
   * @name Code
   */
  code?: Maybe<Scalars['String']['output']>;
  /** Description of the instance */
  description?: Maybe<Scalars['String']['output']>;
  /** Name of the instance */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * A text string to specify which standard the type is from.
   * @name Standard
   */
  standard?: Maybe<Scalars['String']['output']>;
  /** Text based labels for generic use, limited to 1000 */
  tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
};

/** Navigational aid for traversing CogniteCADModel instances */
export type CogniteCadModel = Cognite3DModel &
  CogniteDescribable & {
    /** Alternative names for the node */
    aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /** Description of the instance */
    description?: Maybe<Scalars['String']['output']>;
    /** Name of the instance */
    name?: Maybe<Scalars['String']['output']>;
    /** List of revisions for this CAD model */
    revisions?: Maybe<Maybe<CogniteCadRevision>[]>;
    /** Text based labels for generic use, limited to 1000 */
    tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /** Thumbnail of the 3D model */
    thumbnail?: Maybe<CogniteFile>;
    /** CAD, PointCloud or Image360 */
    type?: Maybe<Cognite3DModelType>;
  };

/** Represents nodes from the 3D model that have been contextualized */
export type CogniteCadNode = CogniteDescribable & {
  /** Alternative names for the node */
  aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Reference to a node within a CAD model from the 3D API */
  cadNodeReference?: Maybe<Scalars['String']['output']>;
  /** Description of the instance */
  description?: Maybe<Scalars['String']['output']>;
  /** Direct relation to Cognite3DModel */
  model3D?: Maybe<CogniteCadModel>;
  /** Name of the instance */
  name?: Maybe<Scalars['String']['output']>;
  /** Direct relation to object3D grouping for this node */
  object3D?: Maybe<Cognite3DObject>;
  /** List of direct relations to instances of Cognite3DRevision which this CogniteCADNode exists in. */
  revisions?: Maybe<Maybe<CogniteCadRevision>[]>;
  /** List of subtree sizes in the same order as revisions. Used by Reveal and similar applications to know how many nodes exists below this node in the hierarchy */
  subTreeSizes?: Maybe<Maybe<Scalars['Int64']['output']>[]>;
  /** Text based labels for generic use, limited to 1000 */
  tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** List of tree indexes in the same order as revisions. Used by Reveal and similar applications to map from CogniteCADNode to tree index */
  treeIndexes?: Maybe<Maybe<Scalars['Int64']['output']>[]>;
};

export type CogniteCadRevision = Cognite3DRevision & {
  /** . */
  model3D?: Maybe<CogniteCadModel>;
  published?: Maybe<Scalars['Boolean']['output']>;
  /** The 3D API revision identifier for this CAD model */
  revisionId?: Maybe<Scalars['Int64']['output']>;
  status?: Maybe<Cognite3DRevisionStatus>;
  type?: Maybe<Cognite3DRevisionType>;
};

/** The cube map holds references to 6 images in used to visually represent the surrounding environment */
export type CogniteCubeMap = {
  /** Direct relation to a file holding the back projection of the cube map */
  back?: Maybe<CogniteFile>;
  /** Direct relation to a file holding the bottom projection of the cube map */
  bottom?: Maybe<CogniteFile>;
  /** Direct relation to a file holding the front projection of the cube map */
  front?: Maybe<CogniteFile>;
  /** Direct relation to a file holding the left projection of the cube map */
  left?: Maybe<CogniteFile>;
  /** Direct relation to a file holding the right projection of the cube map */
  right?: Maybe<CogniteFile>;
  /** Direct relation to a file holding the top projection of the cube map */
  top?: Maybe<CogniteFile>;
};

/** The describable core concept is used as a standard way of holding the bare minimum of information about the instance */
export type CogniteDescribable = {
  /** Alternative names for the node */
  aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Description of the instance */
  description?: Maybe<Scalars['String']['output']>;
  /** Name of the instance */
  name?: Maybe<Scalars['String']['output']>;
  /** Text based labels for generic use, limited to 1000 */
  tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
};

/** Annotation for diagrams */
export type CogniteDiagramAnnotation = CogniteAnnotation &
  CogniteDescribable &
  CogniteSourceable & {
    /** Alternative names for the node */
    aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /** The confidence that the annotation is a good match */
    confidence?: Maybe<Scalars['Float']['output']>;
    /** Description of the instance */
    description?: Maybe<Scalars['String']['output']>;
    /** The number of the page on which this annotation is located in the endNode File if an endNode is present. The first page has number 1 */
    endNodePageNumber?: Maybe<Scalars['Int64']['output']>;
    /** The text extracted from within the bounding box on the endNode. Only applicable if an endNode is defined */
    endNodeText?: Maybe<Scalars['String']['output']>;
    /** Value between [0,1]. Maximum abscissa of the bounding box (right edge). Must be strictly more than endNodeXMin. Only applicable if an endNode is defined */
    endNodeXMax?: Maybe<Scalars['Float']['output']>;
    /** Value between [0,1]. Minimum abscissa of the bounding box (left edge). Must be strictly less than endNodeXMax. Only applicable if an endNode is defined */
    endNodeXMin?: Maybe<Scalars['Float']['output']>;
    /** Value between [0,1]. Maximum ordinate of the bounding box (top edge). Must be strictly more than endNodeYMin. Only applicable if an endNode is defined */
    endNodeYMax?: Maybe<Scalars['Float']['output']>;
    /** Value between [0,1]. Minimum ordinate of the bounding box (bottom edge). Must be strictly less than endNodeYMax. Only applicable if an endNode is defined */
    endNodeYMin?: Maybe<Scalars['Float']['output']>;
    /** Name of the instance */
    name?: Maybe<Scalars['String']['output']>;
    /** Direct relation to a source system */
    source?: Maybe<CogniteSourceSystem>;
    /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
    sourceContext?: Maybe<Scalars['String']['output']>;
    /** When the instance was created in source system (if available) */
    sourceCreatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceCreatedUser?: Maybe<Scalars['String']['output']>;
    /** Identifier from the source system */
    sourceId?: Maybe<Scalars['String']['output']>;
    /** When the instance was last updated in the source system (if available) */
    sourceUpdatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceUpdatedUser?: Maybe<Scalars['String']['output']>;
    /** The number of the page on which this annotation is located in `startNode` File. The first page has number 1 */
    startNodePageNumber?: Maybe<Scalars['Int64']['output']>;
    /** The text extracted from within the bounding box on the startNode */
    startNodeText?: Maybe<Scalars['String']['output']>;
    /** Value between [0,1]. Maximum abscissa of the bounding box (right edge). Must be strictly more than startNodeXMin */
    startNodeXMax?: Maybe<Scalars['Float']['output']>;
    /** Value between [0,1]. Minimum abscissa of the bounding box (left edge). Must be strictly less than startNodeXMax */
    startNodeXMin?: Maybe<Scalars['Float']['output']>;
    /** Value between [0,1]. Maximum ordinate of the bounding box (top edge). Must be strictly more than startNodeYMin */
    startNodeYMax?: Maybe<Scalars['Float']['output']>;
    /** Value between [0,1]. Minimum ordinate of the bounding box (bottom edge). Must be strictly less than startNodeYMax */
    startNodeYMin?: Maybe<Scalars['Float']['output']>;
    /** The status of the annotation */
    status?: Maybe<CogniteAnnotationStatus>;
    /** Text based labels for generic use, limited to 1000 */
    tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
  };

/**
 * Equipment represents physical supplies or devices.
 * @name Equipment
 */
export type CogniteEquipment = CogniteDescribable &
  CogniteSourceable & {
    /**
     * An automatically updated list of activities related to the equipment.
     * @name Activities
     */
    activities?: Maybe<Maybe<CogniteActivity>[]>;
    /** Alternative names for the node */
    aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * The asset the equipment is related to.
     * @name Asset
     */
    asset?: Maybe<CogniteAsset>;
    /** Description of the instance */
    description?: Maybe<Scalars['String']['output']>;
    /**
     * Specifies the type of the equipment. It's a direct relation to CogniteEquipmentType.
     * @name Equipment type
     */
    equipmentType?: Maybe<CogniteEquipmentType>;
    /**
     * A list of files the equipment relates to.
     * @name Files
     */
    files?: Maybe<Maybe<CogniteFile>[]>;
    /**
     * The manufacturer of the equipment.
     * @name Manufacturer
     */
    manufacturer?: Maybe<Scalars['String']['output']>;
    /** Name of the instance */
    name?: Maybe<Scalars['String']['output']>;
    /**
     * The serial number of the equipment.
     * @name Serial number
     */
    serialNumber?: Maybe<Scalars['String']['output']>;
    /** Direct relation to a source system */
    source?: Maybe<CogniteSourceSystem>;
    /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
    sourceContext?: Maybe<Scalars['String']['output']>;
    /** When the instance was created in source system (if available) */
    sourceCreatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceCreatedUser?: Maybe<Scalars['String']['output']>;
    /** Identifier from the source system */
    sourceId?: Maybe<Scalars['String']['output']>;
    /** When the instance was last updated in the source system (if available) */
    sourceUpdatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceUpdatedUser?: Maybe<Scalars['String']['output']>;
    /** Text based labels for generic use, limited to 1000 */
    tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * An automatically updated list of time series related to the equipment.
     * @name Time series
     */
    timeSeries?: Maybe<Maybe<CogniteTimeSeries>[]>;
  };

/**
 * Represents the type of equipment.
 * @name Equipment type
 */
export type CogniteEquipmentType = CogniteDescribable & {
  /** Alternative names for the node */
  aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /**
   * A unique identifier for the type of equipment.
   * @name Code
   */
  code?: Maybe<Scalars['String']['output']>;
  /** Description of the instance */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Represents the class of equipment.
   * @name Equipment class
   */
  equipmentClass?: Maybe<Scalars['String']['output']>;
  /** Name of the instance */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * An identifier for the standard this equipment type is sourced from, for example, ISO14224.
   * @name Standard
   */
  standard?: Maybe<Scalars['String']['output']>;
  /**
   * A reference to the source of the equipment standard.
   * @name Standard reference
   */
  standardReference?: Maybe<Scalars['String']['output']>;
  /** Text based labels for generic use, limited to 1000 */
  tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
};

/**
 * Represents files.
 * @name File
 */
export type CogniteFile = CogniteDescribable &
  CogniteSourceable & {
    /** Alternative names for the node */
    aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * A list of assets this file is related to.
     * @name Assets
     */
    assets?: Maybe<Maybe<CogniteAsset>[]>;
    /**
     * Specifies the detected category the file belongs to. It's a direct relation to an instance of CogniteFileCategory.
     * @name Category
     */
    category?: Maybe<CogniteFileCategory>;
    /** Description of the instance */
    description?: Maybe<Scalars['String']['output']>;
    /**
     * Contains the path elements from the source (if the source system has a file system hierarchy or similar.)
     * @name Directory
     */
    directory?: Maybe<Scalars['String']['output']>;
    /**
     * An automatically updated list of equipment this file is related to.
     * @name Equipment
     */
    equipment?: Maybe<Maybe<CogniteEquipment>[]>;
    /**
     * Specifies if the file content has been uploaded to Cognite Data Fusion or not.
     * @name Is uploaded
     */
    isUploaded?: Maybe<Scalars['Boolean']['output']>;
    /**
     * The MIME type of the file.
     * @name MIME type
     */
    mimeType?: Maybe<Scalars['String']['output']>;
    /** Name of the instance */
    name?: Maybe<Scalars['String']['output']>;
    /** Direct relation to a source system */
    source?: Maybe<CogniteSourceSystem>;
    /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
    sourceContext?: Maybe<Scalars['String']['output']>;
    /** When the instance was created in source system (if available) */
    sourceCreatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceCreatedUser?: Maybe<Scalars['String']['output']>;
    /** Identifier from the source system */
    sourceId?: Maybe<Scalars['String']['output']>;
    /** When the instance was last updated in the source system (if available) */
    sourceUpdatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceUpdatedUser?: Maybe<Scalars['String']['output']>;
    /** Text based labels for generic use, limited to 1000 */
    tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * The time the file upload completed.
     * @name Uploaded time
     */
    uploadedTime?: Maybe<Scalars['Timestamp']['output']>;
  };

/**
 * Represents the categories of files as determined by contextualization or categorization.
 * @name File category
 */
export type CogniteFileCategory = CogniteDescribable & {
  /** Alternative names for the node */
  aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /**
   * An identifier for the category, for example, 'AA' for Accounting (from Norsok.)
   * @name Code
   */
  code: Scalars['String']['output'];
  /** Description of the instance */
  description?: Maybe<Scalars['String']['output']>;
  /** Name of the instance */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the standard the category originates from, for example, 'Norsok'.
   * @name Standard
   */
  standard?: Maybe<Scalars['String']['output']>;
  /**
   * A reference to the source of the category standard.
   * @name Standard reference
   */
  standardReference?: Maybe<Scalars['String']['output']>;
  /** Text based labels for generic use, limited to 1000 */
  tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
};

/**
 * A formal request or directive to perform maintenance tasks such as repair, inspection, or servicing of equipment or assets. It's often called a 'work order'.
 * @name Maintenance order
 */
export type CogniteMaintenanceOrder = CogniteActivity &
  CogniteDescribable &
  CogniteSchedulable &
  CogniteSourceable & {
    /** Alternative names for the node */
    aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * A list of assets the activity is related to.
     * @name Assets
     */
    assets?: Maybe<Maybe<CogniteAsset>[]>;
    /** Description of the instance */
    description?: Maybe<Scalars['String']['output']>;
    /** The actual end time of an activity (or similar that extends this) */
    endTime?: Maybe<Scalars['Timestamp']['output']>;
    /**
     * A list of equipment the activity is related to.
     * @name Equipment
     */
    equipment?: Maybe<Maybe<CogniteEquipment>[]>;
    /**
     * The primary asset (functional location) the maintenance order refers to.
     * @name Main asset
     */
    mainAsset?: Maybe<CogniteAsset>;
    /** Name of the instance */
    name?: Maybe<Scalars['String']['output']>;
    /**
     * Lists the individual work items on the maintenance order. An automatically populated list of operations related to the maintenance order.
     * @name Operations
     */
    operations?: Maybe<Maybe<CogniteOperation>[]>;
    /**
     * A number that shows how important this maintenance order is. Lower numbers mean it's more important, and 0 means it's the most important.
     * @name Priority
     */
    priority?: Maybe<Scalars['Int64']['output']>;
    /**
     * Describes the priority of the maintenance order.
     * @name Priority description
     */
    priorityDescription?: Maybe<Scalars['String']['output']>;
    /** The planned end time of an activity (or similar that extends this) */
    scheduledEndTime?: Maybe<Scalars['Timestamp']['output']>;
    /** The planned start time of an activity (or similar that extends this) */
    scheduledStartTime?: Maybe<Scalars['Timestamp']['output']>;
    /** Direct relation to a source system */
    source?: Maybe<CogniteSourceSystem>;
    /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
    sourceContext?: Maybe<Scalars['String']['output']>;
    /** When the instance was created in source system (if available) */
    sourceCreatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceCreatedUser?: Maybe<Scalars['String']['output']>;
    /** Identifier from the source system */
    sourceId?: Maybe<Scalars['String']['output']>;
    /** When the instance was last updated in the source system (if available) */
    sourceUpdatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceUpdatedUser?: Maybe<Scalars['String']['output']>;
    /** The actual start time of an activity (or similar that extends this) */
    startTime?: Maybe<Scalars['Timestamp']['output']>;
    /**
     * The lifecycle status of the maintenance order, for example, 'Partially complete'. It's often derived from the 'SystemStatus' field in SAP.
     * @name Status
     */
    status?: Maybe<Scalars['String']['output']>;
    /** Text based labels for generic use, limited to 1000 */
    tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * A list of time series the activity is related to.
     * @name Time series
     */
    timeSeries?: Maybe<Maybe<CogniteTimeSeries>[]>;
    /**
     * The code for the type of maintenance order, for example, 'PM01' for 'Corrective maintenance'.
     * @name Type
     */
    type?: Maybe<Scalars['String']['output']>;
  };

/**
 * A formal record to report maintenance issues, defects, or requests, starting the process for planning and running maintenance activities.
 * @name Notification
 */
export type CogniteNotification = CogniteDescribable &
  CogniteSchedulable &
  CogniteSourceable & {
    /** Alternative names for the node */
    aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * The asset (functional location) the notification is related to.
     * @name Asset
     */
    asset?: Maybe<CogniteAsset>;
    /** Description of the instance */
    description?: Maybe<Scalars['String']['output']>;
    /** The actual end time of an activity (or similar that extends this) */
    endTime?: Maybe<Scalars['Timestamp']['output']>;
    /**
     * The maintenance order that was created from the notification.
     * @name Maintenance order
     */
    maintenanceOrder?: Maybe<CogniteMaintenanceOrder>;
    /** Name of the instance */
    name?: Maybe<Scalars['String']['output']>;
    /**
     * A number that shows how important the notification is. Lower numbers mean it's more important, and 0 means it's the most important.
     * @name Priority
     */
    priority?: Maybe<Scalars['Int64']['output']>;
    /**
     * Describes the priority of the notification.
     * @name Priority description
     */
    priorityDescription?: Maybe<Scalars['String']['output']>;
    /** The planned end time of an activity (or similar that extends this) */
    scheduledEndTime?: Maybe<Scalars['Timestamp']['output']>;
    /** The planned start time of an activity (or similar that extends this) */
    scheduledStartTime?: Maybe<Scalars['Timestamp']['output']>;
    /** Direct relation to a source system */
    source?: Maybe<CogniteSourceSystem>;
    /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
    sourceContext?: Maybe<Scalars['String']['output']>;
    /** When the instance was created in source system (if available) */
    sourceCreatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceCreatedUser?: Maybe<Scalars['String']['output']>;
    /** Identifier from the source system */
    sourceId?: Maybe<Scalars['String']['output']>;
    /** When the instance was last updated in the source system (if available) */
    sourceUpdatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceUpdatedUser?: Maybe<Scalars['String']['output']>;
    /** The actual start time of an activity (or similar that extends this) */
    startTime?: Maybe<Scalars['Timestamp']['output']>;
    /**
     * The current lifecycle status of the notification, for example, 'order created'.
     * @name Status
     */
    status?: Maybe<Scalars['String']['output']>;
    /** Text based labels for generic use, limited to 1000 */
    tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * The code for the notification type, for example, 'M1' for  'Maintenance request'.
     * @name Type
     */
    type?: Maybe<Scalars['String']['output']>;
  };

/**
 * Operations represent a specific part of the work included in a maintenance order. Often called a 'work order item'.
 * @name Operation
 */
export type CogniteOperation = CogniteActivity &
  CogniteDescribable &
  CogniteSchedulable &
  CogniteSourceable & {
    /** Alternative names for the node */
    aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * A list of assets the activity is related to.
     * @name Assets
     */
    assets?: Maybe<Maybe<CogniteAsset>[]>;
    /** Description of the instance */
    description?: Maybe<Scalars['String']['output']>;
    /** The actual end time of an activity (or similar that extends this) */
    endTime?: Maybe<Scalars['Timestamp']['output']>;
    /**
     * A list of equipment the activity is related to.
     * @name Equipment
     */
    equipment?: Maybe<Maybe<CogniteEquipment>[]>;
    /**
     * The primary asset (functional location) the operation is related to.
     * @name Main asset
     */
    mainAsset?: Maybe<CogniteAsset>;
    /**
     * The primary skill or resource required to perform the operation, for example, 'maintenance technician').
     * @name Main discipline
     */
    mainDiscipline?: Maybe<Scalars['String']['output']>;
    /**
     * The maintenance order the operation is related to.
     * @name Maintenance order
     */
    maintenanceOrder?: Maybe<CogniteMaintenanceOrder>;
    /** Name of the instance */
    name?: Maybe<Scalars['String']['output']>;
    /**
     * The number of resources required to perform the operation, for example, the number of required maintenance technicians.
     * @name Number of main discipline
     */
    numberOfMainDiscipline?: Maybe<Scalars['Int64']['output']>;
    /**
     * The number of hours required to perform the maintenance operation. The duration is calculated by dividing the personHours by the numberOfMainDiscipline.
     * @name Person hours
     */
    personHours?: Maybe<Scalars['Float']['output']>;
    /**
     * The code for the phase the operation belongs to. Each operation belongs to a single phase, for example, 'Scaffolding'.
     * @name Phase
     */
    phase?: Maybe<Scalars['String']['output']>;
    /** The planned end time of an activity (or similar that extends this) */
    scheduledEndTime?: Maybe<Scalars['Timestamp']['output']>;
    /** The planned start time of an activity (or similar that extends this) */
    scheduledStartTime?: Maybe<Scalars['Timestamp']['output']>;
    /**
     * A number that shows the order in which the operations are performed. Lower numbers mean they happen earlier, and 0 means it's the first operation.
     * @name Sequence
     */
    sequence?: Maybe<Scalars['Int64']['output']>;
    /** Direct relation to a source system */
    source?: Maybe<CogniteSourceSystem>;
    /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
    sourceContext?: Maybe<Scalars['String']['output']>;
    /** When the instance was created in source system (if available) */
    sourceCreatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceCreatedUser?: Maybe<Scalars['String']['output']>;
    /** Identifier from the source system */
    sourceId?: Maybe<Scalars['String']['output']>;
    /** When the instance was last updated in the source system (if available) */
    sourceUpdatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceUpdatedUser?: Maybe<Scalars['String']['output']>;
    /** The actual start time of an activity (or similar that extends this) */
    startTime?: Maybe<Scalars['Timestamp']['output']>;
    /**
     * The lifecycle status of the operation, for example, 'Partially complete'. It's often derived from the UserStatus field in SAP.
     * @name Status
     */
    status?: Maybe<Scalars['String']['output']>;
    /** Text based labels for generic use, limited to 1000 */
    tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * A list of time series the activity is related to.
     * @name Time series
     */
    timeSeries?: Maybe<Maybe<CogniteTimeSeries>[]>;
  };

/** Navigational aid for traversing CognitePointCloudModel instances */
export type CognitePointCloudModel = Cognite3DModel &
  CogniteDescribable & {
    /** Alternative names for the node */
    aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /** Description of the instance */
    description?: Maybe<Scalars['String']['output']>;
    /** Name of the instance */
    name?: Maybe<Scalars['String']['output']>;
    /** List of revisions for this PointCloud model */
    revisions?: Maybe<Maybe<CognitePointCloudRevision>[]>;
    /** Text based labels for generic use, limited to 1000 */
    tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /** Thumbnail of the 3D model */
    thumbnail?: Maybe<CogniteFile>;
    /** CAD, PointCloud or Image360 */
    type?: Maybe<Cognite3DModelType>;
  };

/** Navigational aid for traversing CognitePointCloudRevision instances */
export type CognitePointCloudRevision = Cognite3DRevision & {
  /** . */
  model3D?: Maybe<CognitePointCloudModel>;
  published?: Maybe<Scalars['Boolean']['output']>;
  /** The 3D API revision identifier for this PointCloud model */
  revisionId?: Maybe<Scalars['Int64']['output']>;
  status?: Maybe<Cognite3DRevisionStatus>;
  type?: Maybe<Cognite3DRevisionType>;
};

/** PointCloud volume definition */
export type CognitePointCloudVolume = CogniteDescribable & {
  /** Alternative names for the node */
  aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Description of the instance */
  description?: Maybe<Scalars['String']['output']>;
  /** Specifies the version the ‘volume’ field is following. Volume definition is today 9 floats (property volume) */
  formatVersion?: Maybe<Scalars['String']['output']>;
  /** Direct relation to Cognite3DModel instance */
  model3D?: Maybe<CogniteCadModel>;
  /** Name of the instance */
  name?: Maybe<Scalars['String']['output']>;
  /** Direct relation to object3D grouping for this node */
  object3D?: Maybe<Cognite3DObject>;
  /** List of direct relations to revision information */
  revisions?: Maybe<Maybe<CogniteCadRevision>[]>;
  /** Text based labels for generic use, limited to 1000 */
  tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Relevant coordinates for the volume type, 9 floats in total, that defines the volume */
  volume?: Maybe<Maybe<Scalars['Float']['output']>[]>;
  /** Unique volume metric hashes used to access the 3D specialized data storage */
  volumeReferences?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Type of volume (Cylinder or Box) */
  volumeType?: Maybe<CognitePointCloudVolumeVolumeType>;
};

export enum CognitePointCloudVolumeVolumeType {
  Box = 'Box',
  Cylinder = 'Cylinder',
}

/** CogniteSchedulable represents the metadata about when an activity (or similar) starts and ends. */
export type CogniteSchedulable = {
  /** The actual end time of an activity (or similar that extends this) */
  endTime?: Maybe<Scalars['Timestamp']['output']>;
  /** The planned end time of an activity (or similar that extends this) */
  scheduledEndTime?: Maybe<Scalars['Timestamp']['output']>;
  /** The planned start time of an activity (or similar that extends this) */
  scheduledStartTime?: Maybe<Scalars['Timestamp']['output']>;
  /** The actual start time of an activity (or similar that extends this) */
  startTime?: Maybe<Scalars['Timestamp']['output']>;
};

/** The CogniteSourceSystem core concept is used to standardize the way source system is stored. */
export type CogniteSourceSystem = CogniteDescribable & {
  /** Alternative names for the node */
  aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Description of the instance */
  description?: Maybe<Scalars['String']['output']>;
  /** Manufacturer of the source system */
  manufacturer?: Maybe<Scalars['String']['output']>;
  /** Name of the instance */
  name?: Maybe<Scalars['String']['output']>;
  /** Text based labels for generic use, limited to 1000 */
  tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Version identifier for the source system */
  version?: Maybe<Scalars['String']['output']>;
};

export type CogniteSourceable = {
  /** Direct relation to a source system */
  source?: Maybe<CogniteSourceSystem>;
  /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
  sourceContext?: Maybe<Scalars['String']['output']>;
  /** When the instance was created in source system (if available) */
  sourceCreatedTime?: Maybe<Scalars['Timestamp']['output']>;
  /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
  sourceCreatedUser?: Maybe<Scalars['String']['output']>;
  /** Identifier from the source system */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** When the instance was last updated in the source system (if available) */
  sourceUpdatedTime?: Maybe<Scalars['Timestamp']['output']>;
  /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
  sourceUpdatedUser?: Maybe<Scalars['String']['output']>;
};

/**
 * Represents a series of data points in time order.
 * @name Time series
 */
export type CogniteTimeSeries = CogniteDescribable &
  CogniteSourceable & {
    /**
     * An automatically updated list of activities the time series is related to.
     * @name Activities
     */
    activities?: Maybe<Maybe<CogniteActivity>[]>;
    /** Alternative names for the node */
    aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * A list of assets the time series is related to.
     * @name Assets
     */
    assets?: Maybe<Maybe<CogniteAsset>[]>;
    /** Description of the instance */
    description?: Maybe<Scalars['String']['output']>;
    /**
     * A list of equipment the time series is related to.
     * @name Equipment
     */
    equipment?: Maybe<Maybe<CogniteEquipment>[]>;
    /**
     * Specifies whether the time series is a step time series or not.
     * @name Is step
     */
    isStep: Scalars['Boolean']['output'];
    /** Name of the instance */
    name?: Maybe<Scalars['String']['output']>;
    /** Direct relation to a source system */
    source?: Maybe<CogniteSourceSystem>;
    /** Context of the source id. For systems where the sourceId is globally unique, the sourceContext is expected to not be set. */
    sourceContext?: Maybe<Scalars['String']['output']>;
    /** When the instance was created in source system (if available) */
    sourceCreatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who created the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceCreatedUser?: Maybe<Scalars['String']['output']>;
    /** Identifier from the source system */
    sourceId?: Maybe<Scalars['String']['output']>;
    /**
     * The unit specified in the source system.
     * @name Source unit
     */
    sourceUnit?: Maybe<Scalars['String']['output']>;
    /** When the instance was last updated in the source system (if available) */
    sourceUpdatedTime?: Maybe<Scalars['Timestamp']['output']>;
    /** User identifier from the source system on who last updated the source data. This identifier is not guaranteed to match the user identifiers in CDF */
    sourceUpdatedUser?: Maybe<Scalars['String']['output']>;
    /**
     * The state set of the time series. It is only in effect when the type is 'state'.
     * @name State set
     */
    stateSet?: Maybe<Scalars['JSONObject']['output']>;
    /** Text based labels for generic use, limited to 1000 */
    tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
    /**
     * Specifies the data type of the data points.
     * @name Type
     */
    type?: Maybe<CogniteTimeSeriesType>;
    /**
     * The unit of the time series.
     * @name Unit
     */
    unit?: Maybe<CogniteUnit>;
  };

export enum CogniteTimeSeriesType {
  /** Time series with double floating point data points. */
  Numeric = 'numeric',
  /** Time series with state data points. */
  State = 'state',
  /** Time series with string data points. */
  String = 'string',
}

/** Represents a single unit of measurement */
export type CogniteUnit = CogniteDescribable & {
  /** Alternative names for the node */
  aliases?: Maybe<Maybe<Scalars['String']['output']>[]>;
  /** Description of the instance */
  description?: Maybe<Scalars['String']['output']>;
  /** Name of the instance */
  name?: Maybe<Scalars['String']['output']>;
  /** Specifies the physical quantity the unit measures */
  quantity?: Maybe<Scalars['String']['output']>;
  /** Source of the unit definition */
  source?: Maybe<Scalars['String']['output']>;
  /** Reference to the source of the unit definition */
  sourceReference?: Maybe<Scalars['String']['output']>;
  /** The symbol for the unit of measurement */
  symbol?: Maybe<Scalars['String']['output']>;
  /** Text based labels for generic use, limited to 1000 */
  tags?: Maybe<Maybe<Scalars['String']['output']>[]>;
};

/** CogniteVisualizable defines the standard way to reference a related 3D resource */
export type CogniteVisualizable = {
  /** Direct relation to an Object3D instance representing the 3D resource */
  object3D?: Maybe<Cognite3DObject>;
};

/** Typed view over 'Entity' showing companies only (where 'entityType' = 'company'). Use this view to identify the top-level company context, then navigate down to assets, fields, reservoirs, wells and strings through the 'FlatHierarchy' navigation view. */
export type Company = {
  /** Attribute capturing end date time for this company in the production optimization context. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Entity Type attribute describing this company in more detail, often derived from master data or configuration tables. */
  entityType?: Maybe<Scalars['String']['output']>;
  /** Name or label for this company, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  name?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing start date time for this company in the production optimization context. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
};

/**
 * Daily field-level production and injection rollups for surveillance and target
 * comparison.
 *
 * Contains daily aggregated data on production and injection volumes for oil,
 * gas, and water at the field level, derived from operational reports and
 * allocation systems. It answers analytical questions regarding field
 * performance, such as actual versus target production rates and injection
 * monitoring for various fluids. The view excludes detailed well-level data. Use
 * cases: performance surveillance, operational planning, and identifying
 * discrepancies between expected and actual production metrics.
 */
export type DailyRollupFieldAgent = {
  /** Daily allocated gas injection volume (Sm3). Field total. */
  dayAllocInjGasInjection?: Maybe<TimeSeries>;
  /** Daily allocated gas injection rate (Sm3/d). */
  dayAllocInjGasInjectionRate?: Maybe<TimeSeries>;
  /** Daily allocated water injection volume (Sm3). Field total. */
  dayAllocInjWaterInjection?: Maybe<TimeSeries>;
  /** Daily allocated water injection rate (Sm3/d). */
  dayAllocInjWaterInjectionRate?: Maybe<TimeSeries>;
  /** Daily allocated gas production volume (Sm3). Field total. */
  dayAllocProdAllocatedGas?: Maybe<TimeSeries>;
  /** Daily allocated gas production rate (Sm3/d). */
  dayAllocProdAllocatedGasRate?: Maybe<TimeSeries>;
  /** Daily allocated oil production volume (Sm3). Field total. */
  dayAllocProdAllocatedOil?: Maybe<TimeSeries>;
  /** Daily allocated oil production rate (Sm3/d or bbl/d). */
  dayAllocProdAllocatedOilRate?: Maybe<TimeSeries>;
  /** Daily allocated water production volume (Sm3). Field total. */
  dayAllocProdAllocatedWater?: Maybe<TimeSeries>;
  /** Daily allocated water production rate (Sm3/d). */
  dayAllocProdAllocatedWaterRate?: Maybe<TimeSeries>;
  /** Reference to field. Join to FlatHierarchy_Agent for reservoir/sector context. */
  fieldEntity?: Maybe<Field>;
  /** Unconstrained gas injection potential. For injection performance. */
  potentialGasInjection?: Maybe<TimeSeries>;
  /** Unconstrained gas production potential. Performance benchmark. */
  potentialGasProduction?: Maybe<TimeSeries>;
  /** Unconstrained oil production potential. Performance benchmark. */
  potentialOilProduction?: Maybe<TimeSeries>;
  /** Unconstrained water injection potential. For injection performance. */
  potentialWaterInjection?: Maybe<TimeSeries>;
  /** Unconstrained water production potential. Performance benchmark. */
  potentialWaterProduction?: Maybe<TimeSeries>;
  /** Target gas injection from planning. For gap analysis. */
  targetGasInjection?: Maybe<TimeSeries>;
  /** Target gas production from planning. For gap analysis. */
  targetGasProduction?: Maybe<TimeSeries>;
  /** Target oil production from planning. For gap analysis. */
  targetOilproduction?: Maybe<TimeSeries>;
  /** Target water injection from planning. For gap analysis. */
  targetWaterInjection?: Maybe<TimeSeries>;
  /** Target water production from planning. For gap analysis. */
  targetWaterProduction?: Maybe<TimeSeries>;
};

/** Daily roll-up of allocated, target, and potential production and injection metrics at an asset level. Values are derived from the allocation engine and planning/optimization results and are used in daily surveillance and decision support. */
export type DailyRollupOutputAsset = {
  /** Daily final allocated gas injection volume allocated to this asset, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocInjGasInjection?: Maybe<TimeSeries>;
  /** Daily final allocated gas injection rate for this asset, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocInjGasInjectionRate?: Maybe<TimeSeries>;
  /** Daily final allocated water injection volume allocated to this asset, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocInjWaterInjection?: Maybe<TimeSeries>;
  /** Daily final allocated water injection rate for this asset, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocInjWaterInjectionRate?: Maybe<TimeSeries>;
  /** Daily final allocated gas production volume allocated to this asset, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocProdAllocatedGas?: Maybe<TimeSeries>;
  /** Daily final allocated gas production rate for this asset, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocProdAllocatedGasRate?: Maybe<TimeSeries>;
  /** Daily final allocated oil production volume allocated to this asset, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocProdAllocatedOil?: Maybe<TimeSeries>;
  /** Daily final allocated oil production rate for this asset, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocProdAllocatedOilRate?: Maybe<TimeSeries>;
  /** Daily final allocated water production volume allocated to this asset, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocProdAllocatedWater?: Maybe<TimeSeries>;
  /** Daily final allocated water production rate for this asset, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocProdAllocatedWaterRate?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Asset>;
  /** Unconstrained potential production or injection capacity for this asset, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialGasInjection?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this asset, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialGasProduction?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this asset, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialOilProduction?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this asset, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialWaterInjection?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this asset, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialWaterProduction?: Maybe<TimeSeries>;
  /** Target value for this asset defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetGasInjection?: Maybe<TimeSeries>;
  /** Target value for this asset defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetGasProduction?: Maybe<TimeSeries>;
  /** Target value for this asset defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetOilproduction?: Maybe<TimeSeries>;
  /** Target value for this asset defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetWaterInjection?: Maybe<TimeSeries>;
  /** Target value for this asset defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetWaterProduction?: Maybe<TimeSeries>;
};

/** Daily roll-up of allocated, target, and potential production and injection metrics at a company portfolio level. Values are derived from the allocation engine and planning/optimization results and are used in daily surveillance and decision support. */
export type DailyRollupOutputCompany = {
  /** Daily final allocated gas injection volume allocated to this company portfolio, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocInjGasInjection?: Maybe<TimeSeries>;
  /** Daily final allocated gas injection rate for this company portfolio, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocInjGasInjectionRate?: Maybe<TimeSeries>;
  /** Daily final allocated water injection volume allocated to this company portfolio, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocInjWaterInjection?: Maybe<TimeSeries>;
  /** Daily final allocated water injection rate for this company portfolio, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocInjWaterInjectionRate?: Maybe<TimeSeries>;
  /** Daily final allocated gas production volume allocated to this company portfolio, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocProdAllocatedGas?: Maybe<TimeSeries>;
  /** Daily final allocated gas production rate for this company portfolio, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocProdAllocatedGasRate?: Maybe<TimeSeries>;
  /** Daily final allocated oil production volume allocated to this company portfolio, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocProdAllocatedOil?: Maybe<TimeSeries>;
  /** Daily final allocated oil production rate for this company portfolio, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocProdAllocatedOilRate?: Maybe<TimeSeries>;
  /** Daily final allocated water production volume allocated to this company portfolio, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocProdAllocatedWater?: Maybe<TimeSeries>;
  /** Daily final allocated water production rate for this company portfolio, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocProdAllocatedWaterRate?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Company>;
  /** Unconstrained potential production or injection capacity for this company portfolio, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialGasInjection?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this company portfolio, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialGasProduction?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this company portfolio, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialOilProduction?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this company portfolio, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialWaterInjection?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this company portfolio, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialWaterProduction?: Maybe<TimeSeries>;
  /** Target value for this company portfolio defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetGasInjection?: Maybe<TimeSeries>;
  /** Target value for this company portfolio defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetGasProduction?: Maybe<TimeSeries>;
  /** Target value for this company portfolio defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetOilproduction?: Maybe<TimeSeries>;
  /** Target value for this company portfolio defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetWaterInjection?: Maybe<TimeSeries>;
  /** Target value for this company portfolio defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetWaterProduction?: Maybe<TimeSeries>;
};

/** Daily roll-up of allocated, target, and potential production and injection metrics at a field level. Values are derived from the allocation engine and planning/optimization results and are used in daily surveillance and decision support. */
export type DailyRollupOutputField = {
  /** Daily final allocated gas injection volume allocated to this field, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocInjGasInjection?: Maybe<TimeSeries>;
  /** Daily final allocated gas injection rate for this field, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocInjGasInjectionRate?: Maybe<TimeSeries>;
  /** Daily final allocated water injection volume allocated to this field, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocInjWaterInjection?: Maybe<TimeSeries>;
  /** Daily final allocated water injection rate for this field, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocInjWaterInjectionRate?: Maybe<TimeSeries>;
  /** Daily final allocated gas production volume allocated to this field, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocProdAllocatedGas?: Maybe<TimeSeries>;
  /** Daily final allocated gas production rate for this field, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocProdAllocatedGasRate?: Maybe<TimeSeries>;
  /** Daily final allocated oil production volume allocated to this field, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocProdAllocatedOil?: Maybe<TimeSeries>;
  /** Daily final allocated oil production rate for this field, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocProdAllocatedOilRate?: Maybe<TimeSeries>;
  /** Daily final allocated water production volume allocated to this field, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocProdAllocatedWater?: Maybe<TimeSeries>;
  /** Daily final allocated water production rate for this field, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocProdAllocatedWaterRate?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Field>;
  /** Unconstrained potential production or injection capacity for this field, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialGasInjection?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this field, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialGasProduction?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this field, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialOilProduction?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this field, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialWaterInjection?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this field, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialWaterProduction?: Maybe<TimeSeries>;
  /** Target value for this field defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetGasInjection?: Maybe<TimeSeries>;
  /** Target value for this field defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetGasProduction?: Maybe<TimeSeries>;
  /** Target value for this field defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetOilproduction?: Maybe<TimeSeries>;
  /** Target value for this field defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetWaterInjection?: Maybe<TimeSeries>;
  /** Target value for this field defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetWaterProduction?: Maybe<TimeSeries>;
};

/** Daily roll-up of allocated, target, and potential production and injection metrics at a surface location level. Values are derived from the allocation engine and planning/optimization results and are used in daily surveillance and decision support. */
export type DailyRollupOutputLocation = {
  /** Daily final allocated gas injection volume allocated to this surface location, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocInjGasInjection?: Maybe<TimeSeries>;
  /** Daily final allocated gas injection rate for this surface location, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocInjGasInjectionRate?: Maybe<TimeSeries>;
  /** Daily final allocated water injection volume allocated to this surface location, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocInjWaterInjection?: Maybe<TimeSeries>;
  /** Daily final allocated water injection rate for this surface location, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocInjWaterInjectionRate?: Maybe<TimeSeries>;
  /** Daily final allocated gas production volume allocated to this surface location, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocProdAllocatedGas?: Maybe<TimeSeries>;
  /** Daily final allocated gas production rate for this surface location, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocProdAllocatedGasRate?: Maybe<TimeSeries>;
  /** Daily final allocated oil production volume allocated to this surface location, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocProdAllocatedOil?: Maybe<TimeSeries>;
  /** Daily final allocated oil production rate for this surface location, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocProdAllocatedOilRate?: Maybe<TimeSeries>;
  /** Daily final allocated water production volume allocated to this surface location, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocProdAllocatedWater?: Maybe<TimeSeries>;
  /** Daily final allocated water production rate for this surface location, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocProdAllocatedWaterRate?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Location>;
  /** Unconstrained potential production or injection capacity for this surface location, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialGasInjection?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this surface location, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialGasProduction?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this surface location, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialOilProduction?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this surface location, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialWaterInjection?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this surface location, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialWaterProduction?: Maybe<TimeSeries>;
  /** Target value for this surface location defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetGasInjection?: Maybe<TimeSeries>;
  /** Target value for this surface location defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetGasProduction?: Maybe<TimeSeries>;
  /** Target value for this surface location defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetOilproduction?: Maybe<TimeSeries>;
  /** Target value for this surface location defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetWaterInjection?: Maybe<TimeSeries>;
  /** Target value for this surface location defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetWaterProduction?: Maybe<TimeSeries>;
};

/** Daily roll-up of allocated, target, and potential production and injection metrics at a reservoir level. Values are derived from the allocation engine and planning/optimization results and are used in daily surveillance and decision support. */
export type DailyRollupOutputReservoir = {
  /** Daily final allocated gas injection volume allocated to this reservoir, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocInjGasInjection?: Maybe<TimeSeries>;
  /** Daily final allocated gas injection rate for this reservoir, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocInjGasInjectionRate?: Maybe<TimeSeries>;
  /** Daily final allocated water injection volume allocated to this reservoir, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocInjWaterInjection?: Maybe<TimeSeries>;
  /** Daily final allocated water injection rate for this reservoir, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocInjWaterInjectionRate?: Maybe<TimeSeries>;
  /** Daily final allocated gas production volume allocated to this reservoir, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocProdAllocatedGas?: Maybe<TimeSeries>;
  /** Daily final allocated gas production rate for this reservoir, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocProdAllocatedGasRate?: Maybe<TimeSeries>;
  /** Daily final allocated oil production volume allocated to this reservoir, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocProdAllocatedOil?: Maybe<TimeSeries>;
  /** Daily final allocated oil production rate for this reservoir, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocProdAllocatedOilRate?: Maybe<TimeSeries>;
  /** Daily final allocated water production volume allocated to this reservoir, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocProdAllocatedWater?: Maybe<TimeSeries>;
  /** Daily final allocated water production rate for this reservoir, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocProdAllocatedWaterRate?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Reservoir>;
  /** Unconstrained potential production or injection capacity for this reservoir, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialGasInjection?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this reservoir, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialGasProduction?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this reservoir, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialOilProduction?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this reservoir, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialWaterInjection?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this reservoir, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialWaterProduction?: Maybe<TimeSeries>;
  /** Target value for this reservoir defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetGasInjection?: Maybe<TimeSeries>;
  /** Target value for this reservoir defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetGasProduction?: Maybe<TimeSeries>;
  /** Target value for this reservoir defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetOilproduction?: Maybe<TimeSeries>;
  /** Target value for this reservoir defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetWaterInjection?: Maybe<TimeSeries>;
  /** Target value for this reservoir defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetWaterProduction?: Maybe<TimeSeries>;
};

/** Daily roll-up of allocated, target, and potential production and injection metrics at a well level. Values are derived from the allocation engine and planning/optimization results and are used in daily surveillance and decision support. */
export type DailyRollupOutputWell = {
  /** Daily final allocated gas injection volume allocated to this well, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocInjGasInjection?: Maybe<TimeSeries>;
  /** Daily final allocated gas injection rate for this well, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocInjGasInjectionRate?: Maybe<TimeSeries>;
  /** Daily final allocated water injection volume allocated to this well, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocInjWaterInjection?: Maybe<TimeSeries>;
  /** Daily final allocated water injection rate for this well, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocInjWaterInjectionRate?: Maybe<TimeSeries>;
  /** Daily final allocated gas production volume allocated to this well, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocProdAllocatedGas?: Maybe<TimeSeries>;
  /** Daily final allocated gas production rate for this well, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocProdAllocatedGasRate?: Maybe<TimeSeries>;
  /** Daily final allocated oil production volume allocated to this well, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocProdAllocatedOil?: Maybe<TimeSeries>;
  /** Daily final allocated oil production rate for this well, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocProdAllocatedOilRate?: Maybe<TimeSeries>;
  /** Daily final allocated water production volume allocated to this well, after distributing measured totals down to the appropriate level. Used in mass balance, allocation reconciliation, and regulatory reporting. */
  dayAllocProdAllocatedWater?: Maybe<TimeSeries>;
  /** Daily final allocated water production rate for this well, derived by the allocation engine from tests, meters, and network constraints. Typically expressed in Sm3/d or bbl/d and used for daily production reporting, loss analysis, and optimization. */
  dayAllocProdAllocatedWaterRate?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Well>;
  /** Unconstrained potential production or injection capacity for this well, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialGasInjection?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this well, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialGasProduction?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this well, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialOilProduction?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this well, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialWaterInjection?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this well, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialWaterProduction?: Maybe<TimeSeries>;
  /** Target value for this well defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetGasInjection?: Maybe<TimeSeries>;
  /** Target value for this well defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetGasProduction?: Maybe<TimeSeries>;
  /** Target value for this well defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetOilproduction?: Maybe<TimeSeries>;
  /** Target value for this well defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetWaterInjection?: Maybe<TimeSeries>;
  /** Target value for this well defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetWaterProduction?: Maybe<TimeSeries>;
};

/**
 * Data-driven and ML rate estimates with injection compliance per well string (WF10).
 *
 * Properties from WellOutputs_Ext_1_String. ML-derived oil, gas, water, liquid
 * rates and injector compliance. Use when querying ML outputs or injector compliance. For physics-based and priority rates use EstimatedRates_String_Agent.
 *
 * Use for: Real-Time Well Rate and Pressure Estimation (WF10).
 *
 * @name Data-Driven Rates - String (Agent)
 */
export type DataDrivenRatesStringAgent = {
  dataDrivenGasRateStd?: Maybe<TimeSeries>;
  dataDrivenLiquidRateStd?: Maybe<TimeSeries>;
  dataDrivenOilRateStd?: Maybe<TimeSeries>;
  dataDrivenWaterRateStd?: Maybe<TimeSeries>;
  giBHPCompliance?: Maybe<TimeSeries>;
  giTargetRateCompliance?: Maybe<TimeSeries>;
  giTechnicalRateCompliance?: Maybe<TimeSeries>;
  giWHPCompliance?: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
  wiBHPCompliance?: Maybe<TimeSeries>;
  wiTargetRateCompliance?: Maybe<TimeSeries>;
  wiTechnicalRateCompliance?: Maybe<TimeSeries>;
  wiWHPCompliance?: Maybe<TimeSeries>;
};

/** Data Mapping view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type DataMapping = {
  /** Attribute capturing date for this entity in the production optimization context. */
  date?: Maybe<Scalars['Timestamp']['output']>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  fieldName?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing lat for this entity, used in calculations, reporting, or model configuration. */
  lat?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing long for this entity, used in calculations, reporting, or model configuration. */
  long?: Maybe<Scalars['Float32']['output']>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  reservoirName?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing reservoir pressure rmserror for this entity, used in calculations, reporting, or model configuration. */
  reservoirPressureRMSError?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing reservoir pressure string for this entity, used in calculations, reporting, or model configuration. */
  reservoirPressureString?: Maybe<Scalars['Float32']['output']>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  stringName?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing x for this entity, used in calculations, reporting, or model configuration. */
  x?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing y for this entity, used in calculations, reporting, or model configuration. */
  y?: Maybe<Scalars['Float32']['output']>;
};

/**
 * ESP and motor performance alarms (WF12) with medium or high priority.
 *
 * Contains alarms generated by Electric Submersible Pumps (ESPs) and associated
 * motors, medium and high-priority alarms as part of the WF12 workflow. Sourced
 * from operational monitoring systems that track ESP performance and
 * diagnostics, to analyze alarm occurrences, their severity, and potential
 * impacts on production. It can answer questions regarding the frequency and
 * types of alarms, trends in alarm priorities, and the relationship between
 * alarm occurrences and operational performance. Excludes low-priority or non-WF12 alarms.
 *
 * Use for: ESP and Motor Performance and Diagnostics (WF12), Real-Time Surveillance (WF18).
 *
 * @name ESP Alarms (Agent)
 */
export type EspAlarmsAgent = {
  /** Alarm category (ESP). */
  alarmCategory?: Maybe<Scalars['String']['output']>;
  /** Reference to AlarmDefinition node. */
  alarmCode?: Maybe<Scalars['JSONObject']['output']>;
  /** Alarm code identifier (WF12-001, WF12-002, etc.). */
  alarmCodeExternalId?: Maybe<Scalars['String']['output']>;
  /** Count of how many times this alarm has occurred. */
  alarmCounter?: Maybe<Scalars['Int']['output']>;
  /** Alarm criticality level. Pre-filtered to 2 and 3. */
  alarmCriticality?: Maybe<Scalars['String']['output']>;
  /** Alarm validity flag. Pre-filtered to 'Valid'. */
  alarmFlags?: Maybe<Scalars['String']['output']>;
  /** Human-readable alarm name from AlarmDefinition. */
  alarmName?: Maybe<Scalars['String']['output']>;
  /** Alarm priority level. Pre-filtered to Medium and High. */
  alarmPriority?: Maybe<Scalars['String']['output']>;
  /** Detailed alarm message with specific conditions that triggered it. */
  customWorkflowAlarmMessage?: Maybe<Scalars['String']['output']>;
  /** When the alarm was cleared. Null means alarm is still active. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** External ID of the entity for joining to other views. */
  entityExternalId: Scalars['String']['output'];
  /** Display name of the entity (well, string) with the alarm. */
  entityName: Scalars['String']['output'];
  /** Type of entity (string, well, field). */
  entityType: Scalars['String']['output'];
  /** When the alarm was triggered. */
  startDateTime: Scalars['Timestamp']['output'];
  /** Alarm sub-category for domain filtering. */
  subCategory?: Maybe<Scalars['String']['output']>;
  /** Sub-workflow that generated the alarm. */
  subWorkflowName?: Maybe<Scalars['String']['output']>;
  /** Associated troubleshooting ticket ID if one was created. */
  ticketId?: Maybe<Scalars['String']['output']>;
  wellString?: Maybe<StringAsset>;
  /** Workflow code (WF12 for ESP). */
  workflowCode?: Maybe<Scalars['String']['output']>;
  /** Workflow name from AlarmDefinition. */
  workflowName?: Maybe<Scalars['String']['output']>;
};

/** Electric submersible pump (ESP) equipment, configuration, and operating constraints, including motor, cable, controller, and stage design parameters used in production optimization and surveillance. */
export type EspCable = {
  /** Cable Type attribute describing this entity in more detail, often derived from master data or configuration tables. */
  cableType?: Maybe<Scalars['String']['output']>;
  /** Free-text description providing engineering context, assumptions, or clarifications about this entity or the associated signal, used to support interpretation and troubleshooting. */
  description?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing max current allowed for this entity, used in calculations, reporting, or model configuration. */
  maxCurrentAllowed?: Maybe<Scalars['Float']['output']>;
  /** Numeric value storing prosper index for this entity, used in calculations, reporting, or model configuration. */
  prosperIndex?: Maybe<Scalars['Int64']['output']>;
  /** Numeric value storing voltage drop coefficient for this entity, used in calculations, reporting, or model configuration. */
  voltageDropCoefficient?: Maybe<Scalars['Float']['output']>;
};

/**
 * Model-calculated ESP performance outputs per well string (WF12).
 *
 * Motor efficiency and load, pump head, average pump rate, calculation status.
 * Use with ESPMeasurements_String_Agent and ESPLimits_String_Agent for full ESP diagnostics.
 *
 * Use for: ESP and Motor Performance and Diagnostics (WF12).
 *
 * @name ESP Calculations - Well String (Agent)
 */
export type EspCalculationsStringAgent = {
  /** Status of ESP rate calculation. Values: SUCCESS, FAILED, NO_DATA. Check before using ESP-derived outputs. */
  espqlAnalysisStatus?: Maybe<TimeSeries>;
  /**
   * ESP motor efficiency (%, TS). Ratio of hydraulic power output to electrical
   * power input. Declining trend may indicate motor degradation.
   */
  motorEfficiency?: Maybe<TimeSeries>;
  /**
   * ESP motor load (%, TS). Current electrical load as percentage of rated
   * capacity. High values indicate operating near limits.
   */
  motorLoad?: Maybe<TimeSeries>;
  /** Average pump rate (stb/d, TS) over the calculation period. */
  pumpAvgRate?: Maybe<TimeSeries>;
  /**
   * ESP pump head (ft, TS). Pressure increase provided by the pump. Compare
   * to pump curve to assess operating point and efficiency.
   */
  pumpHead?: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
};

/**
 * JSON plot/curve file references per well string from WF12.
 *
 * Contains file pointers to specialised JSON curve outputs generated during
 * ESP and motor performance diagnostics (WF12). Covers the gradient plot
 * (pressure vs depth) produced by the ESP model run. All files are JSON and
 * cannot be represented as scalar timeseries values.
 *
 * Use with ESPMeasurements_String_Agent and ESPCalculations_String_Agent for
 * full WF12 ESP diagnostics including live sensor data and calculated outputs.
 *
 * Use for: ESP and Motor Performance and Diagnostics (WF12).
 *
 * @name ESP Curve Data - String (Agent)
 */
export type EspCurveDataStringAgent = {
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
};

/**
 * ESP operating limit thresholds per well string (WF12).
 *
 * Engineering limits: motor temp/current/power, pump delta-T, fluid rates,
 * intake/discharge pressures, head, free gas tolerance, monitoring flags.
 * Compare against ESPMeasurements_String_Agent for limit exceedances. For gas lift use GasLiftLimits_String_Agent.
 *
 * Use for: ESP and Motor Performance and Diagnostics (WF12).
 *
 * @name ESP Operating Limits - Well String (Agent)
 */
export type EspLimitsStringAgent = {
  /** Asphaltene deposition risk flag or score for this well string. */
  asphalteneRisk?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum discharge pressure limit (psia, TS). Exceeding may cause mechanical overload. */
  espMaxDischargePressure?: Maybe<TimeSeries>;
  /**
   * Maximum fluid rate pump can handle (stb/d, TS). Above this, pump
   * experiences upthrust and shaft wear.
   */
  espMaxFluidRate?: Maybe<TimeSeries>;
  /**
   * Maximum free gas the pump can tolerate (%, TS). High gas causes gas
   * locking and damage â€” use gas separator if exceeded.
   */
  espMaxFreeGasInPump?: Maybe<TimeSeries>;
  /** Maximum head the pump can develop (ft, TS). Exceeding causes mechanical overload. */
  espMaxHead?: Maybe<TimeSeries>;
  /**
   * Maximum allowable motor current (amps, TS). When pumpCurrent exceeds this,
   * motor is overloaded â€” indicates undersized pump or high head conditions.
   */
  espMaxMotorAmps?: Maybe<TimeSeries>;
  /** Boolean flag â€” espMaxMotorAmps limit is actively monitored for alarms. */
  espMaxMotorAmps_active?: Maybe<TimeSeries>;
  /** Maximum motor power limit (HP or kW, TS). Used to size VSD and cables. */
  espMaxMotorPwr?: Maybe<TimeSeries>;
  /**
   * Maximum allowable motor temperature (Â°F, TS). When pumpMotorTemp exceeds
   * this, motor damage risk is high. Critical alarm threshold.
   */
  espMaxMotorTemp?: Maybe<TimeSeries>;
  /** Boolean flag â€” espMaxMotorTemp limit is actively monitored for alarms. */
  espMaxMotorTemp_active?: Maybe<TimeSeries>;
  /**
   * Maximum temperature rise across pump (Â°F, TS). High delta-T indicates low
   * flow â€” motor not adequately cooled by fluid.
   */
  espMaxPumpDeltaTemp?: Maybe<TimeSeries>;
  /**
   * Minimum fluid rate for stable operation (stb/d, TS). Below this, pump may
   * experience downthrust and motor overheating.
   */
  espMinFluidRate?: Maybe<TimeSeries>;
  /**
   * Minimum intake pressure limit (psia, TS). Below this, gas breakout causes
   * cavitation and pump damage. Critical operating limit.
   */
  espMinIntakePressure?: Maybe<TimeSeries>;
  /** Boolean flag â€” espMinIntakePressure limit is actively monitored for alarms. */
  espMinIntakePressure_active?: Maybe<TimeSeries>;
  /** Fluid velocity limit or reference value (ft/s, TS). Used for erosion and flow assurance checks. */
  fluidVelocity?: Maybe<Scalars['Boolean']['output']>;
  /** Hydrate formation risk flag or score for this well string. */
  hydrateRisk?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum GOR limit (scf/stb, TS). High GOR may indicate gas breakthrough or lift issues. */
  maxGOR?: Maybe<TimeSeries>;
  /** Maximum liquid rate limit (stb/d, TS). Facility or well capacity constraint. */
  maxLiquidRate?: Maybe<TimeSeries>;
  /** Maximum oil rate limit (stb/d, TS). Allocation or facility constraint. */
  maxOilRate?: Maybe<TimeSeries>;
  /** PE5 flow stability criteria threshold for this well string. */
  pe5StabilityCriteria?: Maybe<Scalars['Boolean']['output']>;
  /** Wax deposition risk flag or score for this well string. */
  waxRisk?: Maybe<Scalars['Boolean']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
};

/**
 * Real-time ESP sensor readings per well string (WF12).
 *
 * Live measurements: pump frequency, intake/discharge pressures and temperatures,
 * motor current, voltage, vibration, downhole BHP/BHT. Use to monitor pump health
 * and compare against ESPLimits_String_Agent. For calculated outputs see ESPCalculations_String_Agent.
 *
 * Use for: ESP and Motor Performance and Diagnostics (WF12).
 *
 * @name ESP Measurements - Well String (Agent)
 */
export type EspMeasurementsStringAgent = {
  /** Annulus pressure (psia, TS). Difference from casingHeadPress can indicate tubing leaks. */
  annulusPress?: Maybe<TimeSeries>;
  /**
   * Bottom-hole flowing pressure (psia, TS). Used to calculate drawdown and
   * compare to reservoir pressure for productivity analysis.
   */
  bottomHolePress?: Maybe<TimeSeries>;
  /** Bottom-hole temperature (Â°F, TS). Important for PVT and pump performance calculations. */
  bottomHoleTemp?: Maybe<TimeSeries>;
  /** Casing head pressure (psia, TS). Surface annulus pressure; useful for well integrity and flow context. */
  casingHeadPress?: Maybe<TimeSeries>;
  /** Production choke opening (% or 64ths, TS). Affects backpressure on well and ESP discharge. */
  chokeOpening?: Maybe<TimeSeries>;
  /** Choke size (64ths or mm, TS). With wellhead pressure defines backpressure and rate. */
  chokeSize?: Maybe<TimeSeries>;
  /** Flowline pressure (psia, TS). Downstream backpressure on ESP; high value can indicate restriction or manifold pressure. */
  flowLinePress?: Maybe<TimeSeries>;
  /** Flowline temperature (Â°F, TS). Surface fluid temp; compare to wellHeadTemp for heat loss. */
  flowLineTemp?: Maybe<TimeSeries>;
  /** Artificial lift type (TS). Confirm value = ESP before querying ESP-specific diagnostics. */
  liftType?: Maybe<TimeSeries>;
  /**
   * Motor current draw (amps, TS). Indicates motor loading. Compare to
   * espMaxMotorAmps limit â€” overload causes overheating and potential failure.
   */
  pumpCurrent?: Maybe<TimeSeries>;
  /**
   * Pressure at pump discharge (psia, TS). Differential with intake shows pump
   * head. Compare to espMaxDischargePressure limit.
   */
  pumpDischargePress?: Maybe<TimeSeries>;
  /**
   * Temperature at pump discharge (Â°F, TS). High delta-T (discharge - intake)
   * may indicate low flow. Compare to espMaxPumpDeltaTemp.
   */
  pumpDischargeTemp?: Maybe<TimeSeries>;
  /**
   * ESP pump operating frequency (Hz, TS). Controlled by VSD. Compare to design
   * frequency for speed-related diagnostics.
   */
  pumpFrequency?: Maybe<TimeSeries>;
  /**
   * Pressure at pump intake (psia, TS). Low intake pressure may indicate gas
   * interference or upthrust condition. Compare to espMinIntakePressure limit.
   */
  pumpIntakePress?: Maybe<TimeSeries>;
  /** Temperature at pump intake (Â°F, TS). Fluid cools the motor â€” low temp with high motor temp indicates poor cooling. */
  pumpIntakeTemp?: Maybe<TimeSeries>;
  /**
   * ESP motor winding temperature (Â°F, TS). CRITICAL for motor protection.
   * Compare to espMaxMotorTemp limit â€” exceeding causes insulation damage.
   */
  pumpMotorTemp?: Maybe<TimeSeries>;
  /**
   * Vibration sensor reading (TS). High vibration indicates mechanical issues:
   * worn bearings, shaft misalignment, or gas slugging through pump.
   */
  pumpVibration?: Maybe<TimeSeries>;
  /** Surface voltage supplied to ESP (volts, TS). Low voltage causes high current and overheating. */
  pumpVoltage?: Maybe<TimeSeries>;
  /** Flowing wellhead pressure (psia, TS). Tubing head pressure; compare with intake/discharge for pump head. */
  wellHeadPress?: Maybe<TimeSeries>;
  /** Flowing wellhead temperature (Â°F, TS). Surface fluid temp; useful for flow assurance and pump cooling context. */
  wellHeadTemp?: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
};

/** Electric submersible pump (ESP) equipment, configuration, and operating constraints, including motor, cable, controller, and stage design parameters used in production optimization and surveillance. */
export type EspMotor = {
  /** Numeric value storing current for this entity, used in calculations, reporting, or model configuration. */
  current?: Maybe<Scalars['Float']['output']>;
  /** Free-text description providing engineering context, assumptions, or clarifications about this entity or the associated signal, used to support interpretation and troubleshooting. */
  description?: Maybe<Scalars['String']['output']>;
  /** Manufacturer attribute describing this entity in more detail, often derived from master data or configuration tables. */
  manufacturer?: Maybe<Scalars['String']['output']>;
  /** Motor Series attribute describing this entity in more detail, often derived from master data or configuration tables. */
  motorSeries?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing power for this entity, used in calculations, reporting, or model configuration. */
  power?: Maybe<Scalars['Float']['output']>;
  /** Numeric value storing prosper index for this entity, used in calculations, reporting, or model configuration. */
  prosperIndex?: Maybe<Scalars['Int64']['output']>;
  /** Numeric value storing voltage for this entity, used in calculations, reporting, or model configuration. */
  voltage?: Maybe<Scalars['Float']['output']>;
};

/** Electric submersible pump (ESP) equipment, configuration, and operating constraints, including motor, cable, controller, and stage design parameters used in production optimization and surveillance. */
export type EspPump = {
  /** Free-text description providing engineering context, assumptions, or clarifications about this entity or the associated signal, used to support interpretation and troubleshooting. */
  description?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing frequency for this entity, used in calculations, reporting, or model configuration. */
  frequency?: Maybe<Scalars['Float']['output']>;
  /** Manufacturer attribute describing this entity in more detail, often derived from master data or configuration tables. */
  manufacturer?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing maximum rate for this entity, used in calculations, reporting, or model configuration. */
  maximumRate?: Maybe<Scalars['Float']['output']>;
  /** Numeric value storing minimum rate for this entity, used in calculations, reporting, or model configuration. */
  minimumRate?: Maybe<Scalars['Float']['output']>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  name?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing prosper index for this entity, used in calculations, reporting, or model configuration. */
  prosperIndex?: Maybe<Scalars['Int64']['output']>;
  /** Numeric value storing pump size for this entity, used in calculations, reporting, or model configuration. */
  pumpSize?: Maybe<Scalars['Float']['output']>;
  /** Numeric value storing stages for this entity, used in calculations, reporting, or model configuration. */
  stages?: Maybe<Scalars['Int']['output']>;
};

/** Electric submersible pump (ESP) equipment, configuration, and operating constraints, including motor, cable, controller, and stage design parameters used in production optimization and surveillance. */
export type EspPumpDetails = {
  /** Numeric value storing adco installation for this entity, used in calculations, reporting, or model configuration. */
  adcoInstallation?: Maybe<Scalars['Float32']['output']>;
  /** Agh Matl attribute describing this entity in more detail, often derived from master data or configuration tables. */
  aghMatl?: Maybe<Scalars['String']['output']>;
  /** Agh Model attribute describing this entity in more detail, often derived from master data or configuration tables. */
  aghModel?: Maybe<Scalars['String']['output']>;
  /** Agh n ORu attribute describing this entity in more detail, often derived from master data or configuration tables. */
  agh_nORu?: Maybe<Scalars['String']['output']>;
  /** Boh Matl attribute describing this entity in more detail, often derived from master data or configuration tables. */
  bohMatl?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing boh series for this entity, used in calculations, reporting, or model configuration. */
  bohSeries?: Maybe<Scalars['Float32']['output']>;
  /** Boh Thd attribute describing this entity in more detail, often derived from master data or configuration tables. */
  bohThd?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing cable size for this entity, used in calculations, reporting, or model configuration. */
  cableSize?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing cable total length for this entity, used in calculations, reporting, or model configuration. */
  cableTotalLength?: Maybe<Scalars['Float32']['output']>;
  /** Cable Type attribute describing this entity in more detail, often derived from master data or configuration tables. */
  cableType?: Maybe<Scalars['String']['output']>;
  /** Cable n ORu attribute describing this entity in more detail, often derived from master data or configuration tables. */
  cable_nORu?: Maybe<Scalars['String']['output']>;
  /** Free-text comments field capturing operator or engineer notes related to this measurement, configuration, or event. */
  comments?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing commission date for this entity in the production optimization context. */
  commissionDate?: Maybe<Scalars['Timestamp']['output']>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Esp Component attribute describing this entity in more detail, often derived from master data or configuration tables. */
  espComponent?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing esp sensor depth md ft for this entity, used in calculations, reporting, or model configuration. */
  espSensorDepth_MD_ft?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing esp sensor depth tvd ft for this entity, used in calculations, reporting, or model configuration. */
  espSensorDepth_TVD_ft?: Maybe<Scalars['Float32']['output']>;
  /** Field attribute describing this entity in more detail, often derived from master data or configuration tables. */
  field?: Maybe<Field>;
  /** Intake Vgsa Matl attribute describing this entity in more detail, often derived from master data or configuration tables. */
  intakeVgsaMatl?: Maybe<Scalars['String']['output']>;
  /** Intake Vgsa Model attribute describing this entity in more detail, often derived from master data or configuration tables. */
  intakeVgsaModel?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing intake vgsa series for this entity, used in calculations, reporting, or model configuration. */
  intakeVgsaSeries?: Maybe<Scalars['Float32']['output']>;
  /** Intake Vgsa n ORu attribute describing this entity in more detail, often derived from master data or configuration tables. */
  intakeVgsa_nORu?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing mle for this entity, used in calculations, reporting, or model configuration. */
  mle?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing mle series for this entity, used in calculations, reporting, or model configuration. */
  mleSeries?: Maybe<Scalars['Float32']['output']>;
  /** Mle Type attribute describing this entity in more detail, often derived from master data or configuration tables. */
  mleType?: Maybe<Scalars['String']['output']>;
  /** Monitor Type attribute describing this entity in more detail, often derived from master data or configuration tables. */
  monitorType?: Maybe<Scalars['String']['output']>;
  /** Monitor n ORu attribute describing this entity in more detail, often derived from master data or configuration tables. */
  monitor_nORu?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing motor a for this entity, used in calculations, reporting, or model configuration. */
  motorA?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing motor hsg for this entity, used in calculations, reporting, or model configuration. */
  motorHsg?: Maybe<Scalars['Float32']['output']>;
  /** Motor Matl attribute describing this entity in more detail, often derived from master data or configuration tables. */
  motorMatl?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing motor ref w for this entity, used in calculations, reporting, or model configuration. */
  motorRefW?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing motor series for this entity, used in calculations, reporting, or model configuration. */
  motorSeries?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing motor total power for this entity, used in calculations, reporting, or model configuration. */
  motorTotalPower?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing motor total v for this entity, used in calculations, reporting, or model configuration. */
  motorTotalV?: Maybe<Scalars['Float32']['output']>;
  /** Motor n ORu attribute describing this entity in more detail, often derived from master data or configuration tables. */
  motor_nORu?: Maybe<Scalars['String']['output']>;
  /** N ORu attribute describing this entity in more detail, often derived from master data or configuration tables. */
  nORu?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing number of poles for this entity, used in calculations, reporting, or model configuration. */
  numberOfPoles?: Maybe<Scalars['Int']['output']>;
  /** Packer attribute describing this entity in more detail, often derived from master data or configuration tables. */
  packer?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing panel vsd a for this entity, used in calculations, reporting, or model configuration. */
  panelVsdA?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing panel vsd kva for this entity, used in calculations, reporting, or model configuration. */
  panelVsdKVA?: Maybe<Scalars['Float32']['output']>;
  /** Panel Vsd Type attribute describing this entity in more detail, often derived from master data or configuration tables. */
  panelVsdType?: Maybe<Scalars['String']['output']>;
  /** Protector Matl attribute describing this entity in more detail, often derived from master data or configuration tables. */
  protectorMatl?: Maybe<Scalars['String']['output']>;
  /** Protector Model attribute describing this entity in more detail, often derived from master data or configuration tables. */
  protectorModel?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing protector series for this entity, used in calculations, reporting, or model configuration. */
  protectorSeries?: Maybe<Scalars['Float32']['output']>;
  /** Protector n ORu attribute describing this entity in more detail, often derived from master data or configuration tables. */
  protector_nORu?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing pull date for this entity in the production optimization context. */
  pullDate?: Maybe<Scalars['Timestamp']['output']>;
  /** Pull Reason attribute describing this entity in more detail, often derived from master data or configuration tables. */
  pullReason?: Maybe<Scalars['String']['output']>;
  /** Pump Ar attribute describing this entity in more detail, often derived from master data or configuration tables. */
  pumpAr?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing pump hsg for this entity, used in calculations, reporting, or model configuration. */
  pumpHsg?: Maybe<Scalars['Float32']['output']>;
  /** Pump Matl attribute describing this entity in more detail, often derived from master data or configuration tables. */
  pumpMatl?: Maybe<Scalars['String']['output']>;
  /** Pump Model attribute describing this entity in more detail, often derived from master data or configuration tables. */
  pumpModel?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing pump series for this entity, used in calculations, reporting, or model configuration. */
  pumpSeries?: Maybe<Scalars['Float32']['output']>;
  /** Pump n ORu attribute describing this entity in more detail, often derived from master data or configuration tables. */
  pump_nORu?: Maybe<Scalars['String']['output']>;
  /** Root Cause attribute describing this entity in more detail, often derived from master data or configuration tables. */
  rootCause?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing run date for this entity in the production optimization context. */
  runDate?: Maybe<Scalars['Timestamp']['output']>;
  /** Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  status?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing stop orfailure date for this entity in the production optimization context. */
  stopORfailureDate?: Maybe<Scalars['Timestamp']['output']>;
  /** Supply Company attribute describing this entity in more detail, often derived from master data or configuration tables. */
  supplyCompany?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing tol md for this entity, used in calculations, reporting, or model configuration. */
  tol_MD?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing tol tvd for this entity, used in calculations, reporting, or model configuration. */
  tol_TVD?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing top reservoir depth md for this entity, used in calculations, reporting, or model configuration. */
  topReservoirDepth_MD?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing top reservoir depth tvd for this entity, used in calculations, reporting, or model configuration. */
  topReservoirDepth_TVD?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing total stages for this entity, used in calculations, reporting, or model configuration. */
  totalStages?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing transformer a for this entity, used in calculations, reporting, or model configuration. */
  transformerA?: Maybe<Scalars['Float32']['output']>;
  /** Free-text comments field capturing operator or engineer notes related to this measurement, configuration, or event. */
  transformerComments?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing transformer kva for this entity, used in calculations, reporting, or model configuration. */
  transformerKVA?: Maybe<Scalars['Float32']['output']>;
  /** Transformer Tap Setting attribute describing this entity in more detail, often derived from master data or configuration tables. */
  transformerTapSetting?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing transformer voltage ratio for this entity, used in calculations, reporting, or model configuration. */
  transformerVoltageRatio?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing well installation number for this entity, used in calculations, reporting, or model configuration. */
  wellInstallationNumber?: Maybe<Scalars['Float32']['output']>;
  /** Y Tool attribute describing this entity in more detail, often derived from master data or configuration tables. */
  yTool?: Maybe<Scalars['String']['output']>;
};

/** Base view for all logical entities in the iPSO solution (company, asset, field, reservoir, location, well, string, etc.). Other views like 'Well', 'Field', 'Reservoir' and 'String_asset' filter this view by 'entityType' and should be preferred for traversal and querying rather than using 'Entity' directly. */
export type Entity = {
  /** Attribute capturing end date time for this entity in the production optimization context. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Entity Type attribute describing this entity in more detail, often derived from master data or configuration tables. */
  entityType?: Maybe<Scalars['String']['output']>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  name?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing start date time for this entity in the production optimization context. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
};

/**
 * Base entity registry â€” companies, assets, fields, reservoirs, sectors,
 * locations, wells, and strings â€” scoped to in-scope instance spaces.
 *
 * Single catalogue of every logical entity in the iPSO model with its display
 * name, type, and effective date range. Underpins the hierarchy and per-entity
 * views; sourced from the central entity repository. Excludes operational or
 * measurement data.
 *
 * @name Entity (Agent Scoped)
 */
export type EntityAgent = {
  /** Timestamp at which the entity was deactivated. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Type of entity. Values are company, asset, field, reservoir, sector, location, well, string. */
  entityType?: Maybe<Scalars['String']['output']>;
  /** Display name of the entity. */
  name?: Maybe<Scalars['String']['output']>;
  /** Timestamp at which the entity became active. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
};

/**
 * All estimated rates and BHP per well string across every estimation method.
 *
 * For simple rate lookups use PriorityRates_String_Agent. Use this view when
 * comparing estimation methods. Exposes priority, system analysis (IPR+VLP),
 * choke, IPR-only, VLP-only, performance curve, and data-driven/ML. For
 * performance scores and analysis status see RateDiagnostics_String_Agent.
 *
 * Use for: comparing estimation methods (WF10).
 *
 * @name Estimated Rates - Well String (Agent)
 */
export type EstimatedRatesStringAgent = {
  /** Flowing bottom-hole pressure from choke analysis (psi, TS). */
  chokeAnalysisFbhp?: Maybe<TimeSeries>;
  /** Gas rate from choke equation analysis (MSCF/d, TS). */
  chokeAnalysisGasRateStd?: Maybe<TimeSeries>;
  /** Total liquid rate from choke equation analysis, oil + water (stb/d, TS). */
  chokeAnalysisLiquidRateStd?: Maybe<TimeSeries>;
  /** Oil rate from choke equation analysis (stb/d, TS). */
  chokeAnalysisOilRateStd?: Maybe<TimeSeries>;
  /** Choke analysis calculation status. Values: SUCCESS, FAILED, CRITICAL_FLOW, SUBCRITICAL_FLOW. */
  chokeAnalysisStatus?: Maybe<TimeSeries>;
  /** Water rate from choke equation analysis (stb/d, TS). */
  chokeAnalysisWaterRateStd?: Maybe<TimeSeries>;
  /** Flowing BHP from performance curve analysis (psi, TS). */
  curveAnalysisFbhp?: Maybe<TimeSeries>;
  /** Gas rate from performance curve analysis (MSCF/d, TS). */
  curveAnalysisGasRateStd?: Maybe<TimeSeries>;
  /** Total liquid rate from performance curve lookup (stb/d, TS). */
  curveAnalysisLiquidRateStd?: Maybe<TimeSeries>;
  /** Oil rate from performance curve lookup (stb/d, TS). */
  curveAnalysisOilRateStd?: Maybe<TimeSeries>;
  /** Water rate from performance curve analysis (stb/d, TS). */
  curveAnalysisWaterRateStd?: Maybe<TimeSeries>;
  /** Flowing BHP from data-driven analysis / ML models (psi, TS). */
  dataAnalysisFbhp?: Maybe<TimeSeries>;
  /** Gas rate from data-driven analysis / ML models (MSCF/d, TS). */
  dataAnalysisGasRateStd?: Maybe<TimeSeries>;
  /** Total liquid rate from data-driven analysis / ML models (stb/d, TS). */
  dataAnalysisLiquidRateStd?: Maybe<TimeSeries>;
  /** Oil rate from data-driven analysis / ML models (stb/d, TS). */
  dataAnalysisOilRateStd?: Maybe<TimeSeries>;
  /** Water rate from data-driven analysis / ML models (stb/d, TS). */
  dataAnalysisWaterRateStd?: Maybe<TimeSeries>;
  /** Flowing BHP used for IPR curve lookup (psi, TS). */
  iprAnalysisFbhp?: Maybe<TimeSeries>;
  /** Gas rate from IPR curve analysis (MSCF/d, TS). */
  iprAnalysisGasRateStd?: Maybe<TimeSeries>;
  /** Total liquid rate from IPR curve. Represents reservoir deliverability potential (stb/d, TS). */
  iprAnalysisLiquidRateStd?: Maybe<TimeSeries>;
  /** Oil rate from IPR curve at current reservoir/flowing conditions (stb/d, TS). */
  iprAnalysisOilRateStd?: Maybe<TimeSeries>;
  /** Water rate from IPR curve analysis (stb/d, TS). */
  iprAnalysisWaterRateStd?: Maybe<TimeSeries>;
  /** Source of the BHP value. Values: MEASURED (downhole gauge), CALCULATED (from WHP traverse), ESTIMATED (correlation). */
  pressureSource?: Maybe<TimeSeries>;
  /** Best-available flowing bottom-hole pressure from the priority method (psi, TS). */
  priorityFbhp?: Maybe<TimeSeries>;
  /** Best-available estimated gas rate from the priority analysis method (MSCF/d, TS). */
  priorityGasRateStd?: Maybe<TimeSeries>;
  /** Best-available estimated total liquid rate, oil + water (stb/d, TS). */
  priorityLiquidRateStd?: Maybe<TimeSeries>;
  /** Analysis method that produced the priority rates. Values: SYSTEM_ANALYSIS, CHOKE_ANALYSIS, ALLOCATION, WELL_TEST, DATA_ANALYSIS. */
  priorityMethod?: Maybe<TimeSeries>;
  /** Best-available estimated oil rate from the priority analysis method (stb/d, TS). */
  priorityOilRateStd?: Maybe<TimeSeries>;
  /** Best-available estimated water rate from the priority analysis method (stb/d, TS). */
  priorityWaterRateStd?: Maybe<TimeSeries>;
  /** Current reservoir pressure at datum depth (psi, TS). */
  reservoirPressureDatum?: Maybe<TimeSeries>;
  /** Reservoir pressure corrected to mid-perforation depth. Used directly in IPR calculations (psi, TS). */
  reservoirPressureMidPerforation?: Maybe<TimeSeries>;
  /** Flowing bottom-hole pressure from system analysis (psi, TS). */
  systemAnalysisFbhp?: Maybe<TimeSeries>;
  /** Gas rate from IPR/VLP system analysis (MSCF/d, TS). */
  systemAnalysisGasRateStd?: Maybe<TimeSeries>;
  /** Total liquid rate from IPR/VLP system analysis, oil + water (stb/d, TS). */
  systemAnalysisLiquidRateStd?: Maybe<TimeSeries>;
  /** Oil rate from IPR/VLP system analysis (stb/d, TS). */
  systemAnalysisOilRateStd?: Maybe<TimeSeries>;
  /** System analysis calculation status. Values: SUCCESS, FAILED, NO_INTERSECTION, INVALID_INPUT. */
  systemAnalysisStatus?: Maybe<TimeSeries>;
  /** Water rate from IPR/VLP system analysis (stb/d, TS). */
  systemAnalysisWaterRateStd?: Maybe<TimeSeries>;
  /** Flowing BHP from VLP curve at current rate and WHP (psi, TS). */
  vlpAnalysisFbhp?: Maybe<TimeSeries>;
  /** Gas rate from VLP curve analysis (MSCF/d, TS). */
  vlpAnalysisGasRateStd?: Maybe<TimeSeries>;
  /** Total liquid rate from VLP curve. Represents tubing hydraulic capacity (stb/d, TS). */
  vlpAnalysisLiquidRateStd?: Maybe<TimeSeries>;
  /** Oil rate from VLP curve at current tubing/separator conditions (stb/d, TS). */
  vlpAnalysisOilRateStd?: Maybe<TimeSeries>;
  /** Water rate from VLP curve analysis (stb/d, TS). */
  vlpAnalysisWaterRateStd?: Maybe<TimeSeries>;
  /** Well string identifier. */
  wellString?: Maybe<StringAsset>;
};

/** Events String view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type EventsString = {
  /** Time series signal representing bottomhole pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  bottomholePressure?: Maybe<TimeSeries>;
  /** Time series signal representing bottomhole temperature for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  bottomholeTemperature?: Maybe<TimeSeries>;
  /** Time series signal representing casing pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  casingPressure?: Maybe<TimeSeries>;
  /** Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  currentStatus?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Time series signal representing event reason for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  eventReason?: Maybe<TimeSeries>;
  /** Time series signal representing event start date time for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  eventStartDateTime?: Maybe<TimeSeries>;
  /** Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  statusCode?: Maybe<TimeSeries>;
  /** Time series signal representing wellhead pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellheadPressure?: Maybe<TimeSeries>;
  /** Time series signal representing wellhead temperature for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellheadTemperature?: Maybe<TimeSeries>;
};

/** Typed view over 'Entity' showing fields only (where 'entityType' = 'field'). Use this view to identify a field by name, then navigate to its wells or strings through the 'FlatHierarchy' and 'SectorHierarchy' navigation views. */
export type Field = {
  /** Attribute capturing end date time for this field in the production optimization context. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Entity Type attribute describing this field in more detail, often derived from master data or configuration tables. */
  entityType?: Maybe<Scalars['String']['output']>;
  /** Name or label for this field, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  name?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing start date time for this field in the production optimization context. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
};

/** Field Formation view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type FieldFormation = {
  /** Numeric value storing datum depth for this field, used in calculations, reporting, or model configuration. */
  datumDepth?: Maybe<Scalars['Float32']['output']>;
  /** Field attribute describing this field in more detail, often derived from master data or configuration tables. */
  field?: Maybe<Field>;
  /** Numeric value storing gas gradient for this field, used in calculations, reporting, or model configuration. */
  gasGradient?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing gas oil contact for this field, used in calculations, reporting, or model configuration. */
  gasOilContact?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing gaswater contact for this field, used in calculations, reporting, or model configuration. */
  gaswaterContact?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing oil gradient for this field, used in calculations, reporting, or model configuration. */
  oilGradient?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing oil water contact for this field, used in calculations, reporting, or model configuration. */
  oilWaterContact?: Maybe<Scalars['Float32']['output']>;
  /** Reservoir attribute describing this field in more detail, often derived from master data or configuration tables. */
  reservoir?: Maybe<Reservoir>;
  /** Reservoir Type attribute describing this field in more detail, often derived from master data or configuration tables. */
  reservoirType?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing rw for this field, used in calculations, reporting, or model configuration. */
  rw?: Maybe<Scalars['Float32']['output']>;
  /** Attribute capturing start date time for this field in the production optimization context. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Attribute capturing stop date time for this field in the production optimization context. */
  stopDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Numeric value storing water gradient for this field, used in calculations, reporting, or model configuration. */
  waterGradient?: Maybe<Scalars['Float32']['output']>;
};

/** Field Inputs view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type FieldInputs = {
  /** Time series signal representing actual gas injection for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  actualGasInjection?: Maybe<TimeSeries>;
  /** Time series signal representing actual gas injection rate for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  actualGasInjectionRate?: Maybe<TimeSeries>;
  /** Time series signal representing actual gas production for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  actualGasProduction?: Maybe<TimeSeries>;
  /** Time series signal representing actual gas production rate for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  actualGasProductionRate?: Maybe<TimeSeries>;
  /** Time series signal representing actual oil production for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  actualOilProduction?: Maybe<TimeSeries>;
  /** Time series signal representing actual oil production rate for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  actualOilProductionRate?: Maybe<TimeSeries>;
  /** Time series signal representing actual water injection for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  actualWaterInjection?: Maybe<TimeSeries>;
  /** Time series signal representing actual water injection rate for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  actualWaterInjectionRate?: Maybe<TimeSeries>;
  /** Time series signal representing actual water production for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  actualWaterProduction?: Maybe<TimeSeries>;
  /** Time series signal representing actual water production rate for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  actualWaterProductionRate?: Maybe<TimeSeries>;
  /** Time series signal representing ambient temperature for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  ambientTemperature?: Maybe<TimeSeries>;
  /** Time series signal representing associated gas production for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  associatedGasProduction?: Maybe<TimeSeries>;
  /** Time series signal representing associated gas production rate for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  associatedGasProductionRate?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Field>;
  /** Time series signal representing non asrgas injection for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  nonASRGasInjection?: Maybe<TimeSeries>;
  /** Time series signal representing non asrgas injection rate for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  nonASRGasInjectionRate?: Maybe<TimeSeries>;
  /** Time series signal representing non associated gas production for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  nonAssociatedGasProduction?: Maybe<TimeSeries>;
  /** Time series signal representing non associated gas production rate for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  nonAssociatedGasProductionRate?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this field, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialGasInjection?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this field, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialGasProduction?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this field, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialOilProduction?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this field, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialWaterInjection?: Maybe<TimeSeries>;
  /** Unconstrained potential production or injection capacity for this field, representing what could be achieved with no system limitations and used as a benchmark against actual and target performance. */
  potentialWaterProduction?: Maybe<TimeSeries>;
  /** Target value for this field defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetGasInjection?: Maybe<TimeSeries>;
  /** Target value for this field defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetGasProduction?: Maybe<TimeSeries>;
  /** Target value for this field defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetOilProduction?: Maybe<TimeSeries>;
  /** Target value for this field defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetWaterInjection?: Maybe<TimeSeries>;
  /** Target value for this field defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  targetWaterProduction?: Maybe<TimeSeries>;
};

/** Aggregated field-level outputs including counts of active and inactive wells by lift type and service (producers, gas injectors, water injectors, WAG wells) used for monitoring field performance and optimization decisions. */
export type FieldOutputs = {
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Field>;
  /** Time series signal representing wells active gi for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsActiveGi?: Maybe<TimeSeries>;
  /** Time series signal representing wells active gp nf for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsActiveGpNf?: Maybe<TimeSeries>;
  /** Time series signal representing wells active op esp for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsActiveOpEsp?: Maybe<TimeSeries>;
  /** Time series signal representing wells active op gl for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsActiveOpGl?: Maybe<TimeSeries>;
  /** Time series signal representing wells active op nf for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsActiveOpNf?: Maybe<TimeSeries>;
  /** Time series signal representing wells active wag for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsActiveWAG?: Maybe<TimeSeries>;
  /** Time series signal representing wells active wi for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsActiveWi?: Maybe<TimeSeries>;
  /** Time series signal representing wells in active gi for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsInActiveGi?: Maybe<TimeSeries>;
  /** Time series signal representing wells in active gp nf for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsInActiveGpNf?: Maybe<TimeSeries>;
  /** Time series signal representing wells in active op esp for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsInActiveOpEsp?: Maybe<TimeSeries>;
  /** Time series signal representing wells in active op gl for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsInActiveOpGl?: Maybe<TimeSeries>;
  /** Time series signal representing wells in active op nf for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsInActiveOpNf?: Maybe<TimeSeries>;
  /** Time series signal representing wells in active wi for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsInActiveWi?: Maybe<TimeSeries>;
  /** Time series signal representing wells inactive wag for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsInactiveWAG?: Maybe<TimeSeries>;
};

/**
 * DENORMALIZED HIERARCHY LOOKUP TABLE - Primary view for navigating the asset hierarchy.
 *
 * STRUCTURE: Each row = one String (completion) with all its parent entities pre-joined.
 * Hierarchy: Company → Asset → Field → Reservoir/Location → Well → String
 *
 * WHY USE THIS: Avoids complex multi-hop joins. Query ANY hierarchy relationship in a single step.
 *
 * QUERY PATTERNS:
 * - Find wells in a field: Filter field.name = 'X', select well
 * - Find strings in a reservoir: Filter reservoir.name = 'Y', select string
 * - Find fields in an asset: Filter asset.name = 'A', select DISTINCT field
 * - Find parent of any entity: Filter on child, select parent property
 *
 * KEY BEHAVIORS:
 * - One row per string means parent entities repeat (use DISTINCT for unique parents)
 * - References return full entity objects - access .name, .externalId, etc.
 * - Use startDateTime/endDateTime for historical hierarchy lookups
 */
export type FlatHierarchy = {
  /** Operating concession or business unit. Groups multiple fields. Filter here to scope queries to a specific asset. */
  asset?: Maybe<Asset>;
  /** Top-level parent entity (e.g., ADNOC ONSHORE, ADNOC OFFSHORE). Access company.name for the company name. */
  company?: Maybe<Company>;
  /** When this hierarchy relationship ended. NULL = currently active. For current hierarchy only, filter where endDateTime is null. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Oil/gas field containing the well. Common filter target for field-level queries. Each field contains multiple wells and reservoirs. */
  field?: Maybe<Field>;
  /** Surface infrastructure where the well connects (platform, manifold, drilling island, or onshore facility). Filter here to find all wells at a specific location. */
  location?: Maybe<Location>;
  /** Subsurface reservoir formation the string produces from. Multiple strings can target the same reservoir. Filter here to analyze reservoir-level production. */
  reservoir?: Maybe<Reservoir>;
  /** When this hierarchy relationship became effective. Used for temporal queries when hierarchy changes over time (e.g., well transferred between fields). */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Completion/producing interval within the well. The LEAF ENTITY of this view - each row represents exactly one string. This is the entity that has production data (oil, gas, water rates). Use string.name for string identifier. */
  string?: Maybe<StringAsset>;
  /** Physical wellbore containing this string. A well may have multiple strings (completions). Use well.name for well identifier. Filter here to find all strings in a specific well. */
  well?: Maybe<Well>;
};

/**
 * Flattened company â†’ asset â†’ field â†’ reservoir â†’ location â†’ well â†’ string
 * hierarchy, scoped to in-scope assets.
 *
 * One row per string with its full ancestry across the production hierarchy
 * and the effective date range of that relationship. Sourced from the base
 * FlatHierarchy and refined via the in_scope_asset_node_refs configuration.
 * Excludes operational or measurement data.
 *
 * @name FlatHierarchy (Agent Scoped)
 */
export type FlatHierarchyAgent = {
  /** Operating concession or business unit. */
  asset?: Maybe<Asset>;
  /** Top-level parent entity, e.g. ADNOC ONSHORE, ADNOC OFFSHORE. */
  company?: Maybe<Company>;
  /** Timestamp at which this hierarchy relationship ended. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Oil or gas field containing the well. */
  field?: Maybe<Field>;
  /** Surface infrastructure where the well connects, such as cluster, platform, manifold, drilling island, or onshore facility. */
  location?: Maybe<Location>;
  /** Subsurface reservoir formation the string produces from. */
  reservoir?: Maybe<Reservoir>;
  /** Timestamp at which this hierarchy relationship became effective. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Completion or producing interval within the well. Leaf entity of this view; one row per string. */
  string?: Maybe<StringAsset>;
  /** Physical wellbore. A well may contain multiple strings. */
  well?: Maybe<Well>;
};

/**
 * Flow assurance detection and mitigation alarms with medium or high priority.
 *
 * Contains flow assurance alarms, medium or high priority, sourced from
 * operational monitoring systems within petroleum production environments.
 * Answers questions on the frequency, duration, and types of alarms triggered,
 * to assess mitigation and prioritize responses. Excludes low-priority or non-WF20 alarms.
 *
 * Use for: Flow Assurance Detection and Mitigation (WF20), Real-Time Surveillance (WF18).
 *
 * @name Flow Assurance Alarms (Agent)
 */
export type FlowAssuranceAlarmsAgent = {
  alarmCategory?: Maybe<Scalars['String']['output']>;
  alarmCode?: Maybe<Scalars['JSONObject']['output']>;
  alarmCodeExternalId?: Maybe<Scalars['String']['output']>;
  alarmCriticality?: Maybe<Scalars['String']['output']>;
  alarmFlags?: Maybe<Scalars['String']['output']>;
  alarmName?: Maybe<Scalars['String']['output']>;
  alarmPriority?: Maybe<Scalars['String']['output']>;
  customWorkflowAlarmMessage?: Maybe<Scalars['String']['output']>;
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  entityExternalId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  startDateTime: Scalars['Timestamp']['output'];
  subCategory?: Maybe<Scalars['String']['output']>;
  subWorkflowName?: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
  workflowCode?: Maybe<Scalars['String']['output']>;
  workflowName?: Maybe<Scalars['String']['output']>;
};

/**
 * Flowline-level outputs from GAP network simulation (WF20).
 *
 * Pressure drops, flow rates, erosion/corrosion metrics per flowline. Use for
 * flowline performance, constraints, and failure points. Excludes historical or real-time time-series.
 *
 * Use for: Flow Assurance Detection and Mitigation (WF20).
 *
 * @name Flowline Outputs - Network (Agent)
 */
export type FlowlineOutputsNetworkAgent = {
  /** Connected manifold for gas injection path. */
  connectedManifoldIdGI?: Maybe<TimeSeries>;
  /** Connected manifold for water injection path. */
  connectedManifoldIdWI?: Maybe<TimeSeries>;
  /** Flowline entity name. */
  entityName?: Maybe<Entity>;
  /** Estimated pressure drop across flowline (TS). */
  estimatedFlowlineDeltaP?: Maybe<TimeSeries>;
  /** Reference to parent network model. */
  network?: Maybe<Network>;
  /** Above erosion velocity threshold (0/1, TS). */
  nmvAboveErosionVelocity?: Maybe<TimeSeries>;
  /** Asphaltene deposition risk (0/1, TS). */
  nmvAsphalteneFlag?: Maybe<TimeSeries>;
  /** Flowline identified as production bottleneck (0/1, TS). */
  nmvBottleneckFlag?: Maybe<TimeSeries>;
  /** C-factor for inflow performance (TS). */
  nmvCFactor?: Maybe<TimeSeries>;
  /** Condensate-gas ratio (TS). */
  nmvCgr?: Maybe<TimeSeries>;
  /** ID of connected production manifold/junction. */
  nmvConnectedManifoldId?: Maybe<TimeSeries>;
  /** Differential pressure across flowline (TS). */
  nmvDp?: Maybe<TimeSeries>;
  /** Erosion velocity ratio (TS). >1 = exceeds erosion limit. */
  nmvErosionVelocity?: Maybe<TimeSeries>;
  /** Erosional velocity limit flag (0/1, TS). */
  nmvErosionalVelocityFlag?: Maybe<TimeSeries>;
  /** Simulated flowline outlet pressure (TS). */
  nmvFlowlinePressure?: Maybe<TimeSeries>;
  /** Gas flow rate through flowline (TS). */
  nmvGasRate?: Maybe<TimeSeries>;
  /** Gas-liquid ratio (TS). */
  nmvGlr?: Maybe<TimeSeries>;
  /** Gas-oil ratio (TS). */
  nmvGor?: Maybe<TimeSeries>;
  /** Hydrate formation risk (0/1, TS). */
  nmvHydrateFlag?: Maybe<TimeSeries>;
  /** Gas injection flow rate through flowline (TS). */
  nmvInjectionGasRate?: Maybe<TimeSeries>;
  /** Water injection flow rate through flowline (TS). */
  nmvInjectionWaterRate?: Maybe<TimeSeries>;
  /** Total liquid flow rate through flowline (TS). */
  nmvLiquidRate?: Maybe<TimeSeries>;
  /** Measured flowline pressure for comparison to simulated (TS). */
  nmvMeasuredFlowlinePressure?: Maybe<TimeSeries>;
  /** Mixture velocity in flowline (TS). */
  nmvMixtureVelocity?: Maybe<TimeSeries>;
  /** Oil flow rate through flowline (TS). */
  nmvOilRate?: Maybe<TimeSeries>;
  /** PE5 flow stability indicator (0/1, TS). 1 = stable. */
  nmvPe5StabilityFlag?: Maybe<TimeSeries>;
  /** Pressure at flowline node (TS). */
  nmvPressure?: Maybe<TimeSeries>;
  /** Pressure match quality (0-1, TS). 1 = perfect match between simulated and measured. */
  nmvPressureMatchIndex?: Maybe<TimeSeries>;
  /** Flowline-specific pressure match quality (0-1, TS). */
  nmvPressureMatchIndexFLP?: Maybe<TimeSeries>;
  /** Scale formation risk (0/1, TS). */
  nmvScaleFlag?: Maybe<TimeSeries>;
  /** Temperature at flowline node (TS). */
  nmvTemperature?: Maybe<TimeSeries>;
  /** Unstable flow detected (0/1, TS). */
  nmvUnstableFlag?: Maybe<TimeSeries>;
  /** Operating outside defined constraints (0/1, TS). */
  nmvViolatingConstraintsFlag?: Maybe<TimeSeries>;
  /** Water cut fraction (TS). */
  nmvWaterCut?: Maybe<TimeSeries>;
  /** Water flow rate through flowline (TS). */
  nmvWaterRate?: Maybe<TimeSeries>;
  /** Wax deposition risk (0/1, TS). */
  nmvWaxFlag?: Maybe<TimeSeries>;
  /** Water-gas ratio (TS). */
  nmvWgr?: Maybe<TimeSeries>;
};

/** Fluid Composition view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type FluidComposition = {
  /** Time series signal representing c1 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c1?: Maybe<TimeSeries>;
  /** Time series signal representing c2 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c2?: Maybe<TimeSeries>;
  /** Time series signal representing c3 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c3?: Maybe<TimeSeries>;
  /** Time series signal representing c6 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c6?: Maybe<TimeSeries>;
  /** Time series signal representing c7c14 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c7c14?: Maybe<TimeSeries>;
  /** Time series signal representing c15c25 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c15c25?: Maybe<TimeSeries>;
  /** Time series signal representing c26c80 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c26c80?: Maybe<TimeSeries>;
  /** Time series signal representing cgr for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  cgr?: Maybe<TimeSeries>;
  /** Time series signal representing co2 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  co2?: Maybe<TimeSeries>;
  /** Time series signal representing condensate gravity for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  condensateGravity?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Field>;
  /** Time series signal representing h2s for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  h2s?: Maybe<TimeSeries>;
  /** Time series signal representing i c4 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  iC4?: Maybe<TimeSeries>;
  /** Time series signal representing i c5 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  iC5?: Maybe<TimeSeries>;
  /** Time series signal representing n2 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  n2?: Maybe<TimeSeries>;
  /** Time series signal representing n c4 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  nC4?: Maybe<TimeSeries>;
  /** Time series signal representing n c5 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  nC5?: Maybe<TimeSeries>;
  /** Time series signal representing specific gas gravity for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  specificGasGravity?: Maybe<TimeSeries>;
  /** Time series signal representing water salinity for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterSalinity?: Maybe<TimeSeries>;
  /** Time series signal representing wgr for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wgr?: Maybe<TimeSeries>;
};

/** Formation Volume Factor view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type FormationVolumeFactor = {
  /** Numeric value storing b gas for this entity, used in calculations, reporting, or model configuration. */
  bGas?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing b gas injector for this entity, used in calculations, reporting, or model configuration. */
  bGasInjector?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing b oil for this entity, used in calculations, reporting, or model configuration. */
  bOil?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing b water for this entity, used in calculations, reporting, or model configuration. */
  bWater?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing b water injector for this entity, used in calculations, reporting, or model configuration. */
  bWaterInjector?: Maybe<Scalars['Float32']['output']>;
  /** Attribute capturing effective date for this entity in the production optimization context. */
  effectiveDate?: Maybe<Scalars['Timestamp']['output']>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Numeric value storing pb for this entity, used in calculations, reporting, or model configuration. */
  pb?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing pressure for this entity, used in calculations, reporting, or model configuration. */
  pressure?: Maybe<Scalars['Float32']['output']>;
  /** Reservoir attribute describing this entity in more detail, often derived from master data or configuration tables. */
  reservoir?: Maybe<Reservoir>;
  /** Numeric value storing rs for this entity, used in calculations, reporting, or model configuration. */
  rs?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing temperature for this entity, used in calculations, reporting, or model configuration. */
  temperature?: Maybe<Scalars['Float32']['output']>;
};

/** GL Valve Data view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type GlValveData = {
  /** Numeric value storing dome pressure for this entity, used in calculations, reporting, or model configuration. */
  domePressure?: Maybe<Scalars['Float32']['output']>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Field attribute describing this entity in more detail, often derived from master data or configuration tables. */
  field?: Maybe<Field>;
  /** Numeric value storing gas lift mandrel for this entity, used in calculations, reporting, or model configuration. */
  gasLiftMandrel?: Maybe<Scalars['Int']['output']>;
  /** Numeric value storing gl port size for this entity, used in calculations, reporting, or model configuration. */
  glPortSize?: Maybe<Scalars['Int']['output']>;
  /** Gl Valve Material attribute describing this entity in more detail, often derived from master data or configuration tables. */
  glValveMaterial?: Maybe<Scalars['String']['output']>;
  /** Gl Valve Orifice Series attribute describing this entity in more detail, often derived from master data or configuration tables. */
  glValveOrificeSeries?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing gl valve size for this entity, used in calculations, reporting, or model configuration. */
  glValveSize?: Maybe<Scalars['Float32']['output']>;
  /** Attribute capturing installation date for this entity in the production optimization context. */
  installationDate?: Maybe<Scalars['Timestamp']['output']>;
  /** Numeric value storing measured depth for this entity, used in calculations, reporting, or model configuration. */
  measuredDepth?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing r value for this entity, used in calculations, reporting, or model configuration. */
  rValue?: Maybe<Scalars['Float']['output']>;
  /** Numeric value storing test rack opening pressure for this entity, used in calculations, reporting, or model configuration. */
  testRackOpeningPressure?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing true vertical depth for this entity, used in calculations, reporting, or model configuration. */
  trueVerticalDepth?: Maybe<Scalars['Float32']['output']>;
  /** Type attribute describing this entity in more detail, often derived from master data or configuration tables. */
  type?: Maybe<Scalars['String']['output']>;
};

/**
 * Gas lift troubleshooting and diagnostic alarms with medium or high priority.
 *
 * Contains diagnostic alarms, gas lift operations, focusing on those with medium
 * or high priority. Sourced from operational monitoring systems that track alarm
 * events, to analyze alarm occurrences and their implications on gas lift
 * performance. It answers analytical questions such as the frequency of high-
 * priority alarms and troubleshooting effectiveness. Excludes low-priority or non-WF14 alarms.
 *
 * Use for: Gas Lift Troubleshooting and Diagnostics (WF14), Real-Time Surveillance (WF18).
 *
 * @name Gas Lift Diagnostic Alarms (Agent)
 */
export type GasLiftAlarmsAgent = {
  alarmCategory?: Maybe<Scalars['String']['output']>;
  alarmCode?: Maybe<Scalars['JSONObject']['output']>;
  alarmCodeExternalId?: Maybe<Scalars['String']['output']>;
  /** Number of consecutive occurrences of this alarm. */
  alarmCounter?: Maybe<Scalars['Int']['output']>;
  alarmCriticality?: Maybe<Scalars['String']['output']>;
  alarmFlags?: Maybe<Scalars['String']['output']>;
  alarmName?: Maybe<Scalars['String']['output']>;
  alarmPriority?: Maybe<Scalars['String']['output']>;
  customWorkflowAlarmMessage?: Maybe<Scalars['String']['output']>;
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  entityExternalId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  startDateTime: Scalars['Timestamp']['output'];
  /** Alarm sub-category for domain filtering. */
  subCategory?: Maybe<Scalars['String']['output']>;
  /** Sub-workflow that generated the alarm. */
  subWorkflowName?: Maybe<Scalars['String']['output']>;
  /** Associated ticket/action ID if alarm has been acknowledged. */
  ticketId?: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
  workflowCode?: Maybe<Scalars['String']['output']>;
  workflowName?: Maybe<Scalars['String']['output']>;
};

/**
 * Model-calculated gas lift outputs per well string (WF14).
 *
 * GLIR variants (measured, network, choke, allocated, priority), GL analysis status,
 * choke parameters. Use glirSelected for best-available GLIR. Use with GasLiftMeasurements_String_Agent and GasLiftLimits_String_Agent.
 *
 * Use for: Gas Lift Troubleshooting and Diagnostics (WF14).
 *
 * @name Gas Lift Calculations - Well String (Agent)
 */
export type GasLiftCalculationsStringAgent = {
  /**
   * Calculated GL choke discharge coefficient (Cd, TS). Deviations from
   * typical values may indicate erosion or plugging.
   */
  glChokeCdCalc?: Maybe<TimeSeries>;
  /**
   * Calculated GL choke size required to achieve current GLIR given upstream
   * pressure conditions (64ths inch, TS).
   */
  glChokeSizeCalc?: Maybe<TimeSeries>;
  /** Allocated gas lift injection rate from daily allocation (MSCF/d, TS). */
  glirAllocated?: Maybe<TimeSeries>;
  /** Gas lift injection rate calculated from GL choke equation (MSCF/d, TS). */
  glirChokeEquation?: Maybe<TimeSeries>;
  /** Measured gas lift injection rate from flow meter (MSCF/d, TS). */
  glirMeasured?: Maybe<TimeSeries>;
  /** Gas lift injection rate from network simulation model (MSCF/d, TS). */
  glirNetworkSimulation?: Maybe<TimeSeries>;
  /**
   * Selected/priority gas lift injection rate (MSCF/d, TS). The most reliable
   * GLIR value â€” use for optimization and surveillance.
   */
  glirSelected?: Maybe<TimeSeries>;
  /** Source of selected GLIR. Values: MEASURED, NETWORK_SIMULATION, CHOKE_EQUATION, ALLOCATED. */
  glirSelectedType?: Maybe<TimeSeries>;
  /** Status of gas lift rate calculation. Values: SUCCESS, FAILED, NO_DATA. */
  glqlAnalysisStatus?: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
};

/**
 * Gas lift operating limit thresholds per well string (WF14).
 *
 * Engineering limits: casing/wellhead pressures, manifold pressure, BHP target,
 * temperature, rate limits (liquid, oil, GOR), monitoring flags. Compare against GasLiftMeasurements_String_Agent for exceedances. For ESP use ESPLimits_String_Agent.
 *
 * Use for: Gas Lift Troubleshooting and Diagnostics (WF14).
 *
 * @name Gas Lift Operating Limits - Well String (Agent)
 */
export type GasLiftLimitsStringAgent = {
  /** Asphaltene deposition risk flag or score for this well string. */
  asphalteneRisk?: Maybe<Scalars['Boolean']['output']>;
  /** Fluid velocity limit or reference value (ft/s, TS). Used for erosion and flow assurance checks. */
  fluidVelocity?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum allowable casing head pressure (psia, TS). Exceeding may damage casing or cause valve malfunction. */
  glMaxCasingHeadPressure?: Maybe<TimeSeries>;
  /** Boolean flag â€” glMaxCasingHeadPressure limit is actively monitored for alarms. */
  glMaxCasingHeadPressure_active?: Maybe<TimeSeries>;
  /** Maximum temperature drop across gas lift choke (Â°F, TS). Excessive cooling may cause hydrate formation. */
  glMaxLiftChokeDeltaTemp?: Maybe<TimeSeries>;
  /** Maximum manifold pressure limit (psia, TS). High manifold pressure reduces available lift gas differential. */
  glMaxManifoldPressure?: Maybe<TimeSeries>;
  /** Maximum wellhead temperature limit (Â°F, TS). */
  glMaxWellHeadTemp?: Maybe<TimeSeries>;
  /** Minimum bottomhole pressure target (psia, TS). Gas lift should achieve this BHP for optimal production. */
  glMinBHP?: Maybe<TimeSeries>;
  /** Minimum casing head pressure for stable injection (psia, TS). Below this, may not reach operating valve depth. */
  glMinCasingHeadPressure?: Maybe<TimeSeries>;
  /** Boolean flag â€” glMinCasingHeadPressure limit is actively monitored for alarms. */
  glMinCasingHeadPressure_active?: Maybe<TimeSeries>;
  /** Minimum manifold pressure limit (psia, TS). Below this may cause unstable flow. */
  glMinManifolddPressure?: Maybe<TimeSeries>;
  /** Minimum wellhead pressure for stable flow (psia, TS). Below may cause heading. */
  glMinWellHeadPressure?: Maybe<TimeSeries>;
  /** Hydrate formation risk flag or score for this well string. */
  hydrateRisk?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum GOR limit (scf/stb, TS). High GOR may indicate gas breakthrough or lift issues. */
  maxGOR?: Maybe<TimeSeries>;
  /** Maximum liquid rate limit (stb/d, TS). Facility or well capacity constraint. */
  maxLiquidRate?: Maybe<TimeSeries>;
  /** Maximum oil rate limit (stb/d, TS). Allocation or facility constraint. */
  maxOilRate?: Maybe<TimeSeries>;
  /** Maximum wellhead pressure limit (psia, TS). Equipment rating limit. */
  maxWellHeadPressure?: Maybe<TimeSeries>;
  /** PE5 flow stability criteria threshold for this well string. */
  pe5StabilityCriteria?: Maybe<Scalars['Boolean']['output']>;
  /** Wax deposition risk flag or score for this well string. */
  waxRisk?: Maybe<Scalars['Boolean']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
};

/**
 * Real-time gas lift sensor readings per well string (WF14).
 *
 * Live measurements: injection rate, CV inlet pressure/temperature, CV size,
 * casing/wellhead pressures and temperatures, annulus pressure, choke settings,
 * downhole BHP/BHT. Compare against GasLiftLimits_String_Agent. For calculated outputs see GasLiftCalculations_String_Agent.
 *
 * Use for: Gas Lift Troubleshooting and Diagnostics (WF14).
 *
 * @name Gas Lift Measurements - Well String (Agent)
 */
export type GasLiftMeasurementsStringAgent = {
  /** Annulus pressure (psia, TS). Difference from casingHeadPress can indicate tubing leaks. */
  annulusPress?: Maybe<TimeSeries>;
  /** Bottom-hole flowing pressure (psia, TS). Compare to glMinBHP target for GL efficiency. */
  bottomHolePress?: Maybe<TimeSeries>;
  /** Bottom-hole temperature (Â°F, TS). Important for PVT calculations. */
  bottomHoleTemp?: Maybe<TimeSeries>;
  /**
   * Casing head pressure (psia, TS). Critical for gas lift operation â€” affects
   * injection depth and valve opening. Oscillations indicate instability/multipointing.
   */
  casingHeadPress?: Maybe<TimeSeries>;
  /** Production choke opening (% or 64ths, TS). Affects backpressure on well. */
  chokeOpening?: Maybe<TimeSeries>;
  /** Surface choke size setting (TS). Used for choke performance calculations. */
  chokeSize?: Maybe<TimeSeries>;
  /** Downstream flowline pressure (psia, TS). High flowline pressure reduces well deliverability. */
  flowLinePress?: Maybe<TimeSeries>;
  /** Flowline temperature (Â°F, TS). Used for hydrate risk assessment. */
  flowLineTemp?: Maybe<TimeSeries>;
  /**
   * Inlet pressure at the gas lift flow control valve (psia, TS). Used to
   * calculate injection differential and optimize gas allocation.
   */
  gasLiftFlowCVInletPress?: Maybe<TimeSeries>;
  /** Effective orifice/trim size of the gas lift flow control valve (TS). */
  gasLiftFlowCVSize?: Maybe<TimeSeries>;
  /**
   * Current gas lift injection rate (Mscf/d, TS). Compare to design rate and
   * limits. Higher than expected may indicate multipointing.
   */
  gasLiftInjRate?: Maybe<TimeSeries>;
  /** Gas lift injection temperature (Â°F, TS). Important for hydrate risk assessment. */
  gasLiftInjTemp?: Maybe<TimeSeries>;
  /** Artificial lift type (TS). Confirm value = GAS_LIFT before querying GL-specific diagnostics. */
  liftType?: Maybe<TimeSeries>;
  /** Flowing wellhead pressure (psia, TS). Combined with casing pressure indicates lift efficiency. */
  wellHeadPress?: Maybe<TimeSeries>;
  /** Flowing wellhead temperature (Â°F, TS). Temperature differential helps diagnose flow issues. */
  wellHeadTemp?: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
};

/**
 * Long-term well string inactivity with reasons and downtime start dates (WF25/WF18).
 *
 * Strings classified INACTIVE (extended/indefinite offline). Distinct from
 * WellStatus_String_Agent (real-time flowing/shut-in). Use for inactive well
 * aging, downtime impact, workover candidate screening, well availability.
 *
 * Use for: Well Status Detection (WF25), Real-Time Surveillance (WF18).
 */
export type InactiveStringAgent = {
  /**
   * Date when the string became inactive. Used to calculate downtime duration
   * and track inactive well aging.
   */
  downtimeStartDate?: Maybe<TimeSeries>;
  /**
   * Category of inactivity explaining why the string is inactive, e.g.,
   * 'MECHANICAL_FAILURE', 'AWAITING_WORKOVER', 'LOW_PRODUCTIVITY', 'ABANDONED'.
   */
  inactiveCategory?: Maybe<TimeSeries>;
  /**
   * Activity status of the string: 'ACTIVE' or 'INACTIVE'. Active strings are
   * available for production/injection. Inactive strings are temporarily or
   * permanently offline (awaiting workover, abandoned, etc.).
   */
  stringStatus?: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
};

/** Inactive String view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type InactiveString = {
  /** Time series signal representing action date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  actionDate?: Maybe<TimeSeries>;
  /** Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  actionStatus?: Maybe<TimeSeries>;
  /** Time series signal representing category code for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  categoryCode?: Maybe<TimeSeries>;
  /** Time series signal representing downtime start date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  downtimeStartDate?: Maybe<TimeSeries>;
  /** Time series signal representing duration for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  duration?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Time series signal representing expected rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  expectedRate?: Maybe<TimeSeries>;
  /** Time series signal representing inactive category for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  inactiveCategory?: Maybe<TimeSeries>;
  /** Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  problemName?: Maybe<TimeSeries>;
  /** Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  stringStatus?: Maybe<TimeSeries>;
  /** Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  stringStatusAll?: Maybe<TimeSeries>;
};

/** Inj Press Guideline String view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type InjPressGuidelineString = {
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Numeric value storing gi max bhip for this production string, used in calculations, reporting, or model configuration. */
  giMaxBHIP?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing gi max inj rate for this production string, used in calculations, reporting, or model configuration. */
  giMaxInjRate?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing gi max whip for this production string, used in calculations, reporting, or model configuration. */
  giMaxWHIP?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing wi max bhip for this production string, used in calculations, reporting, or model configuration. */
  wiMaxBHIP?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing wi max inj rate for this production string, used in calculations, reporting, or model configuration. */
  wiMaxInjRate?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing wi max whip for this production string, used in calculations, reporting, or model configuration. */
  wiMaxWHIP?: Maybe<Scalars['Float32']['output']>;
};

/**
 * Injection pressure guidelines and operating limits per well string (WF15).
 *
 * Max WHP, min BHP, fracture gradient, operating pressure bands. Use for safe
 * injection practices, optimal pressure settings, over-pressurization risk. For
 * performance trends see InjectionPerformance_String_Agent.
 *
 * Use for: Water or Gas Injection Monitoring (WF15).
 *
 * @name Injection Pressure Guidelines - String (Agent)
 */
export type InjPressGuidelineStringAgent = {
  giMaxBHIP?: Maybe<Scalars['Float32']['output']>;
  giMaxInjRate?: Maybe<Scalars['Float32']['output']>;
  giMaxWHIP?: Maybe<Scalars['Float32']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
  wiMaxBHIP?: Maybe<Scalars['Float32']['output']>;
  wiMaxInjRate?: Maybe<Scalars['Float32']['output']>;
  wiMaxWHIP?: Maybe<Scalars['Float32']['output']>;
};

/**
 * Injection monitoring and VRR alarms with medium or high priority.
 *
 * The Injection Monitoring Alarms (Agent) view contains data related to medium
 * and high-priority alarms associated with water or gas injection and VRR
 * (Volume Reduction Ratio) monitoring. This data is sourced from operational
 * workflows focused on injection monitoring and includes alarm codes,
 * priorities, and timestamps, allowing for the analysis of alarm occurrences and
 * their implications on operational efficiency. It can answer questions
 * regarding frequency, criticality, and duration of injection/VRR alarms. Excludes low-priority alarms.
 *
 * Use for: Water or Gas Injection Monitoring (WF15), VRR (WF16/WF17), Real-Time Surveillance (WF18).
 *
 * @name Injection Monitoring Alarms (Agent)
 */
export type InjectionAlarmsAgent = {
  alarmCategory?: Maybe<Scalars['String']['output']>;
  alarmCode?: Maybe<Scalars['JSONObject']['output']>;
  alarmCodeExternalId?: Maybe<Scalars['String']['output']>;
  /** Number of consecutive occurrences of this alarm. */
  alarmCounter?: Maybe<Scalars['Int']['output']>;
  alarmCriticality?: Maybe<Scalars['String']['output']>;
  alarmFlags?: Maybe<Scalars['String']['output']>;
  alarmName?: Maybe<Scalars['String']['output']>;
  alarmPriority?: Maybe<Scalars['String']['output']>;
  customWorkflowAlarmMessage?: Maybe<Scalars['String']['output']>;
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  entityExternalId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  startDateTime: Scalars['Timestamp']['output'];
  /** Alarm sub-category for domain filtering. */
  subCategory?: Maybe<Scalars['String']['output']>;
  /** Sub-workflow that generated the alarm. */
  subWorkflowName?: Maybe<Scalars['String']['output']>;
  /** Associated ticket/action ID if alarm has been acknowledged. */
  ticketId?: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
  workflowCode?: Maybe<Scalars['String']['output']>;
  workflowName?: Maybe<Scalars['String']['output']>;
};

/**
 * Injection well performance metrics at string level (WF15).
 *
 * Gas and water injection rates, pressures, efficiency, Hall plot. Use for
 * effectiveness of injection strategies, injectivity trends, compliance with
 * targets, and Hall plot diagnostics. Excludes surface facility or reservoir views.
 *
 * Use for: Water or Gas Injection Monitoring (WF15).
 *
 * @name Injection Performance - String Level (Agent)
 */
export type InjectionPerformanceStringAgent = {
  /** Average WHP during cumulative gas injection period (psi, TS). */
  cumulativeGasInjPress?: Maybe<TimeSeries>;
  /** Cumulative gas injection volume (MSCF, TS). Used for voidage tracking. */
  cumulativeGasInjVol?: Maybe<TimeSeries>;
  /** Average WHP during cumulative water injection period (psi, TS). */
  cumulativeWaterInjPress?: Maybe<TimeSeries>;
  /** Cumulative water injection volume (stb, TS). Used for voidage tracking. */
  cumulativeWaterInjVol?: Maybe<TimeSeries>;
  /** Cumulative gas injection at reservoir conditions (rb, TS). */
  downholeGasInjectionVolume?: Maybe<TimeSeries>;
  /**
   * Cumulative water injection at reservoir conditions (rb, TS). Used for
   * VRR and material balance calculations.
   */
  downholeWaterInjectionVolume?: Maybe<TimeSeries>;
  /**
   * Bottom-hole pressure during gas injection (psi, TS). Measured if
   * instrumented, otherwise calculated from WHP.
   */
  giBHP?: Maybe<TimeSeries>;
  /**
   * Current gas injection rate (MSCF/d, TS). Real-time from flow meter
   * or calculated from operating conditions.
   */
  giRate?: Maybe<TimeSeries>;
  /**
   * Target gas injection rate (MSCF/d, TS) from production plan or optimization.
   * Compare to giRate to assess injection compliance.
   */
  giTargetRate?: Maybe<TimeSeries>;
  /**
   * Maximum technically achievable gas injection rate (MSCF/d, TS) given
   * current well and facility constraints.
   */
  giTechnicalRate?: Maybe<TimeSeries>;
  /** Wellhead pressure during gas injection (psi, TS). */
  giWHP?: Maybe<TimeSeries>;
  /**
   * Hall plot trend interpretation: 'STABLE', 'IMPROVING', 'DECLINING',
   * 'STIMULATION_NEEDED'. Key diagnostic for injection well surveillance.
   */
  hallInterpretation?: Maybe<TimeSeries>;
  /**
   * Hall plot cumulative value or slope (TS). Trend changes indicate
   * injectivity changes over time.
   */
  hallLine?: Maybe<TimeSeries>;
  /**
   * Injection efficiency (%, TS). Actual rate / target rate. 100% = fully
   * meeting target.
   */
  injectionEfficiency?: Maybe<TimeSeries>;
  /** Flag: 1 = below efficiency threshold (needs attention), 0 = acceptable. */
  injectionEfficiencyFlag?: Maybe<TimeSeries>;
  /** Rank among all injectors (1 = best, TS). Use to identify worst performers. */
  injectionEfficiencyRank?: Maybe<TimeSeries>;
  /**
   * Injectivity index (stb/d/psi, TS). Rate of injection per unit
   * pressure increase. Key metric for injection well health.
   */
  injectivityIndex?: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
  /** Bottom-hole pressure during water injection (psi, TS). */
  wiBHP?: Maybe<TimeSeries>;
  /** Current water injection rate (stb/d, TS). Real-time from flow meter. */
  wiRate?: Maybe<TimeSeries>;
  /** Target water injection rate (stb/d, TS) from production plan or optimization. */
  wiTargetRate?: Maybe<TimeSeries>;
  /** Maximum technically achievable water injection rate (stb/d, TS). */
  wiTechnicalRate?: Maybe<TimeSeries>;
  /** Wellhead pressure during water injection (psi, TS). */
  wiWHP?: Maybe<TimeSeries>;
};

/** Injection Allocation Factor view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type InjectionAllocationFactor = {
  /** Numeric value storing allocation factor for this entity, used in calculations, reporting, or model configuration. */
  allocationFactor?: Maybe<Scalars['Float32']['output']>;
  /** Attribute capturing effective date for this entity in the production optimization context. */
  effectiveDate?: Maybe<Scalars['Timestamp']['output']>;
  /** Injector String attribute describing this entity in more detail, often derived from master data or configuration tables. */
  injectorString?: Maybe<StringAsset>;
  /** Producer String attribute describing this entity in more detail, often derived from master data or configuration tables. */
  producerString?: Maybe<StringAsset>;
  /** Source attribute describing this entity in more detail, often derived from master data or configuration tables. */
  source?: Maybe<Scalars['String']['output']>;
};

/** Lift Type Parameter String view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type LiftTypeParameterString = {
  /** Time series signal representing amorphous fe s for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  amorphousFeS?: Maybe<TimeSeries>;
  /** Time series signal representing amorphous silica for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  amorphousSilica?: Maybe<TimeSeries>;
  /** Time series signal representing anhydrite for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  anhydrite?: Maybe<TimeSeries>;
  /** Numeric value storing asphaltene max limit for this production string, used in calculations, reporting, or model configuration. */
  asphalteneMaxLimit?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing asphaltene min limit for this production string, used in calculations, reporting, or model configuration. */
  asphalteneMinLimit?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing asphaltene relative wt for this production string, used in calculations, reporting, or model configuration. */
  asphalteneRelativeWT?: Maybe<Scalars['Float32']['output']>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  asphalteneRisk?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing ba co3 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  baCO3?: Maybe<TimeSeries>;
  /** Time series signal representing barite for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  barite?: Maybe<TimeSeries>;
  /** Time series signal representing ca f2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  caF2?: Maybe<TimeSeries>;
  /** Time series signal representing ca oh2 portlandite for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  caOH2Portlandite?: Maybe<TimeSeries>;
  /** Time series signal representing calcite for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  calcite?: Maybe<TimeSeries>;
  /** Time series signal representing calestite for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  calestite?: Maybe<TimeSeries>;
  /** Time series signal representing chrysotile for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  chrysotile?: Maybe<TimeSeries>;
  /** Numeric value storing corrosion max limit for this production string, used in calculations, reporting, or model configuration. */
  corrosionMaxLimit?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing corrosion min limit for this production string, used in calculations, reporting, or model configuration. */
  corrosionMinLimit?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing corrosion relative wt for this production string, used in calculations, reporting, or model configuration. */
  corrosionRelativeWT?: Maybe<Scalars['Float32']['output']>;
  /** Time series signal representing diopside for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  diopside?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Numeric value storing erosion max limit for this production string, used in calculations, reporting, or model configuration. */
  erosionMaxLimit?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing erosion min limit for this production string, used in calculations, reporting, or model configuration. */
  erosionMinLimit?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing erosion relative wt for this production string, used in calculations, reporting, or model configuration. */
  erosionRelativeWT?: Maybe<Scalars['Float32']['output']>;
  /** Time series signal representing esp max discharge pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMaxDischargePressure?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMaxDischargePressure_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp max fluid rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMaxFluidRate?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMaxFluidRate_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp max free gas in pump for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMaxFreeGasInPump?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMaxFreeGasInPump_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp max head for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMaxHead?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMaxHead_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp max motor amps for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMaxMotorAmps?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMaxMotorAmps_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp max motor efficiency for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMaxMotorEfficiency?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMaxMotorEfficiency_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp max motor load permissible for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMaxMotorLoadPermissible?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMaxMotorLoadPermissible_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp max motor pwr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMaxMotorPwr?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMaxMotorPwr_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp max motor speed inductor type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMaxMotorSpeed_InductorType?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMaxMotorSpeed_InductorType_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp max motor speed pmm type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMaxMotorSpeed_PmmType?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMaxMotorSpeed_PmmType_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp max motor temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMaxMotorTemp?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMaxMotorTemp_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp max pump delta temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMaxPumpDeltaTemp?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMaxPumpDeltaTemp_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp max pump fluid velocity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMaxPumpFluidVelocity?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMaxPumpFluidVelocity_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp max pwr avail generated for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMaxPwrAvail_Generated?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMaxPwrAvail_Generated_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp max surface kva for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMaxSurfaceKva?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMaxSurfaceKva_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp max trq on shaft for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMaxTrqOnShaft?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMaxTrqOnShaft_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp max voltage drop along cable for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMaxVoltageDropAlongCable?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMaxVoltageDropAlongCable_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp min fluid rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMinFluidRate?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMinFluidRate_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp min intake pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMinIntakePressure?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMinIntakePressure_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp min intake temperature for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMinIntakeTemperature?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMinIntakeTemperature_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp min motor power factor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMinMotorPowerFactor?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMinMotorPowerFactor_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing esp min pump fluid velocity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espMinPumpFluidVelocity?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  espMinPumpFluidVelocity_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing fe co3 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  feCO3?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  fluidVelocity?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing four calc options for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  fourCalcOptions?: Maybe<TimeSeries>;
  /** Time series signal representing gl max casing head pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  glMaxCasingHeadPressure?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  glMaxCasingHeadPressure_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing gl max lift choke delta temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  glMaxLiftChokeDeltaTemp?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  glMaxLiftChokeDeltaTemp_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing gl max manifold pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  glMaxManifoldPressure?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  glMaxManifoldPressure_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing gl max well head temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  glMaxWellHeadTemp?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  glMaxWellHeadTemp_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing gl min bhp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  glMinBHP?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  glMinBHP_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing gl min casing head pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  glMinCasingHeadPressure?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  glMinCasingHeadPressure_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing gl min manifoldd pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  glMinManifolddPressure?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  glMinManifolddPressure_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing gl min well head pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  glMinWellHeadPressure?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  glMinWellHeadPressure_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing greenalite for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  greenalite?: Maybe<TimeSeries>;
  /** Time series signal representing gypsum for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gypsum?: Maybe<TimeSeries>;
  /** Time series signal representing halite for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  halite?: Maybe<TimeSeries>;
  /** Time series signal representing hemihydrate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  hemihydrate?: Maybe<TimeSeries>;
  /** Numeric value storing hydrate max limit for this production string, used in calculations, reporting, or model configuration. */
  hydrateMaxLimit?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing hydrate min limit for this production string, used in calculations, reporting, or model configuration. */
  hydrateMinLimit?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing hydrate relative wt for this production string, used in calculations, reporting, or model configuration. */
  hydrateRelativeWT?: Maybe<Scalars['Float32']['output']>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  hydrateRisk?: Maybe<Scalars['Boolean']['output']>;
  /** Numeric value storing liquid loading max limit for this production string, used in calculations, reporting, or model configuration. */
  liquidLoadingMaxLimit?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing liquid loading min limit for this production string, used in calculations, reporting, or model configuration. */
  liquidLoadingMinLimit?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing liquid loading relative wt for this production string, used in calculations, reporting, or model configuration. */
  liquidLoadingRelativeWT?: Maybe<Scalars['Float32']['output']>;
  /** Time series signal representing mackinawite for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mackinawite?: Maybe<TimeSeries>;
  /** Time series signal representing max gor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  maxGOR?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  maxGOR_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing max liquid rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  maxLiquidRate?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  maxLiquidRate_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing max oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  maxOilRate?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  maxOilRate_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing max well head pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  maxWellHeadPressure?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  maxWellHeadPressure_active?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing mg oh2 brucite for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mgOH2Brucite?: Maybe<TimeSeries>;
  /** Time series signal representing pb sgalena for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pbSGalena?: Maybe<TimeSeries>;
  /** Numeric value storing pe5 max limit for this production string, used in calculations, reporting, or model configuration. */
  pe5MaxLimit?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing pe5 min limit for this production string, used in calculations, reporting, or model configuration. */
  pe5MinLimit?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing pe5 relative wt for this production string, used in calculations, reporting, or model configuration. */
  pe5RelativeWT?: Maybe<Scalars['Float32']['output']>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  pe5StabilityCriteria?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing quartz for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  quartz?: Maybe<TimeSeries>;
  /** Time series signal representing sr co3 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  srCO3?: Maybe<TimeSeries>;
  /** Time series signal representing troilite pyrrhotite for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  troilitePyrrhotite?: Maybe<TimeSeries>;
  /** Time series signal representing use ph tuning for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  usePhTuning?: Maybe<TimeSeries>;
  /** Numeric value storing wax max limit for this production string, used in calculations, reporting, or model configuration. */
  waxMaxLimit?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing wax min limit for this production string, used in calculations, reporting, or model configuration. */
  waxMinLimit?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing wax relative wt for this production string, used in calculations, reporting, or model configuration. */
  waxRelativeWT?: Maybe<Scalars['Float32']['output']>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  waxRisk?: Maybe<Scalars['Boolean']['output']>;
  /** Time series signal representing zn co3 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  znCO3?: Maybe<TimeSeries>;
  /** Time series signal representing zn s for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  znS?: Maybe<TimeSeries>;
};

/** Location view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type Location = {
  /** Attribute capturing end date time for this entity in the production optimization context. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Entity Type attribute describing this entity in more detail, often derived from master data or configuration tables. */
  entityType?: Maybe<Scalars['String']['output']>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  name?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing start date time for this entity in the production optimization context. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
};

/** Location Inputs view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type LocationInputs = {
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Location>;
  /** Time series signal representing flow line pressure for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  flowLinePressure?: Maybe<TimeSeries>;
  /** Time series signal representing water header pressure for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterHeaderPressure?: Maybe<TimeSeries>;
  /** Time series signal representing water header temperature for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterHeaderTemperature?: Maybe<TimeSeries>;
};

/** Manifold Inputs view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type ManifoldInputs = {
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Entity>;
  /** Time series signal representing manifold gas inj pressure for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  manifoldGasInjPressure?: Maybe<TimeSeries>;
  /** Time series signal representing manifold gas inj rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  manifoldGasInjRate?: Maybe<TimeSeries>;
  /** Time series signal representing manifold gas inj temperature for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  manifoldGasInjTemperature?: Maybe<TimeSeries>;
  /** Time series signal representing manifold water inj pressure for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  manifoldWaterInjPressure?: Maybe<TimeSeries>;
  /** Time series signal representing manifold water inj rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  manifoldWaterInjRate?: Maybe<TimeSeries>;
  /** Time series signal representing manifold water inj temperature for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  manifoldWaterInjTemperature?: Maybe<TimeSeries>;
};

/** Map Grid Mapping view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type MapGridMapping = {
  /** Attribute capturing date for this entity in the production optimization context. */
  date?: Maybe<Scalars['Timestamp']['output']>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  fieldName?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing lat for this entity, used in calculations, reporting, or model configuration. */
  lat?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing long for this entity, used in calculations, reporting, or model configuration. */
  long?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing p10 for this entity, used in calculations, reporting, or model configuration. */
  p10?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing p50 for this entity, used in calculations, reporting, or model configuration. */
  p50?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing p90 for this entity, used in calculations, reporting, or model configuration. */
  p90?: Maybe<Scalars['Float32']['output']>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  reservoirName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  reservoirPressureMapGrid?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing reservoir pressure rmserror for this entity, used in calculations, reporting, or model configuration. */
  reservoirPressureRMSError?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing x for this entity, used in calculations, reporting, or model configuration. */
  x?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing y for this entity, used in calculations, reporting, or model configuration. */
  y?: Maybe<Scalars['Float32']['output']>;
};

/**
 * Measured injection rates from wellhead meters per well string (WF15).
 *
 * Real-time gas and water injection from wellhead meters; no allocation. Use for
 * actual injection rates, trends, and well-string comparisons. For allocated volumes see AllocatedInjection_String_Agent.
 *
 * Use for: Water or Gas Injection Monitoring (WF15).
 */
export type MeasuredInjectionStringAgent = {
  /** Gas injection choke opening (TS). Controls gas injection rate at wellhead. */
  gasInjChokeOpening?: Maybe<TimeSeries>;
  /**
   * Measured gas injection rate (MSCF/d) from wellhead flow meter. This is the
   * direct measurement, not an allocated value. Use for real-time injection
   * monitoring and comparison with allocated volumes.
   */
  gasInjRate?: Maybe<TimeSeries>;
  /** Gas injection wellhead pressure (psia, TS). From wellhead meter; indicates line pressure and injectivity. */
  gasInjWellheadPress?: Maybe<TimeSeries>;
  /** Water injection choke opening (TS). Controls water injection rate at wellhead. */
  waterInjChokeOpening?: Maybe<TimeSeries>;
  /**
   * Measured water injection rate (stb/d) from wellhead flow meter. This is the
   * direct measurement, not an allocated value. Use for real-time injection
   * monitoring and comparison with allocated volumes.
   */
  waterInjRate?: Maybe<TimeSeries>;
  /** Water injection wellhead pressure (psia, TS). From wellhead meter; indicates line pressure and injectivity. */
  waterInjWellheadPress?: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
};

/**
 * Well test measured rates per well string from separator measurements.
 *
 * Contains comprehensive measurements from well tests, separator-measured rates
 * of oil, gas, and water at standard conditions, along with pertinent metadata
 * such as test dates and allocation approval flags. Sourced from actual well
 * tests conducted in the field, providing a reliable basis for production rate
 * calibration and validation of network models. It can address analytical
 * questions regarding the latest well test results, approved tests, and specific
 * ratios like gas-to-oil and water-cut metrics. Excludes simulated or estimated
 * rates, which may be present in other views, ensuring that users are working
 * with verified physical measurements.
 *
 * @name Measured Rates - Well Test (Agent)
 */
export type MeasuredRatesWellTestStringAgent = {
  /** Condensate-gas ratio at live/local conditions (stb/MMscf, TS). */
  cgrLC?: Maybe<TimeSeries>;
  /** Formation/reservoir gas-oil ratio (scf/stb, TS). */
  formationGOR?: Maybe<TimeSeries>;
  /** Well string identifier. */
  wellString?: Maybe<StringAsset>;
  /**
   * Well test allocation approval status (TS). Values: 'Accepted', 'Rejected'.
   * @name isApproved
   */
  wellTestApprovedAllocationFlag?: Maybe<TimeSeries>;
  /**
   * Condensate-gas ratio at standard conditions (stb/MMscf, TS).
   * @name condensateGasRatio
   */
  wellTestCGR?: Maybe<TimeSeries>;
  /** Separator gas-oil ratio from well test (scf/stb, TS). */
  wellTestGOR?: Maybe<TimeSeries>;
  /**
   * Measured gas production rate at standard conditions (MMscfd, TS).
   * @name gasRateStd
   */
  wellTestGasRateStd?: Maybe<TimeSeries>;
  /**
   * Gas-oil ratio at downhole/insitu conditions (scf/stb, TS).
   * @name gorInsitu
   */
  wellTestGorInsitu?: Maybe<TimeSeries>;
  /**
   * Gas-oil ratio at PTS conditions (scf/stb, TS).
   * @name gorPts
   */
  wellTestGorPts?: Maybe<TimeSeries>;
  /**
   * Total liquid rate (oil + water) at PTS conditions (stb/d, TS).
   * @name liquidRatePts
   */
  wellTestLiquidRatePts?: Maybe<TimeSeries>;
  /**
   * Measured oil production rate at standard conditions (stb/d, TS).
   * @name oilRateStd
   */
  wellTestOilRateStd?: Maybe<TimeSeries>;
  /**
   * Well test start date (TS).
   * @name testDate
   */
  wellTestStartDate?: Maybe<TimeSeries>;
  /**
   * Total gas-oil ratio at standard conditions (scf/stb, TS).
   * @name totalGorStd
   */
  wellTestTotalGorStd?: Maybe<TimeSeries>;
  /**
   * Water-gas ratio at standard conditions (stb/MMscf, TS).
   * @name waterGasRatio
   */
  wellTestWGR?: Maybe<TimeSeries>;
  /**
   * Water cut at standard conditions: water / (oil + water) * 100 (%, TS).
   * @name waterCut
   */
  wellTestWaterCut?: Maybe<TimeSeries>;
  /**
   * Water cut at downhole/insitu conditions (%, TS).
   * @name waterCutInsitu
   */
  wellTestWaterCutInsitu?: Maybe<TimeSeries>;
  /**
   * Water cut at PTS conditions (%, TS).
   * @name waterCutPts
   */
  wellTestWaterCutPts?: Maybe<TimeSeries>;
  /**
   * Measured water production rate at standard conditions (stb/d, TS).
   * @name waterRateStd
   */
  wellTestWaterRateStd?: Maybe<TimeSeries>;
  /** Water-gas ratio at live/local conditions (stb/MMscf, TS). */
  wgrLC?: Maybe<TimeSeries>;
};

/**
 * Model management alarms with medium or high priority.
 *
 * Contains alarms generated during the model management processes, those with
 * medium or high priority. Sourced from the workflows associated with well and
 * network model updates and calibrations, allowing users to analyze alarm
 * occurrences and their implications on model performance. It can answer
 * questions regarding the frequency and types of alarms triggered, their impact
 * on operations and entities affected. Excludes low-priority or non-WF9 alarms.
 *
 * Use for: Well and Network Model Update and Management (WF9), Real-Time Surveillance (WF18).
 *
 * @name Model Management Alarms (Agent)
 */
export type ModelManagementAlarmsAgent = {
  alarmCategory?: Maybe<Scalars['String']['output']>;
  alarmCode?: Maybe<Scalars['JSONObject']['output']>;
  alarmCodeExternalId?: Maybe<Scalars['String']['output']>;
  alarmCriticality?: Maybe<Scalars['String']['output']>;
  alarmFlags?: Maybe<Scalars['String']['output']>;
  alarmName?: Maybe<Scalars['String']['output']>;
  alarmPriority?: Maybe<Scalars['String']['output']>;
  customWorkflowAlarmMessage?: Maybe<Scalars['String']['output']>;
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  entityExternalId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  startDateTime: Scalars['Timestamp']['output'];
  subCategory?: Maybe<Scalars['String']['output']>;
  subWorkflowName?: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
  workflowCode?: Maybe<Scalars['String']['output']>;
  workflowName?: Maybe<Scalars['String']['output']>;
};

/**
 * Model-matched rates from Prosper well model calibration per well string.
 *
 * Contains model-matched rates generated by the Prosper well model, which are
 * aligned with well test data, including oil, gas, water, liquid rates, and
 * bottom hole pressure (BHP). Sourced from calibrated Prosper models and is used
 * to evaluate the accuracy of the model against actual measurements, answering
 * questions related to model performance and well efficiency. It excludes raw
 * well test data or uncalibrated model outputs, distinguishing it from other
 * views that may focus on unprocessed measurements. Use cases: assessing model
 * quality through alarm flags that highlight deviations from both measured data
 * and historical performance trends.
 *
 * @name Model-Matched Rates - String (Agent)
 */
export type ModelMatchedRatesStringAgent = {
  /** Model-matched condensate-gas ratio at live/local conditions (stb/MMscf, TS). */
  cgrLC?: Maybe<TimeSeries>;
  /** Model-matched condensate-gas ratio at standard conditions (stb/MMscf, TS). */
  cgrSC?: Maybe<TimeSeries>;
  /**
   * Choke model validation alarm (TS). 1 = pass, 0 = fail.
   * @name chokeCheckStatus
   */
  chokeAlarms?: Maybe<TimeSeries>;
  /**
   * Choke equation gas rate (MMscfd, TS).
   * @name chokeCalculatedGasRate
   */
  chokeMatchedgasRate?: Maybe<TimeSeries>;
  /**
   * Choke equation liquid rate (stb/d, TS).
   * @name chokeCalculatedLiquidRate
   */
  chokeMatchedliquidRate?: Maybe<TimeSeries>;
  /**
   * Measured gas rate at standard conditions (MMscfd, TS).
   * @name measuredGasRate
   */
  gasRateSC?: Maybe<TimeSeries>;
  /** Model-matched gas-oil ratio at live/local conditions (scf/stb, TS). */
  gorLC?: Maybe<TimeSeries>;
  /**
   * Historical trend validation alarm (TS). 1 = pass, 0 = fail.
   * @name historyCheckStatus
   */
  historicalAlarms?: Maybe<TimeSeries>;
  /**
   * Prosper model validation alarm (TS). 1 = pass, 0 = fail.
   * @name modelCheckStatus
   */
  modelAlarms?: Maybe<TimeSeries>;
  /** Prosper model-matched flowing bottom-hole pressure (psi, TS). */
  modelMatchedBHP?: Maybe<TimeSeries>;
  /**
   * Prosper model-matched gas rate (MMscfd, TS).
   * @name modelMatchedGasRate
   */
  modelMatchedgasRate?: Maybe<TimeSeries>;
  /**
   * Prosper model-matched total liquid rate (stb/d, TS).
   * @name modelMatchedLiquidRate
   */
  modelMatchedliquidRate?: Maybe<TimeSeries>;
  /**
   * Prosper model-matched oil rate (stb/d, TS).
   * @name modelMatchedOilRate
   */
  modelMatchedoilRate?: Maybe<TimeSeries>;
  /**
   * Prosper model-matched water rate (stb/d, TS).
   * @name modelMatchedWaterRate
   */
  modelMatchedwaterRate?: Maybe<TimeSeries>;
  /**
   * Measured oil rate at standard conditions (stb/d, TS).
   * @name measuredOilRate
   */
  oilRateSC?: Maybe<TimeSeries>;
  /**
   * PVT validation alarm (TS). 1 = pass, 0 = fail.
   * @name pvtCheckStatus
   */
  pvtAlarms?: Maybe<TimeSeries>;
  /** Model-matched total gas-oil ratio at standard conditions (scf/stb, TS). */
  totalGorSC?: Maybe<TimeSeries>;
  /** Model-matched water cut at live/local conditions (fraction, TS). */
  waterCutLC?: Maybe<TimeSeries>;
  /** Model-matched water cut at standard conditions (fraction, TS). */
  waterCutSC?: Maybe<TimeSeries>;
  /** Well string identifier. */
  wellString?: Maybe<StringAsset>;
  /** Model-matched water-gas ratio at live/local conditions (stb/MMscf, TS). */
  wgrLC?: Maybe<TimeSeries>;
  /** Model-matched water-gas ratio at standard conditions (stb/MMscf, TS). */
  wgrSC?: Maybe<TimeSeries>;
};

/** Mpfm view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type Mpfm = {
  /** Attribute capturing end date time for this entity in the production optimization context. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Entity Type attribute describing this entity in more detail, often derived from master data or configuration tables. */
  entityType?: Maybe<Scalars['String']['output']>;
  /** Location attribute describing this entity in more detail, often derived from master data or configuration tables. */
  location?: Maybe<Location>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  modelName?: Maybe<Scalars['String']['output']>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  name?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing start date time for this entity in the production optimization context. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
};

/** Configuration parameters and input signals for the multiphase flow meter (MPFM) model, such as PVT properties, calibration factors, and operating settings used to compute phase rates and diagnostics. */
export type MpfmInputs = {
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Mpfm>;
  /** Time series signal representing mpfm bswmax range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmBSWMaxRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm bswmin range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmBSWMinRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm calc cgrin situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmCalcCGRInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm calc cgrstd for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmCalcCGRStd?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm calc gorinsitu for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmCalcGORInsitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm calc gorstd for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmCalcGORStd?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm calc gas density in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmCalcGasDensityInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm calc liquid rate in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmCalcLiquidRateInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm calc liquid rate std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmCalcLiquidRateStd?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm calc oil density in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmCalcOilDensityInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm calc wgrin situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmCalcWGRInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm calc wgrstd for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmCalcWGRStd?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm calc wlrin situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmCalcWLRInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm calc water density in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmCalcWaterDensityInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm cum gas vol in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmCumGasVolInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm cum gas vol std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmCumGasVolStd?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm cum liquid vol in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmCumLiquidVolInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm cum liquid vol std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmCumLiquidVolStd?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm delta press max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmDeltaPressMaxRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm delta press min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmDeltaPressMinRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm differential press for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmDifferentialPress?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm flag on test for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmFlagOnTest?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm gorlcmax range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmGORLCMaxRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm gorlcmin range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmGORLCMinRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm gorstb for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmGORSTB?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm gvfin situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmGVFInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm gvfmax range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmGVFMaxRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm gvfmin range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmGVFMinRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm gas density in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmGasDensityInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm gas density max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmGasDensityMaxRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm gas density min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmGasDensityMinRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm gas density std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmGasDensityStd?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm gas mass flow in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmGasMassFlowInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm gas mass flow rate max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmGasMassFlowRateMaxRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm gas mass flow rate min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmGasMassFlowRateMinRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm gas mass flow std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmGasMassFlowStd?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm gas max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmGasMaxRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm gas min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmGasMinRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm gas rate in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmGasRateInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm gas rate std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmGasRateStd?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm line press for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmLinePress?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm line temp for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmLineTemp?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm liq max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmLiqMaxRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm liq min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmLiqMinRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm liquid rate in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmLiquidRateInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm liquid rate stb for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmLiquidRateSTB?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm ovfmax range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmOVFMaxRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm ovfmin range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmOVFMinRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm oil density in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmOilDensityInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm oil density max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmOilDensityMaxRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm oil density min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmOilDensityMinRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm oil density std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmOilDensityStd?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm oil mass flow in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmOilMassFlowInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm oil mass flow rate max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmOilMassFlowRateMaxRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm oil mass flow rate min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmOilMassFlowRateMinRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm oil mass flow std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmOilMassFlowStd?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm oil max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmOilMaxRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm oil min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmOilMinRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm oil rate in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmOilRateInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm oil rate std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmOilRateStd?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm oil vol fraction in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmOilVolFractionInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm press max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmPressMaxRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm press min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmPressMinRange?: Maybe<TimeSeries>;
  /** Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  mpfmStatus?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm temp max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmTempMaxRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm temp min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmTempMinRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm total gorscmax range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmTotalGORSCMaxRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm total gorscmin range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmTotalGORSCMinRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm total mass flow for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmTotalMassFlow?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm wlrmax range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmWLRMaxRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm wlrmin range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmWLRMinRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm wvfmax range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmWVFMaxRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm wvfmin range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmWVFMinRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm water cut in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmWaterCutInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm water cut stb for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmWaterCutSTB?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm water density in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmWaterDensityInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm water density max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmWaterDensityMaxRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm water density min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmWaterDensityMinRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm water density std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmWaterDensityStd?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm water mass flow in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmWaterMassFlowInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm water mass flow rate max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmWaterMassFlowRateMaxRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm water mass flow rate min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmWaterMassFlowRateMinRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm water mass flow std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmWaterMassFlowStd?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm water max range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmWaterMaxRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm water min range for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmWaterMinRange?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm water rate in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmWaterRateInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm water rate std for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmWaterRateStd?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm water salinity for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmWaterSalinity?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm water volume fraction in situ for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmWaterVolumeFractionInSitu?: Maybe<TimeSeries>;
};

/** Measured and modeled outputs from the multiphase flow meter (MPFM) for a well or production stream, covering phase rates, pressures, compositions, diagnostics, and model match indicators used for calibration and surveillance. */
export type MpfmOutputs = {
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  cgrLC?: Maybe<TimeSeries>;
  /** MPFM-related alarm indicators or codes capturing issues such as bad input data, unstable flow regime, or model extrapolation beyond calibrated ranges. */
  chokeAlarms?: Maybe<TimeSeries>;
  /** MPFM-related alarm indicators or codes capturing issues such as bad input data, unstable flow regime, or model extrapolation beyond calibrated ranges. */
  chokeAlarmsCode?: Maybe<TimeSeries>;
  /** Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation. */
  chokeMatchedliquidRate?: Maybe<TimeSeries>;
  /** Free-text comments field capturing operator or engineer notes related to this measurement, configuration, or event. */
  comments?: Maybe<TimeSeries>;
  /** Fluid composition vector used by the MPFM model, such as gas–oil ratio, water cut, or component fractions, important for accurate rate computation and diagnostics. */
  composition?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  espwear?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  fluidProperties?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  formationGOR?: Maybe<TimeSeries>;
  /** Fluid density used or measured by the MPFM, either at line conditions (LC) or standard conditions (SC), used in converting between mass and volumetric rates and in model calculations. */
  gasDensityLC?: Maybe<TimeSeries>;
  /** Fluid density used or measured by the MPFM, either at line conditions (LC) or standard conditions (SC), used in converting between mass and volumetric rates and in model calculations. */
  gasDensitySC?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  gasMassFlowRateLC?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  gasMassFlowRateSC?: Maybe<TimeSeries>;
  /** Phase volume fraction at line conditions derived from MPFM measurements, indicating the proportion of each phase in the flow stream and helping to diagnose flow regime and measurement quality. */
  gasVolumeFractionLC?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  glFcvOutletTemp?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  glinjectionRate?: Maybe<TimeSeries>;
  /** MPFM-related alarm indicators or codes capturing issues such as bad input data, unstable flow regime, or model extrapolation beyond calibrated ranges. */
  historicalAlarms?: Maybe<TimeSeries>;
  /** MPFM-related alarm indicators or codes capturing issues such as bad input data, unstable flow regime, or model extrapolation beyond calibrated ranges. */
  historicalAlarmsCode?: Maybe<TimeSeries>;
  /** Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation. */
  liquidRateLc?: Maybe<TimeSeries>;
  /** Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation. */
  liquidRateSc?: Maybe<TimeSeries>;
  /** MPFM-related alarm indicators or codes capturing issues such as bad input data, unstable flow regime, or model extrapolation beyond calibrated ranges. */
  modelAlarms?: Maybe<TimeSeries>;
  /** MPFM-related alarm indicators or codes capturing issues such as bad input data, unstable flow regime, or model extrapolation beyond calibrated ranges. */
  modelAlarmsCode?: Maybe<TimeSeries>;
  /** Fluid composition vector used by the MPFM model, such as gas–oil ratio, water cut, or component fractions, important for accurate rate computation and diagnostics. */
  modelComposition?: Maybe<TimeSeries>;
  /** Model-derived diagnostic metric from the MPFM solution, indicating how well the internal model matches measured data and whether the flow is within stable operating envelopes. */
  modelMatchedBHP?: Maybe<TimeSeries>;
  /** Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation. */
  modelMatchedgasRate?: Maybe<TimeSeries>;
  /** Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation. */
  modelMatchedliquidRate?: Maybe<TimeSeries>;
  /** Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation. */
  modelMatchedoilRate?: Maybe<TimeSeries>;
  /** Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation. */
  modelMatchedwaterRate?: Maybe<TimeSeries>;
  /** Model-derived diagnostic metric from the MPFM solution, indicating how well the internal model matches measured data and whether the flow is within stable operating envelopes. */
  modelMinStableRate?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  modelProductivityIndex?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  modelReservoirModel?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  modelReservoirPressure?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  modelStabilityFlag?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  modelVlpModel?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  modelWellTestTimestamp?: Maybe<TimeSeries>;
  /** MPFM-related alarm indicators or codes capturing issues such as bad input data, unstable flow regime, or model extrapolation beyond calibrated ranges. */
  mpfmAlarms?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  mpfmDifferentialPressure?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  mpfmLinePressure?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  mpfmLineTemperature?: Maybe<TimeSeries>;
  /** Fluid density used or measured by the MPFM, either at line conditions (LC) or standard conditions (SC), used in converting between mass and volumetric rates and in model calculations. */
  oilDensityLC?: Maybe<TimeSeries>;
  /** Fluid density used or measured by the MPFM, either at line conditions (LC) or standard conditions (SC), used in converting between mass and volumetric rates and in model calculations. */
  oilDensitySC?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  oilMassFlowRateLC?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  oilMassFlowRateSC?: Maybe<TimeSeries>;
  /** Phase volume fraction at line conditions derived from MPFM measurements, indicating the proportion of each phase in the flow stream and helping to diagnose flow regime and measurement quality. */
  oilVolumeFractionLC?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  ptsDateTime?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  pumpDischargeTemp?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  pumpMotorTemp?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  pumpPower?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  pumpVibration?: Maybe<TimeSeries>;
  /** MPFM-related alarm indicators or codes capturing issues such as bad input data, unstable flow regime, or model extrapolation beyond calibrated ranges. */
  pvtAlarms?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  sampleDateTime?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  stablePeriodEndDate?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  stablePeriodStartDate?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  validatedBy?: Maybe<TimeSeries>;
  /** Fluid density used or measured by the MPFM, either at line conditions (LC) or standard conditions (SC), used in converting between mass and volumetric rates and in model calculations. */
  waterDensityLC?: Maybe<TimeSeries>;
  /** Fluid density used or measured by the MPFM, either at line conditions (LC) or standard conditions (SC), used in converting between mass and volumetric rates and in model calculations. */
  waterDensitySC?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  waterMassFlowRateLC?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  waterMassFlowRateSC?: Maybe<TimeSeries>;
  /** Phase volume fraction at line conditions derived from MPFM measurements, indicating the proportion of each phase in the flow stream and helping to diagnose flow regime and measurement quality. */
  waterVolumeFractionLC?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  wellTestApprovedAllocationFlag?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestArtificialLiftType?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestBottomHolePressure?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestBottomHoleTemperature?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestCGR?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestCasingHeadPressure?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestCasingHeadTemperature?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestChokeOpening?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestChokeSize?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestDuration?: Maybe<TimeSeries>;
  /** Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation. */
  wellTestEgorVendorStdGasRate?: Maybe<TimeSeries>;
  /** Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation. */
  wellTestEgorVendorStdOilRate?: Maybe<TimeSeries>;
  /** Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation. */
  wellTestEgorVendorStdWaterRate?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestEndDate?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestEspMotorCurrent?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestEspMotorPower?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestEspMotorVoltage?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestEspPumpDischargePressure?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestEspPumpFrequency?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestEspPumpIntakePressure?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestEspPumpIntakeTemperature?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestFlowlinePressure?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestFlowlineTemperature?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestGOR?: Maybe<TimeSeries>;
  /** Fluid density used or measured by the MPFM, either at line conditions (LC) or standard conditions (SC), used in converting between mass and volumetric rates and in model calculations. */
  wellTestGasDensityInSitu?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestGasLiftVolume?: Maybe<TimeSeries>;
  /** Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation. */
  wellTestGasRateInsitu?: Maybe<TimeSeries>;
  /** Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation. */
  wellTestGasRatePts?: Maybe<TimeSeries>;
  /** Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation. */
  wellTestGasRateStd?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestGlFlControlValvOutletPres?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestGlFlControlValveInletPres?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestGlFlControlValveInletTemp?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestGlInjectionChokeOpening?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestGorInsitu?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestGorPts?: Maybe<TimeSeries>;
  /** Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation. */
  wellTestLiquidRatePts?: Maybe<TimeSeries>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  wellTestMpfmName?: Maybe<TimeSeries>;
  /** Fluid density used or measured by the MPFM, either at line conditions (LC) or standard conditions (SC), used in converting between mass and volumetric rates and in model calculations. */
  wellTestOilDensityInSitu?: Maybe<TimeSeries>;
  /** Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation. */
  wellTestOilRateInsitu?: Maybe<TimeSeries>;
  /** Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation. */
  wellTestOilRatePts?: Maybe<TimeSeries>;
  /** Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation. */
  wellTestOilRateStd?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestStartDate?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestStartDateDH?: Maybe<TimeSeries>;
  /** Text describing the functional role of the production string (for example main producer, backup, injector, idle), used in surveillance and planning. */
  wellTestStringFunction?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestTestMethod?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestTestSeparatorLinePressure?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestTestSeparatorLineTemperature?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestTestType?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestTestTypeDesc?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestTotalGorStd?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestTotalMassFlowRateGas?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestTotalMassFlowRateOil?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestTotalMassFlowRateWater?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  wellTestValidationFlag?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestWGR?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestWaterCut?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestWaterCutInsitu?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestWaterCutPts?: Maybe<TimeSeries>;
  /** Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation. */
  wellTestWaterRateInsitu?: Maybe<TimeSeries>;
  /** Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation. */
  wellTestWaterRatePts?: Maybe<TimeSeries>;
  /** Phase flow rate calculated or measured by the multiphase flow meter (MPFM) at line or standard conditions, used for well surveillance, allocation calibration, and model validation. */
  wellTestWaterRateStd?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestWellheadPressure?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wellTestWellheadTemperature?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wgrLC?: Maybe<TimeSeries>;
  /** Time series output from the multiphase flow meter (MPFM) representing a measured or computed quantity used in well surveillance and allocation. */
  wlrLC?: Maybe<TimeSeries>;
};

/** Well test results derived from the multiphase flow meter (MPFM), including stabilized phase rates and key test conditions, used to calibrate allocation and network models. */
export type MpfmWellTestOutputs = {
  /** Numeric value storing alarm count for this well, used in calculations, reporting, or model configuration. */
  alarmCount?: Maybe<Scalars['Int']['output']>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Mpfm>;
  /** Field attribute describing this well in more detail, often derived from master data or configuration tables. */
  field?: Maybe<Field>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  process1Flag?: Maybe<Scalars['String']['output']>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  process2Flag?: Maybe<Scalars['String']['output']>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  process3Flag?: Maybe<Scalars['String']['output']>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  process4Flag?: Maybe<Scalars['String']['output']>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  singlePointWellTestFlag?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing stable period end date time for this well in the production optimization context. */
  stablePeriodEndDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  stablePeriodFlag?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing stable period start date time for this well in the production optimization context. */
  stablePeriodStartDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Attribute capturing start date time for this well in the production optimization context. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** String On Test attribute describing this well in more detail, often derived from master data or configuration tables. */
  stringOnTest?: Maybe<StringAsset>;
  /** Well On Test attribute describing this well in more detail, often derived from master data or configuration tables. */
  wellOnTest?: Maybe<Well>;
  /** Attribute capturing well test date time for this well in the production optimization context. */
  wellTestDateTime?: Maybe<Scalars['Timestamp']['output']>;
};

/** Network view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type Network = {
  /** Attribute capturing connected fields for this entity in the production optimization context. */
  connectedFields?: Maybe<Maybe<Field>[]>;
  /** Attribute capturing end date time for this entity in the production optimization context. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Entity Type attribute describing this entity in more detail, often derived from master data or configuration tables. */
  entityType?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing field for this entity in the production optimization context. */
  field?: Maybe<Maybe<Field>[]>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  fieldName?: Maybe<Field>;
  /** Attribute capturing linked field for this entity in the production optimization context. */
  linkedField?: Maybe<Maybe<Scalars['JSONObject']['output']>[]>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  name?: Maybe<Scalars['String']['output']>;
  /** Network Type attribute describing this entity in more detail, often derived from master data or configuration tables. */
  networkType?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  primaryFluid?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing start date time for this entity in the production optimization context. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
};

/** Input parameters, constraints, and configuration used by the integrated production network model, such as equipment limits, control settings, and boundary conditions for simulations and optimizations. */
export type NetworkInputs = {
  /** Time series signal representing asphaltene table for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  asphalteneTable?: Maybe<TimeSeries>;
  /** Time series signal representing available glrate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  availableGLRate?: Maybe<TimeSeries>;
  /** Time series signal representing available power for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  availablePower?: Maybe<TimeSeries>;
  /** Time series signal representing capacity gas rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  capacityGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing capacity oil rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  capacityOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing capacity water rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  capacityWaterRate?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Network>;
  /** Time series signal representing flowline max cfactor for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  flowlineMaxCFactor?: Maybe<TimeSeries>;
  /** Time series signal representing flowline max line pressure for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  flowlineMaxLinePressure?: Maybe<TimeSeries>;
  /** Time series signal representing flowline max mixture velocity for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  flowlineMaxMixtureVelocity?: Maybe<TimeSeries>;
  /** Time series signal representing gas barrel of oil equivalent for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasBarrelOfOilEquivalent?: Maybe<TimeSeries>;
  /** Time series signal representing gas price for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasPrice?: Maybe<TimeSeries>;
  /** Time series signal representing gas processing cost for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasProcessingCost?: Maybe<TimeSeries>;
  /** Time series signal representing hydrate table for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  hydrateTable?: Maybe<TimeSeries>;
  /** Time series signal representing joint max co2 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  jointMaxCO2?: Maybe<TimeSeries>;
  /** Time series signal representing joint max gas rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  jointMaxGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing joint max h2 s for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  jointMaxH2S?: Maybe<TimeSeries>;
  /** Time series signal representing joint max liquid rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  jointMaxLiquidRate?: Maybe<TimeSeries>;
  /** Time series signal representing joint max n2 for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  jointMaxN2?: Maybe<TimeSeries>;
  /** Time series signal representing joint max oil rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  jointMaxOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing joint max pressure for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  jointMaxPressure?: Maybe<TimeSeries>;
  /** Time series signal representing joint min pressure for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  jointMinPressure?: Maybe<TimeSeries>;
  /** Time series signal representing lift cost for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  liftCost?: Maybe<TimeSeries>;
  /** Time series signal representing manifold press for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  manifoldPress?: Maybe<TimeSeries>;
  /** Time series signal representing manifold temp for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  manifoldTemp?: Maybe<TimeSeries>;
  /** Time series signal representing oil price for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilPrice?: Maybe<TimeSeries>;
  /** Time series signal representing oil processing cost for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilProcessingCost?: Maybe<TimeSeries>;
  /** Time series signal representing planned facility downtime for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  plannedFacilityDowntime?: Maybe<TimeSeries>;
  /** Time series signal representing scale table for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  scaleTable?: Maybe<TimeSeries>;
  /** Time series signal representing separator gas rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  separatorGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing separator max gas rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  separatorMaxGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing separator max oil rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  separatorMaxOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing separator max water rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  separatorMaxWaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing separator oil rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  separatorOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing separator pressure for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  separatorPressure?: Maybe<TimeSeries>;
  /** Time series signal representing separator temperature for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  separatorTemperature?: Maybe<TimeSeries>;
  /** Time series signal representing separator water rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  separatorWaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing surface pump max liquid rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  surfacePumpMaxLiquidRate?: Maybe<TimeSeries>;
  /** Time series signal representing water disposal cost for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterDisposalCost?: Maybe<TimeSeries>;
  /** Time series signal representing wax table for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waxTable?: Maybe<TimeSeries>;
  /** Time series signal representing well max gor for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellMaxGOR?: Maybe<TimeSeries>;
};

/** Definition and metadata for the integrated production network model, including topology, fluid systems, and configuration versions used to support simulation and optimization scenarios. */
export type NetworkModel = {
  /** Change Details attribute describing this entity in more detail, often derived from master data or configuration tables. */
  changeDetails?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing connected fields for this entity in the production optimization context. */
  connectedFields?: Maybe<Maybe<Field>[]>;
  /** Free-text description providing engineering context, assumptions, or clarifications about this entity or the associated signal, used to support interpretation and troubleshooting. */
  description?: Maybe<Scalars['String']['output']>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  garFileName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  legacyGapFileExternalId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  legacyGapFileId?: Maybe<Scalars['Int64']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  legacyGarFileExternalId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  legacyGarFileId?: Maybe<Scalars['Int64']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  legacyInputGapFileId?: Maybe<Scalars['Int64']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  legacyInputGarFileId?: Maybe<Scalars['Int64']['output']>;
  /** Attribute capturing model config for this entity in the production optimization context. */
  modelConfig?: Maybe<Scalars['JSONObject']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  modelConfigLegacyFileExternalId?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing model effective time for this entity in the production optimization context. */
  modelEffectiveTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  modelSimIntRevisionConfigLegacyFileExternalId?: Maybe<Scalars['String']['output']>;
  /** Model Updated By attribute describing this entity in more detail, often derived from master data or configuration tables. */
  modelUpdatedBy?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing model updated time for this entity in the production optimization context. */
  modelUpdatedTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Model Uploaded By attribute describing this entity in more detail, often derived from master data or configuration tables. */
  modelUploadedBy?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing model uploaded time for this entity in the production optimization context. */
  modelUploadedTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Network attribute describing this entity in more detail, often derived from master data or configuration tables. */
  network?: Maybe<Network>;
  /** Network Type attribute describing this entity in more detail, often derived from master data or configuration tables. */
  networkType?: Maybe<Scalars['String']['output']>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  originalGarFileName?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing pressure matched well models for this entity, used in calculations, reporting, or model configuration. */
  pressureMatchedWellModels?: Maybe<Scalars['Int']['output']>;
  /** Attribute capturing productivity index difference percentage for this entity in the production optimization context. */
  productivityIndexDifferencePercentage?: Maybe<Scalars['JSONObject']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  simIntExternalId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  simIntModelExternalId?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing sim int model revision created time for this entity in the production optimization context. */
  simIntModelRevisionCreatedTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Free-text description providing engineering context, assumptions, or clarifications about this entity or the associated signal, used to support interpretation and troubleshooting. */
  simIntModelRevisionDescription?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  simIntModelRevisionExternalId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  simIntModelRevisionId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  simIntModelRevisionLogId?: Maybe<Scalars['String']['output']>;
  /** Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  simIntModelRevisionStatus?: Maybe<Scalars['String']['output']>;
  /** Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  simIntModelRevisionStatusMessage?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing sim int model revision updated time for this entity in the production optimization context. */
  simIntModelRevisionUpdatedTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  simIntModelRevisionVersionId?: Maybe<Scalars['Int']['output']>;
  /** Source attribute describing this entity in more detail, often derived from master data or configuration tables. */
  source?: Maybe<Scalars['String']['output']>;
  /** Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  status?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing total well models for this entity, used in calculations, reporting, or model configuration. */
  totalWellModels?: Maybe<Scalars['Int']['output']>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  wf8Processed?: Maybe<Scalars['Boolean']['output']>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  wf9Consumed?: Maybe<Scalars['Boolean']['output']>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  wf9Processed?: Maybe<Scalars['Boolean']['output']>;
};

/** Outputs from the integrated production network model at the specified aggregation level, including simulated phase rates, pressures, bottleneck indicators, and scenario results used in optimization and planning. */
export type NetworkOutputsField = {
  /** User name, role, or system identifier that executed the ad-hoc optimization or simulation scenario, providing traceability for scenario results. */
  adHocOptimization1ExecutedBy?: Maybe<TimeSeries>;
  /** Resulting gas rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity. */
  adHocOptimization1GasRate?: Maybe<TimeSeries>;
  /** Resulting oil rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity. */
  adHocOptimization1OilRate?: Maybe<TimeSeries>;
  /** Resulting water rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity. */
  adHocOptimization1WaterRate?: Maybe<TimeSeries>;
  /** User name, role, or system identifier that executed the ad-hoc optimization or simulation scenario, providing traceability for scenario results. */
  adHocOptimization2ExecutedBy?: Maybe<TimeSeries>;
  /** Resulting gas rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity. */
  adHocOptimization2GasRate?: Maybe<TimeSeries>;
  /** Resulting oil rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity. */
  adHocOptimization2OilRate?: Maybe<TimeSeries>;
  /** Resulting water rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity. */
  adHocOptimization2WaterRate?: Maybe<TimeSeries>;
  /** User name, role, or system identifier that executed the ad-hoc optimization or simulation scenario, providing traceability for scenario results. */
  adHocSimulation1ExecutedBy?: Maybe<TimeSeries>;
  /** Resulting gas rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity. */
  adHocSimulation1GasRate?: Maybe<TimeSeries>;
  /** Resulting oil rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity. */
  adHocSimulation1OilRate?: Maybe<TimeSeries>;
  /** Resulting water rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity. */
  adHocSimulation1WaterRate?: Maybe<TimeSeries>;
  /** User name, role, or system identifier that executed the ad-hoc optimization or simulation scenario, providing traceability for scenario results. */
  adHocSimulation2ExecutedBy?: Maybe<TimeSeries>;
  /** Resulting gas rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity. */
  adHocSimulation2GasRate?: Maybe<TimeSeries>;
  /** Resulting oil rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity. */
  adHocSimulation2OilRate?: Maybe<TimeSeries>;
  /** Resulting water rate from the ad-hoc optimization or simulation scenario at the field level, used to compare alternative operating strategies and quantify opportunity. */
  adHocSimulation2WaterRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calcualtedSeparatorGasRate?: Maybe<TimeSeries>;
  /** Simulated pressure at the relevant point in the production network for this field, derived from the network model and used to check constraints and diagnose bottlenecks. */
  calculatedFlowLinePressure?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedJointCo2?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedJointGasRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedJointH2S?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedJointLiquidRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedJointN2?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedJointOilRate?: Maybe<TimeSeries>;
  /** Simulated pressure at the relevant point in the production network for this field, derived from the network model and used to check constraints and diagnose bottlenecks. */
  calculatedJointPressure?: Maybe<TimeSeries>;
  /** Simulated pressure at the relevant point in the production network for this field, derived from the network model and used to check constraints and diagnose bottlenecks. */
  calculatedPressureMatchIndex?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedSeparatorOilRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedSepratorWaterRate?: Maybe<TimeSeries>;
  /** Total simulated gas rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates. */
  calculatedTotalGasRate?: Maybe<TimeSeries>;
  /** Total simulated gas rate for this field from gas injection wells or streams from the integrated production network model, used to understand system behavior and compare against measured rates. */
  calculatedTotalGasRateGI?: Maybe<TimeSeries>;
  /** Total simulated fluid rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates. */
  calculatedTotalLiquidRate?: Maybe<TimeSeries>;
  /** Total simulated fluid rate for this field from water injection wells or streams from the integrated production network model, used to understand system behavior and compare against measured rates. */
  calculatedTotalLiquidRateWI?: Maybe<TimeSeries>;
  /** Total simulated oil rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates. */
  calculatedTotalOilRate?: Maybe<TimeSeries>;
  /** Total simulated water rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates. */
  calculatedTotalWaterRate?: Maybe<TimeSeries>;
  /** Total simulated water rate for this field from water injection wells or streams from the integrated production network model, used to understand system behavior and compare against measured rates. */
  calculatedTotalWaterRateWI?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Field>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  estimatedFlowlineUnstableflowFlag?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  estimatedFlowlineflowassuranceflag?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  fsoprGasRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  fsoprOilRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  fsoprWaterRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  hydraulicGasRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  hydraulicOilRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  hydraulicWaterRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  systemOptimizedGasLiftRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  systemOptimizedGasRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  systemOptimizedOilRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  systemOptimizedPower?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  systemOptimizedWaterRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  technicalGasRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  technicalOilRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  technicalWaterRate?: Maybe<TimeSeries>;
  /** Total simulated gas rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates. */
  wellSolverEstimatedTotalGasRate?: Maybe<TimeSeries>;
  /** Total simulated fluid rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates. */
  wellSolverEstimatedTotalLiquidRate?: Maybe<TimeSeries>;
  /** Total simulated oil rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates. */
  wellSolverEstimatedTotalOilRate?: Maybe<TimeSeries>;
  /** Total simulated water rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates. */
  wellSolverEstimatedTotalWaterRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  wellSolverGasDeviation?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  wellSolverGasDifference?: Maybe<TimeSeries>;
  /** Index or score describing how well the simulated network results match measured data at this level, used to assess model quality before using it for optimization. */
  wellSolverGasFlowMatchIndex?: Maybe<TimeSeries>;
  /** Index or score describing how well the simulated network results match measured data at this level, used to assess model quality before using it for optimization. */
  wellSolverGasFlowMatchIndexTolerance?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  wellSolverLiquidDifference?: Maybe<TimeSeries>;
  /** Total simulated gas rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates. */
  wellSolverMeasuredTotalGasRate?: Maybe<TimeSeries>;
  /** Total simulated fluid rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates. */
  wellSolverMeasuredTotalLiquidRate?: Maybe<TimeSeries>;
  /** Total simulated oil rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates. */
  wellSolverMeasuredTotalOilRate?: Maybe<TimeSeries>;
  /** Total simulated water rate for this field from the integrated production network model, used to understand system behavior and compare against measured rates. */
  wellSolverMeasuredTotalWaterRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  wellSolverOilDeviation?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  wellSolverOilDifference?: Maybe<TimeSeries>;
  /** Index or score describing how well the simulated network results match measured data at this level, used to assess model quality before using it for optimization. */
  wellSolverOilFlowMatchIndex?: Maybe<TimeSeries>;
  /** Index or score describing how well the simulated network results match measured data at this level, used to assess model quality before using it for optimization. */
  wellSolverOilFlowMatchIndexTolerance?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  wellSolverWaterDeviation?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  wellSolverWaterDifference?: Maybe<TimeSeries>;
  /** Index or score describing how well the simulated network results match measured data at this level, used to assess model quality before using it for optimization. */
  wellSolverWaterFlowMatchIndex?: Maybe<TimeSeries>;
  /** Index or score describing how well the simulated network results match measured data at this level, used to assess model quality before using it for optimization. */
  wellSolverWaterFlowMatchIndexTolerance?: Maybe<TimeSeries>;
};

/** Outputs from the integrated production network model at the specified aggregation level, including simulated phase rates, pressures, bottleneck indicators, and scenario results used in optimization and planning. */
export type NetworkOutputsString = {
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocOptimization1ChokeBeanSize?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocOptimization1ChokeOpening?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocOptimization1EspFrequency?: Maybe<TimeSeries>;
  /** User name, role, or system identifier that executed the ad-hoc optimization or simulation scenario, providing traceability for scenario results. */
  adHocOptimization1ExecutedBy?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocOptimization1FBHP?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocOptimization1FWHP?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocOptimization1GasLiftRate?: Maybe<TimeSeries>;
  /** Resulting gas rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity. */
  adHocOptimization1GasRate?: Maybe<TimeSeries>;
  /** Resulting oil rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity. */
  adHocOptimization1OilRate?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocOptimization1OptimizedParameter?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocOptimization1Power?: Maybe<TimeSeries>;
  /** Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  adHocOptimization1RunID?: Maybe<TimeSeries>;
  /** Resulting water rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity. */
  adHocOptimization1WaterRate?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocOptimization2ChokeBeanSize?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocOptimization2ChokeOpening?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocOptimization2EspFrequency?: Maybe<TimeSeries>;
  /** User name, role, or system identifier that executed the ad-hoc optimization or simulation scenario, providing traceability for scenario results. */
  adHocOptimization2ExecutedBy?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocOptimization2FBHP?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocOptimization2FWHP?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocOptimization2GasLiftRate?: Maybe<TimeSeries>;
  /** Resulting gas rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity. */
  adHocOptimization2GasRate?: Maybe<TimeSeries>;
  /** Resulting oil rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity. */
  adHocOptimization2OilRate?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocOptimization2OptimizedParameter?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocOptimization2Power?: Maybe<TimeSeries>;
  /** Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  adHocOptimization2RunID?: Maybe<TimeSeries>;
  /** Resulting water rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity. */
  adHocOptimization2WaterRate?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocSimulation1ChokeBeanSize?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocSimulation1ChokeOpening?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocSimulation1EspFrequency?: Maybe<TimeSeries>;
  /** User name, role, or system identifier that executed the ad-hoc optimization or simulation scenario, providing traceability for scenario results. */
  adHocSimulation1ExecutedBy?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocSimulation1FBHP?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocSimulation1FWHP?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocSimulation1GasLiftRate?: Maybe<TimeSeries>;
  /** Resulting gas rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity. */
  adHocSimulation1GasRate?: Maybe<TimeSeries>;
  /** Resulting oil rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity. */
  adHocSimulation1OilRate?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocSimulation1OptimizedParameter?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocSimulation1Power?: Maybe<TimeSeries>;
  /** Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  adHocSimulation1RunID?: Maybe<TimeSeries>;
  /** Resulting water rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity. */
  adHocSimulation1WaterRate?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocSimulation2ChokeBeanSize?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocSimulation2ChokeOpening?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocSimulation2EspFrequency?: Maybe<TimeSeries>;
  /** User name, role, or system identifier that executed the ad-hoc optimization or simulation scenario, providing traceability for scenario results. */
  adHocSimulation2ExecutedBy?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocSimulation2FBHP?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocSimulation2FWHP?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocSimulation2GasLiftRate?: Maybe<TimeSeries>;
  /** Resulting gas rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity. */
  adHocSimulation2GasRate?: Maybe<TimeSeries>;
  /** Resulting oil rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity. */
  adHocSimulation2OilRate?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocSimulation2OptimizedParameter?: Maybe<TimeSeries>;
  /** Numeric result or configuration parameter associated with an ad-hoc optimization or simulation scenario in the network model, used for what-if analysis and decision support. */
  adHocSimulation2Power?: Maybe<TimeSeries>;
  /** Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  adHocSimulation2RunID?: Maybe<TimeSeries>;
  /** Resulting water rate from the ad-hoc optimization or simulation scenario at the production string level, used to compare alternative operating strategies and quantify opportunity. */
  adHocSimulation2WaterRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  asphalteneFlag_well?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedChokeBeanSize?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedChokeBeanSizeGI?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedChokeBeanSizeWI?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedChokeOpening?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedEspFrequency?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedGasLiftRate?: Maybe<TimeSeries>;
  /** Index or score describing how well the simulated network results match measured data at this level, used to assess model quality before using it for optimization. */
  calculatedGasRateMatchIndex?: Maybe<TimeSeries>;
  /** Index or score describing how well the simulated network results match measured data at this level, used to assess model quality before using it for optimization. */
  calculatedOilRateMatchIndex?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedPower?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedPumpLquidRate?: Maybe<TimeSeries>;
  /** Index or score describing how well the simulated network results match measured data at this level, used to assess model quality before using it for optimization. */
  calculatedWaterRateMatchIndex?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedWellBHP?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedWellBHPGI?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedWellBHPWI?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedWellESPMotorLoad?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedWellFBHP?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedWellFWHP?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedWellGasRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedWellGasRateGI?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedWellLiquidRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedWellOilRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedWellWaterRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  calculatedWellWaterRateWI?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  chokeDP?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  constraintFlag_well?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  espEfficiency?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  formationWellGasOilRatio?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  fsoprChokeBeanSize?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  fsoprChokeOpening?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  fsoprEspFrequency?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  fsoprFBHP?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  fsoprFWHP?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  fsoprGasLiftRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  fsoprGasRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  fsoprOilRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  fsoprOptimizedParameter?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  fsoprPower?: Maybe<TimeSeries>;
  /** Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  fsoprRunID?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  fsoprWaterRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  gapOptimizedParameter?: Maybe<TimeSeries>;
  /** Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  gapWellName?: Maybe<Scalars['String']['output']>;
  /** Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  gapWellNameHistorical?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  gasLiftInjection?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  gasLiftInjectionPress?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  hydrateFlag_well?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  hydraulicChokeBeanSize?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  hydraulicChokeOpening?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  hydraulicEspFrequency?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  hydraulicFBHP?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  hydraulicFWHP?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  hydraulicGasLiftRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  hydraulicGasRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  hydraulicOilRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  hydraulicOptimizedParameter?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  hydraulicPower?: Maybe<TimeSeries>;
  /** Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  hydraulicRunID?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  hydraulicWaterRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  pe5StabilityFlag_well?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  scaleFlag_well?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  systemOptimizedChokeBeanSize?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  systemOptimizedChokeOpening?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  systemOptimizedEspFrequency?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  systemOptimizedFBHP?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  systemOptimizedFWHP?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  systemOptimizedGasLiftRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  systemOptimizedGasRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  systemOptimizedOilRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  systemOptimizedOptimizedParameter?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  systemOptimizedPower?: Maybe<TimeSeries>;
  /** Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  systemOptimizedRunID?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  systemOptimizedWaterRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  technicalChokeBeanSize?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  technicalChokeOpening?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  technicalEspFrequency?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  technicalFBHP?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  technicalFWHP?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  technicalGasLiftRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  technicalGasRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  technicalOilRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  technicalOptimizedParameter?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  technicalPower?: Maybe<TimeSeries>;
  /** Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  technicalRunID?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  technicalWaterRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  waxFlag_well?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  wellSolverDifference?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  wellSolverEstimatedOilRate?: Maybe<TimeSeries>;
  /** Time series output from the integrated production network model representing a simulated operational variable at this level, used in planning and optimization analyses. */
  wellSolverMeasuredOilRate?: Maybe<TimeSeries>;
};

/**
 * Current-state network model rates per well string from WF7 GAP simulation (WF7).
 *
 * Calculated oil, gas, and water production rates per string with match indices
 * quantifying accuracy against measured rates. Use for current-state network
 * production performance and model match assessment. Excludes optimization
 * scenario rates (see OptimizedRates_Network_String_Agent) and the richer
 * per-network matched outputs (see StringOutputs_Network_Agent).
 *
 * Use for: Network Surveillance (WF7).
 *
 * @name Network Model Rates - String (Agent)
 */
export type NetworkRatesStringAgent = {
  /** Gas rate match index, calculated vs measured (0-1 scale, TS). */
  calculatedGasRateMatchIndex?: Maybe<TimeSeries>;
  /** Oil rate match index, calculated vs measured (0-1 scale, TS). */
  calculatedOilRateMatchIndex?: Maybe<TimeSeries>;
  /** Water rate match index, calculated vs measured (0-1 scale, TS). */
  calculatedWaterRateMatchIndex?: Maybe<TimeSeries>;
  /** Network-calculated flowing BHP (psi, TS). */
  calculatedWellFBHP?: Maybe<TimeSeries>;
  /** Network-solved gas production rate (MSCF/d, TS). */
  calculatedWellGasRate?: Maybe<TimeSeries>;
  /** Gas injection rate from network solve (MSCF/d, TS). */
  calculatedWellGasRateGI?: Maybe<TimeSeries>;
  /** Network-solved total liquid rate (stb/d, TS). */
  calculatedWellLiquidRate?: Maybe<TimeSeries>;
  /** Network-solved oil production rate (stb/d, TS). */
  calculatedWellOilRate?: Maybe<TimeSeries>;
  /** Network-solved water production rate (stb/d, TS). */
  calculatedWellWaterRate?: Maybe<TimeSeries>;
  /** Water injection rate from network solve (stb/d, TS). */
  calculatedWellWaterRateWI?: Maybe<TimeSeries>;
  /**
   * Formation gas-oil ratio input to GAP network model (scf/stb, TS).
   * @name formationGOR
   */
  formationWellGasOilRatio?: Maybe<TimeSeries>;
  /** GAP model well name mapping. */
  gapWellName?: Maybe<Scalars['String']['output']>;
  /** Gas lift injection rate from network solve (MSCF/d, TS). */
  gasLiftInjection?: Maybe<TimeSeries>;
  /** Difference between well solver estimated and measured oil rates (TS). */
  wellSolverDifference?: Maybe<TimeSeries>;
  /** Well solver estimated oil rate input (stb/d, TS). */
  wellSolverEstimatedOilRate?: Maybe<TimeSeries>;
  /** Well solver measured oil rate input (stb/d, TS). */
  wellSolverMeasuredOilRate?: Maybe<TimeSeries>;
  /** Well string identifier. */
  wellString?: Maybe<StringAsset>;
};

/**
 * Network risk indicators for flow assurance and operational risk (WF20).
 *
 * Risk scores and categories for network components. Use to assess failure points
 * and prioritize maintenance. Excludes financial or detailed performance metrics.
 *
 * Use for: Flow Assurance Detection and Mitigation (WF20).
 *
 * @name Network Risk (Agent)
 */
export type NetworkRiskAgent = {
  /** Overall aggregated flow assurance risk level (TS). */
  aggregatedRisk?: Maybe<TimeSeries>;
  /** Maximum asphaltene onset temperature delta (TS). */
  asphalteneDTMax?: Maybe<TimeSeries>;
  /** Asphaltene risk level (TS). */
  asphalteneRisk?: Maybe<TimeSeries>;
  /** Maximum corrosion rate across entity (TS). */
  corrosionRateMax?: Maybe<TimeSeries>;
  /** Corrosion risk level (TS). */
  corrosionRisk?: Maybe<TimeSeries>;
  /** Network entity name. */
  entityName?: Maybe<Entity>;
  /** Maximum erosion rate (TS). */
  erosionMax?: Maybe<TimeSeries>;
  /** Erosion risk level (TS). */
  erosionRisk?: Maybe<TimeSeries>;
  /** Maximum erosion velocity ratio (TS). >1 = exceeds limit. */
  evrMax?: Maybe<TimeSeries>;
  /** Erosion velocity risk level (TS). */
  evrRisk?: Maybe<TimeSeries>;
  /** Maximum hydrate temperature delta (TS). Negative = above hydrate curve. */
  hydrateDTMax?: Maybe<TimeSeries>;
  /** Hydrate formation risk level (TS). */
  hydrateRisk?: Maybe<TimeSeries>;
  /** Reference to parent network model. */
  network?: Maybe<Network>;
  /** Maximum PE5 stability indicator (TS). */
  pe5StabilityMax?: Maybe<TimeSeries>;
  /** PE5 stability risk level (TS). */
  pe5StabilityRisk?: Maybe<TimeSeries>;
  /** Maximum scale saturation index (TS). >1 = scaling likely. */
  scaleSIMax?: Maybe<TimeSeries>;
  /** Scale risk level (TS). */
  scaleSIRisk?: Maybe<TimeSeries>;
  /** Maximum wax deposition temperature delta (TS). Negative = below WAT. */
  waxDTMax?: Maybe<TimeSeries>;
  /** Wax deposition risk level (TS). */
  waxRisk?: Maybe<TimeSeries>;
};

/** Network Risk Optimization Scenarios view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type NetworkRiskOptimizationScenarios = {
  /** Time series signal representing aggregated risk for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  aggregatedRisk?: Maybe<TimeSeries>;
  /** Time series signal representing asphaltene dtmax for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  asphalteneDTMax?: Maybe<TimeSeries>;
  /** Time series signal representing asphaltene risk for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  asphalteneRisk?: Maybe<TimeSeries>;
  /** Time series signal representing corrosion rate max for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  corrosionRateMax?: Maybe<TimeSeries>;
  /** Time series signal representing corrosion risk for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  corrosionRisk?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Entity>;
  /** Time series signal representing erosion max for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  erosionMax?: Maybe<TimeSeries>;
  /** Time series signal representing erosion risk for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  erosionRisk?: Maybe<TimeSeries>;
  /** Time series signal representing evr max for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  evrMax?: Maybe<TimeSeries>;
  /** Time series signal representing evr risk for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  evrRisk?: Maybe<TimeSeries>;
  /** Time series signal representing hydrate dtmax for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  hydrateDTMax?: Maybe<TimeSeries>;
  /** Time series signal representing hydrate risk for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  hydrateRisk?: Maybe<TimeSeries>;
  /** Network attribute describing this entity in more detail, often derived from master data or configuration tables. */
  network?: Maybe<Network>;
  /** Time series signal representing pe5 stability max for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pe5StabilityMax?: Maybe<TimeSeries>;
  /** Time series signal representing pe5 stability risk for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pe5StabilityRisk?: Maybe<TimeSeries>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  runID?: Maybe<TimeSeries>;
  /** Time series signal representing scale simax for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  scaleSIMax?: Maybe<TimeSeries>;
  /** Time series signal representing scale sirisk for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  scaleSIRisk?: Maybe<TimeSeries>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  scenarioName?: Maybe<Scalars['String']['output']>;
  /** Time series signal representing wax dtmax for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waxDTMax?: Maybe<TimeSeries>;
  /** Time series signal representing wax risk for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waxRisk?: Maybe<TimeSeries>;
};

/**
 * Per-scenario network risk and mitigation comparison (WF11/WF20).
 *
 * Risk scores and mitigation recommendations for each optimization scenario,
 * including asphaltene, wax, and hydrate risk assessments, evaluated against a
 * current-state baseline. Use to compare candidate optimization strategies,
 * identify the most critical risks, and prioritize mitigation actions. For
 * current-state risk see NetworkRisk_Agent. Excludes raw operational data and
 * historical trends.
 *
 * Use for: Production Optimization Scenarios (WF11), Flow Assurance Detection and Mitigation (WF20).
 *
 * @name Network Risk - Optimization Scenarios (Agent)
 */
export type NetworkRiskOptimizationScenariosAgent = {
  /** Overall aggregated risk level for this scenario (TS). */
  aggregatedRisk?: Maybe<TimeSeries>;
  /** Maximum asphaltene delta-T for this scenario (TS). */
  asphalteneDTMax?: Maybe<TimeSeries>;
  /** Asphaltene risk level for this scenario (TS). */
  asphalteneRisk?: Maybe<TimeSeries>;
  /** Maximum corrosion rate for this scenario (TS). */
  corrosionRateMax?: Maybe<TimeSeries>;
  /** Corrosion risk level for this scenario (TS). */
  corrosionRisk?: Maybe<TimeSeries>;
  /** Network entity name. */
  entityName?: Maybe<Entity>;
  /** Maximum erosion rate for this scenario (TS). */
  erosionMax?: Maybe<TimeSeries>;
  /** Erosion risk level for this scenario (TS). */
  erosionRisk?: Maybe<TimeSeries>;
  /** Maximum erosion velocity ratio for this scenario (TS). */
  evrMax?: Maybe<TimeSeries>;
  /** Erosion velocity risk level for this scenario (TS). */
  evrRisk?: Maybe<TimeSeries>;
  /** Maximum hydrate delta-T for this scenario (TS). */
  hydrateDTMax?: Maybe<TimeSeries>;
  /** Hydrate risk level for this scenario (TS). */
  hydrateRisk?: Maybe<TimeSeries>;
  /** Reference to parent network model. */
  network?: Maybe<Network>;
  /** Maximum PE5 stability for this scenario (TS). */
  pe5StabilityMax?: Maybe<TimeSeries>;
  /** PE5 stability risk level for this scenario (TS). */
  pe5StabilityRisk?: Maybe<TimeSeries>;
  /** Unique identifier for this optimization run. */
  runID?: Maybe<TimeSeries>;
  /** Maximum scale saturation index for this scenario (TS). */
  scaleSIMax?: Maybe<TimeSeries>;
  /** Scale risk level for this scenario (TS). */
  scaleSIRisk?: Maybe<TimeSeries>;
  /** Name of the optimization scenario. */
  scenarioName?: Maybe<Scalars['String']['output']>;
  /** Maximum wax delta-T for this scenario (TS). */
  waxDTMax?: Maybe<TimeSeries>;
  /** Wax risk level for this scenario (TS). */
  waxRisk?: Maybe<TimeSeries>;
};

/**
 * Production optimization opportunities tracking potential gains from well
 * interventions.
 *
 * Contains data related to production optimization opportunities tracking
 * potential gains from well interventions. This view aggregates information from
 * operational databases and historical performance metrics, to analyze the
 * effectiveness of various well interventions. It answers analytical questions
 * such as the potential oil gain from specific opportunities, the status of open
 * or closed interventions, and the validation status of pending opportunities.
 * Excludes detailed financial metrics or external market conditions (see other
 * related views focused on economic analysis).
 */
export type OpportunityAgent = {
  /** Actual date when intervention was executed. */
  actualExecutionDate?: Maybe<Scalars['Date']['output']>;
  /** Current gas production rate before intervention (Mscf/d). */
  baselineGasRate?: Maybe<Scalars['Float']['output']>;
  /** Current oil production rate before intervention (stb/d). Baseline for gain calculation. */
  baselineOilRate?: Maybe<Scalars['Float']['output']>;
  /** Current water production rate before intervention (stb/d). */
  baselineWaterRate?: Maybe<Scalars['Float']['output']>;
  /** Date when opportunity was identified and created. */
  createdDate?: Maybe<Scalars['Date']['output']>;
  /** Cumulative oil production gained since execution (stb). Tracks realized value. */
  cumulativeOilGain?: Maybe<Scalars['Float']['output']>;
  /** Detailed description of the opportunity, including technical rationale. */
  description?: Maybe<Scalars['String']['output']>;
  /** Predicted gas rate after intervention (Mscf/d). */
  estimatedGasRate?: Maybe<Scalars['Float']['output']>;
  /** Predicted oil rate after intervention (stb/d). Expected gain = estimated - baseline. */
  estimatedOilRate?: Maybe<Scalars['Float']['output']>;
  /** Predicted water rate after intervention (stb/d). */
  estimatedWaterRate?: Maybe<Scalars['Float']['output']>;
  /** Type of intervention required (e.g., WORKOVER, CHOKE_CHANGE, STIMULATION). */
  interventionActivity?: Maybe<Scalars['String']['output']>;
  /** Person responsible for driving this opportunity to execution. */
  owner?: Maybe<Scalars['String']['output']>;
  /** Scheduled date for intervention execution. */
  plannedExecutionDate?: Maybe<Scalars['Date']['output']>;
  /** Origin of opportunity identification (e.g., SURVEILLANCE, WORKFLOW, MANUAL). */
  source?: Maybe<Scalars['String']['output']>;
  /**
   * Current opportunity status: OPEN, VALIDATED, PLANNED, EXECUTED, CLOSED.
   * Use to track lifecycle progress.
   */
  status?: Maybe<Scalars['String']['output']>;
  /** Brief summary of the production opportunity. Use for quick identification. */
  summary?: Maybe<Scalars['String']['output']>;
  /** Link to associated ticket in TicketRegistry. Use to join for full ticket details. */
  ticketExternalID?: Maybe<Scalars['String']['output']>;
  /** Type of opportunity (e.g., CHOKE_ADJUSTMENT, RECOMPLETION, GAS_LIFT_OPT). */
  type?: Maybe<Scalars['String']['output']>;
  /** Comments from validation review, including technical justification. */
  validationComments?: Maybe<Scalars['String']['output']>;
  /** Validation status: PENDING, VALIDATED, REJECTED. Indicates engineering review state. */
  validationStatus?: Maybe<Scalars['String']['output']>;
  /** Date when value tracking ended for this opportunity. */
  valueTrackingEndDate?: Maybe<Scalars['Date']['output']>;
  /** Reason for ending value tracking (e.g., RATE_DECLINE, NEW_INTERVENTION). */
  valueTrackingEndReason?: Maybe<Scalars['String']['output']>;
  /** Status of value tracking: ACTIVE, COMPLETED, NOT_STARTED. */
  valueTrackingStatus?: Maybe<Scalars['String']['output']>;
  /** Name of the well this opportunity applies to. Primary filter for well-based queries. */
  wellName?: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
  /** Well type classification (PRODUCER, INJECTOR, etc.). */
  wellType?: Maybe<Scalars['String']['output']>;
};

/**
 * Optimization scenario rates per well string from WF7 GAP network (WF7/WF11).
 *
 * Per-string oil/gas/water rates under each optimization scenario (technical,
 * hydraulic, custom) produced by the GAP network optimizer. Use to compare
 * scenario outcomes against the current-state baseline and quantify uplift.
 * For current-state rates see NetworkRates_String_Agent; for the richer
 * per-network matched snapshot see StringOutputs_Network_Agent. Excludes
 * historical production data.
 *
 * Use for: Network Surveillance (WF7), Production Optimization Scenarios (WF11).
 *
 * @name Optimized Rates - Network Scenarios (Agent)
 */
export type OptimizedRatesNetworkStringAgent = {
  /** Ad-hoc optimization scenario 1 gas rate (MSCF/d, TS). */
  adHocOptimization1GasRate?: Maybe<TimeSeries>;
  /** Ad-hoc optimization scenario 1 oil rate (stb/d, TS). */
  adHocOptimization1OilRate?: Maybe<TimeSeries>;
  /** Ad-hoc optimization scenario 1 water rate (stb/d, TS). */
  adHocOptimization1WaterRate?: Maybe<TimeSeries>;
  /** Ad-hoc optimization scenario 2 gas rate (MSCF/d, TS). */
  adHocOptimization2GasRate?: Maybe<TimeSeries>;
  /** Ad-hoc optimization scenario 2 oil rate (stb/d, TS). */
  adHocOptimization2OilRate?: Maybe<TimeSeries>;
  /** Ad-hoc optimization scenario 2 water rate (stb/d, TS). */
  adHocOptimization2WaterRate?: Maybe<TimeSeries>;
  /** Ad-hoc simulation scenario 1 gas rate (MSCF/d, TS). */
  adHocSimulation1GasRate?: Maybe<TimeSeries>;
  /** Ad-hoc simulation scenario 1 oil rate (stb/d, TS). */
  adHocSimulation1OilRate?: Maybe<TimeSeries>;
  /** Ad-hoc simulation scenario 1 water rate (stb/d, TS). */
  adHocSimulation1WaterRate?: Maybe<TimeSeries>;
  /** Ad-hoc simulation scenario 2 gas rate (MSCF/d, TS). */
  adHocSimulation2GasRate?: Maybe<TimeSeries>;
  /** Ad-hoc simulation scenario 2 oil rate (stb/d, TS). */
  adHocSimulation2OilRate?: Maybe<TimeSeries>;
  /** FSOPR operating point gas rate (MSCF/d, TS). */
  fsoprGasRate?: Maybe<TimeSeries>;
  /** FSOPR operating point oil rate (stb/d, TS). */
  fsoprOilRate?: Maybe<TimeSeries>;
  /** FSOPR operating point water rate (stb/d, TS). */
  fsoprWaterRate?: Maybe<TimeSeries>;
  /** Hydraulic operating point gas rate (MSCF/d, TS). */
  hydraulicGasRate?: Maybe<TimeSeries>;
  /** Hydraulic operating point oil rate (stb/d, TS). */
  hydraulicOilRate?: Maybe<TimeSeries>;
  /** Hydraulic operating point water rate (stb/d, TS). */
  hydraulicWaterRate?: Maybe<TimeSeries>;
  /** Optimized gas lift injection rate (MSCF/d, TS). */
  systemOptimizedGasLiftRate?: Maybe<TimeSeries>;
  /** System-optimized gas rate (MSCF/d, TS). */
  systemOptimizedGasRate?: Maybe<TimeSeries>;
  /** System-optimized oil rate (stb/d, TS). Network-wide optimal. */
  systemOptimizedOilRate?: Maybe<TimeSeries>;
  /** System-optimized water rate (stb/d, TS). */
  systemOptimizedWaterRate?: Maybe<TimeSeries>;
  /** Technical operating point gas rate (MSCF/d, TS). */
  technicalGasRate?: Maybe<TimeSeries>;
  /** Technical operating point oil rate (stb/d, TS). */
  technicalOilRate?: Maybe<TimeSeries>;
  /** Technical operating point water rate (stb/d, TS). */
  technicalWaterRate?: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
};

/**
 * SRM/GAP optimization results per well string (WF17).
 *
 * Optimized rates and setpoints from Sector Reservoir Model and GAP; well-string
 * performance across optimization scenarios. Use for optimal production rates and gas lift optimization potential.
 *
 * Use for: VRR Optimization (WF17).
 *
 * @name Optimized Rates - SRM (Agent)
 */
export type OptimizedRatesSrmStringAgent = {
  /** When this optimization scenario was executed (TS). */
  executionDate?: Maybe<TimeSeries>;
  /**
   * Whether this is the official approved scenario (boolean flag).
   * 1 = approved for execution, 0 = exploratory/what-if scenario.
   */
  isOfficial?: Maybe<TimeSeries>;
  /** SRM-optimized gas production rate (MSCF/d, TS). */
  optimizeGasRateSRM?: Maybe<TimeSeries>;
  /** SRM-optimized water production rate (stb/d, TS). */
  optimizeWaterRateSRM?: Maybe<TimeSeries>;
  /**
   * GAP-optimized bottomhole flowing pressure (psia, TS). Target drawdown
   * for production optimization.
   */
  optimizedBHFPGAP?: Maybe<TimeSeries>;
  /**
   * GAP-optimized choke size setting (TS). Recommended choke opening
   * for production optimization.
   */
  optimizedChokeSizeGAP?: Maybe<TimeSeries>;
  /**
   * GAP-optimized ESP pump frequency (Hz, TS). Recommended VSD frequency
   * for optimal pump performance.
   */
  optimizedESPFrequencyGAP?: Maybe<TimeSeries>;
  /** GAP network-optimized gas injection rate (MSCF/d, TS). */
  optimizedGasInjRateGAP?: Maybe<TimeSeries>;
  /**
   * SRM-optimized gas injection rate (MSCF/d, TS). Target injection rate
   * for VRR optimization.
   */
  optimizedGasInjRateSRM?: Maybe<TimeSeries>;
  /**
   * GAP-optimized gas lift injection rate (MSCF/d, TS). Recommended GL
   * rate for maximum oil production with minimum gas usage.
   */
  optimizedGasLiftRateGAP?: Maybe<TimeSeries>;
  /** GAP network-optimized gas production rate (MSCF/d, TS). */
  optimizedGasRateGAP?: Maybe<TimeSeries>;
  /**
   * Optimized injection rate at reservoir conditions (rb/d, TS).
   * Used for VRR calculation at reservoir conditions.
   */
  optimizedInjRateResCond?: Maybe<TimeSeries>;
  /**
   * GAP network-optimized oil production rate (stb/d, TS). Accounts for
   * network constraints (manifold pressure, pipeline capacity).
   */
  optimizedOilRateGAP?: Maybe<TimeSeries>;
  /**
   * SRM-optimized oil production rate (stb/d, TS). Compare to current
   * production to identify uplift potential.
   */
  optimizedOilRateSRM?: Maybe<TimeSeries>;
  /**
   * Optimized production rate at reservoir conditions (rb/d, TS).
   * Used for VRR calculation at reservoir conditions.
   */
  optimizedProdRateResCond?: Maybe<TimeSeries>;
  /** Optimized wellhead pressure (psia, TS). */
  optimizedWHP?: Maybe<TimeSeries>;
  /** GAP network-optimized water injection rate (stb/d, TS). */
  optimizedWaterInjRateGAP?: Maybe<TimeSeries>;
  /**
   * SRM-optimized water injection rate (stb/d, TS). Target injection rate
   * for VRR optimization.
   */
  optimizedWaterInjRateSRM?: Maybe<TimeSeries>;
  /** GAP network-optimized water production rate (stb/d, TS). */
  optimizedWaterRateGAP?: Maybe<TimeSeries>;
  /**
   * Optimization scenario name/identifier (TS). Groups results from the
   * same optimization run.
   */
  scenario?: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
};

/** Reference pressure, temperature, and spinner conditions for pressure–temperature–spinner (PTS) surveys, used to normalize, interpret, and compare wellbore survey data. */
export type PtsReferenceConditions = {
  /** Attribute capturing date for this entity in the production optimization context. */
  date?: Maybe<Scalars['Timestamp']['output']>;
  /** Field Code attribute describing this entity in more detail, often derived from master data or configuration tables. */
  fieldCode?: Maybe<Scalars['String']['output']>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  fieldName?: Maybe<Field>;
  /** Numeric value storing ref stg press1 for this entity, used in calculations, reporting, or model configuration. */
  refStgPress1?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing ref stg press2 for this entity, used in calculations, reporting, or model configuration. */
  refStgPress2?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing ref stg press3 for this entity, used in calculations, reporting, or model configuration. */
  refStgPress3?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing ref stg press4 for this entity, used in calculations, reporting, or model configuration. */
  refStgPress4?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing ref stg press5 for this entity, used in calculations, reporting, or model configuration. */
  refStgPress5?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing ref stg temp1 for this entity, used in calculations, reporting, or model configuration. */
  refStgTemp1?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing ref stg temp2 for this entity, used in calculations, reporting, or model configuration. */
  refStgTemp2?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing ref stg temp3 for this entity, used in calculations, reporting, or model configuration. */
  refStgTemp3?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing ref stg temp4 for this entity, used in calculations, reporting, or model configuration. */
  refStgTemp4?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing ref stg temp5 for this entity, used in calculations, reporting, or model configuration. */
  refStgTemp5?: Maybe<Scalars['Float32']['output']>;
};

/** PVT analysis results describing oil, gas, and water properties over pressure and temperature, supporting network modeling, wellbore hydraulics, allocation, and production forecasting. */
export type PvtAnalysisString = {
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Time series signal representing salinity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  salinity?: Maybe<TimeSeries>;
  /** Time series signal representing sample date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  sampleDate?: Maybe<TimeSeries>;
  /** Time series signal representing sample type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  sampleType?: Maybe<TimeSeries>;
  /** Time series signal representing water cut for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterCut?: Maybe<TimeSeries>;
};

/**
 * PVT analysis results and fluid property measurements per well string.
 *
 * Contains PVT sample analysis reference data, fluid type, sample date, and
 * analysis quality indicators for each well string. Sourced from laboratory
 * analyses of fluid samples collected from wells, to address analytical
 * questions regarding fluid characteristics and behavior under varying
 * conditions. It excludes production data or reservoir performance metrics (see
 * other views). Use cases: evaluating fluid properties for reservoir simulations
 * and optimizing production strategies based on sample quality and composition.
 *
 * @name PVT Analysis - String (Agent)
 */
export type PvtAnalysisStringAgent = {
  salinity?: Maybe<TimeSeries>;
  sampleDate?: Maybe<TimeSeries>;
  sampleType?: Maybe<TimeSeries>;
  waterCut?: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
};

/**
 * Best-available rate and pressure estimates per well string â€” default for simple rate lookups.
 *
 * Priority (best-available) oil, gas, water, liquid rates, flowing BHP, and
 * source method. Use for "what is the current rate for well X?" or "show
 * production figures for field X". For method-comparison use EstimatedRates_String_Agent.
 *
 * Use for: Real-Time Well Rate and Pressure Estimation (WF10).
 *
 * @name Priority Rates - Best Available Estimates (Agent)
 */
export type PriorityRatesStringAgent = {
  /** Best-available flowing bottom-hole pressure (psi, TS). */
  priorityFbhp?: Maybe<TimeSeries>;
  /** Best-available estimated gas rate (MSCF/d, TS). */
  priorityGasRateStd?: Maybe<TimeSeries>;
  /** Best-available estimated total liquid rate, oil + water (stb/d, TS). */
  priorityLiquidRateStd?: Maybe<TimeSeries>;
  /** Analysis method that produced the priority rates. Values: SYSTEM_ANALYSIS, CHOKE_ANALYSIS, ALLOCATION, WELL_TEST, DATA_ANALYSIS. */
  priorityMethod?: Maybe<TimeSeries>;
  /** Best-available estimated oil rate (stb/d, TS). */
  priorityOilRateStd?: Maybe<TimeSeries>;
  /** Best-available estimated water rate (stb/d, TS). */
  priorityWaterRateStd?: Maybe<TimeSeries>;
  /** Well string identifier. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
};

/** Production planning assumptions, constraints, and targets over time at the relevant aggregation level, used to compare actual performance versus plan and to steer optimization scenarios. */
export type ProdplanString = {
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Time series signal representing fmopr contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  fmoprContr?: Maybe<TimeSeries>;
  /** Time series signal representing fmopr water for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  fmoprWater?: Maybe<TimeSeries>;
  /** Time series signal representing gi allowable contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giAllowableContr?: Maybe<TimeSeries>;
  /** Time series signal representing gi allowable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giAllowableRate?: Maybe<TimeSeries>;
  /** Time series signal representing gi available contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giAvailableContr?: Maybe<TimeSeries>;
  /** Time series signal representing gi submitted month for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giSubmittedMonth?: Maybe<TimeSeries>;
  /** Time series signal representing gi sustainable contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giSustainableContr?: Maybe<TimeSeries>;
  /** Time series signal representing gi sustainable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giSustainableRate?: Maybe<TimeSeries>;
  /** Time series signal representing gi technical rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giTechnicalRate?: Maybe<TimeSeries>;
  /** Time series signal representing gi well availability for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giWellAvailability?: Maybe<TimeSeries>;
  /** Time series signal representing op bg for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opBg?: Maybe<TimeSeries>;
  /** Time series signal representing op bo for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opBo?: Maybe<TimeSeries>;
  /** Time series signal representing op bw for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opBw?: Maybe<TimeSeries>;
  /** Time series signal representing op rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opRs?: Maybe<TimeSeries>;
  /** Time series signal representing op submitted month for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opSubmittedMonth?: Maybe<TimeSeries>;
  /** Time series signal representing op vrr adjustment for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opVrrAdjustment?: Maybe<TimeSeries>;
  /** Time series signal representing op war for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opWar?: Maybe<TimeSeries>;
  /** Time series signal representing op war vrr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opWarVrr?: Maybe<TimeSeries>;
  /** Time series signal representing op wpr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opWpr?: Maybe<TimeSeries>;
  /** Time series signal representing op wpr flow assurance for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opWprFlowAssurance?: Maybe<TimeSeries>;
  /** Time series signal representing op wpr integrity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opWprIntegrity?: Maybe<TimeSeries>;
  /** Time series signal representing op wpr man press for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opWprManPress?: Maybe<TimeSeries>;
  /** Time series signal representing op wsopr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opWsopr?: Maybe<TimeSeries>;
  /** Time series signal representing op wtr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opWtr?: Maybe<TimeSeries>;
  /** Time series signal representing quota contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  quotaContr?: Maybe<TimeSeries>;
  /** Time series signal representing wi allowable contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiAllowableContr?: Maybe<TimeSeries>;
  /** Time series signal representing wi allowable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiAllowableRate?: Maybe<TimeSeries>;
  /** Time series signal representing wi available contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiAvailableContr?: Maybe<TimeSeries>;
  /** Time series signal representing wi submitted month for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiSubmittedMonth?: Maybe<TimeSeries>;
  /** Time series signal representing wi sustainable contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiSustainableContr?: Maybe<TimeSeries>;
  /** Time series signal representing wi sustainable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiSustainableRate?: Maybe<TimeSeries>;
  /** Time series signal representing wi technical rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiTechnicalRate?: Maybe<TimeSeries>;
  /** Time series signal representing wi well availability for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiWellAvailability?: Maybe<TimeSeries>;
  /** Time series signal representing wsopr total gas for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wsoprTotalGas?: Maybe<TimeSeries>;
};

/** Production planning assumptions, constraints, and targets over time at the relevant aggregation level, used to compare actual performance versus plan and to steer optimization scenarios. */
export type ProdplanStringReservoirSector = {
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Time series signal representing fmopr contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  fmoprContr?: Maybe<TimeSeries>;
  /** Time series signal representing fmopr water for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  fmoprWater?: Maybe<TimeSeries>;
  /** Time series signal representing gi allowable contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giAllowableContr?: Maybe<TimeSeries>;
  /** Time series signal representing gi allowable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giAllowableRate?: Maybe<TimeSeries>;
  /** Time series signal representing gi available contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giAvailableContr?: Maybe<TimeSeries>;
  /** Time series signal representing gi submitted month for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giSubmittedMonth?: Maybe<TimeSeries>;
  /** Time series signal representing gi sustainable contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giSustainableContr?: Maybe<TimeSeries>;
  /** Time series signal representing gi sustainable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giSustainableRate?: Maybe<TimeSeries>;
  /** Time series signal representing gi technical rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giTechnicalRate?: Maybe<TimeSeries>;
  /** Time series signal representing gi well availability for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giWellAvailability?: Maybe<TimeSeries>;
  /** Time series signal representing op bg for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opBg?: Maybe<TimeSeries>;
  /** Time series signal representing op bo for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opBo?: Maybe<TimeSeries>;
  /** Time series signal representing op bw for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opBw?: Maybe<TimeSeries>;
  /** Time series signal representing op rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opRs?: Maybe<TimeSeries>;
  /** Time series signal representing op submitted month for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opSubmittedMonth?: Maybe<TimeSeries>;
  /** Time series signal representing op vrr adjustment for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opVrrAdjustment?: Maybe<TimeSeries>;
  /** Time series signal representing op war for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opWar?: Maybe<TimeSeries>;
  /** Time series signal representing op war vrr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opWarVrr?: Maybe<TimeSeries>;
  /** Time series signal representing op wpr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opWpr?: Maybe<TimeSeries>;
  /** Time series signal representing op wpr flow assurance for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opWprFlowAssurance?: Maybe<TimeSeries>;
  /** Time series signal representing op wpr integrity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opWprIntegrity?: Maybe<TimeSeries>;
  /** Time series signal representing op wpr man press for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opWprManPress?: Maybe<TimeSeries>;
  /** Time series signal representing op wsopr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opWsopr?: Maybe<TimeSeries>;
  /** Time series signal representing op wtr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  opWtr?: Maybe<TimeSeries>;
  /** Time series signal representing quota contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  quotaContr?: Maybe<TimeSeries>;
  /** Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  reservoirName?: Maybe<Scalars['String']['output']>;
  /** Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  sectorName?: Maybe<Scalars['String']['output']>;
  /** Time series signal representing wi allowable contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiAllowableContr?: Maybe<TimeSeries>;
  /** Time series signal representing wi allowable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiAllowableRate?: Maybe<TimeSeries>;
  /** Time series signal representing wi available contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiAvailableContr?: Maybe<TimeSeries>;
  /** Time series signal representing wi submitted month for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiSubmittedMonth?: Maybe<TimeSeries>;
  /** Time series signal representing wi sustainable contr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiSustainableContr?: Maybe<TimeSeries>;
  /** Time series signal representing wi sustainable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiSustainableRate?: Maybe<TimeSeries>;
  /** Time series signal representing wi technical rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiTechnicalRate?: Maybe<TimeSeries>;
  /** Time series signal representing wi well availability for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiWellAvailability?: Maybe<TimeSeries>;
  /** Time series signal representing wsopr total gas for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wsoprTotalGas?: Maybe<TimeSeries>;
};

/**
 * Reservoir management guidelines and operating limits for production strings (WF6).
 *
 * Max GOR, min BHP/WHP, max liquid/oil rates per string. Use to assess adherence
 * to guidelines, identify wells outside limits, and flag reservoir damage risk.
 * Excludes historical performance or detailed rates (see other views).
 *
 * Use for: Well Operating Envelope (WF6).
 */
export type ProducerGuidelinesStringAgent = {
  /**
   * Maximum allowed Gas-Oil Ratio (scf/stb) from reservoir management guidelines.
   * Wells with GOR above this limit are violating guidelines and may need
   * choke adjustment or investigation.
   */
  maxGOR?: Maybe<Scalars['Float32']['output']>;
  /**
   * Maximum allowed liquid production rate (stb/d) from reservoir management
   * guidelines. Wells above this limit may need rate constraints.
   */
  maxLiquidRate?: Maybe<Scalars['Float32']['output']>;
  /**
   * Maximum allowed oil production rate (stb/d) from reservoir management
   * guidelines. Used for rate constraint optimization.
   */
  maxOilRate?: Maybe<Scalars['Float32']['output']>;
  /**
   * Minimum allowed Bottomhole Pressure (psia) from reservoir management guidelines.
   * Production wells operating below this BHP may be causing reservoir damage
   * or excessive drawdown.
   */
  minBHP?: Maybe<Scalars['Float32']['output']>;
  /**
   * Minimum allowed Wellhead Pressure (psia) from reservoir management
   * guidelines. Wells operating below this WHP may indicate flow instability,
   * liquid loading, or insufficient reservoir energy.
   */
  minWHP?: Maybe<Scalars['Float32']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
};

/**
 * Production allocation alarms with medium or high priority.
 *
 * Contains production allocation alarms, medium or high priority, derived from
 * workflows WF5 and WF13. Sourced from operational monitoring systems that track
 * alarm events, allowing users to analyze alarm occurrences, their severity, and
 * associated workflows. It can answer questions regarding the frequency and
 * types of alarms and impact on allocation. Excludes low-priority or non-WF5/WF13 alarms.
 *
 * Use for: Production Allocation (WF5), Gas Lift Estimation (WF13), Real-Time Surveillance (WF18).
 *
 * @name Production Allocation Alarms (Agent)
 */
export type ProductionAllocationAlarmsAgent = {
  alarmCategory?: Maybe<Scalars['String']['output']>;
  alarmCode?: Maybe<Scalars['JSONObject']['output']>;
  alarmCodeExternalId?: Maybe<Scalars['String']['output']>;
  /** Number of consecutive occurrences of this alarm. */
  alarmCounter?: Maybe<Scalars['Int']['output']>;
  alarmCriticality?: Maybe<Scalars['String']['output']>;
  alarmFlags?: Maybe<Scalars['String']['output']>;
  alarmName?: Maybe<Scalars['String']['output']>;
  alarmPriority?: Maybe<Scalars['String']['output']>;
  customWorkflowAlarmMessage?: Maybe<Scalars['String']['output']>;
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  entityExternalId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  startDateTime: Scalars['Timestamp']['output'];
  /** Alarm sub-category for domain filtering. */
  subCategory?: Maybe<Scalars['String']['output']>;
  /** Sub-workflow that generated the alarm. */
  subWorkflowName?: Maybe<Scalars['String']['output']>;
  /** Associated ticket/action ID if alarm has been acknowledged. */
  ticketId?: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
  workflowCode?: Maybe<Scalars['String']['output']>;
  workflowName?: Maybe<Scalars['String']['output']>;
};

/** Prosper Model view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type ProsperModel = {
  /** Attribute capturing asphaltene curve for this entity in the production optimization context. */
  asphalteneCurve?: Maybe<Scalars['JSONObject']['output']>;
  /** Numeric value storing bottom perforation depth for this entity, used in calculations, reporting, or model configuration. */
  bottomPerforationDepth?: Maybe<Scalars['Float']['output']>;
  /** Bottom Perforation Depth Unit attribute describing this entity in more detail, often derived from master data or configuration tables. */
  bottomPerforationDepthUnit?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  bottomTubingId?: Maybe<Scalars['Float']['output']>;
  /** Bottom Tubing Id Unit attribute describing this entity in more detail, often derived from master data or configuration tables. */
  bottomTubingIdUnit?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing bubble point for this entity in the production optimization context. */
  bubblePoint?: Maybe<Scalars['JSONObject']['output']>;
  /** Numeric value storing c coefficient for this entity, used in calculations, reporting, or model configuration. */
  cCoefficient?: Maybe<Scalars['Float']['output']>;
  /** C Coefficient Unit attribute describing this entity in more detail, often derived from master data or configuration tables. */
  cCoefficientUnit?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing calibration well test rate for this entity, used in calculations, reporting, or model configuration. */
  calibrationWellTestRate?: Maybe<Scalars['Float']['output']>;
  /** Calibration Well Test Rate Unit attribute describing this entity in more detail, often derived from master data or configuration tables. */
  calibrationWellTestRateUnit?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing calibration well test time for this entity in the production optimization context. */
  calibrationWellTestTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Change Details attribute describing this entity in more detail, often derived from master data or configuration tables. */
  changeDetails?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing critical point for this entity in the production optimization context. */
  criticalPoint?: Maybe<Scalars['JSONObject']['output']>;
  /** Free-text description providing engineering context, assumptions, or clarifications about this entity or the associated signal, used to support interpretation and troubleshooting. */
  description?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing deviation survey record count for this entity, used in calculations, reporting, or model configuration. */
  deviationSurveyRecordCount?: Maybe<Scalars['Int']['output']>;
  /** Esp Current Cable attribute describing this entity in more detail, often derived from master data or configuration tables. */
  espCurrentCable?: Maybe<Scalars['String']['output']>;
  /** Esp Current Motor attribute describing this entity in more detail, often derived from master data or configuration tables. */
  espCurrentMotor?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing esp pump depth for this entity, used in calculations, reporting, or model configuration. */
  espPumpDepth?: Maybe<Scalars['Float']['output']>;
  /** Esp Pump Depth Unit attribute describing this entity in more detail, often derived from master data or configuration tables. */
  espPumpDepthUnit?: Maybe<Scalars['String']['output']>;
  /** Esp Pump Model attribute describing this entity in more detail, often derived from master data or configuration tables. */
  espPumpModel?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing esp stages for this entity, used in calculations, reporting, or model configuration. */
  espStages?: Maybe<Scalars['Int']['output']>;
  /** Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  executeStatus?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing fbhp at min stable rate for this entity, used in calculations, reporting, or model configuration. */
  fbhpAtMinStableRate?: Maybe<Scalars['Float']['output']>;
  /** Fbhp At Min Stable Rate Unit attribute describing this entity in more detail, often derived from master data or configuration tables. */
  fbhpAtMinStableRateUnit?: Maybe<Scalars['String']['output']>;
  /** Field attribute describing this entity in more detail, often derived from master data or configuration tables. */
  field?: Maybe<Field>;
  /** Numeric value storing file size for this entity, used in calculations, reporting, or model configuration. */
  fileSize?: Maybe<Scalars['Float']['output']>;
  /** Numeric value storing flow exponent for this entity, used in calculations, reporting, or model configuration. */
  flowExponent?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  fluid?: Maybe<Scalars['Int']['output']>;
  /** Numeric value storing geo thermal gradient record count for this entity, used in calculations, reporting, or model configuration. */
  geoThermalGradientRecordCount?: Maybe<Scalars['Int']['output']>;
  /** Numeric value storing gl injection depth for this entity, used in calculations, reporting, or model configuration. */
  glInjectionDepth?: Maybe<Scalars['Float']['output']>;
  /** Gl Injection Depth Unit attribute describing this entity in more detail, often derived from master data or configuration tables. */
  glInjectionDepthUnit?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing gl method for this entity, used in calculations, reporting, or model configuration. */
  glMethod?: Maybe<Scalars['Int']['output']>;
  /** Numeric value storing gl orifice size for this entity, used in calculations, reporting, or model configuration. */
  glOrificeSize?: Maybe<Scalars['Float']['output']>;
  /** Gl Orifice Size Unit attribute describing this entity in more detail, often derived from master data or configuration tables. */
  glOrificeSizeUnit?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing gl valve depth for this entity, used in calculations, reporting, or model configuration. */
  glValveDepth?: Maybe<Scalars['Float']['output']>;
  /** Gl Valve Depth Unit attribute describing this entity in more detail, often derived from master data or configuration tables. */
  glValveDepthUnit?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing hydrate curve for this entity in the production optimization context. */
  hydrateCurve?: Maybe<Scalars['JSONObject']['output']>;
  /** Ipr Model attribute describing this entity in more detail, often derived from master data or configuration tables. */
  iprModel?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  legacyDataSetId?: Maybe<Scalars['Int64']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  legacyFileExternalId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  legacyFileId?: Maybe<Scalars['Int64']['output']>;
  /** Numeric value storing lift method for this entity, used in calculations, reporting, or model configuration. */
  liftMethod?: Maybe<Scalars['Int']['output']>;
  /** Numeric value storing max measured depth for this entity, used in calculations, reporting, or model configuration. */
  maxMeasuredDepth?: Maybe<Scalars['Float']['output']>;
  /** Max Measured Depth Unit attribute describing this entity in more detail, often derived from master data or configuration tables. */
  maxMeasuredDepthUnit?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing max true vertical depth for this entity, used in calculations, reporting, or model configuration. */
  maxTrueVerticalDepth?: Maybe<Scalars['Float']['output']>;
  /** Max True Vertical Depth Unit attribute describing this entity in more detail, often derived from master data or configuration tables. */
  maxTrueVerticalDepthUnit?: Maybe<Scalars['String']['output']>;
  /** Mime Type attribute describing this entity in more detail, often derived from master data or configuration tables. */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing min stable rate for this entity, used in calculations, reporting, or model configuration. */
  minStableRate?: Maybe<Scalars['Float']['output']>;
  /** Min Stable Rate Unit attribute describing this entity in more detail, often derived from master data or configuration tables. */
  minStableRateUnit?: Maybe<Scalars['String']['output']>;
  /** Model Accepted By attribute describing this entity in more detail, often derived from master data or configuration tables. */
  modelAcceptedBy?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing model accepted time for this entity in the production optimization context. */
  modelAcceptedTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Attribute capturing model effective time for this entity in the production optimization context. */
  modelEffectiveTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  modelStatus?: Maybe<Scalars['String']['output']>;
  /** Model Updated By attribute describing this entity in more detail, often derived from master data or configuration tables. */
  modelUpdatedBy?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing model updated time for this entity in the production optimization context. */
  modelUpdatedTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Model Uploaded By attribute describing this entity in more detail, often derived from master data or configuration tables. */
  modelUploadedBy?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing model uploaded time for this entity in the production optimization context. */
  modelUploadedTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  name?: Maybe<Scalars['String']['output']>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  originalProsperFileName?: Maybe<Scalars['String']['output']>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  pE5Flag?: Maybe<Scalars['Int']['output']>;
  /** Attribute capturing pending modifications for this entity in the production optimization context. */
  pendingModifications?: Maybe<Scalars['JSONObject']['output']>;
  /** Attribute capturing phase envelope for this entity in the production optimization context. */
  phaseEnvelope?: Maybe<Scalars['JSONObject']['output']>;
  /** Numeric value storing pi for this entity, used in calculations, reporting, or model configuration. */
  pi?: Maybe<Scalars['Float']['output']>;
  /** Pi Unit attribute describing this entity in more detail, often derived from master data or configuration tables. */
  piUnit?: Maybe<Scalars['String']['output']>;
  /** Platform attribute describing this entity in more detail, often derived from master data or configuration tables. */
  platform?: Maybe<Scalars['String']['output']>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  prosperLocationName?: Maybe<Scalars['String']['output']>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  prosperWellName?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing pvt for this entity, used in calculations, reporting, or model configuration. */
  pvt?: Maybe<Scalars['Float']['output']>;
  /** Pvt Unit attribute describing this entity in more detail, often derived from master data or configuration tables. */
  pvtUnit?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing rate deviation percentage for this entity, used in calculations, reporting, or model configuration. */
  rateDeviationPercentage?: Maybe<Scalars['Float']['output']>;
  /** Attribute capturing reservoir for this entity in the production optimization context. */
  reservoir?: Maybe<Maybe<Reservoir>[]>;
  /** Numeric value storing reservoir bubble point for this entity, used in calculations, reporting, or model configuration. */
  reservoirBubblePoint?: Maybe<Scalars['Float']['output']>;
  /** Reservoir Bubble Point Unit attribute describing this entity in more detail, often derived from master data or configuration tables. */
  reservoirBubblePointUnit?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing reservoir pressure for this entity, used in calculations, reporting, or model configuration. */
  reservoirPressure?: Maybe<Scalars['Float']['output']>;
  /** Reservoir Pressure Unit attribute describing this entity in more detail, often derived from master data or configuration tables. */
  reservoirPressureUnit?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing reservoir temperature for this entity, used in calculations, reporting, or model configuration. */
  reservoirTemperature?: Maybe<Scalars['Float']['output']>;
  /** Reservoir Temperature Unit attribute describing this entity in more detail, often derived from master data or configuration tables. */
  reservoirTemperatureUnit?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  simIntExternalId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  simIntModelExternalId?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing sim int model revision created time for this entity in the production optimization context. */
  simIntModelRevisionCreatedTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Free-text description providing engineering context, assumptions, or clarifications about this entity or the associated signal, used to support interpretation and troubleshooting. */
  simIntModelRevisionDescription?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  simIntModelRevisionExternalId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  simIntModelRevisionId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  simIntModelRevisionLogId?: Maybe<Scalars['String']['output']>;
  /** Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  simIntModelRevisionStatus?: Maybe<Scalars['String']['output']>;
  /** Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  simIntModelRevisionStatusMessage?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing sim int model revision updated time for this entity in the production optimization context. */
  simIntModelRevisionUpdatedTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  simIntModelRevisionVersionId?: Maybe<Scalars['Int']['output']>;
  /** Source attribute describing this entity in more detail, often derived from master data or configuration tables. */
  source?: Maybe<Scalars['String']['output']>;
  /** Source Location attribute describing this entity in more detail, often derived from master data or configuration tables. */
  sourceLocation?: Maybe<Scalars['String']['output']>;
  /** String attribute describing this entity in more detail, often derived from master data or configuration tables. */
  string?: Maybe<StringAsset>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  string_name?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing top perforation depth for this entity, used in calculations, reporting, or model configuration. */
  topPerforationDepth?: Maybe<Scalars['Float']['output']>;
  /** Top Perforation Depth Unit attribute describing this entity in more detail, often derived from master data or configuration tables. */
  topPerforationDepthUnit?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing u val for this entity, used in calculations, reporting, or model configuration. */
  uVal?: Maybe<Scalars['Float']['output']>;
  /** U Val Unit attribute describing this entity in more detail, often derived from master data or configuration tables. */
  uValUnit?: Maybe<Scalars['String']['output']>;
  /** Vlp Model attribute describing this entity in more detail, often derived from master data or configuration tables. */
  vlpModel?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing wax curve for this entity in the production optimization context. */
  waxCurve?: Maybe<Scalars['JSONObject']['output']>;
  /** Numeric value storing wear factor for this entity, used in calculations, reporting, or model configuration. */
  wearFactor?: Maybe<Scalars['Float']['output']>;
  /** Well attribute describing this entity in more detail, often derived from master data or configuration tables. */
  well?: Maybe<Well>;
  /** Numeric value storing well completion record count for this entity, used in calculations, reporting, or model configuration. */
  wellCompletionRecordCount?: Maybe<Scalars['Int']['output']>;
  /** Numeric value storing well type for this entity, used in calculations, reporting, or model configuration. */
  wellType?: Maybe<Scalars['Int']['output']>;
  /** Numeric value storing wf2 estimated rate for this entity, used in calculations, reporting, or model configuration. */
  wf2EstimatedRate?: Maybe<Scalars['Float']['output']>;
  /** Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  wf2ModelMatchedStatus?: Maybe<Scalars['String']['output']>;
  /** Wf2 Processed attribute describing this entity in more detail, often derived from master data or configuration tables. */
  wf2Processed?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing wf3 estimated rate for this entity, used in calculations, reporting, or model configuration. */
  wf3EstimatedRate?: Maybe<Scalars['Float']['output']>;
  /** Wf3 Estimated Rate Unit attribute describing this entity in more detail, often derived from master data or configuration tables. */
  wf3EstimatedRateUnit?: Maybe<Scalars['String']['output']>;
  /** Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  wf3ModelMatchedStatus?: Maybe<Scalars['String']['output']>;
};

/** Prosper Model Event Log view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type ProsperModelEventLog = {
  /** Model Accepted By attribute describing this entity in more detail, often derived from master data or configuration tables. */
  modelAcceptedBy?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing model accepted time for this entity in the production optimization context. */
  modelAcceptedTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  modelStatus?: Maybe<Scalars['String']['output']>;
  /** Model Updated By attribute describing this entity in more detail, often derived from master data or configuration tables. */
  modelUpdatedBy?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing model updated time for this entity in the production optimization context. */
  modelUpdatedTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Prosper Model attribute describing this entity in more detail, often derived from master data or configuration tables. */
  prosperModel?: Maybe<ProsperModel>;
  /** Operational status for this entity (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  wf3ModelMatchedStatus?: Maybe<Scalars['String']['output']>;
};

/** Prosper Model Metrics view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type ProsperModelMetrics = {
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Field attribute describing this entity in more detail, often derived from master data or configuration tables. */
  field?: Maybe<Field>;
  /** Time series signal representing model availability for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelAvailability?: Maybe<TimeSeries>;
};

/**
 * Prosper well model repository with calibration status, version, and model
 * metadata.
 *
 * Contains data on well models, including their calibration status, versioning,
 * associated metadata, and ESP equipment (pump model, current motor, current
 * cable), sourced from the Prosper modeling system. This view is designed to
 * address analytical questions related to model availability, calibration
 * success, performance metrics, and equipment type across various wells, to
 * assess the operational readiness of models in the field. Use cases: monitoring
 * model compliance, identifying wells requiring immediate attention, evaluating
 * the overall health of the modeling infrastructure, and statistical summaries
 * of efficiency or wear grouped by ESP type, pump model, motor, or cable.
 *
 * @name Prosper Model Status (Agent)
 */
export type ProsperModelAgent = {
  /** Current cable identifier/type from the Prosper model (e.g., cable type or model code). Use for grouping by cable type alongside pump and motor. */
  espCurrentCable?: Maybe<Scalars['String']['output']>;
  /** Current motor identifier/model from the Prosper model (e.g., motor type or model code). Use for grouping by motor type alongside pump and cable. */
  espCurrentMotor?: Maybe<Scalars['String']['output']>;
  /** ESP pump model/type from the Prosper model (e.g., manufacturer model code). Use for grouping or filtering by ESP type; supports statistical summaries by pump model and vendor. */
  espPumpModel?: Maybe<Scalars['String']['output']>;
  /** Reference to Field. Use for field-level aggregations. DO NOT USE - THIS IS UNRELIABLE */
  field?: Maybe<Field>;
  /** IPR model type (e.g., Vogel, Fetkovitch, Jones). */
  iprModel?: Maybe<Scalars['String']['output']>;
  /** Artificial lift method. 0=Natural Flow, 1=ESP, 2=Gas Lift, 3=PCP, 4=Rod Pump. Use to filter by lift type. */
  liftMethod?: Maybe<Scalars['Int']['output']>;
  /** Minimum stable flow rate from model (stb/d). */
  minStableRate?: Maybe<Scalars['Float']['output']>;
  /** When the model became the active/effective model for the string. */
  modelEffectiveTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Overall model status. Values: ACCEPTED, PENDING, UNDER_REVIEW, NEEDS_UPDATE. Use to identify valid vs invalid models. */
  modelStatus?: Maybe<Scalars['String']['output']>;
  /** When the model was last updated/recalibrated. */
  modelUpdatedTime?: Maybe<Scalars['Timestamp']['output']>;
  /** When the Prosper model file was uploaded to iPSO. */
  modelUploadedTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Productivity index from Prosper model (stb/d/psi). */
  pi?: Maybe<Scalars['Float']['output']>;
  /** Reservoir pressure used in Prosper model (psi). Compare across wells in same reservoir to identify outliers. */
  reservoirPressure?: Maybe<Scalars['Float']['output']>;
  /** String name for display (e.g., LI001-L). */
  string_name?: Maybe<Scalars['String']['output']>;
  /** VLP correlation used (e.g., Beggs and Brill, Hagedorn Brown). */
  vlpModel?: Maybe<Scalars['String']['output']>;
  /** ESP wear factor (0-1). Values < 1 indicate pump degradation. */
  wearFactor?: Maybe<Scalars['Float']['output']>;
  /** Reference to wellString. Use to join with hierarchy. */
  wellString?: Maybe<StringAsset>;
  /** WF2 model matching status for rate estimation workflow. */
  wf2ModelMatchedStatus?: Maybe<Scalars['String']['output']>;
  /** WF3 auto-calibration status. Values: MATCHED, NEEDS_CALIBRATION, NOT_MATCHED, UNDER_REVIEW. Use to find calibration failures. */
  wf3ModelMatchedStatus?: Maybe<Scalars['String']['output']>;
};

/** Pseudo Pressure Table view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type PseudoPressureTable = {
  /** Numeric value storing pressure for this entity, used in calculations, reporting, or model configuration. */
  pressure?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing pseudo pressure for this entity, used in calculations, reporting, or model configuration. */
  pseudoPressure?: Maybe<Scalars['Float32']['output']>;
};

/** Pts Outputs String view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type PtsOutputsString = {
  /** Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  anchoringFluid?: Maybe<TimeSeries>;
  /** Time series signal representing b glpts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  bGLPts1?: Maybe<TimeSeries>;
  /** Time series signal representing b oil for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  bOil?: Maybe<TimeSeries>;
  /** Time series signal representing b oil rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  bOilRs?: Maybe<TimeSeries>;
  /** Time series signal representing bg pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  bgPts1?: Maybe<TimeSeries>;
  /** Time series signal representing black oil prop model for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  blackOilPropModel?: Maybe<TimeSeries>;
  /** Time series signal representing bo pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  boPts1?: Maybe<TimeSeries>;
  /** Time series signal representing bw pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  bwPts1?: Maybe<TimeSeries>;
  /** Time series signal representing c o2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  cO2?: Maybe<TimeSeries>;
  /** Time series signal representing c o2 rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  cO2Rs?: Maybe<TimeSeries>;
  /** Time series signal representing calc saturation press for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  calcSaturationPress?: Maybe<TimeSeries>;
  /** Time series signal representing calc total gorpvt rs pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  calcTotalGORPvtRsPts2?: Maybe<TimeSeries>;
  /** Time series signal representing calc well test gor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  calcWellTestGOR?: Maybe<TimeSeries>;
  /** Time series signal representing calc well test gorin situ for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  calcWellTestGORInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing calc well test total gor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  calcWellTestTotalGOR?: Maybe<TimeSeries>;
  /** Time series signal representing cgr pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  cgrPts1?: Maybe<TimeSeries>;
  /** Time series signal representing composition for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  composition?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Time series signal representing est gas lift injection rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  estGasLiftInjectionRate?: Maybe<TimeSeries>;
  /** Time series signal representing field gltolerance update for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  fieldGLToleranceUpdate?: Maybe<TimeSeries>;
  /** Time series signal representing fluid comp model pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  fluidCompModelPtsRef?: Maybe<TimeSeries>;
  /** Time series signal representing fluid comp model pts ref free gas for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  fluidCompModelPtsRefFreeGas?: Maybe<TimeSeries>;
  /** Time series signal representing fluid comp model pts ref result for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  fluidCompModelPtsRefResult?: Maybe<TimeSeries>;
  /** Time series signal representing fluid comp model well test for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  fluidCompModelWellTest?: Maybe<TimeSeries>;
  /** Time series signal representing fluid composition pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  fluidCompositionPts1?: Maybe<TimeSeries>;
  /** Time series signal representing fluid composition pts1 free gas for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  fluidCompositionPts1FreeGas?: Maybe<TimeSeries>;
  /** Time series signal representing fluid properties for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  fluidProperties?: Maybe<TimeSeries>;
  /** Time series signal representing free cgrpts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  freeCGRPtsRef?: Maybe<TimeSeries>;
  /** Time series signal representing free gorpts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  freeGORPtsRef?: Maybe<TimeSeries>;
  /** Time series signal representing free gorsc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  freeGORSC?: Maybe<TimeSeries>;
  /** Time series signal representing gas density pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasDensityPts1?: Maybe<TimeSeries>;
  /** Time series signal representing gas density pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasDensityPts2?: Maybe<TimeSeries>;
  /** Time series signal representing gas gravity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasGravity?: Maybe<TimeSeries>;
  /** Time series signal representing gas rate pvtrs pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasRatePVTRsPts1?: Maybe<TimeSeries>;
  /** Time series signal representing h2 s for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  h2S?: Maybe<TimeSeries>;
  /** Time series signal representing h2 srs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  h2SRs?: Maybe<TimeSeries>;
  /** Time series signal representing hydrate curve total fluid pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  hydrateCurveTotalFluidPtsRef?: Maybe<TimeSeries>;
  /** Time series signal representing matching method for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  matchingMethod?: Maybe<TimeSeries>;
  /** Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  modelRevisionExternalId?: Maybe<TimeSeries>;
  /** Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  modelRevisionFileId?: Maybe<TimeSeries>;
  /** Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  modelRevisionId?: Maybe<TimeSeries>;
  /** Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  modelRevisionModelExternalId?: Maybe<TimeSeries>;
  /** Time series signal representing n2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  n2?: Maybe<TimeSeries>;
  /** Time series signal representing n2 rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  n2Rs?: Maybe<TimeSeries>;
  /** Time series signal representing n2 srs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  n2SRs?: Maybe<TimeSeries>;
  /** Time series signal representing oil apipts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilAPIPts1?: Maybe<TimeSeries>;
  /** Time series signal representing oil apipts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilAPIPts2?: Maybe<TimeSeries>;
  /** Time series signal representing oil density pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilDensityPts1?: Maybe<TimeSeries>;
  /** Time series signal representing oil density pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilDensityPts2?: Maybe<TimeSeries>;
  /** Time series signal representing oil gravity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilGravity?: Maybe<TimeSeries>;
  /** Time series signal representing oil viscosity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilViscosity?: Maybe<TimeSeries>;
  /** Time series signal representing oil viscosity rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilViscosityRs?: Maybe<TimeSeries>;
  /** Time series signal representing phase envelope conditions model pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  phaseEnvelopeConditionsModelPtsRef?: Maybe<TimeSeries>;
  /** Time series signal representing phase envelope conditions model pts ref free gas for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  phaseEnvelopeConditionsModelPtsRefFreeGas?: Maybe<TimeSeries>;
  /** Time series signal representing phase envelope conditions model pts ref result for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  phaseEnvelopeConditionsModelPtsRefResult?: Maybe<TimeSeries>;
  /** Time series signal representing phase envelope conditions model pts rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  phaseEnvelopeConditionsModelPtsRs?: Maybe<TimeSeries>;
  /** Time series signal representing phase envelope conditions model well test for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  phaseEnvelopeConditionsModelWellTest?: Maybe<TimeSeries>;
  /** Time series signal representing phase envelope records model pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  phaseEnvelopeRecordsModelPtsRef?: Maybe<TimeSeries>;
  /** Time series signal representing phase envelope records model pts ref free gas for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  phaseEnvelopeRecordsModelPtsRefFreeGas?: Maybe<TimeSeries>;
  /** Time series signal representing phase envelope records model pts ref result for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  phaseEnvelopeRecordsModelPtsRefResult?: Maybe<TimeSeries>;
  /** Time series signal representing phase envelope records model pts ref rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  phaseEnvelopeRecordsModelPtsRefRs?: Maybe<TimeSeries>;
  /** Time series signal representing phase envelope records model well test for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  phaseEnvelopeRecordsModelWellTest?: Maybe<TimeSeries>;
  /** Pvt Info attribute describing this production string in more detail, often derived from master data or configuration tables. */
  pvtInfo?: Maybe<Scalars['String']['output']>;
  /** Time series signal representing sample composition for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  sampleComposition?: Maybe<TimeSeries>;
  /** Time series signal representing sample date time for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  sampleDateTime?: Maybe<TimeSeries>;
  /** Time series signal representing saturation pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  saturationPressure?: Maybe<TimeSeries>;
  /** Time series signal representing saturation pressure rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  saturationPressureRs?: Maybe<TimeSeries>;
  /** Time series signal representing solution cgr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  solutionCGR?: Maybe<TimeSeries>;
  /** Time series signal representing solution cgrpts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  solutionCGRPts1?: Maybe<TimeSeries>;
  /** Time series signal representing solution gor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  solutionGOR?: Maybe<TimeSeries>;
  /** Time series signal representing solution gorpts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  solutionGORPts1?: Maybe<TimeSeries>;
  /** Time series signal representing solution gorrs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  solutionGORRs?: Maybe<TimeSeries>;
  /** Time series signal representing solution gorrs pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  solutionGORRsPts1?: Maybe<TimeSeries>;
  /** Time series signal representing solution gorrs pts1scfbbl for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  solutionGORRsPts1scfbbl?: Maybe<TimeSeries>;
  /** Time series signal representing specific gas gravity rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  specificGasGravityRs?: Maybe<TimeSeries>;
  /** Time series signal representing specific gravity gas pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  specificGravityGasPts1?: Maybe<TimeSeries>;
  /** Time series signal representing specific gravity gas pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  specificGravityGasPts2?: Maybe<TimeSeries>;
  /** Time series signal representing specific gravity oil pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  specificGravityOilPts1?: Maybe<TimeSeries>;
  /** Time series signal representing specific gravity oil pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  specificGravityOilPts2?: Maybe<TimeSeries>;
  /** Time series signal representing specific oil gravity rs for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  specificOilGravityRs?: Maybe<TimeSeries>;
  /** Time series signal representing total cgrpts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  totalCGRPts2?: Maybe<TimeSeries>;
  /** Time series signal representing total gorpvt rs pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  totalGORPvtRsPts2?: Maybe<TimeSeries>;
  /** Time series signal representing used gas lift injection rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  usedGasLiftInjectionRate?: Maybe<TimeSeries>;
  /** Time series signal representing used gas lift injection rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  usedGasLiftInjectionRateLC?: Maybe<TimeSeries>;
  /** Time series signal representing water density pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterDensityPts1?: Maybe<TimeSeries>;
  /** Time series signal representing water density pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterDensityPts2?: Maybe<TimeSeries>;
  /** Time series signal representing water salinity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterSalinity?: Maybe<TimeSeries>;
  /** Time series signal representing well test cgrpts for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestCGRPts?: Maybe<TimeSeries>;
  /** Time series signal representing well test cgrpts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestCGRPts1?: Maybe<TimeSeries>;
  /** Time series signal representing well test cgrpts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestCGRPts2?: Maybe<TimeSeries>;
  /** Time series signal representing well test cgrpts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestCGRPtsRef?: Maybe<TimeSeries>;
  /** Time series signal representing well test estimated glrate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEstimatedGLRate?: Maybe<TimeSeries>;
  /** Time series signal representing well test glmass flow rate pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGLMassFlowRatePts1?: Maybe<TimeSeries>;
  /** Time series signal representing well test glmass flow rate pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGLMassFlowRatePts2?: Maybe<TimeSeries>;
  /** Time series signal representing well test gor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGOR?: Maybe<TimeSeries>;
  /** Time series signal representing well test gorpts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGORPts1?: Maybe<TimeSeries>;
  /** Time series signal representing well test gas mass flow rate pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGasMassFlowRatePts1?: Maybe<TimeSeries>;
  /** Time series signal representing well test gas mass flow rate pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGasMassFlowRatePts2?: Maybe<TimeSeries>;
  /** Time series signal representing well test gas mass flow rate pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGasMassFlowRatePtsRef?: Maybe<TimeSeries>;
  /** Time series signal representing well test gas rate pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGasRatePts1?: Maybe<TimeSeries>;
  /** Time series signal representing well test gas rate pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGasRatePts2?: Maybe<TimeSeries>;
  /** Time series signal representing well test gas rate pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGasRatePtsRef?: Maybe<TimeSeries>;
  /** Time series signal representing well test gor pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGorPts2?: Maybe<TimeSeries>;
  /** Time series signal representing well test gor pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGorPtsRef?: Maybe<TimeSeries>;
  /** Time series signal representing well test hcmass flow rate pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestHCMassFlowRatePts1?: Maybe<TimeSeries>;
  /** Time series signal representing well test hcmass flow rate pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestHCMassFlowRatePts2?: Maybe<TimeSeries>;
  /** Time series signal representing well test hcmass flow rate pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestHCMassFlowRatePtsRef?: Maybe<TimeSeries>;
  /** Time series signal representing well test liquid rate pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestLiquidRatePts1?: Maybe<TimeSeries>;
  /** Time series signal representing well test liquid rate pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestLiquidRatePts2?: Maybe<TimeSeries>;
  /** Time series signal representing well test liquid rate pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestLiquidRatePtsRef?: Maybe<TimeSeries>;
  /** Time series signal representing well test oil mass flow rate pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestOilMassFlowRatePts1?: Maybe<TimeSeries>;
  /** Time series signal representing well test oil mass flow rate pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestOilMassFlowRatePts2?: Maybe<TimeSeries>;
  /** Time series signal representing well test oil mass flow rate pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestOilMassFlowRatePtsRef?: Maybe<TimeSeries>;
  /** Time series signal representing well test oil rate pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestOilRatePts1?: Maybe<TimeSeries>;
  /** Time series signal representing well test oil rate pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestOilRatePts2?: Maybe<TimeSeries>;
  /** Time series signal representing well test oil rate pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestOilRatePtsRef?: Maybe<TimeSeries>;
  /** Time series signal representing well test sgvpts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestSGVPts1?: Maybe<TimeSeries>;
  /** Time series signal representing well test sgvpts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestSGVPts2?: Maybe<TimeSeries>;
  /** Time series signal representing well test sovpts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestSOVPts1?: Maybe<TimeSeries>;
  /** Time series signal representing well test sovpts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestSOVPts2?: Maybe<TimeSeries>;
  /** Time series signal representing well test total mass flow rate pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTotalMassFlowRatePts1?: Maybe<TimeSeries>;
  /** Time series signal representing well test total mass flow rate pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTotalMassFlowRatePts2?: Maybe<TimeSeries>;
  /** Time series signal representing well test total mass flow rate pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTotalMassFlowRatePtsRef?: Maybe<TimeSeries>;
  /** Time series signal representing well test used glrate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestUsedGLRate?: Maybe<TimeSeries>;
  /** Time series signal representing well test wgrpts for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWGRPts?: Maybe<TimeSeries>;
  /** Time series signal representing well test wgrpts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWGRPts1?: Maybe<TimeSeries>;
  /** Time series signal representing well test wgrpts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWGRPts2?: Maybe<TimeSeries>;
  /** Time series signal representing well test wgrpts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWGRPtsRef?: Maybe<TimeSeries>;
  /** Time series signal representing well test water cut pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterCutPts1?: Maybe<TimeSeries>;
  /** Time series signal representing well test water cut pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterCutPts2?: Maybe<TimeSeries>;
  /** Time series signal representing well test water cut pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterCutPtsRef?: Maybe<TimeSeries>;
  /** Time series signal representing well test water mass flow rate pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterMassFlowRatePts1?: Maybe<TimeSeries>;
  /** Time series signal representing well test water mass flow rate pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterMassFlowRatePts2?: Maybe<TimeSeries>;
  /** Time series signal representing well test water mass flow rate pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterMassFlowRatePtsRef?: Maybe<TimeSeries>;
  /** Time series signal representing well test water rate pts1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterRatePts1?: Maybe<TimeSeries>;
  /** Time series signal representing well test water rate pts2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterRatePts2?: Maybe<TimeSeries>;
  /** Time series signal representing well test water rate pts ref for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterRatePtsRef?: Maybe<TimeSeries>;
};

/**
 * Path-to-surface corrected rates, GOR, water cut at stock-tank conditions (WF10/WF19).
 *
 * Well performance from calibrated models and wellhead measurements. Use for well
 * efficiency, production optimization, reservoir performance, and production trends. Excludes historical or geological detail.
 *
 * Use for: Rate and Pressure Estimation (WF10), Reservoir Pressure and PI (WF19).
 *
 * @name PTS Outputs - String (Agent)
 */
export type PtsOutputsStringAgent = {
  /**
   *   Gas formation volume factor (Bg) from line conditions (PTS1/LC) to PTS reference conditions (TS).
   *   Also referred to as gasExpansionFactorPTS1toPTSRef.
   *
   * @name gasExpansionFactorPTS1toPTSRef
   */
  bgPts1?: Maybe<TimeSeries>;
  /**
   *   Gas formation volume factor (Bg) from standard conditions (PTS2/SC) to PTS reference conditions (TS).
   *   Also referred to as gasExpansionFactorPTS2toPTSRef.
   *
   * @name gasExpansionFactorPTS2toPTSRef
   */
  bgPts2?: Maybe<TimeSeries>;
  /**
   *   Oil formation volume factor (Bo) from line conditions (PTS1/LC) to PTS reference conditions (res bbl/stb, TS).
   *   Also referred to as oilShrinkageFactorPTS1toPTSRef.
   *
   * @name oilShrinkageFactorPTS1toPTSRef
   */
  boPts1?: Maybe<TimeSeries>;
  /**
   *   Oil formation volume factor (Bo) from standard conditions (PTS2/SC) to PTS reference conditions (res bbl/stb, TS).
   *   Also referred to as oilShrinkageFactorPTS2toPTSRef.
   *
   * @name oilShrinkageFactorPTS2toPTSRef
   */
  boPts2?: Maybe<TimeSeries>;
  cO2?: Maybe<TimeSeries>;
  calcWellTestGOR?: Maybe<TimeSeries>;
  calcWellTestGORInSitu?: Maybe<TimeSeries>;
  /**
   * Calculated total GOR based on vendor-reported rates (scf/stb, TS).
   * Compare to wellTestGorPtsRef (WF01-transformed GOR at PTS reference conditions) to assess correction magnitude.
   */
  calcWellTestTotalGOR?: Maybe<TimeSeries>;
  composition?: Maybe<TimeSeries>;
  estGasLiftInjectionRate?: Maybe<TimeSeries>;
  fluidCompositionPts1?: Maybe<TimeSeries>;
  freeCGRPtsRef?: Maybe<TimeSeries>;
  freeGORPtsRef?: Maybe<TimeSeries>;
  freeGORSC?: Maybe<TimeSeries>;
  /** Gas density at PTS1 / line conditions (LC) (kg/m3, TS). */
  gasDensityPts1?: Maybe<TimeSeries>;
  /** Gas density at PTS2 / standard conditions (SC) (kg/m3, TS). */
  gasDensityPts2?: Maybe<TimeSeries>;
  /** Gas gravity at PTS reference conditions (relative to air, TS). */
  gasGravity?: Maybe<TimeSeries>;
  h2S?: Maybe<TimeSeries>;
  n2?: Maybe<TimeSeries>;
  /** Oil density at PTS1 / line conditions (LC) (kg/m3, TS). */
  oilDensityPts1?: Maybe<TimeSeries>;
  /** Oil density at PTS2 / standard conditions (SC) (kg/m3, TS). */
  oilDensityPts2?: Maybe<TimeSeries>;
  sampleDateTime?: Maybe<TimeSeries>;
  saturationPressure?: Maybe<TimeSeries>;
  solutionCGR?: Maybe<TimeSeries>;
  solutionCGRPts1?: Maybe<TimeSeries>;
  solutionGOR?: Maybe<TimeSeries>;
  solutionGORPts1?: Maybe<TimeSeries>;
  /** Specific gravity of gas at PTS1 / line conditions (LC) (TS). */
  specificGravityGasPts1?: Maybe<TimeSeries>;
  /** Specific gravity of gas at PTS2 / standard conditions (SC) (TS). */
  specificGravityGasPts2?: Maybe<TimeSeries>;
  usedGasLiftInjectionRate?: Maybe<TimeSeries>;
  /** Water density at PTS1 / line conditions (LC) (kg/m3, TS). */
  waterDensityPts1?: Maybe<TimeSeries>;
  /** Water density at PTS2 / standard conditions (SC) (kg/m3, TS). */
  waterDensityPts2?: Maybe<TimeSeries>;
  waterSalinity?: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
  /** Condensate-gas ratio at PTS reference conditions (stb/MMscf, TS). */
  wellTestCGRPtsRef?: Maybe<TimeSeries>;
  wellTestEstimatedGLRate?: Maybe<TimeSeries>;
  wellTestGOR?: Maybe<TimeSeries>;
  wellTestGORPts1?: Maybe<TimeSeries>;
  wellTestGasRatePts1?: Maybe<TimeSeries>;
  /** Gas rate at PTS2 / standard conditions (MMscfd, TS). */
  wellTestGasRatePts2?: Maybe<TimeSeries>;
  /**
   * GOR at PTS2 / standard conditions (scf/stb, TS).
   * Compare to wellTestTotalGorStd (vendor) and calcWellTestTotalGOR (calculated) for validation.
   */
  wellTestGorPts2?: Maybe<TimeSeries>;
  /**
   * GOR transformed by WF01 to PTS reference conditions (scf/stb, TS).
   * Use together with calcWellTestTotalGOR (measured GOR based on vendor-reported rates) for comparison.
   * Use to list wells above/below a GOR limit or above maxGOR from producer guidelines.
   */
  wellTestGorPtsRef?: Maybe<TimeSeries>;
  wellTestLiquidRatePts1?: Maybe<TimeSeries>;
  /** Liquid rate at PTS2 / standard conditions (stb/d, TS). */
  wellTestLiquidRatePts2?: Maybe<TimeSeries>;
  /** Total liquid rate at PTS reference conditions (stb/d, TS). */
  wellTestLiquidRatePtsRef?: Maybe<TimeSeries>;
  wellTestOilRatePts1?: Maybe<TimeSeries>;
  /** Oil rate at PTS2 / standard conditions (stb/d, TS). */
  wellTestOilRatePts2?: Maybe<TimeSeries>;
  /**
   * PTS-corrected oil rate at reference conditions (stb/d, TS).
   * Compare to wellTestOilRateStd (vendor-reported standard rate) to assess PTS correction impact.
   */
  wellTestOilRatePtsRef?: Maybe<TimeSeries>;
  wellTestUsedGLRate?: Maybe<TimeSeries>;
  wellTestWGRPts1?: Maybe<TimeSeries>;
  wellTestWaterCutPts1?: Maybe<TimeSeries>;
  /**
   * Water cut at PTS2 / standard conditions (%, TS).
   * Compare to wellTestWaterCut (vendor-reported) to validate PTS calculation.
   */
  wellTestWaterCutPts2?: Maybe<TimeSeries>;
  /**
   * Water cut at PTS reference conditions (%, TS).
   * Use to list wells above a water cut threshold or to track change between consecutive accepted well tests.
   */
  wellTestWaterCutPtsRef?: Maybe<TimeSeries>;
  wellTestWaterRatePts1?: Maybe<TimeSeries>;
  /** Water rate at PTS2 / standard conditions (stb/d, TS). */
  wellTestWaterRatePts2?: Maybe<TimeSeries>;
};

/**
 * Well performance scores, rate-change metrics, analysis status, choke/GL parameters per string.
 *
 * Diagnostic metadata about the estimation process (not rate values). Use for:
 * well performance vs potential, ESP/GL/GRD analysis success, rate change, or
 * implied choke size. For rate estimates use EstimatedRates_String_Agent; for
 * data-driven rates use DataDrivenRates_String_Agent.
 *
 * Use for: performance scores and analysis status (WF10).
 *
 * @name Rate Diagnostics - Well Performance and Analysis Status (Agent)
 */
export type RateDiagnosticsStringAgent = {
  /** Calculated production choke discharge coefficient (Cd, TS). Typical range 0.6â€“0.9; deviations indicate restriction or erosion. */
  chokeCdCalc?: Maybe<TimeSeries>;
  /** Calculated production choke size implied by current rate and pressure conditions (64ths inch, TS). */
  chokeSizeCalc?: Maybe<TimeSeries>;
  /** Status of Gas Rate Decline analysis. Values: SUCCESS, FAILED, INSUFFICIENT_DATA. */
  grdAnalysisStatus?: Maybe<TimeSeries>;
  /**
   * Difference between current and reference liquid rate (stb/d, TS).
   * Positive = above reference, negative = below. Used for rate-change
   * monitoring and alarm triggering.
   */
  qliqDelta?: Maybe<TimeSeries>;
  /**
   * Well performance indicator (dimensionless). Composite efficiency or
   * health score vs theoretical potential.
   */
  wellPerformance?: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
};

/** Typed view over 'Entity' showing reservoirs only (where 'entityType' = 'reservoir'). Use this view to identify a reservoir by name, then navigate to its wells or strings through the 'FlatHierarchy' and 'SectorHierarchy' navigation views. */
export type Reservoir = {
  /** Attribute capturing end date time for this reservoir in the production optimization context. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Entity Type attribute describing this reservoir in more detail, often derived from master data or configuration tables. */
  entityType?: Maybe<Scalars['String']['output']>;
  /** Name or label for this reservoir, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  name?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing start date time for this reservoir in the production optimization context. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
};

/** Reservoir Inputs view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type ReservoirInputs = {
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Reservoir>;
  /** Time series signal representing reservoir injection allocation factor for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  reservoirInjectionAllocationFactor?: Maybe<TimeSeries>;
  /** Time series signal representing reservoir injection allocation gas factor for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  reservoirInjectionAllocationGasFactor?: Maybe<TimeSeries>;
  /** Time series signal representing reservoir injection allocation oil factor for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  reservoirInjectionAllocationOilFactor?: Maybe<TimeSeries>;
  /** Time series signal representing reservoir injection allocation water factor for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  reservoirInjectionAllocationWaterFactor?: Maybe<TimeSeries>;
  /** Time series signal representing reservoir production allocation factor for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  reservoirProductionAllocationFactor?: Maybe<TimeSeries>;
  /** Time series signal representing reservoir production allocation gas factor for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  reservoirProductionAllocationGasFactor?: Maybe<TimeSeries>;
  /** Time series signal representing reservoir production allocation oil factor for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  reservoirProductionAllocationOilFactor?: Maybe<TimeSeries>;
  /** Time series signal representing reservoir production allocation water factor for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  reservoirProductionAllocationWaterFactor?: Maybe<TimeSeries>;
};

/**
 * Reservoir-level allocation factors for production and injection (WF16).
 *
 * How production and injection from facilities are distributed among reservoirs.
 * Use for allocation share per reservoir and which reservoir has highest allocation. Excludes well connectivity or performance detail.
 *
 * Use for: VRR Monitoring and Surveillance (WF16).
 *
 * @name Reservoir Inputs - Allocation Factors (Agent)
 */
export type ReservoirInputsAgent = {
  /** Reference to reservoir. */
  reservoir?: Maybe<Reservoir>;
  /**
   * Combined injection allocation factor for this reservoir (fraction, TS).
   * Overall share of total facility injection attributed to this reservoir.
   */
  reservoirInjectionAllocationFactor?: Maybe<TimeSeries>;
  /**
   * Gas injection allocation factor for this reservoir (fraction, TS).
   * Share of facility gas injection attributed to this reservoir.
   */
  reservoirInjectionAllocationGasFactor?: Maybe<TimeSeries>;
  /**
   * Oil injection allocation factor for this reservoir (fraction, TS).
   * Used in WAG (Water-Alternating-Gas) injection schemes.
   */
  reservoirInjectionAllocationOilFactor?: Maybe<TimeSeries>;
  /**
   * Water injection allocation factor for this reservoir (fraction, TS).
   * Share of facility water injection attributed to this reservoir.
   */
  reservoirInjectionAllocationWaterFactor?: Maybe<TimeSeries>;
  /**
   * Combined production allocation factor for this reservoir (fraction, TS).
   * Overall share of total facility production attributed to this reservoir.
   */
  reservoirProductionAllocationFactor?: Maybe<TimeSeries>;
  /**
   * Gas production allocation factor for this reservoir (fraction, TS).
   * Share of facility gas production attributed to this reservoir.
   */
  reservoirProductionAllocationGasFactor?: Maybe<TimeSeries>;
  /**
   * Oil production allocation factor for this reservoir (fraction, TS).
   * Share of facility oil production attributed to this reservoir.
   */
  reservoirProductionAllocationOilFactor?: Maybe<TimeSeries>;
  /**
   * Water production allocation factor for this reservoir (fraction, TS).
   * Share of facility water production attributed to this reservoir.
   */
  reservoirProductionAllocationWaterFactor?: Maybe<TimeSeries>;
};

/** Aggregated reservoir-level outputs including counts of active and inactive wells, injection rates and downhole production/injection volumes, as well as voidage replacement ratio (VRR) and pressure compliance metrics for reservoir management and optimization. */
export type ReservoirOutputs = {
  /** Time series signal representing downhole gas injection volume for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  downholeGasInjectionVolume?: Maybe<TimeSeries>;
  /** Time series signal representing downhole gas production volume for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  downholeGasProductionVolume?: Maybe<TimeSeries>;
  /** Time series signal representing downhole oil production volume for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  downholeOilProductionVolume?: Maybe<TimeSeries>;
  /** Time series signal representing downhole water injection volume for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  downholeWaterInjectionVolume?: Maybe<TimeSeries>;
  /** Time series signal representing downhole water production volume for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  downholeWaterProductionVolume?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Reservoir>;
  /** Field attribute describing this reservoir in more detail, often derived from master data or configuration tables. */
  field?: Maybe<Field>;
  /** Time series signal representing gi rate for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giRate?: Maybe<TimeSeries>;
  /** Target production or injection rate setpoint for this reservoir, typically coming from production planning or optimization scenarios, used to guide field control and compare against actual performance. */
  giTargetRate?: Maybe<TimeSeries>;
  /** Target production or injection rate setpoint for this reservoir, typically coming from production planning or optimization scenarios, used to guide field control and compare against actual performance. */
  giTargetRateCompliance?: Maybe<TimeSeries>;
  /** Time series signal representing mtd vrr for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mtdVRR?: Maybe<TimeSeries>;
  /** Time series signal representing mtd vrrcompliance for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mtdVRRCompliance?: Maybe<TimeSeries>;
  /** Time series signal representing pressure compliance for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pressureCompliance?: Maybe<TimeSeries>;
  /** Time series signal representing region pressure for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  regionPressure?: Maybe<TimeSeries>;
  /** Time series signal representing vrr for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vrr?: Maybe<TimeSeries>;
  /** Time series signal representing vrr compliance for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vrrCompliance?: Maybe<TimeSeries>;
  /** Time series signal representing wells active gi for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsActiveGi?: Maybe<TimeSeries>;
  /** Time series signal representing wells active gp nf for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsActiveGpNf?: Maybe<TimeSeries>;
  /** Time series signal representing wells active op esp for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsActiveOpEsp?: Maybe<TimeSeries>;
  /** Time series signal representing wells active op gl for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsActiveOpGl?: Maybe<TimeSeries>;
  /** Time series signal representing wells active op nf for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsActiveOpNf?: Maybe<TimeSeries>;
  /** Time series signal representing wells active wi for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsActiveWi?: Maybe<TimeSeries>;
  /** Time series signal representing wells in active gi for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsInActiveGi?: Maybe<TimeSeries>;
  /** Time series signal representing wells in active gp nf for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsInActiveGpNf?: Maybe<TimeSeries>;
  /** Time series signal representing wells in active op esp for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsInActiveOpEsp?: Maybe<TimeSeries>;
  /** Time series signal representing wells in active op gl for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsInActiveOpGl?: Maybe<TimeSeries>;
  /** Time series signal representing wells in active op nf for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsInActiveOpNf?: Maybe<TimeSeries>;
  /** Time series signal representing wells in active wi for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsInActiveWi?: Maybe<TimeSeries>;
  /** Time series signal representing wi rate for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiRate?: Maybe<TimeSeries>;
  /** Target production or injection rate setpoint for this reservoir, typically coming from production planning or optimization scenarios, used to guide field control and compare against actual performance. */
  wiTargetRate?: Maybe<TimeSeries>;
  /** Target production or injection rate setpoint for this reservoir, typically coming from production planning or optimization scenarios, used to guide field control and compare against actual performance. */
  wiTargetRateCompliance?: Maybe<TimeSeries>;
  /** Time series signal representing ytd vrr for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  ytdVRR?: Maybe<TimeSeries>;
  /** Time series signal representing ytd vrrcompliance for this reservoir, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  ytdVRRCompliance?: Maybe<TimeSeries>;
};

/**
 * Reservoir-level VRR metrics, compliance ratios, injection balance (WF16).
 *
 * Reservoir output metrics for VRR compliance, injection strategies, well activity.
 * Use to assess reservoir health and injection-related risks. Excludes geological or historical detail.
 *
 * Use for: VRR Monitoring and Surveillance (WF16).
 *
 * @name Reservoir Outputs (Agent)
 */
export type ReservoirOutputsAgent = {
  /**
   * Downhole gas injection volume at reservoir conditions (rb, TS).
   * Used in VRR numerator calculation.
   */
  downholeGasInjectionVolume?: Maybe<TimeSeries>;
  /**
   * Downhole gas production volume at reservoir conditions (rb, TS).
   * Used in VRR denominator calculation.
   */
  downholeGasProductionVolume?: Maybe<TimeSeries>;
  /**
   * Downhole oil production volume at reservoir conditions (rb, TS).
   * Used in VRR denominator calculation.
   */
  downholeOilProductionVolume?: Maybe<TimeSeries>;
  /**
   * Downhole water injection volume at reservoir conditions (rb, TS).
   * Used in VRR numerator calculation.
   */
  downholeWaterInjectionVolume?: Maybe<TimeSeries>;
  /**
   * Downhole water production volume at reservoir conditions (rb, TS).
   * Used in VRR denominator calculation.
   */
  downholeWaterProductionVolume?: Maybe<TimeSeries>;
  /** Parent field containing this reservoir. Use for field-level aggregation. */
  field?: Maybe<Field>;
  /** Aggregated gas injection rate for the reservoir (MSCF/d, TS). */
  giRate?: Maybe<TimeSeries>;
  /**
   * Gas injection target rate from planning/optimization (MSCF/d, TS).
   * Compare to giRate for performance gap.
   */
  giTargetRate?: Maybe<TimeSeries>;
  /** Gas injection target rate compliance flag (TS). 1 = giRate meets target. */
  giTargetRateCompliance?: Maybe<TimeSeries>;
  /**
   * Month-to-date VRR (TS). Cumulative VRR from start of current month.
   * Use for monthly trend vs daily VRR.
   */
  mtdVRR?: Maybe<TimeSeries>;
  /** Month-to-date VRR compliance flag (TS). 1 = within target band for the month. */
  mtdVRRCompliance?: Maybe<TimeSeries>;
  /**
   * Reservoir pressure compliance flag (TS). 1 = within expected range from
   * Reservoir_Guideline.expectedReservoirPressure.
   */
  pressureCompliance?: Maybe<TimeSeries>;
  /**
   * Average reservoir region pressure (psi, TS). Compare to
   * Reservoir_Guideline.expectedReservoirPressure for compliance.
   */
  regionPressure?: Maybe<TimeSeries>;
  /** Reference to reservoir. */
  reservoir?: Maybe<Reservoir>;
  /**
   * Daily voidage replacement ratio (TS). Ratio of injected volume to produced
   * volume at reservoir conditions. Target typically ~1.0 for pressure maintenance.
   */
  vrr?: Maybe<TimeSeries>;
  /** Daily VRR compliance flag (TS). 1 = within target band, 0 = out of compliance. */
  vrrCompliance?: Maybe<TimeSeries>;
  /** Count of active gas injector wells (TS). */
  wellsActiveGi?: Maybe<TimeSeries>;
  /** Count of active gas producer wells on natural flow (TS). */
  wellsActiveGpNf?: Maybe<TimeSeries>;
  /** Count of active oil producer wells on ESP (TS). */
  wellsActiveOpEsp?: Maybe<TimeSeries>;
  /** Count of active oil producer wells on gas lift (TS). */
  wellsActiveOpGl?: Maybe<TimeSeries>;
  /** Count of active oil producer wells on natural flow (TS). */
  wellsActiveOpNf?: Maybe<TimeSeries>;
  /** Count of active water injector wells (TS). */
  wellsActiveWi?: Maybe<TimeSeries>;
  /** Count of inactive gas injector wells (TS). */
  wellsInActiveGi?: Maybe<TimeSeries>;
  /** Count of inactive gas producer wells on natural flow (TS). */
  wellsInActiveGpNf?: Maybe<TimeSeries>;
  /** Count of inactive oil producer wells on ESP (TS). */
  wellsInActiveOpEsp?: Maybe<TimeSeries>;
  /** Count of inactive oil producer wells on gas lift (TS). */
  wellsInActiveOpGl?: Maybe<TimeSeries>;
  /** Count of inactive oil producer wells on natural flow (TS). */
  wellsInActiveOpNf?: Maybe<TimeSeries>;
  /** Count of inactive water injector wells (TS). */
  wellsInActiveWi?: Maybe<TimeSeries>;
  /** Aggregated water injection rate for the reservoir (stb/d, TS). */
  wiRate?: Maybe<TimeSeries>;
  /**
   * Water injection target rate from planning/optimization (stb/d, TS).
   * Compare to wiRate for performance gap.
   */
  wiTargetRate?: Maybe<TimeSeries>;
  /** Water injection target rate compliance flag (TS). 1 = wiRate meets target. */
  wiTargetRateCompliance?: Maybe<TimeSeries>;
  /**
   * Year-to-date VRR (TS). Cumulative VRR from start of current year.
   * Use for long-term reservoir management assessment.
   */
  ytdVRR?: Maybe<TimeSeries>;
  /** Year-to-date VRR compliance flag (TS). 1 = within target band for the year. */
  ytdVRRCompliance?: Maybe<TimeSeries>;
};

/** Reservoir Guideline view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type ReservoirGuideline = {
  /** Attribute capturing effective date for this reservoir in the production optimization context. */
  effectiveDate?: Maybe<Scalars['Timestamp']['output']>;
  /** Numeric value storing expected reservoir pressure for this reservoir, used in calculations, reporting, or model configuration. */
  expectedReservoirPressure?: Maybe<Scalars['Float32']['output']>;
  /** Field attribute describing this reservoir in more detail, often derived from master data or configuration tables. */
  field?: Maybe<Field>;
  /** Reservoir attribute describing this reservoir in more detail, often derived from master data or configuration tables. */
  reservoir?: Maybe<Reservoir>;
  /** Numeric value storing reservoir allowable rate for this reservoir, used in calculations, reporting, or model configuration. */
  reservoirAllowableRate?: Maybe<Scalars['Float32']['output']>;
  /** Sector attribute describing this reservoir in more detail, often derived from master data or configuration tables. */
  sector?: Maybe<Sector>;
  /** Numeric value storing technical gas rate for this reservoir, used in calculations, reporting, or model configuration. */
  technicalGasRate?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing technical oil rate for this reservoir, used in calculations, reporting, or model configuration. */
  technicalOilRate?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing vrr requirement for this reservoir, used in calculations, reporting, or model configuration. */
  vrrRequirement?: Maybe<Scalars['Float32']['output']>;
  /** Target value for this reservoir defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  vrrTarget?: Maybe<Scalars['Float32']['output']>;
};

/** Production planning assumptions, constraints, and targets over time at the relevant aggregation level, used to compare actual performance versus plan and to steer optimization scenarios. */
export type ReservoirProdplan = {
  /** Attribute capturing effective date for this reservoir in the production optimization context. */
  effectiveDate?: Maybe<Scalars['Timestamp']['output']>;
  /** Field attribute describing this reservoir in more detail, often derived from master data or configuration tables. */
  field?: Maybe<Field>;
  /** Target value for this reservoir defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  prodTarget?: Maybe<Scalars['Float32']['output']>;
  /** Reservoir attribute describing this reservoir in more detail, often derived from master data or configuration tables. */
  reservoir?: Maybe<Reservoir>;
  /** Attribute capturing submitted month for this reservoir in the production optimization context. */
  submittedMonth?: Maybe<Scalars['Timestamp']['output']>;
  /** Target value for this reservoir defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  vrrTarget?: Maybe<Scalars['Float32']['output']>;
};

/** SHG Producer Guideline view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type ShgProducerGuideline = {
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Numeric value storing max gor for this entity, used in calculations, reporting, or model configuration. */
  maxGOR?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing max liquid rate for this entity, used in calculations, reporting, or model configuration. */
  maxLiquidRate?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing max oil rate for this entity, used in calculations, reporting, or model configuration. */
  maxOilRate?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing min bhp for this entity, used in calculations, reporting, or model configuration. */
  minBHP?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing min whp for this entity, used in calculations, reporting, or model configuration. */
  minWHP?: Maybe<Scalars['Float32']['output']>;
};

/** SPress Settings view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type SPressSettings = {
  /** Attribute capturing date time for this entity in the production optimization context. */
  dateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Entity>;
  /** Numeric value storing max reservoir pressure for this entity, used in calculations, reporting, or model configuration. */
  maxReservoirPressure?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing min number shut in pressures for this entity, used in calculations, reporting, or model configuration. */
  minNumberShutInPressures?: Maybe<Scalars['Int']['output']>;
  /** Numeric value storing min reservoir pressure for this entity, used in calculations, reporting, or model configuration. */
  minReservoirPressure?: Maybe<Scalars['Float32']['output']>;
};

/** SRMOutput view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type SrmOutput = {
  /** Attribute capturing date for this entity in the production optimization context. */
  date?: Maybe<Scalars['Timestamp']['output']>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Execution By attribute describing this entity in more detail, often derived from master data or configuration tables. */
  executionBy?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing execution date for this entity in the production optimization context. */
  executionDate?: Maybe<Scalars['Timestamp']['output']>;
  /** Numeric value storing optimize gas rate for this entity, used in calculations, reporting, or model configuration. */
  optimizeGasRate?: Maybe<Scalars['Float32']['output']>;
  /** Time series signal representing optimized co2 inj rate res cond srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedCO2InjRateResCondSRM?: Maybe<TimeSeries>;
  /** Time series signal representing optimized co2 inj rate srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedCO2InjRateSRM?: Maybe<TimeSeries>;
  /** Numeric value storing optimized oil rate for this entity, used in calculations, reporting, or model configuration. */
  optimizedOilRate?: Maybe<Scalars['Float32']['output']>;
  /** Scenario attribute describing this entity in more detail, often derived from master data or configuration tables. */
  scenario?: Maybe<Scalars['String']['output']>;
};

/** SRMOutputs All Entities view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type SrmOutputsAllEntities = {
  /** Time series signal representing created date for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  createdDate?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Entity>;
  /** Time series signal representing entity type for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  entityType?: Maybe<TimeSeries>;
  /** Time series signal representing execution by for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  executionBy?: Maybe<TimeSeries>;
  /** Time series signal representing execution date for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  executionDate?: Maybe<TimeSeries>;
  /** Time series signal representing gas inj capacity for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasInjCapacity?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  isOfficial?: Maybe<TimeSeries>;
  /** Time series signal representing last updated date for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  lastUpdatedDate?: Maybe<TimeSeries>;
  /** Time series signal representing oil rate quota for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilRateQuota?: Maybe<TimeSeries>;
  /** Time series signal representing optimized co2 inj rate res cond srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedCO2InjRateResCondSRM?: Maybe<TimeSeries>;
  /** Time series signal representing optimized co2 inj rate srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedCO2InjRateSRM?: Maybe<TimeSeries>;
  /** Time series signal representing optimized gas inj rate gap for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedGasInjRateGAP?: Maybe<TimeSeries>;
  /** Time series signal representing optimized gas inj rate res cond srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedGasInjRateResCondSRM?: Maybe<TimeSeries>;
  /** Time series signal representing optimized gas inj rate srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedGasInjRateSRM?: Maybe<TimeSeries>;
  /** Time series signal representing optimized gas rate gap for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedGasRateGAP?: Maybe<TimeSeries>;
  /** Time series signal representing optimized gas rate srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedGasRateSRM?: Maybe<TimeSeries>;
  /** Time series signal representing optimized oil rate gap for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedOilRateGAP?: Maybe<TimeSeries>;
  /** Time series signal representing optimized oil rate srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedOilRateSRM?: Maybe<TimeSeries>;
  /** Time series signal representing optimized prod rate res cond srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedProdRateResCondSRM?: Maybe<TimeSeries>;
  /** Time series signal representing optimized water inj rate gap for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedWaterInjRateGAP?: Maybe<TimeSeries>;
  /** Time series signal representing optimized water inj rate res cond srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedWaterInjRateResCondSRM?: Maybe<TimeSeries>;
  /** Time series signal representing optimized water inj rate srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedWaterInjRateSRM?: Maybe<TimeSeries>;
  /** Time series signal representing optimized water rate gap for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedWaterRateGAP?: Maybe<TimeSeries>;
  /** Time series signal representing optimized water rate srm for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedWaterRateSRM?: Maybe<TimeSeries>;
  /** Time series signal representing scenario for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  scenario?: Maybe<TimeSeries>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  scenaroID?: Maybe<TimeSeries>;
  /** Target value for this entity defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  vrrTarget?: Maybe<TimeSeries>;
  /** Time series signal representing water inj capacity for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterInjCapacity?: Maybe<TimeSeries>;
};

/** SRMOutputs String view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type SrmOutputsString = {
  /** Time series signal representing ad hoc optimized gas inj rate res cond for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  adHocOptimizedGasInjRateResCond?: Maybe<TimeSeries>;
  /** Time series signal representing ad hoc optimized gas inj rate srm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  adHocOptimizedGasInjRateSRM?: Maybe<TimeSeries>;
  /** Time series signal representing ad hoc optimized gas rate srm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  adHocOptimizedGasRateSRM?: Maybe<TimeSeries>;
  /** Time series signal representing ad hoc optimized inj rate res cond for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  adHocOptimizedInjRateResCond?: Maybe<TimeSeries>;
  /** Time series signal representing ad hoc optimized oil rate srm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  adHocOptimizedOilRateSRM?: Maybe<TimeSeries>;
  /** Time series signal representing ad hoc optimized prod rate res cond for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  adHocOptimizedProdRateResCond?: Maybe<TimeSeries>;
  /** Time series signal representing ad hoc optimized water inj rate res cond for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  adHocOptimizedWaterInjRateResCond?: Maybe<TimeSeries>;
  /** Time series signal representing ad hoc optimized water inj rate srm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  adHocOptimizedWaterInjRateSRM?: Maybe<TimeSeries>;
  /** Time series signal representing ad hoc optimized water rate srm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  adHocOptimizedWaterRateSRM?: Maybe<TimeSeries>;
  /** Time series signal representing ad hocoptimized bhfpgap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  adHocoptimizedBHFPGAP?: Maybe<TimeSeries>;
  /** Time series signal representing ad hocoptimized choke size gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  adHocoptimizedChokeSizeGAP?: Maybe<TimeSeries>;
  /** Time series signal representing ad hocoptimized espfrequency gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  adHocoptimizedESPFrequencyGAP?: Maybe<TimeSeries>;
  /** Time series signal representing ad hocoptimized gas inj rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  adHocoptimizedGasInjRateGAP?: Maybe<TimeSeries>;
  /** Time series signal representing ad hocoptimized gas lift rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  adHocoptimizedGasLiftRateGAP?: Maybe<TimeSeries>;
  /** Time series signal representing ad hocoptimized gas rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  adHocoptimizedGasRateGAP?: Maybe<TimeSeries>;
  /** Time series signal representing ad hocoptimized oil rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  adHocoptimizedOilRateGAP?: Maybe<TimeSeries>;
  /** Time series signal representing ad hocoptimized water inj rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  adHocoptimizedWaterInjRateGAP?: Maybe<TimeSeries>;
  /** Time series signal representing ad hocoptimized water rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  adHocoptimizedWaterRateGAP?: Maybe<TimeSeries>;
  /** Time series signal representing created date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  createdDate?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Time series signal representing execution by for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  executionBy?: Maybe<TimeSeries>;
  /** Time series signal representing execution date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  executionDate?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  isOfficial?: Maybe<TimeSeries>;
  /** Time series signal representing last updated date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  lastUpdatedDate?: Maybe<TimeSeries>;
  /** Time series signal representing optimize gas rate srm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizeGasRateSRM?: Maybe<TimeSeries>;
  /** Time series signal representing optimize water rate srm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizeWaterRateSRM?: Maybe<TimeSeries>;
  /** Time series signal representing optimized bhfpgap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedBHFPGAP?: Maybe<TimeSeries>;
  /** Time series signal representing optimized choke size gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedChokeSizeGAP?: Maybe<TimeSeries>;
  /** Time series signal representing optimized espfrequency gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedESPFrequencyGAP?: Maybe<TimeSeries>;
  /** Time series signal representing optimized gas inj rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedGasInjRateGAP?: Maybe<TimeSeries>;
  /** Time series signal representing optimized gas inj rate res cond for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedGasInjRateResCond?: Maybe<TimeSeries>;
  /** Time series signal representing optimized gas inj rate srm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedGasInjRateSRM?: Maybe<TimeSeries>;
  /** Time series signal representing optimized gas lift rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedGasLiftRateGAP?: Maybe<TimeSeries>;
  /** Time series signal representing optimized gas rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedGasRateGAP?: Maybe<TimeSeries>;
  /** Time series signal representing optimized inj rate res cond for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedInjRateResCond?: Maybe<TimeSeries>;
  /** Time series signal representing optimized oil rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedOilRateGAP?: Maybe<TimeSeries>;
  /** Time series signal representing optimized oil rate srm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedOilRateSRM?: Maybe<TimeSeries>;
  /** Time series signal representing optimized prod rate res cond for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedProdRateResCond?: Maybe<TimeSeries>;
  /** Time series signal representing optimized whp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedWHP?: Maybe<TimeSeries>;
  /** Time series signal representing optimized water inj rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedWaterInjRateGAP?: Maybe<TimeSeries>;
  /** Time series signal representing optimized water inj rate res cond for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedWaterInjRateResCond?: Maybe<TimeSeries>;
  /** Time series signal representing optimized water inj rate srm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedWaterInjRateSRM?: Maybe<TimeSeries>;
  /** Time series signal representing optimized water rate gap for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  optimizedWaterRateGAP?: Maybe<TimeSeries>;
  /** Time series signal representing scenario for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  scenario?: Maybe<TimeSeries>;
  /** Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  scenaroID?: Maybe<TimeSeries>;
  /** Time series signal representing well type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellType?: Maybe<TimeSeries>;
};

/** SRMSettings view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type SrmSettings = {
  /** Allocation Factor Type attribute describing this entity in more detail, often derived from master data or configuration tables. */
  allocationFactorType?: Maybe<Scalars['String']['output']>;
  /** Choke Calculation attribute describing this entity in more detail, often derived from master data or configuration tables. */
  chokeCalculation?: Maybe<Scalars['String']['output']>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Field>;
  /** Numeric value storing gas injection weight for this entity, used in calculations, reporting, or model configuration. */
  gasInjectionWeight?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing gas production weight for this entity, used in calculations, reporting, or model configuration. */
  gasProductionWeight?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing max iterations for this entity, used in calculations, reporting, or model configuration. */
  maxIterations?: Maybe<Scalars['Int']['output']>;
  /** Numeric value storing min number well tests for this entity, used in calculations, reporting, or model configuration. */
  minNumberWellTests?: Maybe<Scalars['Int']['output']>;
  /** Numeric value storing min ratio for this entity, used in calculations, reporting, or model configuration. */
  minRatio?: Maybe<Scalars['Float32']['output']>;
  /** Rate Constraint Option attribute describing this entity in more detail, often derived from master data or configuration tables. */
  rateConstraintOption?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing vrr weight for this entity, used in calculations, reporting, or model configuration. */
  vrrWeight?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing water injection weight for this entity, used in calculations, reporting, or model configuration. */
  waterInjectionWeight?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing water production weight for this entity, used in calculations, reporting, or model configuration. */
  waterProductionWeight?: Maybe<Scalars['Float32']['output']>;
};

/** Saturation Pressure Mapping view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type SaturationPressureMapping = {
  /** Asph Table attribute describing this entity in more detail, often derived from master data or configuration tables. */
  asphTable?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing effective date for this entity in the production optimization context. */
  effectiveDate?: Maybe<Scalars['Timestamp']['output']>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Prp File attribute describing this entity in more detail, often derived from master data or configuration tables. */
  prpFile?: Maybe<Scalars['String']['output']>;
  /** Pvt File attribute describing this entity in more detail, often derived from master data or configuration tables. */
  pvtFile?: Maybe<Scalars['String']['output']>;
  /** Pvt Ref attribute describing this entity in more detail, often derived from master data or configuration tables. */
  pvtRef?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing res temp for this entity, used in calculations, reporting, or model configuration. */
  resTemp?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing sat press for this entity, used in calculations, reporting, or model configuration. */
  satPress?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing solution gor for this entity, used in calculations, reporting, or model configuration. */
  solutionGOR?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing wat for this entity, used in calculations, reporting, or model configuration. */
  wat?: Maybe<Scalars['Float32']['output']>;
};

/** Sector view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type Sector = {
  /** Attribute capturing end date time for this entity in the production optimization context. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Entity Type attribute describing this entity in more detail, often derived from master data or configuration tables. */
  entityType?: Maybe<Scalars['String']['output']>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  name?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing start date time for this entity in the production optimization context. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
};

/**
 * DENORMALIZED SECTOR LOOKUP TABLE - For sector-based flow allocation and reservoir analysis.
 *
 * STRUCTURE: Each row = one String with its sector/reservoir assignment and allocation factor.
 * Hierarchy: Reservoir → Sector → Well → String
 *
 * WHY USE THIS: Navigate sector relationships and retrieve allocation factors for flow calculations.
 *
 * QUERY PATTERNS:
 * - Find strings in a sector: Filter sector.name = 'X', select string
 * - Find wells in a reservoir: Filter reservoir.name = 'Y', select DISTINCT well
 * - Get allocation factors: Filter by sector or reservoir, select allocationFactor
 *
 * KEY BEHAVIORS:
 * - One row per string means parent entities repeat (use DISTINCT for unique parents)
 * - References return full entity objects - access .name, .externalId, etc.
 * - Use startDateTime/endDateTime for historical sector assignments
 */
export type SectorHierarchy = {
  /** Numeric factor (0-1) used to allocate production volumes from this string to the sector. Used in flow allocation calculations when a string produces from multiple sectors. */
  allocationFactor?: Maybe<Scalars['Float32']['output']>;
  /** When this sector assignment ended. NULL = currently active. For current assignments only, filter where endDateTime is null. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Subsurface reservoir formation containing the sector. Filter here to find all sectors, wells, or strings within a specific reservoir. */
  reservoir?: Maybe<Reservoir>;
  /** Subdivision of a reservoir used for flow allocation and production management. Multiple wells/strings can belong to the same sector. Filter here to analyze sector-level production. */
  sector?: Maybe<Sector>;
  /** When this sector assignment became effective. Used for temporal queries when sector assignments change over time. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Completion/producing interval within the well. The LEAF ENTITY of this view - each row represents exactly one string. Use string.name for string identifier. */
  string?: Maybe<StringAsset>;
  /** Physical wellbore containing this string. A well may have multiple strings (completions). Use well.name for well identifier. */
  well?: Maybe<Well>;
};

/**
 * Reservoir â†’ sector â†’ well â†’ string mapping with per-string allocation
 * factors, scoped to in-scope assets.
 *
 * Lookup table linking each producing string to its sector within a reservoir,
 * together with the flow allocation factor used in sector-based allocation,
 * and the effective date range of the assignment. Complements
 * FlatHierarchy_Agent, which carries the broader production hierarchy.
 *
 * @name SectorHierarchy (Agent Scoped)
 */
export type SectorHierarchyAgent = {
  /** Fractional flow allocation for this string within its sector. */
  allocationFactor?: Maybe<Scalars['Float32']['output']>;
  /** Timestamp at which this sector assignment ended. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Subsurface reservoir containing the sector. */
  reservoir?: Maybe<Reservoir>;
  /** Subdivision of a reservoir used for flow allocation. */
  sector?: Maybe<Sector>;
  /** Timestamp at which this sector assignment became effective. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Completion or producing interval. One row per string. */
  string?: Maybe<StringAsset>;
  /** Physical wellbore containing the string. */
  well?: Maybe<Well>;
};

/** Aggregated sector-level outputs including counts of active and inactive wells, injection rates and downhole production/injection volumes, as well as voidage replacement ratio (VRR) and pressure compliance metrics for sector surveillance and optimization. */
export type SectorOutputs = {
  /** Time series signal representing downhole gas injection volume for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  downholeGasInjectionVolume?: Maybe<TimeSeries>;
  /** Time series signal representing downhole gas production volume for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  downholeGasProductionVolume?: Maybe<TimeSeries>;
  /** Time series signal representing downhole oil production volume for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  downholeOilProductionVolume?: Maybe<TimeSeries>;
  /** Time series signal representing downhole water injection volume for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  downholeWaterInjectionVolume?: Maybe<TimeSeries>;
  /** Time series signal representing downhole water production volume for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  downholeWaterProductionVolume?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Sector>;
  /** Field attribute describing this entity in more detail, often derived from master data or configuration tables. */
  field?: Maybe<Field>;
  /** Time series signal representing gi rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giRate?: Maybe<TimeSeries>;
  /** Target production or injection rate setpoint for this entity, typically coming from production planning or optimization scenarios, used to guide field control and compare against actual performance. */
  giTargetRate?: Maybe<TimeSeries>;
  /** Target production or injection rate setpoint for this entity, typically coming from production planning or optimization scenarios, used to guide field control and compare against actual performance. */
  giTargetRateCompliance?: Maybe<TimeSeries>;
  /** Time series signal representing mtd vrr for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mtdVRR?: Maybe<TimeSeries>;
  /** Time series signal representing mtd vrrcompliance for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mtdVRRCompliance?: Maybe<TimeSeries>;
  /** Time series signal representing pressure compliance for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pressureCompliance?: Maybe<TimeSeries>;
  /** Time series signal representing region pressure for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  regionPressure?: Maybe<TimeSeries>;
  /** Reservoir attribute describing this entity in more detail, often derived from master data or configuration tables. */
  reservoir?: Maybe<Reservoir>;
  /** Time series signal representing vrr for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vrr?: Maybe<TimeSeries>;
  /** Time series signal representing vrr compliance for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vrrCompliance?: Maybe<TimeSeries>;
  /** Time series signal representing wells active gi for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsActiveGi?: Maybe<TimeSeries>;
  /** Time series signal representing wells active gp nf for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsActiveGpNf?: Maybe<TimeSeries>;
  /** Time series signal representing wells active op esp for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsActiveOpEsp?: Maybe<TimeSeries>;
  /** Time series signal representing wells active op gl for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsActiveOpGl?: Maybe<TimeSeries>;
  /** Time series signal representing wells active op nf for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsActiveOpNf?: Maybe<TimeSeries>;
  /** Time series signal representing wells active wi for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsActiveWi?: Maybe<TimeSeries>;
  /** Time series signal representing wells in active gi for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsInActiveGi?: Maybe<TimeSeries>;
  /** Time series signal representing wells in active gp nf for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsInActiveGpNf?: Maybe<TimeSeries>;
  /** Time series signal representing wells in active op esp for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsInActiveOpEsp?: Maybe<TimeSeries>;
  /** Time series signal representing wells in active op gl for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsInActiveOpGl?: Maybe<TimeSeries>;
  /** Time series signal representing wells in active op nf for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsInActiveOpNf?: Maybe<TimeSeries>;
  /** Time series signal representing wells in active wi for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellsInActiveWi?: Maybe<TimeSeries>;
  /** Time series signal representing wi rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiRate?: Maybe<TimeSeries>;
  /** Target production or injection rate setpoint for this entity, typically coming from production planning or optimization scenarios, used to guide field control and compare against actual performance. */
  wiTargetRate?: Maybe<TimeSeries>;
  /** Target production or injection rate setpoint for this entity, typically coming from production planning or optimization scenarios, used to guide field control and compare against actual performance. */
  wiTargetRateCompliance?: Maybe<TimeSeries>;
  /** Time series signal representing ytd vrr for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  ytdVRR?: Maybe<TimeSeries>;
  /** Time series signal representing ytd vrrcompliance for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  ytdVRRCompliance?: Maybe<TimeSeries>;
};

/** Production planning assumptions, constraints, and targets over time at the relevant aggregation level, used to compare actual performance versus plan and to steer optimization scenarios. */
export type SectorProdplan = {
  /** Attribute capturing effective date for this entity in the production optimization context. */
  effectiveDate?: Maybe<Scalars['Timestamp']['output']>;
  /** Field attribute describing this entity in more detail, often derived from master data or configuration tables. */
  field?: Maybe<Field>;
  /** Reservoir attribute describing this entity in more detail, often derived from master data or configuration tables. */
  reservoir?: Maybe<Reservoir>;
  /** Sector attribute describing this entity in more detail, often derived from master data or configuration tables. */
  sector?: Maybe<Sector>;
  /** Attribute capturing submitted month for this entity in the production optimization context. */
  submittedMonth?: Maybe<Scalars['Timestamp']['output']>;
  /** Target value for this entity defined by planning or optimization processes, used to measure performance gaps and steer operations. */
  vrrTarget?: Maybe<Scalars['Float32']['output']>;
};

/** Separator Inputs view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type SeparatorInputs = {
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Entity>;
  /** Time series signal representing separator gas rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  separatorGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing separator oil rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  separatorOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing separator pressure for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  separatorPressure?: Maybe<TimeSeries>;
  /** Time series signal representing separator water rate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  separatorWaterRate?: Maybe<TimeSeries>;
};

/** String Fluid Composition view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type StringFluidComposition = {
  /** Time series signal representing c1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c1?: Maybe<TimeSeries>;
  /** Time series signal representing c2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c2?: Maybe<TimeSeries>;
  /** Time series signal representing c3 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c3?: Maybe<TimeSeries>;
  /** Time series signal representing c6 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c6?: Maybe<TimeSeries>;
  /** Time series signal representing c7c10 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c7c10?: Maybe<TimeSeries>;
  /** Time series signal representing c7c13 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c7c13?: Maybe<TimeSeries>;
  /** Time series signal representing c7c14 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c7c14?: Maybe<TimeSeries>;
  /** Time series signal representing c7c15 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c7c15?: Maybe<TimeSeries>;
  /** Time series signal representing c7c16 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c7c16?: Maybe<TimeSeries>;
  /** Time series signal representing c7c18 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c7c18?: Maybe<TimeSeries>;
  /** Time series signal representing c11c16 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c11c16?: Maybe<TimeSeries>;
  /** Time series signal representing c14c23 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c14c23?: Maybe<TimeSeries>;
  /** Time series signal representing c14c28 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c14c28?: Maybe<TimeSeries>;
  /** Time series signal representing c14plus for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c14plus?: Maybe<TimeSeries>;
  /** Time series signal representing c15c25 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c15c25?: Maybe<TimeSeries>;
  /** Time series signal representing c16c25 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c16c25?: Maybe<TimeSeries>;
  /** Time series signal representing c16c26 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c16c26?: Maybe<TimeSeries>;
  /** Time series signal representing c17c24 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c17c24?: Maybe<TimeSeries>;
  /** Time series signal representing c17c25 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c17c25?: Maybe<TimeSeries>;
  /** Time series signal representing c17c29 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c17c29?: Maybe<TimeSeries>;
  /** Time series signal representing c17plus for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c17plus?: Maybe<TimeSeries>;
  /** Time series signal representing c24c73 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c24c73?: Maybe<TimeSeries>;
  /** Time series signal representing c25c80 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c25c80?: Maybe<TimeSeries>;
  /** Time series signal representing c25plus for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c25plus?: Maybe<TimeSeries>;
  /** Time series signal representing c26c80 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c26c80?: Maybe<TimeSeries>;
  /** Time series signal representing c27c80 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c27c80?: Maybe<TimeSeries>;
  /** Time series signal representing c28plus for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c28plus?: Maybe<TimeSeries>;
  /** Time series signal representing c30c18 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c30c18?: Maybe<TimeSeries>;
  /** Time series signal representing c30c80 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c30c80?: Maybe<TimeSeries>;
  /** Time series signal representing c74c80 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c74c80?: Maybe<TimeSeries>;
  /** Time series signal representing c74plus for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c74plus?: Maybe<TimeSeries>;
  /** Time series signal representing c80plus for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c80plus?: Maybe<TimeSeries>;
  /** Time series signal representing c81plus for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  c81plus?: Maybe<TimeSeries>;
  /** Time series signal representing cgr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  cgr?: Maybe<TimeSeries>;
  /** Time series signal representing co2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  co2?: Maybe<TimeSeries>;
  /** Time series signal representing condensate gravity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  condensateGravity?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Time series signal representing fluid type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  fluidType?: Maybe<TimeSeries>;
  /** Time series signal representing h2s for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  h2s?: Maybe<TimeSeries>;
  /** Time series signal representing i c4 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  iC4?: Maybe<TimeSeries>;
  /** Time series signal representing i c4plusn c4 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  iC4plusnC4?: Maybe<TimeSeries>;
  /** Time series signal representing i c5 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  iC5?: Maybe<TimeSeries>;
  /** Time series signal representing i c5plusn c5 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  iC5plusnC5?: Maybe<TimeSeries>;
  /** Time series signal representing n2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  n2?: Maybe<TimeSeries>;
  /** Time series signal representing n c4 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  nC4?: Maybe<TimeSeries>;
  /** Time series signal representing n c5 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  nC5?: Maybe<TimeSeries>;
  /** Time series signal representing specific gas gravity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  specificGasGravity?: Maybe<TimeSeries>;
  /** Time series signal representing water salinity for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterSalinity?: Maybe<TimeSeries>;
  /** Time series signal representing wgr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wgr?: Maybe<TimeSeries>;
};

/**
 * String-level fluid composition including oil, gas, and water fractions.
 *
 * Contains detailed fluid composition data at the string level, including
 * various gas and liquid fractions derived from well tests and production data.
 * Sourced from field measurements and laboratory analyses, enabling the
 * resolution of analytical questions related to fluid behavior, phase
 * interactions, and reservoir performance. It excludes historical production
 * rates or reservoir pressure data, which are available in other views. Use
 * cases: optimizing production strategies, assessing flow assurance challenges,
 * and conducting PVT studies for enhanced oil recovery.
 *
 * @name String Fluid Composition (Agent)
 */
export type StringFluidCompositionAgent = {
  c1?: Maybe<TimeSeries>;
  c2?: Maybe<TimeSeries>;
  c3?: Maybe<TimeSeries>;
  c6?: Maybe<TimeSeries>;
  cgr?: Maybe<TimeSeries>;
  co2?: Maybe<TimeSeries>;
  condensateGravity?: Maybe<TimeSeries>;
  fluidType?: Maybe<TimeSeries>;
  h2s?: Maybe<TimeSeries>;
  iC4?: Maybe<TimeSeries>;
  iC5?: Maybe<TimeSeries>;
  n2?: Maybe<TimeSeries>;
  nC4?: Maybe<TimeSeries>;
  nC5?: Maybe<TimeSeries>;
  specificGasGravity?: Maybe<TimeSeries>;
  waterSalinity?: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
  wgr?: Maybe<TimeSeries>;
};

/** String Inputs Static view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type StringInputsStatic = {
  /** Numeric value storing base lat mid perf for this production string, used in calculations, reporting, or model configuration. */
  baseLatMidPerf?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing base long mid perf for this production string, used in calculations, reporting, or model configuration. */
  baseLongMidPerf?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing base x for this production string, used in calculations, reporting, or model configuration. */
  baseX?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing base xmid perf for this production string, used in calculations, reporting, or model configuration. */
  baseXMidPerf?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing base y for this production string, used in calculations, reporting, or model configuration. */
  baseY?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing base ymid perf for this production string, used in calculations, reporting, or model configuration. */
  baseYMidPerf?: Maybe<Scalars['Float32']['output']>;
  /** Borehole Shape attribute describing this production string in more detail, often derived from master data or configuration tables. */
  boreholeShape?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing bottom depth for this production string, used in calculations, reporting, or model configuration. */
  bottomDepth?: Maybe<Scalars['Float32']['output']>;
  /** Crs attribute describing this production string in more detail, often derived from master data or configuration tables. */
  crs?: Maybe<Scalars['String']['output']>;
  /** Numeric value storing elevation for this production string, used in calculations, reporting, or model configuration. */
  elevation?: Maybe<Scalars['Float32']['output']>;
  /** Elevation Ref attribute describing this production string in more detail, often derived from master data or configuration tables. */
  elevationRef?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing end date for this production string in the production optimization context. */
  endDate?: Maybe<Scalars['Timestamp']['output']>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Numeric value storing original base x for this production string, used in calculations, reporting, or model configuration. */
  originalBaseX?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing original base y for this production string, used in calculations, reporting, or model configuration. */
  originalBaseY?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing original top x for this production string, used in calculations, reporting, or model configuration. */
  originalTopX?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing original top y for this production string, used in calculations, reporting, or model configuration. */
  originalTopY?: Maybe<Scalars['Float32']['output']>;
  /** Attribute capturing start date for this production string in the production optimization context. */
  startDate?: Maybe<Scalars['Timestamp']['output']>;
  /** Numeric value storing top depth for this production string, used in calculations, reporting, or model configuration. */
  topDepth?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing top x for this production string, used in calculations, reporting, or model configuration. */
  topX?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing top y for this production string, used in calculations, reporting, or model configuration. */
  topY?: Maybe<Scalars['Float32']['output']>;
  /** Wellbore attribute describing this production string in more detail, often derived from master data or configuration tables. */
  wellbore?: Maybe<Scalars['String']['output']>;
  /** Wellbore Type attribute describing this production string in more detail, often derived from master data or configuration tables. */
  wellboreType?: Maybe<Scalars['String']['output']>;
};

/** String Function view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type StringFunction = {
  /** Attribute capturing end date for this production string in the production optimization context. */
  endDate?: Maybe<Scalars['Timestamp']['output']>;
  /** Field Code attribute describing this production string in more detail, often derived from master data or configuration tables. */
  fieldCode?: Maybe<Scalars['String']['output']>;
  /** Primary Wellbore attribute describing this production string in more detail, often derived from master data or configuration tables. */
  primaryWellbore?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing start date for this production string in the production optimization context. */
  startDate?: Maybe<Scalars['Timestamp']['output']>;
  /** String attribute describing this production string in more detail, often derived from master data or configuration tables. */
  string?: Maybe<Scalars['String']['output']>;
  /** String Code attribute describing this production string in more detail, often derived from master data or configuration tables. */
  stringCode?: Maybe<Scalars['String']['output']>;
  /** Text describing the functional role of the production string (for example main producer, backup, injector, idle), used in surveillance and planning. */
  stringFunction?: Maybe<Scalars['String']['output']>;
  /** Well attribute describing this production string in more detail, often derived from master data or configuration tables. */
  well?: Maybe<Scalars['String']['output']>;
};

/** String Reservoir Inputs view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type StringReservoirInputs = {
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  fieldName?: Maybe<Field>;
  /** Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  reservoirName?: Maybe<Reservoir>;
  /** Time series signal representing string reservoir injection allocation factor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  stringReservoirInjectionAllocationFactor?: Maybe<TimeSeries>;
  /** Time series signal representing string reservoir production allocation factor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  stringReservoirProductionAllocationFactor?: Maybe<TimeSeries>;
};

/**
 * Well string (completion) master data view. Each row represents a single completion
 * interval within a well that can produce or inject fluids independently.
 *
 * Use this view to:
 * - Look up string names and identifiers
 * - Join to FlatHierarchy to find which well, field, or reservoir a string belongs to
 * - Link to operational views (WellOutputs_String, AllocatedProperties_String) for KPIs
 */
export type StringAsset = {
  /**
   * Date and time when this string was permanently abandoned or decommissioned. A null
   * value indicates the string is still active. Used to determine the valid time range
   * for historical queries and to identify inactive strings.
   */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /**
   * Entity type classification. For this view, always 'string' indicating a well
   * completion. Used internally to filter the Entity table to show only string records.
   */
  entityType?: Maybe<Scalars['String']['output']>;
  /**
   * Human-readable name of the well string (completion), typically following a naming
   * convention like "WELL-A_ST1" or "FIELD-WELL-01-L". This is the primary label shown
   * in dashboards, reports, and when searching for strings.
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Date and time when this string became active or was first put on production/injection.
   * Used to determine the valid time range for the string's operational data and to
   * filter out data before the string existed.
   */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
};

/**
 * Well surveillance alarms with medium or high priority.
 *
 * Contains well surveillance alarms that are classified as medium or high
 * priority, sourced from real-time monitoring systems and well status workflows.
 * Use for frequency and types of alarms, wells affected, duration. Excludes low-priority or historical alarms.
 *
 * Use for: Real-Time Surveillance (WF18), Well Status (WF25).
 *
 * @name Well Surveillance Alarms (Agent)
 */
export type SurveillanceAlarmsAgent = {
  alarmCategory?: Maybe<Scalars['String']['output']>;
  alarmCode?: Maybe<Scalars['JSONObject']['output']>;
  alarmCodeExternalId?: Maybe<Scalars['String']['output']>;
  alarmCriticality?: Maybe<Scalars['String']['output']>;
  alarmFlags?: Maybe<Scalars['String']['output']>;
  alarmName?: Maybe<Scalars['String']['output']>;
  alarmPriority?: Maybe<Scalars['String']['output']>;
  customWorkflowAlarmMessage?: Maybe<Scalars['String']['output']>;
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  entityExternalId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  startDateTime: Scalars['Timestamp']['output'];
  subCategory?: Maybe<Scalars['String']['output']>;
  subWorkflowName?: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
  workflowCode?: Maybe<Scalars['String']['output']>;
  workflowName?: Maybe<Scalars['String']['output']>;
};

/**
 * Troubleshooting ticket management for tracking open, closed, and assigned
 * operations tickets.
 *
 * Contains detailed records of troubleshooting tickets, including their
 * lifecycle stages, statuses, and associated metadata such as priority and
 * assignment. Sourced from operational ticketing systems, used to analyze ticket
 * trends, assess workload distribution, and identify areas requiring immediate
 * attention. Typical analytical questions include tracking the status of tickets
 * by category, evaluating response times, and determining the volume of tickets
 * related to specific entities or opportunities. Excludes financial metrics or
 * performance indicators related to ticket resolution (see operational
 * efficiency).
 */
export type TicketRegistryAgent = {
  /** Detailed action plan with steps to remediate the issue. */
  actionPlan?: Maybe<Scalars['String']['output']>;
  /** Person or team assigned to resolve the ticket. */
  assignedTo?: Maybe<Scalars['String']['output']>;
  /** Date/time when ticket was closed. Use for closed ticket analysis. */
  closedDate?: Maybe<Scalars['Timestamp']['output']>;
  /** Full description of the issue, including context and observations. */
  description?: Maybe<Scalars['String']['output']>;
  /** Target date for ticket resolution. Use to find overdue tickets. */
  dueDate?: Maybe<Scalars['Timestamp']['output']>;
  /**
   * Name of the well, string, or field the ticket is associated with.
   * Primary filter for "show tickets for well X" queries.
   */
  entityName?: Maybe<Scalars['String']['output']>;
  /**
   * Type of entity the ticket relates to: WELL, STRING, FIELD, RESERVOIR.
   * Use to filter tickets by entity scope.
   */
  entityType?: Maybe<Scalars['String']['output']>;
  /**
   * Flag indicating if ticket represents a production optimization opportunity.
   * 'true' = opportunity for gain, 'false' = issue/problem.
   */
  isOpportunity?: Maybe<Scalars['String']['output']>;
  /**
   * Ticket priority level: LOW, MEDIUM, HIGH, URGENT.
   * Use to filter critical issues that need immediate attention.
   */
  priority: Scalars['String']['output'];
  /** Recommended action or investigation steps to resolve the issue. */
  recommendation?: Maybe<Scalars['String']['output']>;
  /** Date/time when the ticket was created or reported. Use for age-based queries. */
  reportedDate: Scalars['Timestamp']['output'];
  /**
   * Current ticket status: OPEN, IN_PROGRESS, CLOSED, CANCELLED.
   * Use to filter active vs completed tickets.
   */
  status: Scalars['String']['output'];
  /**
   * Category classification (e.g., WELL_ISSUE, ESP_FAILURE, OPTIMIZATION).
   * Use to filter tickets by problem type.
   */
  ticketCategory?: Maybe<Scalars['String']['output']>;
  /** Unique ticket identifier. Primary key for joining to TicketHistory or SubTasks. */
  ticketId: Scalars['String']['output'];
  /**
   * Origin of the ticket (e.g., ALARM, MANUAL, SURVEILLANCE, WORKFLOW).
   * Indicates how the ticket was created.
   */
  ticketSource?: Maybe<Scalars['String']['output']>;
  /** Brief summary of the issue or action item. Use for quick scanning of tickets. */
  ticketSummary: Scalars['String']['output'];
};

export type TimeSeries = {
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int32']['output']>;
};

/**
 * Value realization tracking with production gain and cost saving records per
 * opportunity.
 *
 * Contains comprehensive data on value realization associated with production
 * gains and cost savings in USD or barrel oil equivalent, derived from various
 * optimization opportunities. Sourced from well performance metrics, ticketing
 * systems, and optimization records, allowing it to answer analytical questions
 * regarding the effectiveness of specific interventions and their financial
 * impacts. It excludes raw production data or detailed operational metrics that
 * may be found in other views focused on real-time production tracking. Use
 * cases: performance assessment of optimization strategies, financial
 * forecasting, and operational efficiency analysis.
 *
 * @name Value Tracking (Agent)
 */
export type ValueTrackingAgent = {
  controlParameter?: Maybe<Scalars['String']['output']>;
  controlParameterPostOptimizedValue?: Maybe<Scalars['Float']['output']>;
  controlParameterScenarioName?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Timestamp']['output']>;
  estimatedGasRate?: Maybe<Scalars['Float']['output']>;
  estimatedOilRate?: Maybe<Scalars['Float']['output']>;
  estimatedTargetGasGain?: Maybe<Scalars['Float']['output']>;
  estimatedTargetOilGain?: Maybe<Scalars['Float']['output']>;
  estimatedTargetTotalGain?: Maybe<Scalars['Float']['output']>;
  oilPrice?: Maybe<Scalars['Float']['output']>;
  opportunityExternalId?: Maybe<OpportunityAgent>;
  realizedCumGasVolumeGain?: Maybe<TimeSeries>;
  realizedCumGasVolumeGainBOE?: Maybe<TimeSeries>;
  realizedCumOilVolumeGain?: Maybe<TimeSeries>;
  realizedDollarCumValueGain?: Maybe<TimeSeries>;
  realizedDollarValueGain?: Maybe<TimeSeries>;
  realizedGasPerformance?: Maybe<TimeSeries>;
  realizedGasRateGain?: Maybe<TimeSeries>;
  realizedGasVolumeGain?: Maybe<TimeSeries>;
  realizedOilPerformance?: Maybe<TimeSeries>;
  realizedOilRateGain?: Maybe<TimeSeries>;
  realizedOilVolumeGain?: Maybe<TimeSeries>;
  realizedTotalCumVolumeGainBOE?: Maybe<TimeSeries>;
  realizedTotalVolumeGainBOE?: Maybe<TimeSeries>;
  realizedWaterPerformance?: Maybe<TimeSeries>;
  realizedWaterRateGain?: Maybe<TimeSeries>;
  source?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Timestamp']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  ticketExternalId?: Maybe<TicketRegistryAgent>;
  wellMovementExternalId?: Maybe<WellMovementAgent>;
  wellName?: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
  wellUptimeHours?: Maybe<TimeSeries>;
};

/** Field-level outputs from the WF05 workflow, summarizing virtual flow meter (VFM) estimates, actual daily production, allocation errors and allocation factors for oil, gas and water across all wells in the field. */
export type Wf05FieldOutputs = {
  /** Operational status for this field (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  agProductionAllocationStatus?: Maybe<TimeSeries>;
  /** Time series signal representing daily actual gas injection for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  dailyActualGasInjection?: Maybe<TimeSeries>;
  /** Time series signal representing daily actual oil production for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  dailyActualOilProduction?: Maybe<TimeSeries>;
  /** Time series signal representing daily actual water injection for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  dailyActualWaterInjection?: Maybe<TimeSeries>;
  /** Time series signal representing daily actual water production for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  dailyActualWaterProduction?: Maybe<TimeSeries>;
  /** Time series signal representing daily associated gas production for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  dailyAssociatedGasProduction?: Maybe<TimeSeries>;
  /** Time series signal representing daily non associated gas production for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  dailyNonAssociatedGasProduction?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Field>;
  /** Time series signal representing execution type for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  executionType?: Maybe<TimeSeries>;
  /** Time series signal representing field allocation volume source for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  fieldAllocationVolumeSource?: Maybe<TimeSeries>;
  /** Time series signal representing field injection allocation volume source for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  fieldInjectionAllocationVolumeSource?: Maybe<TimeSeries>;
  /** Operational status for this field (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  gasInjectioAllocationStatus?: Maybe<TimeSeries>;
  /** Time series signal representing gas injection allocation factor for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasInjectionAllocationFactor?: Maybe<TimeSeries>;
  /** Operational status for this field (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  gasProductionAllocationStatus?: Maybe<TimeSeries>;
  /** Time series signal representing injection wfexecution type for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  injectionWFExecutionType?: Maybe<TimeSeries>;
  /** Operational status for this field (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  nagProductionAllocationStatus?: Maybe<TimeSeries>;
  /** Operational status for this field (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  oilProductionAllocationStatus?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmassociated gas allocation factor for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMAssociatedGasAllocationFactor?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmnon associated gas allocation factor for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMNonAssociatedGasAllocationFactor?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmoil allocation factor for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMOilAllocationFactor?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmrelative field associated gas volume error for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMRelativeFieldAssociatedGasVolumeError?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmrelative field non associated gas volume error for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMRelativeFieldNonAssociatedGasVolumeError?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmrelative field oil volume error for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMRelativeFieldOilVolumeError?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmrelative field water volume error for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMRelativeFieldWaterVolumeError?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmtotal wells estimated associated gas volume for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMTotalWellsEstimatedAssociatedGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmtotal wells estimated non associated gas volume for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMTotalWellsEstimatedNonAssociatedGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmtotal wells estimated oil volume for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMTotalWellsEstimatedOilVolume?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmtotal wells estimated water volume for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMTotalWellsEstimatedWaterVolume?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmwater allocation factor for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMWaterAllocationFactor?: Maybe<TimeSeries>;
  /** Time series signal representing relative field gas volume error for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  relativeFieldGasVolumeError?: Maybe<TimeSeries>;
  /** Time series signal representing relative field water volume error for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  relativeFieldWaterVolumeError?: Maybe<TimeSeries>;
  /** Time series signal representing total wells gas injection volume for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  totalWellsGasInjectionVolume?: Maybe<TimeSeries>;
  /** Time series signal representing total wells water injection volume for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  totalWellsWaterInjectionVolume?: Maybe<TimeSeries>;
  /** Time series signal representing water injection allocation factor for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterInjectionAllocationFactor?: Maybe<TimeSeries>;
  /** Operational status for this field (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  waterInjectionAllocationStatus?: Maybe<TimeSeries>;
  /** Operational status for this field (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  waterProductionAllocationStatus?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmassociated gas allocation factor for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMAssociatedGasAllocationFactor?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmnon associated gas allocation factor for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMNonAssociatedGasAllocationFactor?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmoil allocation factor for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMOilAllocationFactor?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmrelative field associated gas volume error for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMRelativeFieldAssociatedGasVolumeError?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmrelative field non associated gas volume error for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMRelativeFieldNonAssociatedGasVolumeError?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmrelative field oil volume error for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMRelativeFieldOilVolumeError?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmrelative field water volume error for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMRelativeFieldWaterVolumeError?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmtotal wells estimated associated gas volume for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMTotalWellsEstimatedAssociatedGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmtotal wells estimated non associated gas volume for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMTotalWellsEstimatedNonAssociatedGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmtotal wells estimated oil volume for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMTotalWellsEstimatedOilVolume?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmtotal wells estimated water volume for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMTotalWellsEstimatedWaterVolume?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmwater allocation factor for this field, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMWaterAllocationFactor?: Maybe<TimeSeries>;
};

/** String level outputs from the WF05 workflow, providing virtual flow meter (VFM) based oil, gas and water rates, estimated well volumes, method-specific VFM rates and diagnostics used for allocation and well performance evaluation. */
export type Wf05StringOutputs = {
  /** Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  agProductionAllocationStatus?: Maybe<TimeSeries>;
  /** Time series signal representing allocated well injection gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  allocatedWellInjectionGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing allocated well injection gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  allocatedWellInjectionGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing allocated well injection water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  allocatedWellInjectionWaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing allocated well injection water volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  allocatedWellInjectionWaterVolume?: Maybe<TimeSeries>;
  /** Time series signal representing average gas injection rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  averageGasInjectionRate?: Maybe<TimeSeries>;
  /** Time series signal representing average water injection rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  averageWaterInjectionRate?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Time series signal representing execution type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  executionType?: Maybe<TimeSeries>;
  /** Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  gasInjectioAllocationStatus?: Maybe<TimeSeries>;
  /** Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  gasProductionAllocationStatus?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  injectionRateDataSourceFlag?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  isWag?: Maybe<TimeSeries>;
  /** Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  nagProductionAllocationStatus?: Maybe<TimeSeries>;
  /** Time series signal representing normalized weight factor choke for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  normalizedWeightFactorChoke?: Maybe<TimeSeries>;
  /** Time series signal representing normalized weight factor data driven for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  normalizedWeightFactorDataDriven?: Maybe<TimeSeries>;
  /** Time series signal representing normalized weight factor esp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  normalizedWeightFactorESP?: Maybe<TimeSeries>;
  /** Time series signal representing normalized weight factor ipr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  normalizedWeightFactorIPR?: Maybe<TimeSeries>;
  /** Time series signal representing normalized weight factor system analysis for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  normalizedWeightFactorSystemAnalysis?: Maybe<TimeSeries>;
  /** Time series signal representing normalized weight factor vlp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  normalizedWeightFactorVLP?: Maybe<TimeSeries>;
  /** Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  oilProductionAllocationStatus?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmallocated well associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMAllocatedWellAssociatedGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmallocated well non associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMAllocatedWellNonAssociatedGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmallocated well oil volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMAllocatedWellOilVolume?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmallocated well water volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMAllocatedWellWaterVolume?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmaverage associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMAverageAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmaverage non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMAverageNonAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmaverage oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMAverageOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmaverage water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMAverageWaterRate?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  preferredVFMDataSourceFlag?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmestimated well associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMEstimatedWellAssociatedGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmestimated well non associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMEstimatedWellNonAssociatedGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmestimated well oil volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMEstimatedWellOilVolume?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmestimated well water volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMEstimatedWellWaterVolume?: Maybe<TimeSeries>;
  /** Time series signal representing vfm choke average associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmChokeAverageAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm choke average non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmChokeAverageNonAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm choke average oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmChokeAverageOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm choke average water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmChokeAverageWaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm data driven average associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmDataDrivenAverageAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm data driven average non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmDataDrivenAverageNonAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm data driven average oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmDataDrivenAverageOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm data driven average water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmDataDrivenAverageWaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm espaverage associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmESPAverageAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm espaverage non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmESPAverageNonAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm espaverage oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmESPAverageOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm espaverage water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmESPAverageWaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm ipraverage associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmIPRAverageAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm ipraverage non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmIPRAverageNonAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm ipraverage oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmIPRAverageOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm ipraverage water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmIPRAverageWaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm preferred method associated gas allocation rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmPreferredMethodAssociatedGasAllocationRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm preferred method non associated gas allocation rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmPreferredMethodNonAssociatedGasAllocationRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm preferred method oil allocation rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmPreferredMethodOilAllocationRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm preferred method water allocation rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmPreferredMethodWaterAllocationRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm system analysis average associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmSystemAnalysisAverageAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm system analysis average associated non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmSystemAnalysisAverageAssociatedNonAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm system analysis average oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmSystemAnalysisAverageOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm system analysis average water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmSystemAnalysisAverageWaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm vlpaverage associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmVLPAverageAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm vlpaverage non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmVLPAverageNonAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm vlpaverage oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmVLPAverageOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm vlpaverage water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmVLPAverageWaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm weighted average associated gas allocation rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmWeightedAverageAssociatedGasAllocationRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm weighted average method oil allocation rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmWeightedAverageMethodOilAllocationRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm weighted average non associated gas allocation rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmWeightedAverageNonAssociatedGasAllocationRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm weighted average water allocation rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmWeightedAverageWaterAllocationRate?: Maybe<TimeSeries>;
  /** Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  waterInjectionAllocationStatus?: Maybe<TimeSeries>;
  /** Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  waterProductionAllocationStatus?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  weightedAverageDataSourceFlag?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmallocated well associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMAllocatedWellAssociatedGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmallocated well non associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMAllocatedWellNonAssociatedGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmallocated well oil volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMAllocatedWellOilVolume?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmallocated well water volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMAllocatedWellWaterVolume?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmassociated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmestimated well associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMEstimatedWellAssociatedGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmestimated well non associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMEstimatedWellNonAssociatedGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmestimated well oil volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMEstimatedWellOilVolume?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmestimated well water volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMEstimatedWellWaterVolume?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmnon associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMNonAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmoil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmwater rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMWaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing well gas injection volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellGasInjectionVolume?: Maybe<TimeSeries>;
  /** Time series signal representing well type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellType?: Maybe<TimeSeries>;
  /** Time series signal representing well uptime for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellUptime?: Maybe<TimeSeries>;
  /** Time series signal representing well water injection volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellWaterInjectionVolume?: Maybe<TimeSeries>;
};

/** String-reservoir level outputs from the WF05 workflow, providing virtual flow meter (VFM) based oil, gas and water rates, estimated well volumes, method-specific VFM rates and diagnostics used for allocation and well performance evaluation at the reservoir sector level. */
export type Wf05StringReservoirOutputs = {
  /** Time series signal representing allocated well injection gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  allocatedWellInjectionGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing allocated well injection water volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  allocatedWellInjectionWaterVolume?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Time series signal representing execution type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  executionType?: Maybe<TimeSeries>;
  /** Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  fieldName?: Maybe<Field>;
  /** Link String attribute describing this production string in more detail, often derived from master data or configuration tables. */
  linkString?: Maybe<Scalars['String']['output']>;
  /** Time series signal representing normalized weight factor choke for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  normalizedWeightFactorChoke?: Maybe<TimeSeries>;
  /** Time series signal representing normalized weight factor data driven for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  normalizedWeightFactorDataDriven?: Maybe<TimeSeries>;
  /** Time series signal representing normalized weight factor esp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  normalizedWeightFactorESP?: Maybe<TimeSeries>;
  /** Time series signal representing normalized weight factor ipr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  normalizedWeightFactorIPR?: Maybe<TimeSeries>;
  /** Time series signal representing normalized weight factor system analysis for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  normalizedWeightFactorSystemAnalysis?: Maybe<TimeSeries>;
  /** Time series signal representing normalized weight factor vlp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  normalizedWeightFactorVLP?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmallocated well associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMAllocatedWellAssociatedGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmallocated well non associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMAllocatedWellNonAssociatedGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmallocated well oil volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMAllocatedWellOilVolume?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmallocated well water volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMAllocatedWellWaterVolume?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmaverage associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMAverageAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmaverage non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMAverageNonAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmaverage oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMAverageOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmaverage water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMAverageWaterRate?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  preferredVFMDataSourceFlag?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmestimated well associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMEstimatedWellAssociatedGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmestimated well non associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMEstimatedWellNonAssociatedGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmestimated well oil volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMEstimatedWellOilVolume?: Maybe<TimeSeries>;
  /** Time series signal representing preferred vfmestimated well water volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  preferredVFMEstimatedWellWaterVolume?: Maybe<TimeSeries>;
  /** Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  reservoirName?: Maybe<Reservoir>;
  /** Time series signal representing vfm choke average associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmChokeAverageAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm choke average non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmChokeAverageNonAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm choke average oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmChokeAverageOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm choke average water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmChokeAverageWaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm data driven average associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmDataDrivenAverageAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm data driven average non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmDataDrivenAverageNonAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm data driven average oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmDataDrivenAverageOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm data driven average water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmDataDrivenAverageWaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm espaverage associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmESPAverageAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm espaverage non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmESPAverageNonAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm espaverage oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmESPAverageOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm espaverage water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmESPAverageWaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm ipraverage associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmIPRAverageAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm ipraverage non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmIPRAverageNonAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm ipraverage oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmIPRAverageOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm ipraverage water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmIPRAverageWaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm system analysis average associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmSystemAnalysisAverageAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm system analysis average associated non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmSystemAnalysisAverageAssociatedNonAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm system analysis average oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmSystemAnalysisAverageOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm system analysis average water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmSystemAnalysisAverageWaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm vlpaverage associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmVLPAverageAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm vlpaverage non associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmVLPAverageNonAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm vlpaverage oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmVLPAverageOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing vfm vlpaverage water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vfmVLPAverageWaterRate?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  weightedAverageDataSourceFlag?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmallocated well associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMAllocatedWellAssociatedGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmallocated well non associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMAllocatedWellNonAssociatedGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmallocated well oil volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMAllocatedWellOilVolume?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmallocated well water volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMAllocatedWellWaterVolume?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmassociated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmestimated well associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMEstimatedWellAssociatedGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmestimated well non associated gas volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMEstimatedWellNonAssociatedGasVolume?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmestimated well oil volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMEstimatedWellOilVolume?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmestimated well water volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMEstimatedWellWaterVolume?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmnon associated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMNonAssociatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmoil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing weighted average vfmwater rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  weightedAverageVFMWaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing well uptime for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellUptime?: Maybe<TimeSeries>;
};

/** Water Analysis view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type WaterAnalysis = {
  /** Time series signal representing analysis date for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  analysisDate?: Maybe<TimeSeries>;
  /** Time series signal representing barium for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  barium?: Maybe<TimeSeries>;
  /** Time series signal representing bicarbonate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  bicarbonate?: Maybe<TimeSeries>;
  /** Time series signal representing boron for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  boron?: Maybe<TimeSeries>;
  /** Time series signal representing bsw for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  bsw?: Maybe<TimeSeries>;
  /** Time series signal representing calcium for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  calcium?: Maybe<TimeSeries>;
  /** Time series signal representing calculated total disolved solids for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  calculatedTotalDisolvedSolids?: Maybe<TimeSeries>;
  /** Time series signal representing carbonate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  carbonate?: Maybe<TimeSeries>;
  /** Time series signal representing chloride for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  chloride?: Maybe<TimeSeries>;
  /** Time series signal representing company program ref for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  companyProgramRef?: Maybe<TimeSeries>;
  /** Time series signal representing company sample no for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  companySampleNo?: Maybe<TimeSeries>;
  /** Time series signal representing dissolved iron for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  dissolvedIron?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Time series signal representing h2s for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  h2s?: Maybe<TimeSeries>;
  /** Time series signal representing hydroxide for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  hydroxide?: Maybe<TimeSeries>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  id?: Maybe<TimeSeries>;
  /** Time series signal representing iron for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  iron?: Maybe<TimeSeries>;
  /** Time series signal representing magnesium for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  magnesium?: Maybe<TimeSeries>;
  /** Time series signal representing measured total disolved solids for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  measuredTotalDisolvedSolids?: Maybe<TimeSeries>;
  /** Time series signal representing oil content vol for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilContentVol?: Maybe<TimeSeries>;
  /** Time series signal representing ph for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  ph?: Maybe<TimeSeries>;
  /** Time series signal representing ph temp for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  phTemp?: Maybe<TimeSeries>;
  /** Time series signal representing phosphorous for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  phosphorous?: Maybe<TimeSeries>;
  /** Time series signal representing potassium for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  potassium?: Maybe<TimeSeries>;
  /** Time series signal representing remarks for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  remarks?: Maybe<TimeSeries>;
  /** Time series signal representing report ref for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  reportRef?: Maybe<TimeSeries>;
  /** Time series signal representing resistivity for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  resistivity?: Maybe<TimeSeries>;
  /** Time series signal representing resistivity temp for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  resistivityTemp?: Maybe<TimeSeries>;
  /** Time series signal representing salinity for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  salinity?: Maybe<TimeSeries>;
  /** Time series signal representing sample date for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  sampleDate?: Maybe<TimeSeries>;
  /** Time series signal representing sample type for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  sampleType?: Maybe<TimeSeries>;
  /** Time series signal representing sg temp for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  sgTemp?: Maybe<TimeSeries>;
  /** Time series signal representing sodium for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  sodium?: Maybe<TimeSeries>;
  /** Time series signal representing solubility for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  solubility?: Maybe<TimeSeries>;
  /** Time series signal representing specific gravity for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  specificGravity?: Maybe<TimeSeries>;
  /** Time series signal representing strontium for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  strontium?: Maybe<TimeSeries>;
  /** Time series signal representing sulphate for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  sulphate?: Maybe<TimeSeries>;
  /** Time series signal representing temperature for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  temperature?: Maybe<TimeSeries>;
  /** Time series signal representing total iron for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  totalIron?: Maybe<TimeSeries>;
  /** Time series signal representing total suspended solids for this entity, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  totalSuspendedSolids?: Maybe<TimeSeries>;
};

/** Typed view over 'Entity' showing wells only (where 'entityType' = 'well'). Use this view together with 'FlatHierarchy' or 'SectorHierarchy' to navigate from fields, reservoirs or sectors to their wells. */
export type Well = {
  /** Attribute capturing end date time for this well in the production optimization context. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Entity Type attribute describing this well in more detail, often derived from master data or configuration tables. */
  entityType?: Maybe<Scalars['String']['output']>;
  /** Name or label for this well, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  name?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing start date time for this well in the production optimization context. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
};

/**
 * Well behaviour and productivity alarms with medium or high priority.
 *
 * Contains well behaviour and productivity alarms, alarms classified with medium
 * or high priority. Sourced from workflows that monitor well operating
 * envelopes, real-time measurements of well rates and pressures, and reservoir
 * pressure estimations. Use for alarm frequency, duration, impact on well performance. Excludes low-priority alarms.
 *
 * Use for: Real-Time Surveillance (WF18), envelope (WF6), rate/pressure (WF10).
 *
 * @name Well Behaviour & Productivity Alarms (Agent)
 */
export type WellBehaviourAlarmsAgent = {
  alarmCategory?: Maybe<Scalars['String']['output']>;
  alarmCode?: Maybe<Scalars['JSONObject']['output']>;
  alarmCodeExternalId?: Maybe<Scalars['String']['output']>;
  alarmCriticality?: Maybe<Scalars['String']['output']>;
  alarmFlags?: Maybe<Scalars['String']['output']>;
  alarmName?: Maybe<Scalars['String']['output']>;
  alarmPriority?: Maybe<Scalars['String']['output']>;
  customWorkflowAlarmMessage?: Maybe<Scalars['String']['output']>;
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  entityExternalId: Scalars['String']['output'];
  entityName: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  startDateTime: Scalars['Timestamp']['output'];
  subCategory?: Maybe<Scalars['String']['output']>;
  subWorkflowName?: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
  workflowCode?: Maybe<Scalars['String']['output']>;
  workflowName?: Maybe<Scalars['String']['output']>;
};

/** Well Inputs Static view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type WellInputsStatic = {
  /** Numeric value storing crs for this well, used in calculations, reporting, or model configuration. */
  crs?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing elevation for this well, used in calculations, reporting, or model configuration. */
  elevation?: Maybe<Scalars['Float32']['output']>;
  /** Elevation Ref attribute describing this well in more detail, often derived from master data or configuration tables. */
  elevationRef?: Maybe<Scalars['String']['output']>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Well>;
  /** Numeric value storing latitude for this well, used in calculations, reporting, or model configuration. */
  latitude?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing longitude for this well, used in calculations, reporting, or model configuration. */
  longitude?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing original crs for this well, used in calculations, reporting, or model configuration. */
  originalCRS?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing original x for this well, used in calculations, reporting, or model configuration. */
  originalX?: Maybe<Scalars['Float32']['output']>;
  /** Numeric value storing original y for this well, used in calculations, reporting, or model configuration. */
  originalY?: Maybe<Scalars['Float32']['output']>;
  /** Attribute capturing spud date for this well in the production optimization context. */
  spudDate?: Maybe<Scalars['Timestamp']['output']>;
};

/**
 * REAL-TIME SENSOR AND MEASUREMENT DATA for well strings. Contains high-frequency
 * time series from SCADA, historians, and downhole gauges used as inputs for
 * well models, surveillance calculations, and optimization.
 *
 * KEY DATA CATEGORIES:
 * - ESP parameters: pump frequency, pressures, temperatures, current, voltage, vibration
 * - Gas lift parameters: injection rate, CV pressure/temperature, choke settings
 * - Wellhead/flowline: pressures, temperatures, choke size/opening
 * - Downhole: BHP, BHT, annulus pressure (if instrumented)
 * - Valve status: SSV, SSSV, wing valve, control valve positions
 * - Targets/potentials: planned rates and unconstrained capacities
 *
 * DATA SOURCES:
 * - SCADA/DCS for real-time surface measurements
 * - Historians for time series storage
 * - Downhole gauges for BHP/BHT (if instrumented)
 * - Planning systems for targets and potentials
 */
export type WellInputsString = {
  /**
   * Annulus pressure (psia or bara) between tubing and casing. Same as CHP for
   * conventional wells. Important for well integrity monitoring and gas lift
   * injection pressure tracking.
   */
  annulusPress?: Maybe<TimeSeries>;
  /**
   * Flowing bottomhole pressure (FBHP) in psia or bara from permanent downhole gauge.
   * Direct measurement of reservoir-wellbore interface pressure. Most accurate
   * input for IPR analysis when available.
   */
  bottomHolePress?: Maybe<TimeSeries>;
  /**
   * Bottomhole temperature (°F or °C) from permanent downhole gauge. Used for
   * accurate PVT calculations and reservoir temperature tracking.
   */
  bottomHoleTemp?: Maybe<TimeSeries>;
  /**
   * Casing head pressure (psia or bara) at surface. For gas lift wells, indicates
   * annular gas pressure. Rising CHP may indicate tubing leak or gas lift valve issues.
   */
  casingHeadPress?: Maybe<TimeSeries>;
  /**
   * First downstream pressure measurement point after choke (psia or bara).
   * May be used when multiple pressure taps exist downstream of choke.
   */
  chokeDownstreamPressure1?: Maybe<TimeSeries>;
  /**
   * Second downstream pressure measurement point after choke (psia or bara).
   * Additional tap for redundancy or different location in manifold.
   */
  chokeDownstreamPressure2?: Maybe<TimeSeries>;
  /**
   * Production choke opening position (% open) for adjustable chokes. 0% = fully
   * closed, 100% = fully open. Primary surface control for well rate.
   */
  chokeOpening?: Maybe<TimeSeries>;
  /**
   * Production choke bean size (64ths inch) or trim size. Fixed choke setting
   * used in choke equation calculations. May differ from chokeOpening for
   * adjustable chokes.
   */
  chokeSize?: Maybe<TimeSeries>;
  /**
   * Control valve position or status. May be an automated valve for flow control
   * or pressure regulation.
   */
  controlValve?: Maybe<TimeSeries>;
  /**
   * Depth (ft or m) of the downhole pressure/temperature sensor. Required to
   * correct measured pressures to datum or mid-perforation depth.
   */
  depthSensor?: Maybe<TimeSeries>;
  /**
   * Pressure (psia or bara) downstream of production choke. Used with WHP to
   * calculate choke differential and determine flow regime (critical/subcritical).
   */
  downstreamPressure?: Maybe<TimeSeries>;
  /**
   * Reference to the String_asset entity. Use this to join to string master data
   * or navigate via FlatHierarchy to parent well, field, or reservoir.
   */
  entityName?: Maybe<StringAsset>;
  /**
   * Flowline pressure (psia or bara) downstream of choke, typically at pipeline
   * connection. Backpressure on the well affects deliverability through VLP.
   */
  flowLinePress?: Maybe<TimeSeries>;
  /**
   * Flowline temperature (°F or °C) downstream of choke. Important for flow
   * assurance (hydrate, wax, scale) and network modeling.
   */
  flowLineTemp?: Maybe<TimeSeries>;
  /**
   * Gas injection choke opening position (% open). Controls injection rate by
   * varying pressure drop into the well.
   */
  gasInjChokeOpening?: Maybe<TimeSeries>;
  /**
   * Gas injection rate (MSCF/d) for gas injector wells. Measured at wellhead flow
   * meter. Primary measurement for injection allocation.
   */
  gasInjRate?: Maybe<TimeSeries>;
  /**
   * Wellhead pressure (psia or bara) for gas injection wells. Injection WHP
   * upstream of any choke or control valve.
   */
  gasInjWellheadPress?: Maybe<TimeSeries>;
  /**
   * Pressure (psia or bara) upstream of gas lift control valve. Used with downstream
   * pressure to calculate valve differential and verify choke equation calculations.
   */
  gasLiftFlowCVInletPress?: Maybe<TimeSeries>;
  /**
   * Temperature (°F or °C) upstream of gas lift control valve. Used for gas density
   * calculations in choke equation and for Joule-Thomson cooling predictions.
   */
  gasLiftFlowCVInletTemp?: Maybe<TimeSeries>;
  /**
   * Gas lift control valve size or opening position (% or 64ths inch). Used in
   * choke equation to calculate expected flow rate from pressure conditions.
   */
  gasLiftFlowCVSize?: Maybe<TimeSeries>;
  /**
   * Gas lift injection rate (MSCF/d) measured at the well. Primary control variable
   * for gas lift optimization. Compare to optimal GLIR from well models.
   */
  gasLiftInjRate?: Maybe<TimeSeries>;
  /**
   * Gas lift gas temperature (°F or °C) at injection point. May differ from CV inlet
   * due to line losses. Used in annular flow and valve performance calculations.
   */
  gasLiftInjTemp?: Maybe<TimeSeries>;
  /**
   * Measured gas flow rate (MSCF/d) from wellhead or separator meter. May be
   * total gas (solution + free) or separated gas depending on metering point.
   */
  gasRateFlow?: Maybe<TimeSeries>;
  /**
   * Gas injection header pressure (psia or bara). Supply pressure from gas
   * compression system. Shared by multiple injection wells on same header.
   */
  giHeaderPressure?: Maybe<TimeSeries>;
  /**
   * Gas injection header temperature (°F or °C). Used for gas density calculations
   * and Joule-Thomson cooling predictions across injection chokes.
   */
  giHeaderTemperature?: Maybe<TimeSeries>;
  /**
   * Current artificial lift method: 'NATURAL_FLOW', 'ESP', 'GAS_LIFT', 'ROD_PUMP',
   * 'JET_PUMP', 'PCP'. Determines which input parameters are relevant and which
   * well models to apply.
   */
  liftType?: Maybe<TimeSeries>;
  /**
   * Reference to fluid composition or PVT model used for well calculations.
   * May be a composition ID or direct reference to composition table.
   */
  modelComposition?: Maybe<TimeSeries>;
  /**
   * Unconstrained gas injection potential (MSCF/d) - maximum injection rate
   * achievable with unlimited supply and pressure.
   */
  potentialGasInjection?: Maybe<TimeSeries>;
  /**
   * Unconstrained gas production potential (MSCF/d) - maximum rate achievable
   * with no surface constraints.
   */
  potentialGasProduction?: Maybe<TimeSeries>;
  /**
   * Unconstrained oil production potential (stb/d) - maximum rate achievable with
   * no surface constraints (choke fully open, unlimited processing capacity).
   * Used as upper bound for optimization and gap analysis.
   */
  potentialOilProduction?: Maybe<TimeSeries>;
  /**
   * Unconstrained water injection potential (stb/d) - maximum injection rate
   * achievable with unlimited supply and pressure. Based on injectivity index.
   */
  potentialWaterInjection?: Maybe<TimeSeries>;
  /**
   * Unconstrained water production potential (stb/d) - maximum water rate at
   * unconstrained oil/liquid rate. May be a constraint driver for high water cut wells.
   */
  potentialWaterProduction?: Maybe<TimeSeries>;
  /**
   * ESP motor current draw (amps). Indicates motor load and power consumption.
   * Changes in current at constant frequency may indicate fluid property changes,
   * gas slugging, or mechanical issues.
   */
  pumpCurrent?: Maybe<TimeSeries>;
  /**
   * ESP pump discharge pressure (psia or bara) measured at pump outlet. Used with
   * PIP to calculate pump differential pressure (head) and verify pump performance
   * against curve.
   */
  pumpDischargePress?: Maybe<TimeSeries>;
  /**
   * Temperature (°F or °C) at ESP pump discharge. Temperature rise across pump
   * indicates pump efficiency and fluid heating from energy input.
   */
  pumpDischargeTemp?: Maybe<TimeSeries>;
  /**
   * ESP motor frequency (Hz) from variable speed drive (VSD). Controls pump speed
   * and therefore flow rate. Typical range 30-70 Hz. Key control parameter for
   * ESP optimization.
   */
  pumpFrequency?: Maybe<TimeSeries>;
  /**
   * ESP pump intake pressure (psia or bara) measured at the pump suction. Critical
   * for ensuring pump operates above bubble point to avoid gas locking. Low PIP
   * indicates potential pump-off or gas interference.
   */
  pumpIntakePress?: Maybe<TimeSeries>;
  /**
   * Temperature (°F or °C) at ESP pump intake. Important for PVT calculations
   * and monitoring motor cooling. High temperatures may indicate low flow or
   * motor overheating.
   */
  pumpIntakeTemp?: Maybe<TimeSeries>;
  /**
   * ESP motor winding temperature (°F or °C). Critical for motor protection -
   * high temperature indicates overload, inadequate cooling, or impending failure.
   * Typical alarm limits 250-300°F.
   */
  pumpMotorTemp?: Maybe<TimeSeries>;
  /**
   * ESP vibration level (g or mm/s). Indicates mechanical health of pump and motor.
   * Increasing vibration trends suggest bearing wear, shaft imbalance, or scale
   * buildup. Critical for predictive maintenance.
   */
  pumpVibration?: Maybe<TimeSeries>;
  /**
   * ESP motor voltage (volts) from VSD. Used with current to calculate power
   * consumption and motor efficiency. Voltage imbalance indicates electrical issues.
   */
  pumpVoltage?: Maybe<TimeSeries>;
  /**
   * Separator or station pressure (psia or bara). Backpressure condition at
   * delivery point used for flow calculations and network modeling.
   */
  sPress?: Maybe<TimeSeries>;
  /**
   * Subsurface safety valve (SSSV) status: 1 = OPEN, 0 = CLOSED. Downhole emergency
   * valve for well control. Closes automatically on loss of hydraulic control pressure.
   */
  subSurfaceSafetyValve?: Maybe<TimeSeries>;
  /**
   * Surface safety valve (SSV) status: 1 = OPEN, 0 = CLOSED. Emergency shutdown
   * valve at surface. Closed valve blocks all production.
   */
  surfaceSafetyValve?: Maybe<TimeSeries>;
  /**
   * Target gas injection rate (MSCF/d) from injection plan. Based on reservoir
   * management or EOR requirements.
   */
  targetGasInjection?: Maybe<TimeSeries>;
  /** Target gas production rate (MSCF/d) from production plan. */
  targetGasProduction?: Maybe<TimeSeries>;
  /**
   * Target oil production rate (stb/d) from production plan. The rate the string
   * should achieve to meet field targets. Compare to actual allocated rate for
   * performance gap analysis.
   */
  targetOilProduction?: Maybe<TimeSeries>;
  /**
   * Target water injection rate (stb/d) from injection plan. Based on reservoir
   * management requirements for voidage replacement.
   */
  targetWaterInjection?: Maybe<TimeSeries>;
  /**
   * Target water production rate (stb/d) from production plan. May be used as
   * a constraint for water handling capacity.
   */
  targetWaterProduction?: Maybe<TimeSeries>;
  /**
   * Valve status or flag indicating well is routed to production header: 1 = routed
   * to production, 0 = not routed. Used to determine where well flow is directed.
   */
  toProdHeader?: Maybe<TimeSeries>;
  /**
   * Valve status or flag indicating well is routed to test separator: 1 = on test,
   * 0 = not on test. When on test, well flow is measured individually.
   */
  toTestHeader?: Maybe<TimeSeries>;
  /**
   * Water injection header pressure (psia or bara). Supply pressure from water
   * injection pumps. Shared by multiple injection wells on same header.
   */
  waterHeaderPressure?: Maybe<TimeSeries>;
  /**
   * Water injection choke opening position (% open). Controls injection rate by
   * varying pressure drop into the well.
   */
  waterInjChokeOpening?: Maybe<TimeSeries>;
  /**
   * Water injection rate (stb/d or m³/d) for water injector wells. Measured at
   * wellhead flow meter. Primary measurement for injection allocation.
   */
  waterInjRate?: Maybe<TimeSeries>;
  /**
   * Wellhead pressure (psia or bara) for water injection wells. Injection WHP
   * upstream of any choke or control valve.
   */
  waterInjWellheadPress?: Maybe<TimeSeries>;
  /**
   * Tubing head pressure (THP) or wellhead pressure (WHP) in psia or bara. Measured
   * upstream of choke. Primary surface pressure measurement for well performance
   * analysis and VLP calculations.
   */
  wellHeadPress?: Maybe<TimeSeries>;
  /**
   * Wellhead temperature (°F or °C). Used for PVT calculations and monitoring
   * temperature trends that may indicate water breakthrough or gas lift changes.
   */
  wellHeadTemp?: Maybe<TimeSeries>;
  /**
   * Wing valve status: 1 = OPEN, 0 = CLOSED. Primary production path valve on
   * christmas tree. Must be open for production flow.
   */
  wingValve?: Maybe<TimeSeries>;
};

/**
 * Well movement records including choke adjustments, ESP frequency changes, and
 * GL optimization.
 *
 * Contains detailed records of operational changes made to wells, choke
 * adjustments, ESP frequency changes, GL rate optimization, and injection rate
 * modifications. Sourced from well management systems and operational logs,
 * allowing for analysis of optimization recommendations and their execution
 * status. Answers questions on the impact of specific adjustments on well
 * performance and efficiency, as well as track the timeline of changes made.
 * Excludes historical production data or reservoir characteristics (see other
 * related views).
 *
 * @name Well Movement (Agent)
 */
export type WellMovementAgent = {
  actualExecutionDate?: Maybe<Scalars['Date']['output']>;
  baselineGasRate?: Maybe<Scalars['Float']['output']>;
  baselineOilRate?: Maybe<Scalars['Float']['output']>;
  baselineWaterRate?: Maybe<Scalars['Float']['output']>;
  controlParameter?: Maybe<Scalars['String']['output']>;
  controlParameterPostOptimizedValue?: Maybe<Scalars['Float']['output']>;
  controlParameterPreOptimizedValue?: Maybe<Scalars['Float']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  doNotDisturb?: Maybe<Scalars['Boolean']['output']>;
  doNotDisturbEndDate?: Maybe<Scalars['Date']['output']>;
  estimatedGasRate?: Maybe<Scalars['Float']['output']>;
  estimatedOilRate?: Maybe<Scalars['Float']['output']>;
  estimatedWaterRate?: Maybe<Scalars['Float']['output']>;
  executionStatus?: Maybe<Scalars['String']['output']>;
  plannedExecutionDate?: Maybe<Scalars['Date']['output']>;
  scenarioName?: Maybe<Scalars['String']['output']>;
  scenarioType?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  ticketExternalId?: Maybe<Scalars['String']['output']>;
  validationStatus?: Maybe<Scalars['String']['output']>;
  wellName?: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
  wellType?: Maybe<Scalars['String']['output']>;
};

/** Well Outputs Ext 1 String view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type WellOutputsExt_1String = {
  /** Time series signal representing data driven gas rate std for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  dataDrivenGasRateStd?: Maybe<TimeSeries>;
  /** Time series signal representing data driven liquid rate std for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  dataDrivenLiquidRateStd?: Maybe<TimeSeries>;
  /** Time series signal representing data driven oil rate std for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  dataDrivenOilRateStd?: Maybe<TimeSeries>;
  /** Time series signal representing data driven water rate std for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  dataDrivenWaterRateStd?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Time series signal representing gi bhpcompliance for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giBHPCompliance?: Maybe<TimeSeries>;
  /** Target production or injection rate setpoint for this production string, typically coming from production planning or optimization scenarios, used to guide field control and compare against actual performance. */
  giTargetRateCompliance?: Maybe<TimeSeries>;
  /** Time series signal representing gi technical rate compliance for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giTechnicalRateCompliance?: Maybe<TimeSeries>;
  /** Time series signal representing gi whpcompliance for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  giWHPCompliance?: Maybe<TimeSeries>;
  /** Time series signal representing wi bhpcompliance for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiBHPCompliance?: Maybe<TimeSeries>;
  /** Target production or injection rate setpoint for this production string, typically coming from production planning or optimization scenarios, used to guide field control and compare against actual performance. */
  wiTargetRateCompliance?: Maybe<TimeSeries>;
  /** Time series signal representing wi technical rate compliance for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiTechnicalRateCompliance?: Maybe<TimeSeries>;
  /** Time series signal representing wi whpcompliance for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wiWHPCompliance?: Maybe<TimeSeries>;
};

/**
 * OPERATIONAL AND ENGINEERING DATA for well strings. Contains real-time measurements,
 * calculated rates from various analysis methods, and well status indicators.
 *
 * KEY DIFFERENCES FROM AllocatedProperties_String:
 * - This view has OPERATIONAL/ENGINEERING data (pressures, rates, status flags)
 * - AllocatedProperties has ACCOUNTING data (allocated volumes for booking)
 *
 * ANALYSIS METHOD PREFIXES:
 * - systemAnalysis*: Rates from nodal analysis (IPR+VLP intersection)
 * - chokeAnalysis*: Rates calculated from choke equation
 * - iprAnalysis*: Rates from IPR curve only
 * - vlpAnalysis*: Rates from VLP curve only
 * - curveAnalysis*: Rates from performance curves
 * - dataAnalysis*: Rates from data-driven models
 * - priority*: Selected "best" rates for surveillance
 *
 * COMMON QUERIES:
 * - Is string online? onlineStatus
 * - Current flowing BHP? systemAnalysisFbhp or priorityFbhp
 * - Production rates? priorityOilRateStd, priorityGasRateStd, priorityWaterRateStd
 */
export type WellOutputsString = {
  /**
   * Calculated oil formation volume factor (Bo) at current conditions (rb/stb).
   * Used to convert surface volumes to reservoir volumes.
   */
  calcFVF?: Maybe<TimeSeries>;
  /**
   * Calculated gas formation volume factor (Bg) at current conditions (rb/scf
   * or m³/sm³). Used for gas volume conversions.
   */
  calcGasFVF?: Maybe<TimeSeries>;
  /**
   * Calculated gas viscosity (cp) at current pressure and temperature.
   * Used in pressure drop and flow calculations.
   */
  calcGasViscosity?: Maybe<TimeSeries>;
  /**
   * Estimated flowing BHP (psia or bara) from choke analysis, typically
   * back-calculated from WHP using VLP or pressure traverse.
   */
  chokeAnalysisFbhp?: Maybe<TimeSeries>;
  /**
   * Gas rate (MSCF/d) from choke analysis, calculated from choke equation
   * or derived from liquid rate and GOR.
   */
  chokeAnalysisGasRateStd?: Maybe<TimeSeries>;
  /**
   * Total liquid rate (stb/d) calculated from choke equation using upstream
   * pressure, choke size, and fluid properties. Independent of well models.
   */
  chokeAnalysisLiquidRateStd?: Maybe<TimeSeries>;
  /** Oil rate (stb/d) from choke analysis, derived from liquid rate and water cut. */
  chokeAnalysisOilRateStd?: Maybe<TimeSeries>;
  /**
   * Status of choke analysis calculation: 'SUCCESS', 'FAILED', 'CRITICAL_FLOW',
   * 'SUBCRITICAL_FLOW'. Check this before using chokeAnalysis* rates.
   */
  chokeAnalysisStatus?: Maybe<TimeSeries>;
  /** Water rate (stb/d) from choke analysis, derived from liquid rate and water cut. */
  chokeAnalysisWaterRateStd?: Maybe<TimeSeries>;
  /**
   * Calculated discharge coefficient (Cd) for production choke. Typical
   * values 0.6-0.9. Low values may indicate restriction or erosion.
   */
  chokeCdCalc?: Maybe<TimeSeries>;
  /**
   * Calculated production choke size (64ths inch or mm) required to achieve
   * current rate given pressure conditions. Compare to actual choke setting.
   */
  chokeSizeCalc?: Maybe<TimeSeries>;
  /**
   * Average or reference wellhead pressure (psia or bara) during cumulative
   * gas injection period. Used for injectivity trending.
   */
  cumulativeGasInjPress?: Maybe<TimeSeries>;
  /**
   * Cumulative gas injection volume (MSCF or km³) since start of injection
   * or last reset. Used for voidage tracking and EOR monitoring.
   */
  cumulativeGasInjVol?: Maybe<TimeSeries>;
  /**
   * Average or reference wellhead pressure (psia or bara) during cumulative
   * water injection period. Used for injectivity trending.
   */
  cumulativeWaterInjPress?: Maybe<TimeSeries>;
  /**
   * Cumulative water injection volume (stb or m³) since start of injection
   * or last reset. Used for voidage tracking and material balance.
   */
  cumulativeWaterInjVol?: Maybe<TimeSeries>;
  /** Flowing BHP (psia or bara) from performance curve analysis. */
  curveAnalysisFbhp?: Maybe<TimeSeries>;
  /** Gas rate (MSCF/d) from performance curve analysis. */
  curveAnalysisGasRateStd?: Maybe<TimeSeries>;
  /**
   * Liquid rate (stb/d) from performance curve lookup, typically a rate vs
   * pressure or rate vs time curve derived from historical data.
   */
  curveAnalysisLiquidRateStd?: Maybe<TimeSeries>;
  /** Oil rate (stb/d) from performance curve analysis. */
  curveAnalysisOilRateStd?: Maybe<TimeSeries>;
  /** Water rate (stb/d) from performance curve analysis. */
  curveAnalysisWaterRateStd?: Maybe<TimeSeries>;
  /** Flowing BHP (psia or bara) from data analysis models. */
  dataAnalysisFbhp?: Maybe<TimeSeries>;
  /** Gas rate (MSCF/d) from data analysis models. */
  dataAnalysisGasRateStd?: Maybe<TimeSeries>;
  /**
   * Liquid rate (stb/d) from data-driven analysis, typically ML models or
   * statistical methods applied to real-time sensor data.
   */
  dataAnalysisLiquidRateStd?: Maybe<TimeSeries>;
  /** Oil rate (stb/d) from data analysis models. */
  dataAnalysisOilRateStd?: Maybe<TimeSeries>;
  /** Water rate (stb/d) from data analysis models. */
  dataAnalysisWaterRateStd?: Maybe<TimeSeries>;
  /**
   * Gas injection volume at downhole conditions. Relevant for pressure
   * maintenance and EOR volume tracking.
   */
  downholeGasInjectionVolume?: Maybe<TimeSeries>;
  /**
   * Gas production volume at downhole conditions. Calculated from surface
   * rate and Bg. Includes free gas and solution gas.
   */
  downholeGasProductionVolume?: Maybe<TimeSeries>;
  /**
   * Oil production volume (rb/d) at downhole conditions. Calculated from
   * surface rate and Bo. Used for reservoir material balance.
   */
  downholeOilProductionVolume?: Maybe<TimeSeries>;
  /**
   * Water injection volume at downhole conditions. Used for reservoir
   * voidage replacement calculations.
   */
  downholeWaterInjectionVolume?: Maybe<TimeSeries>;
  /**
   * Water production volume (rb/d) at downhole conditions. Water FVF typically
   * ~1.0, so close to surface volume.
   */
  downholeWaterProductionVolume?: Maybe<TimeSeries>;
  /**
   * Reference to the String_asset entity. Use this to join to string master data
   * or navigate via FlatHierarchy to parent well, field, or reservoir.
   */
  entityName?: Maybe<StringAsset>;
  /**
   * Status of ESP rate calculation (ESP Q-Liquid analysis): 'SUCCESS',
   * 'FAILED', 'NO_DATA'. Check before using ESP-derived rates.
   */
  espqlAnalysisStatus?: Maybe<TimeSeries>;
  /**
   * Bottomhole pressure (psia or bara) during gas injection. May be measured
   * (if instrumented) or calculated from WHP using pressure traverse.
   */
  giBHP?: Maybe<TimeSeries>;
  /**
   * Current gas injection rate (MSCF/d). Real-time value from flow meter or
   * calculated from operating conditions.
   */
  giRate?: Maybe<TimeSeries>;
  /**
   * Target gas injection rate (MSCF/d) from production plan or optimization.
   * Compare to giRate to assess injection compliance.
   */
  giTargetRate?: Maybe<TimeSeries>;
  /**
   * Maximum technically achievable gas injection rate (MSCF/d) given current
   * well and facility constraints. Upper bound for optimization.
   */
  giTechnicalRate?: Maybe<TimeSeries>;
  /**
   * Current wellhead pressure (psia or bara) during gas injection. Real-time
   * value from pressure transmitter or SCADA.
   */
  giWHP?: Maybe<TimeSeries>;
  /**
   * Calculated discharge coefficient (Cd) for gas lift choke. Deviations
   * from typical values may indicate erosion or plugging.
   */
  glChokeCdCalc?: Maybe<TimeSeries>;
  /**
   * Calculated gas lift choke size (64ths inch or mm) required to achieve
   * current GLIR given upstream pressure conditions.
   */
  glChokeSizeCalc?: Maybe<TimeSeries>;
  /**
   * Allocated gas lift injection rate (MSCF/d) from daily allocation.
   * May differ from measured if metering is at a header level.
   */
  glirAllocated?: Maybe<TimeSeries>;
  /**
   * Gas lift injection rate (MSCF/d) calculated from GL choke equation
   * using upstream pressure and choke setting.
   */
  glirChokeEquation?: Maybe<TimeSeries>;
  /**
   * Measured gas lift injection rate (MSCF/d) from flow meter. Direct
   * measurement of gas being injected into the annulus for artificial lift.
   */
  glirMeasured?: Maybe<TimeSeries>;
  /**
   * Gas lift injection rate (MSCF/d) from network simulation. Calculated
   * value that may differ from measured due to model assumptions.
   */
  glirNetworkSimulation?: Maybe<TimeSeries>;
  /**
   * Selected/priority gas lift rate (MSCF/d) used for optimization and
   * surveillance. Typically the most reliable of the available GLIR values.
   */
  glirSelected?: Maybe<TimeSeries>;
  /**
   * Source of the selected GLIR: 'MEASURED', 'NETWORK_SIMULATION',
   * 'CHOKE_EQUATION', 'ALLOCATED'. Indicates which value populates glirSelected.
   */
  glirSelectedType?: Maybe<TimeSeries>;
  /**
   * Status of gas lift rate calculation: 'SUCCESS', 'FAILED', 'NO_DATA'.
   * Check before using gas lift-derived rates.
   */
  glqlAnalysisStatus?: Maybe<TimeSeries>;
  /**
   * Status of Gas Rate Decline analysis: 'SUCCESS', 'FAILED', 'INSUFFICIENT_DATA'.
   * Check before using GRD-derived forecasts.
   */
  grdAnalysisStatus?: Maybe<TimeSeries>;
  /**
   * Interpretation of Hall plot trend: 'STABLE', 'IMPROVING', 'DECLINING',
   * 'STIMULATION_NEEDED'. Used for injection well surveillance.
   */
  hallInterpretation?: Maybe<TimeSeries>;
  /**
   * Hall plot cumulative value or slope for injection performance analysis.
   * Trend changes indicate injectivity changes over time.
   */
  hallLine?: Maybe<TimeSeries>;
  /**
   * Cumulative hours the string has been online (producing/injecting) since
   * last reset or start of tracking period. Used for uptime calculations and
   * maintenance scheduling.
   */
  hoursOnline?: Maybe<TimeSeries>;
  /**
   * Injection efficiency metric (%) comparing actual injection rate to
   * target or potential. 100% = fully meeting target.
   */
  injectionEfficiency?: Maybe<TimeSeries>;
  /**
   * Flag indicating injection efficiency status: 1 = below threshold (needs
   * attention), 0 = acceptable. Used for alarm logic.
   */
  injectionEfficiencyFlag?: Maybe<TimeSeries>;
  /**
   * Rank of this string's injection efficiency among all injectors (1 = best).
   * Used for prioritization and identification of underperformers.
   */
  injectionEfficiencyRank?: Maybe<TimeSeries>;
  /**
   * Injectivity index (II) for injectors, in stb/d/psi or m³/d/bar.
   * Measures wellbore-to-reservoir flow efficiency for injection wells.
   */
  injectivityIndex?: Maybe<TimeSeries>;
  /**
   * Flag indicating whether the string has downhole instrumentation (gauges):
   * 1 = instrumented with real-time pressure/temperature, 0 = not instrumented.
   * Affects data quality and available analysis methods.
   */
  instrumented?: Maybe<Scalars['Float32']['output']>;
  /**
   * Flowing BHP (psia or bara) used for IPR curve lookup or the result
   * of IPR analysis at current rate.
   */
  iprAnalysisFbhp?: Maybe<TimeSeries>;
  /** Gas rate (MSCF/d) from IPR curve analysis. */
  iprAnalysisGasRateStd?: Maybe<TimeSeries>;
  /**
   * Liquid rate (stb/d) from IPR curve at current reservoir and flowing
   * conditions. Represents reservoir deliverability potential.
   */
  iprAnalysisLiquidRateStd?: Maybe<TimeSeries>;
  /** Oil rate (stb/d) from IPR curve analysis. */
  iprAnalysisOilRateStd?: Maybe<TimeSeries>;
  /** Water rate (stb/d) from IPR curve analysis. */
  iprAnalysisWaterRateStd?: Maybe<TimeSeries>;
  /**
   * Current artificial lift method: 'NATURAL_FLOW', 'ESP', 'GAS_LIFT', 'ROD_PUMP',
   * 'JET_PUMP', 'PCP'. Critical for selecting appropriate well models and
   * performance curves.
   */
  liftType?: Maybe<TimeSeries>;
  /**
   * ESP motor efficiency (%) - ratio of hydraulic power output to electrical
   * power input. Declining efficiency may indicate motor degradation.
   */
  motorEfficiency?: Maybe<TimeSeries>;
  /**
   * ESP motor load (%) - current electrical load as percentage of rated
   * capacity. High load may indicate operating near limits.
   */
  motorLoad?: Maybe<TimeSeries>;
  /**
   * Current operational status of the string: 'ONLINE' (producing/injecting),
   * 'OFFLINE' (shut-in), 'TEST' (on well test), 'UNSTABLE' (transient conditions).
   * Primary flag for filtering active strings in surveillance dashboards.
   */
  onlineStatus?: Maybe<TimeSeries>;
  /**
   * Reason code or description explaining the current onlineStatus, e.g.,
   * 'SCHEDULED_MAINTENANCE', 'ESP_FAILURE', 'LOW_PRESSURE', 'WELL_TEST'.
   * Useful for downtime analysis and root cause tracking.
   */
  onlineStatusReason?: Maybe<TimeSeries>;
  /**
   * Pressure compliance status: indicates whether current operating pressure
   * is within guidelines. 'COMPLIANT', 'NON_COMPLIANT', 'WARNING'.
   */
  pressureCompliance?: Maybe<TimeSeries>;
  /**
   * Source of the BHP value: 'MEASURED' (downhole gauge), 'CALCULATED' (from
   * WHP traverse), 'ESTIMATED' (correlation). Indicates data quality.
   */
  pressureSource?: Maybe<TimeSeries>;
  /**
   * Selected best-available flowing BHP (psia or bara) for surveillance.
   * Use this as the primary BHP when a single value is needed.
   */
  priorityFbhp?: Maybe<TimeSeries>;
  /**
   * Selected best-available gas rate (MSCF/d) for surveillance. Use this as
   * the primary gas rate when a single value is needed.
   */
  priorityGasRateStd?: Maybe<TimeSeries>;
  /**
   * Selected best-available liquid rate (stb/d) for surveillance. This is the
   * rate shown by default in dashboards and used for real-time monitoring.
   */
  priorityLiquidRateStd?: Maybe<TimeSeries>;
  /**
   * Analysis method selected as the priority/best source for rates:
   * 'SYSTEM_ANALYSIS', 'CHOKE_ANALYSIS', 'ALLOCATION', 'WELL_TEST', 'DATA_ANALYSIS'.
   * Indicates which method's rates populate the priority* fields.
   */
  priorityMethod?: Maybe<TimeSeries>;
  /**
   * Selected best-available oil rate (stb/d) for surveillance. Use this as
   * the primary oil rate when a single value is needed.
   */
  priorityOilRateStd?: Maybe<TimeSeries>;
  /** Selected best-available water rate (stb/d) for surveillance. */
  priorityWaterRateStd?: Maybe<TimeSeries>;
  /** [DEPRECATED - use priorityWaterRateStd] Legacy field with typo in name. */
  priotiryWaterRateStd?: Maybe<TimeSeries>;
  /**
   * Primary product type: 'OIL', 'GAS', 'CONDENSATE', 'WATER'. Determines
   * which phase is used for primary rate calculations and GOR/WOR conventions.
   */
  product?: Maybe<TimeSeries>;
  /**
   * Productivity index (PI) for producers, in stb/d/psi or m³/d/bar.
   * Measures reservoir-to-wellbore flow efficiency. Higher PI = better inflow.
   */
  productivityIndex?: Maybe<TimeSeries>;
  /**
   * Lift type as configured in PROSPER model. Should match operational liftType
   * but may lag during lift method conversions.
   */
  prosperLiftType?: Maybe<TimeSeries>;
  /**
   * Product type as configured in PROSPER model: 'OIL', 'GAS', 'CONDENSATE'.
   * Determines PVT correlations and flow regime calculations in the model.
   */
  prosperProduct?: Maybe<TimeSeries>;
  /** WAG configuration in PROSPER model. Should match operational wag status. */
  prosperWag?: Maybe<TimeSeries>;
  /**
   * Well type as configured in the PROSPER well model: 'CASED_HOLE', 'OPEN_HOLE',
   * 'MULTILATERAL', etc. May differ from operational wellType classification.
   */
  prosperWellType?: Maybe<TimeSeries>;
  /**
   * Average pump rate (stb/d) over the calculation period. May differ from
   * instantaneous rate if pump cycling or varying conditions.
   */
  pumpAvgRate?: Maybe<TimeSeries>;
  /**
   * ESP pump head (ft or m) - pressure increase provided by the pump.
   * Compare to pump curve to assess operating point and efficiency.
   */
  pumpHead?: Maybe<TimeSeries>;
  /**
   * Alarm code from PVT calculations indicating data quality or calculation
   * issues: 0 = OK, non-zero = specific issue code.
   */
  pvt_AlarmCode?: Maybe<TimeSeries>;
  /**
   * Difference between current liquid rate and a reference rate (stb/d).
   * Positive = producing above reference; negative = below reference.
   * Used for rate change monitoring and alarm triggering.
   */
  qliqDelta?: Maybe<TimeSeries>;
  /**
   * Current reservoir pressure (psia or bara) at the datum depth for this string.
   * May be updated from pressure surveys, material balance, or simulation.
   */
  reservoirPressureDatum?: Maybe<TimeSeries>;
  /**
   * Reservoir pressure (psia or bara) corrected to mid-perforation depth.
   * Used directly in IPR calculations and nodal analysis.
   */
  reservoirPressureMidPerforation?: Maybe<TimeSeries>;
  /**
   * Identifier for the choke node associated with this string in the network
   * simulation. Used for choke analysis and pressure drop calculations.
   */
  simulationChokeId?: Maybe<TimeSeries>;
  /**
   * Performance curve input for network simulation, typically combining IPR
   * and VLP curves for nodal analysis.
   */
  simulationCurveInput?: Maybe<TimeSeries>;
  /**
   * Unique identifier linking this string to its representation in the network
   * simulation model. Used to match simulation results back to physical strings.
   */
  simulationId?: Maybe<TimeSeries>;
  /**
   * IPR curve or parameters used as input to the network simulation for this
   * string. May be a reference to a curve table or JSON configuration.
   */
  simulationIprInput?: Maybe<TimeSeries>;
  /**
   * VLP curve or parameters used as input to the network simulation for this
   * string. May be a reference to a curve table or JSON configuration.
   */
  simulationVlpInput?: Maybe<TimeSeries>;
  /**
   * Indicates whether the string is experiencing slugging flow: 'SLUGGING',
   * 'STABLE', 'SEVERE_SLUGGING'. Important for flow assurance monitoring and
   * to flag unreliable rate measurements.
   */
  sluggingStatus?: Maybe<TimeSeries>;
  /**
   * Indicates whether the string is in steady-state flow conditions: 'STEADY' or
   * 'TRANSIENT'. Used to determine if current rates are representative and can
   * be used for allocation or model calibration.
   */
  steadyStateStatus?: Maybe<TimeSeries>;
  /**
   * Subsurface safety valve (SSSV) state: 1 = CLOSED, 0 = OPEN. Critical
   * safety indicator - downhole valve for well control.
   */
  subSurfaceSafetyValveCloseState?: Maybe<Scalars['Int']['output']>;
  /**
   * Surface safety valve (SSV) state: 1 = CLOSED, 0 = OPEN. Critical safety
   * indicator - closed valve blocks production/injection flow.
   */
  surfaceSafetyValveCloseState?: Maybe<Scalars['Int']['output']>;
  /**
   * Flowing bottomhole pressure (psia or bara) at the operating point from
   * nodal analysis. This is the BHP at the IPR-VLP intersection.
   */
  systemAnalysisFbhp?: Maybe<TimeSeries>;
  /**
   * Gas rate at standard conditions (MSCF/d) from nodal analysis. Includes
   * solution gas and free gas. Primary rate for gas producers.
   */
  systemAnalysisGasRateStd?: Maybe<TimeSeries>;
  /**
   * Total liquid rate at stock-tank conditions (stb/d) from nodal analysis
   * (IPR-VLP intersection). Includes both oil and water production.
   */
  systemAnalysisLiquidRateStd?: Maybe<TimeSeries>;
  /**
   * Oil rate at stock-tank conditions (stb/d) from nodal analysis. Calculated
   * from liquid rate using water cut. Primary rate for oil producers.
   */
  systemAnalysisOilRateStd?: Maybe<TimeSeries>;
  /**
   * Status of system analysis calculation: 'SUCCESS', 'FAILED', 'NO_INTERSECTION',
   * 'INVALID_INPUT'. Check this before using systemAnalysis* rates.
   */
  systemAnalysisStatus?: Maybe<TimeSeries>;
  /**
   * Water rate at stock-tank conditions (stb/d) from nodal analysis.
   * Calculated from liquid rate using water cut.
   */
  systemAnalysisWaterRateStd?: Maybe<TimeSeries>;
  /** Flowing BHP (psia or bara) from VLP curve at current rate and WHP conditions. */
  vlpAnalysisFbhp?: Maybe<TimeSeries>;
  /** Gas rate (MSCF/d) from VLP curve analysis. */
  vlpAnalysisGasRateStd?: Maybe<TimeSeries>;
  /**
   * Liquid rate (stb/d) from VLP curve at current tubing and separator
   * conditions. Represents tubing hydraulic capacity.
   */
  vlpAnalysisLiquidRateStd?: Maybe<TimeSeries>;
  /** Oil rate (stb/d) from VLP curve analysis. */
  vlpAnalysisOilRateStd?: Maybe<TimeSeries>;
  /** Water rate (stb/d) from VLP curve analysis. */
  vlpAnalysisWaterRateStd?: Maybe<TimeSeries>;
  /**
   * Water-Alternating-Gas (WAG) status: 'YES' if string alternates between water
   * and gas injection, 'NO' otherwise. Affects injection scheduling and
   * reservoir modeling.
   */
  wag?: Maybe<TimeSeries>;
  /**
   * Well performance indicator or score (dimensionless). May represent
   * efficiency vs theoretical potential, or a composite health score.
   */
  wellPerformance?: Maybe<TimeSeries>;
  /**
   * Validation status of the most recent well test: 'VALID', 'INVALID',
   * 'PENDING_REVIEW'. Indicates whether test results can be used for
   * allocation factors or model calibration.
   */
  wellTestValidation?: Maybe<TimeSeries>;
  /**
   * Classification of the well type: 'PRODUCTION', 'INJECTION', 'OBSERVATION',
   * 'DISPOSAL', 'WAG'. Determines which operational dashboards and KPIs apply.
   */
  wellType?: Maybe<TimeSeries>;
  /**
   * Bottomhole pressure (psia or bara) during water injection. May be measured
   * or calculated from WHP.
   */
  wiBHP?: Maybe<TimeSeries>;
  /**
   * Current water injection rate (stb/d or m³/d). Real-time value from
   * flow meter or calculated.
   */
  wiRate?: Maybe<TimeSeries>;
  /** Target water injection rate (stb/d) from production plan or optimization. */
  wiTargetRate?: Maybe<TimeSeries>;
  /**
   * Maximum technically achievable water injection rate (stb/d) given
   * current well and facility constraints.
   */
  wiTechnicalRate?: Maybe<TimeSeries>;
  /** Current wellhead pressure (psia or bara) during water injection. */
  wiWHP?: Maybe<TimeSeries>;
  /**
   * Wing valve state: 1 = CLOSED, 0 = OPEN. Indicates whether production
   * or injection path through christmas tree is open.
   */
  wingValveCloseState?: Maybe<Scalars['Int']['output']>;
};

/**
 * Per-string operational status â€” lift type, well type, online state, valve
 * states, and reservoir pressure estimates.
 *
 * String-level state attributes sourced from field sensors and monitoring
 * systems, covering online, flow stability, and slugging indicators, surface
 * and subsurface valve positions, well classification (lift type, product,
 * WAG), and current reservoir pressure estimates. Distinct from
 * InactiveString_Agent, which classifies long-term inactivity. Excludes
 * historical performance and detailed production rates.
 *
 * Use for: Well Status Detection (WF25), Real-Time Surveillance (WF18).
 */
export type WellStatusStringAgent = {
  /** Hours online since midnight UTC+04:00, derived from onlineStatus (max 24). */
  hoursOnline?: Maybe<TimeSeries>;
  /** Downhole instrumentation flag, numeric. 1 = real-time P/T gauges present, 0 = not instrumented. */
  instrumented?: Maybe<Scalars['Float32']['output']>;
  /** Artificial lift method. Values are NATURAL_FLOW, ESP, GAS_LIFT, ROD_PUMP, JET_PUMP, PCP. String Time Series. */
  liftType?: Maybe<TimeSeries>;
  /** Online state, numeric. 0 = shut-in, 1 = flowing. */
  onlineStatus?: Maybe<TimeSeries>;
  /** Reasons recorded at shut-in start that triggered the shut-in detection. String Time Series. */
  onlineStatusReason?: Maybe<TimeSeries>;
  /** Pressure compliance status. Values are COMPLIANT, NON_COMPLIANT, WARNING. String Time Series. */
  pressureCompliance?: Maybe<TimeSeries>;
  /** Source method used to derive reservoir pressure. String Time Series. */
  pressureSource?: Maybe<TimeSeries>;
  /** Primary product type. Values are OIL, GAS, CONDENSATE, WATER. String Time Series. */
  product?: Maybe<TimeSeries>;
  /** Estimated reservoir pressure at datum depth (psi). */
  reservoirPressureDatum?: Maybe<TimeSeries>;
  /** Estimated reservoir pressure at mid-perforation depth (psi). */
  reservoirPressureMidPerforation?: Maybe<TimeSeries>;
  /** Hydrodynamic slug-flow indicator, numeric. 0 = not slugging, 1 = slugging. */
  sluggingStatus?: Maybe<TimeSeries>;
  /** Flow stability, numeric. 0 = transient or shut-in, 1 = quasi-steady-state flowing. */
  steadyStateStatus?: Maybe<TimeSeries>;
  /** Subsurface safety valve (SSSV) state, numeric. 0 = OPEN, 1 = CLOSED. */
  subSurfaceSafetyValveCloseState?: Maybe<Scalars['Int']['output']>;
  /** Surface safety valve (SSV) state, numeric. 0 = OPEN, 1 = CLOSED. */
  surfaceSafetyValveCloseState?: Maybe<Scalars['Int']['output']>;
  /** Water-alternating-gas injection flag. Values are YES, NO. String Time Series. */
  wag?: Maybe<TimeSeries>;
  /** Reference to the well string entity. */
  wellString?: Maybe<StringAsset>;
  /** Validation status of the most recent well test. Values are VALID, INVALID, PENDING_REVIEW. String Time Series. */
  wellTestValidation?: Maybe<TimeSeries>;
  /** Well classification. Values are PRODUCTION, INJECTION, OBSERVATION, DISPOSAL, WAG. String Time Series. */
  wellType?: Maybe<TimeSeries>;
  /** Wing valve state, numeric. 0 = OPEN, 1 = CLOSED. */
  wingValveCloseState?: Maybe<Scalars['Int']['output']>;
};

/**
 * Per-string well test analysis outputs â€” productivity and injectivity
 * indices, reservoir pressure, last-test rates and pressures, and current
 * model estimates.
 *
 * String-level outputs from the well test analysis workflow (WF03).
 * Productivity and injectivity indices with percent change versus the
 * previous accepted test, reservoir pressure with percent change, timestamp
 * and measured rates and pressures from the last accepted test, and current
 * real-time model estimates of rates and flowing bottomhole pressure.
 * Excludes raw measurement curves and detailed completion or geological
 * context.
 *
 * Use for: Well Test Analysis (WF03), Real-Time Surveillance (WF18).
 *
 * @name Well Test Analysis (Agent)
 */
export type WellTestAnalysisAgent = {
  /** Current model-estimated flowing bottomhole pressure (psia). */
  modelEstimatedFbhp?: Maybe<TimeSeries>;
  /** Current model-estimated gas rate (Mscf/d). */
  modelEstimatedGasRate?: Maybe<TimeSeries>;
  /** Current model-estimated total liquid rate (oil + water) (stb/d). */
  modelEstimatedLiquidRate?: Maybe<TimeSeries>;
  /** Current model-estimated oil rate (stb/d). */
  modelEstimatedOilRate?: Maybe<TimeSeries>;
  /** Current model-estimated water rate (stb/d). */
  modelEstimatedWaterRate?: Maybe<TimeSeries>;
  /** Injectivity Index for injection wells from the well test model (stb/d/psi). */
  modelInjectivityIndex?: Maybe<TimeSeries>;
  /** Percent change in injectivity index versus the previous accepted well test (%). */
  modelInjectivityIndexPercentChange?: Maybe<TimeSeries>;
  /** Productivity Index from the well test model (stb/d/psi). */
  modelProductivityIndex?: Maybe<TimeSeries>;
  /** Percent change in productivity index versus the previous accepted well test (%). */
  modelProductivityIndexPercentChange?: Maybe<TimeSeries>;
  /** Reservoir pressure from the well test model (psia). */
  modelReservoirPressure?: Maybe<TimeSeries>;
  /** Percent change in reservoir pressure versus the previous accepted well test (%). */
  modelReservoirPressurePercentChange?: Maybe<TimeSeries>;
  /** Casing head pressure during the last accepted well test (psia). */
  modelWellTestChp?: Maybe<TimeSeries>;
  /** Gas rate measured at the last accepted well test (Mscf/d). */
  modelWellTestGasRate?: Maybe<TimeSeries>;
  /** Gas-Oil Ratio measured at the last accepted well test (scf/stb). */
  modelWellTestGor?: Maybe<TimeSeries>;
  /** Total liquid rate (oil + water) measured at the last accepted well test (stb/d). */
  modelWellTestLiquidRate?: Maybe<TimeSeries>;
  /** Permanent downhole gauge pressure during the last accepted well test (psia). */
  modelWellTestPdgPress?: Maybe<TimeSeries>;
  /** Timestamp of the last accepted well test. */
  modelWellTestTimestamp?: Maybe<TimeSeries>;
  /** Water cut (water / total liquid) measured at the last accepted well test (%). */
  modelWellTestWc?: Maybe<TimeSeries>;
  /** Wellhead pressure during the last accepted well test (psia). */
  modelWellTestWhp?: Maybe<TimeSeries>;
  /** Reference to the well string entity. */
  wellString?: Maybe<StringAsset>;
};

/** Well Test Gauge String view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type WellTestGaugeString = {
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Time series signal representing lower datum depth for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  lowerDatumDepth?: Maybe<TimeSeries>;
  /** Time series signal representing lower gauge depth for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  lowerGaugeDepth?: Maybe<TimeSeries>;
  /** Time series signal representing lower gauge position for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  lowerGaugePosition?: Maybe<TimeSeries>;
  /** Time series signal representing lower productivity index for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  lowerProductivityIndex?: Maybe<TimeSeries>;
  /** Time series signal representing lower productivity index ss for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  lowerProductivityIndexSS?: Maybe<TimeSeries>;
  /** Time series signal representing lower res press at datum for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  lowerResPressAtDatum?: Maybe<TimeSeries>;
  /** Time series signal representing lower res press at gauge for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  lowerResPressAtGauge?: Maybe<TimeSeries>;
  /** Time series signal representing lower selected gradient for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  lowerSelectedGradient?: Maybe<TimeSeries>;
  /** Time series signal representing lower test type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  lowerTestType?: Maybe<TimeSeries>;
  /** Time series signal representing na datum depth for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  naDatumDepth?: Maybe<TimeSeries>;
  /** Time series signal representing na gauge depth for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  naGaugeDepth?: Maybe<TimeSeries>;
  /** Time series signal representing na gauge position for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  naGaugePosition?: Maybe<TimeSeries>;
  /** Time series signal representing na productivity index for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  naProductivityIndex?: Maybe<TimeSeries>;
  /** Time series signal representing na productivity index ss for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  naProductivityIndexSS?: Maybe<TimeSeries>;
  /** Time series signal representing na res press at datum for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  naResPressAtDatum?: Maybe<TimeSeries>;
  /** Time series signal representing na res press at gauge for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  naResPressAtGauge?: Maybe<TimeSeries>;
  /** Time series signal representing na selected gradient for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  naSelectedGradient?: Maybe<TimeSeries>;
  /** Time series signal representing na test type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  naTestType?: Maybe<TimeSeries>;
  /** Time series signal representing upper datum depth for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  upperDatumDepth?: Maybe<TimeSeries>;
  /** Time series signal representing upper gauge depth for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  upperGaugeDepth?: Maybe<TimeSeries>;
  /** Time series signal representing upper gauge position for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  upperGaugePosition?: Maybe<TimeSeries>;
  /** Time series signal representing upper productivity index for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  upperProductivityIndex?: Maybe<TimeSeries>;
  /** Time series signal representing upper productivity index ss for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  upperProductivityIndexSS?: Maybe<TimeSeries>;
  /** Time series signal representing upper res press at datum for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  upperResPressAtDatum?: Maybe<TimeSeries>;
  /** Time series signal representing upper res press at gauge for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  upperResPressAtGauge?: Maybe<TimeSeries>;
  /** Time series signal representing upper selected gradient for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  upperSelectedGradient?: Maybe<TimeSeries>;
  /** Time series signal representing upper test type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  upperTestType?: Maybe<TimeSeries>;
};

/** Well Test Inputs String view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type WellTestInputsString = {
  /** Time series signal representing cgr lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  cgrLC?: Maybe<TimeSeries>;
  /** Time series signal representing choke alarms for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  chokeAlarms?: Maybe<TimeSeries>;
  /** Time series signal representing choke alarms code for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  chokeAlarmsCode?: Maybe<TimeSeries>;
  /** Time series signal representing choke matchedliquid rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  chokeMatchedliquidRate?: Maybe<TimeSeries>;
  /** Free-text comments field capturing operator or engineer notes related to this measurement, configuration, or event. */
  comments?: Maybe<TimeSeries>;
  /** Time series signal representing composition for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  composition?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Time series signal representing espwear for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espwear?: Maybe<TimeSeries>;
  /** Time series signal representing fluid properties for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  fluidProperties?: Maybe<TimeSeries>;
  /** Time series signal representing formation gor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  formationGOR?: Maybe<TimeSeries>;
  /** Time series signal representing gas density lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasDensityLC?: Maybe<TimeSeries>;
  /** Time series signal representing gas density sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasDensitySC?: Maybe<TimeSeries>;
  /** Time series signal representing gas mass flow rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasMassFlowRateLC?: Maybe<TimeSeries>;
  /** Time series signal representing gas mass flow rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasMassFlowRateSC?: Maybe<TimeSeries>;
  /** Time series signal representing gas volume fraction lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasVolumeFractionLC?: Maybe<TimeSeries>;
  /** Time series signal representing gl fcv outlet temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  glFcvOutletTemp?: Maybe<TimeSeries>;
  /** Time series signal representing glinjection rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  glinjectionRate?: Maybe<TimeSeries>;
  /** Time series signal representing historical alarms for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  historicalAlarms?: Maybe<TimeSeries>;
  /** Time series signal representing historical alarms code for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  historicalAlarmsCode?: Maybe<TimeSeries>;
  /** Time series signal representing last updated by stable period for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  lastUpdatedByStablePeriod?: Maybe<TimeSeries>;
  /** Time series signal representing last updated by well test for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  lastUpdatedByWellTest?: Maybe<TimeSeries>;
  /** Time series signal representing liquid rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  liquidRateLc?: Maybe<TimeSeries>;
  /** Time series signal representing liquid rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  liquidRateSc?: Maybe<TimeSeries>;
  /** Time series signal representing model alarms for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelAlarms?: Maybe<TimeSeries>;
  /** Time series signal representing model alarms code for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelAlarmsCode?: Maybe<TimeSeries>;
  /** Time series signal representing model composition for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelComposition?: Maybe<TimeSeries>;
  /** Time series signal representing model matched bhp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelMatchedBHP?: Maybe<TimeSeries>;
  /** Time series signal representing model matchedgas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelMatchedgasRate?: Maybe<TimeSeries>;
  /** Time series signal representing model matchedliquid rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelMatchedliquidRate?: Maybe<TimeSeries>;
  /** Time series signal representing model matchedoil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelMatchedoilRate?: Maybe<TimeSeries>;
  /** Time series signal representing model matchedwater rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelMatchedwaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing model min stable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelMinStableRate?: Maybe<TimeSeries>;
  /** Time series signal representing model productivity index for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelProductivityIndex?: Maybe<TimeSeries>;
  /** Time series signal representing model reservoir model for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelReservoirModel?: Maybe<TimeSeries>;
  /** Time series signal representing model reservoir pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelReservoirPressure?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  modelStabilityFlag?: Maybe<TimeSeries>;
  /** Time series signal representing model vlp model for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelVlpModel?: Maybe<TimeSeries>;
  /** Time series signal representing model well test timestamp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelWellTestTimestamp?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm alarms for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmAlarms?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm differential pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmDifferentialPressure?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm line pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmLinePressure?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm line temperature for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmLineTemperature?: Maybe<TimeSeries>;
  /** Time series signal representing oil density lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilDensityLC?: Maybe<TimeSeries>;
  /** Time series signal representing oil density sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilDensitySC?: Maybe<TimeSeries>;
  /** Time series signal representing oil mass flow rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilMassFlowRateLC?: Maybe<TimeSeries>;
  /** Time series signal representing oil mass flow rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilMassFlowRateSC?: Maybe<TimeSeries>;
  /** Time series signal representing oil volume fraction lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilVolumeFractionLC?: Maybe<TimeSeries>;
  /** Time series signal representing pts date time for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  ptsDateTime?: Maybe<TimeSeries>;
  /** Time series signal representing pump discharge temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pumpDischargeTemp?: Maybe<TimeSeries>;
  /** Time series signal representing pump motor temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pumpMotorTemp?: Maybe<TimeSeries>;
  /** Time series signal representing pump power for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pumpPower?: Maybe<TimeSeries>;
  /** Time series signal representing pump vibration for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pumpVibration?: Maybe<TimeSeries>;
  /** Time series signal representing pvt alarms for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pvtAlarms?: Maybe<TimeSeries>;
  /** Time series signal representing sample date time for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  sampleDateTime?: Maybe<TimeSeries>;
  /** Time series signal representing stable period end date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  stablePeriodEndDate?: Maybe<TimeSeries>;
  /** Time series signal representing stable period start date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  stablePeriodStartDate?: Maybe<TimeSeries>;
  /** Time series signal representing validated by for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  validatedBy?: Maybe<TimeSeries>;
  /** Time series signal representing water density lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterDensityLC?: Maybe<TimeSeries>;
  /** Time series signal representing water density sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterDensitySC?: Maybe<TimeSeries>;
  /** Time series signal representing water mass flow rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterMassFlowRateLC?: Maybe<TimeSeries>;
  /** Time series signal representing water mass flow rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterMassFlowRateSC?: Maybe<TimeSeries>;
  /** Time series signal representing water volume fraction lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterVolumeFractionLC?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  wellTestApprovedAllocationFlag?: Maybe<TimeSeries>;
  /** Time series signal representing well test artificial lift type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestArtificialLiftType?: Maybe<TimeSeries>;
  /** Time series signal representing well test bottom hole pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestBottomHolePressure?: Maybe<TimeSeries>;
  /** Time series signal representing well test bottom hole temperature for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestBottomHoleTemperature?: Maybe<TimeSeries>;
  /** Time series signal representing well test cgr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestCGR?: Maybe<TimeSeries>;
  /** Time series signal representing well test casing head pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestCasingHeadPressure?: Maybe<TimeSeries>;
  /** Time series signal representing well test casing head temperature for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestCasingHeadTemperature?: Maybe<TimeSeries>;
  /** Time series signal representing well test choke opening for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestChokeOpening?: Maybe<TimeSeries>;
  /** Time series signal representing well test choke size for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestChokeSize?: Maybe<TimeSeries>;
  /** Time series signal representing well test duration for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestDuration?: Maybe<TimeSeries>;
  /** Time series signal representing well test egor vendor std gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEgorVendorStdGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing well test egor vendor std oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEgorVendorStdOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing well test egor vendor std water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEgorVendorStdWaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing well test end date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEndDate?: Maybe<TimeSeries>;
  /** Time series signal representing well test esp motor current for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEspMotorCurrent?: Maybe<TimeSeries>;
  /** Time series signal representing well test esp motor power for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEspMotorPower?: Maybe<TimeSeries>;
  /** Time series signal representing well test esp motor voltage for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEspMotorVoltage?: Maybe<TimeSeries>;
  /** Time series signal representing well test esp pump discharge pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEspPumpDischargePressure?: Maybe<TimeSeries>;
  /** Time series signal representing well test esp pump frequency for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEspPumpFrequency?: Maybe<TimeSeries>;
  /** Time series signal representing well test esp pump intake pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEspPumpIntakePressure?: Maybe<TimeSeries>;
  /** Time series signal representing well test esp pump intake temperature for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEspPumpIntakeTemperature?: Maybe<TimeSeries>;
  /** Time series signal representing well test flowline pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestFlowlinePressure?: Maybe<TimeSeries>;
  /** Time series signal representing well test flowline temperature for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestFlowlineTemperature?: Maybe<TimeSeries>;
  /** Time series signal representing well test gor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGOR?: Maybe<TimeSeries>;
  /** Time series signal representing well test gas density in situ for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGasDensityInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing well test gas lift volume for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGasLiftVolume?: Maybe<TimeSeries>;
  /** Time series signal representing well test gas rate insitu for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGasRateInsitu?: Maybe<TimeSeries>;
  /** Time series signal representing well test gas rate pts for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGasRatePts?: Maybe<TimeSeries>;
  /** Time series signal representing well test gas rate std for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGasRateStd?: Maybe<TimeSeries>;
  /** Time series signal representing well test gl fl control valv outlet pres for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGlFlControlValvOutletPres?: Maybe<TimeSeries>;
  /** Time series signal representing well test gl fl control valve inlet pres for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGlFlControlValveInletPres?: Maybe<TimeSeries>;
  /** Time series signal representing well test gl fl control valve inlet temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGlFlControlValveInletTemp?: Maybe<TimeSeries>;
  /** Time series signal representing well test gl injection choke opening for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGlInjectionChokeOpening?: Maybe<TimeSeries>;
  /** Time series signal representing well test gl injection choke size for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGlInjectionChokeSize?: Maybe<TimeSeries>;
  /** Time series signal representing well test gor insitu for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGorInsitu?: Maybe<TimeSeries>;
  /** Time series signal representing well test gor pts for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGorPts?: Maybe<TimeSeries>;
  /** Time series signal representing well test liquid rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestLiquidRateLC?: Maybe<TimeSeries>;
  /** Time series signal representing well test liquid rate pts for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestLiquidRatePts?: Maybe<TimeSeries>;
  /** Time series signal representing well test liquid rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestLiquidRateSC?: Maybe<TimeSeries>;
  /** Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  wellTestMpfmName?: Maybe<TimeSeries>;
  /** Time series signal representing well test oil density in situ for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestOilDensityInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing well test oil rate insitu for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestOilRateInsitu?: Maybe<TimeSeries>;
  /** Time series signal representing well test oil rate pts for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestOilRatePts?: Maybe<TimeSeries>;
  /** Time series signal representing well test oil rate std for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestOilRateStd?: Maybe<TimeSeries>;
  /** Time series signal representing well test start date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestStartDate?: Maybe<TimeSeries>;
  /** Time series signal representing well test start date dh for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestStartDateDH?: Maybe<TimeSeries>;
  /** Text describing the functional role of the production string (for example main producer, backup, injector, idle), used in surveillance and planning. */
  wellTestStringFunction?: Maybe<TimeSeries>;
  /** Time series signal representing well test test method for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTestMethod?: Maybe<TimeSeries>;
  /** Time series signal representing well test test separator line pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTestSeparatorLinePressure?: Maybe<TimeSeries>;
  /** Time series signal representing well test test separator line temperature for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTestSeparatorLineTemperature?: Maybe<TimeSeries>;
  /** Time series signal representing well test test type for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTestType?: Maybe<TimeSeries>;
  /** Time series signal representing well test test type desc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTestTypeDesc?: Maybe<TimeSeries>;
  /** Time series signal representing well test total gor std for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTotalGorStd?: Maybe<TimeSeries>;
  /** Time series signal representing well test total mass flow rate gas for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTotalMassFlowRateGas?: Maybe<TimeSeries>;
  /** Time series signal representing well test total mass flow rate oil for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTotalMassFlowRateOil?: Maybe<TimeSeries>;
  /** Time series signal representing well test total mass flow rate water for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTotalMassFlowRateWater?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  wellTestValidationFlag?: Maybe<TimeSeries>;
  /** Time series signal representing well test wgr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWGR?: Maybe<TimeSeries>;
  /** Time series signal representing well test water cut for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterCut?: Maybe<TimeSeries>;
  /** Time series signal representing well test water cut insitu for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterCutInsitu?: Maybe<TimeSeries>;
  /** Time series signal representing well test water cut pts for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterCutPts?: Maybe<TimeSeries>;
  /** Time series signal representing well test water rate insitu for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterRateInsitu?: Maybe<TimeSeries>;
  /** Time series signal representing well test water rate pts for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterRatePts?: Maybe<TimeSeries>;
  /** Time series signal representing well test water rate std for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterRateStd?: Maybe<TimeSeries>;
  /** Time series signal representing well test wellhead pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWellheadPressure?: Maybe<TimeSeries>;
  /** Time series signal representing well test wellhead temperature for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWellheadTemperature?: Maybe<TimeSeries>;
  /** Time series signal representing wgr lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wgrLC?: Maybe<TimeSeries>;
  /** Time series signal representing wlr lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wlrLC?: Maybe<TimeSeries>;
};

/** Aggregated outputs from individual well tests for each well string, including test timing, multiphase rates at standard and line conditions, derived ratios (GOR, WCT), phase densities and mass flow rates used for well performance and model calibration. */
export type WellTestOutputsString = {
  /** Time series signal representing cd value for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  cdValue?: Maybe<TimeSeries>;
  /** Time series signal representing cgr lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  cgrLC?: Maybe<TimeSeries>;
  /** Time series signal representing cgr sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  cgrSC?: Maybe<TimeSeries>;
  /** Time series signal representing choke alarms for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  chokeAlarms?: Maybe<TimeSeries>;
  /** Time series signal representing choke alarms code for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  chokeAlarmsCode?: Maybe<TimeSeries>;
  /** Time series signal representing choke matchedgas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  chokeMatchedgasRate?: Maybe<TimeSeries>;
  /** Time series signal representing choke matchedliquid rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  chokeMatchedliquidRate?: Maybe<TimeSeries>;
  /** Time series signal representing choke size for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  chokeSize?: Maybe<TimeSeries>;
  /** Time series signal representing choke size inch for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  chokeSizeInch?: Maybe<TimeSeries>;
  /** Time series signal representing chp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  chp?: Maybe<TimeSeries>;
  /** Time series signal representing dhgp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  dhgp?: Maybe<TimeSeries>;
  /** Time series signal representing dhgt for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  dhgt?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Time series signal representing espwear for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  espwear?: Maybe<TimeSeries>;
  /** Time series signal representing flp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  flp?: Maybe<TimeSeries>;
  /** Time series signal representing flt for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  flt?: Maybe<TimeSeries>;
  /** Time series signal representing gas density lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasDensityLC?: Maybe<TimeSeries>;
  /** Time series signal representing gas density sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasDensitySC?: Maybe<TimeSeries>;
  /** Time series signal representing gas mass flow rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasMassFlowRateLC?: Maybe<TimeSeries>;
  /** Time series signal representing gas mass flow rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasMassFlowRateSC?: Maybe<TimeSeries>;
  /** Time series signal representing gas rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasRateLC?: Maybe<TimeSeries>;
  /** Time series signal representing gas rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasRateSC?: Maybe<TimeSeries>;
  /** Time series signal representing gas volume fraction lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasVolumeFractionLC?: Maybe<TimeSeries>;
  /** Time series signal representing gl fcv choke size for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  glFcvChokeSize?: Maybe<TimeSeries>;
  /** Time series signal representing gl fcv inlet press for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  glFcvInletPress?: Maybe<TimeSeries>;
  /** Time series signal representing gl fcv inlet temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  glFcvInletTemp?: Maybe<TimeSeries>;
  /** Time series signal representing gl fcv outlet press for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  glFcvOutletPress?: Maybe<TimeSeries>;
  /** Time series signal representing gl fcv outlet temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  glFcvOutletTemp?: Maybe<TimeSeries>;
  /** Time series signal representing glinjection rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  glinjectionRate?: Maybe<TimeSeries>;
  /** Time series signal representing gor lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gorLC?: Maybe<TimeSeries>;
  /** Time series signal representing historical alarms for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  historicalAlarms?: Maybe<TimeSeries>;
  /** Time series signal representing historical alarms code for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  historicalAlarmsCode?: Maybe<TimeSeries>;
  /** Time series signal representing liquid rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  liquidRateLc?: Maybe<TimeSeries>;
  /** Time series signal representing liquid rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  liquidRateSc?: Maybe<TimeSeries>;
  /** Time series signal representing model alarms for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelAlarms?: Maybe<TimeSeries>;
  /** Time series signal representing model alarms code for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelAlarmsCode?: Maybe<TimeSeries>;
  /** Time series signal representing model matched bhp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelMatchedBHP?: Maybe<TimeSeries>;
  /** Time series signal representing model matchedgas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelMatchedgasRate?: Maybe<TimeSeries>;
  /** Time series signal representing model matchedliquid rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelMatchedliquidRate?: Maybe<TimeSeries>;
  /** Time series signal representing model matchedoil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelMatchedoilRate?: Maybe<TimeSeries>;
  /** Time series signal representing model matchedwater rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelMatchedwaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing model min stable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelMinStableRate?: Maybe<TimeSeries>;
  /** Time series signal representing model productivity index for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelProductivityIndex?: Maybe<TimeSeries>;
  /** Time series signal representing model reservoir model for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelReservoirModel?: Maybe<TimeSeries>;
  /** Time series signal representing model reservoir pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelReservoirPressure?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  modelStabilityFlag?: Maybe<TimeSeries>;
  /** Attribute capturing model vlp model for this production string in the production optimization context. */
  modelVlpModel?: Maybe<Scalars['Timestamp']['output']>;
  /** Time series signal representing model well test timestamp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelWellTestTimestamp?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfm?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm alarms for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmAlarms?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm differential pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmDifferentialPressure?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm line pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmLinePressure?: Maybe<TimeSeries>;
  /** Time series signal representing mpfm line temperature for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  mpfmLineTemperature?: Maybe<TimeSeries>;
  /** Time series signal representing oil density lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilDensityLC?: Maybe<TimeSeries>;
  /** Time series signal representing oil density sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilDensitySC?: Maybe<TimeSeries>;
  /** Time series signal representing oil mass flow rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilMassFlowRateLC?: Maybe<TimeSeries>;
  /** Time series signal representing oil mass flow rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilMassFlowRateSC?: Maybe<TimeSeries>;
  /** Time series signal representing oil rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilRateLC?: Maybe<TimeSeries>;
  /** Time series signal representing oil rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilRateSC?: Maybe<TimeSeries>;
  /** Time series signal representing oil volume fraction lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  oilVolumeFractionLC?: Maybe<TimeSeries>;
  /** Time series signal representing pump current for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pumpCurrent?: Maybe<TimeSeries>;
  /** Time series signal representing pump discharge press for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pumpDischargePress?: Maybe<TimeSeries>;
  /** Time series signal representing pump discharge temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pumpDischargeTemp?: Maybe<TimeSeries>;
  /** Time series signal representing pump frequency for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pumpFrequency?: Maybe<TimeSeries>;
  /** Time series signal representing pump intake press for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pumpIntakePress?: Maybe<TimeSeries>;
  /** Time series signal representing pump intake temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pumpIntakeTemp?: Maybe<TimeSeries>;
  /** Time series signal representing pump motor temp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pumpMotorTemp?: Maybe<TimeSeries>;
  /** Time series signal representing pump power for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pumpPower?: Maybe<TimeSeries>;
  /** Time series signal representing pump vibration for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pumpVibration?: Maybe<TimeSeries>;
  /** Time series signal representing pump voltage for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pumpVoltage?: Maybe<TimeSeries>;
  /** Time series signal representing pvt alarms for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pvtAlarms?: Maybe<TimeSeries>;
  /** Time series signal representing pvt alarms code for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  pvtAlarmsCode?: Maybe<TimeSeries>;
  /** Time series signal representing stable period end date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  stablePeriodEndDate?: Maybe<TimeSeries>;
  /** Time series signal representing stable period start date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  stablePeriodStartDate?: Maybe<TimeSeries>;
  /** Time series signal representing total gor sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  totalGorSC?: Maybe<TimeSeries>;
  /** Time series signal representing water cut lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterCutLC?: Maybe<TimeSeries>;
  /** Time series signal representing water cut sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterCutSC?: Maybe<TimeSeries>;
  /** Time series signal representing water density lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterDensityLC?: Maybe<TimeSeries>;
  /** Time series signal representing water density sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterDensitySC?: Maybe<TimeSeries>;
  /** Time series signal representing water mass flow rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterMassFlowRateLC?: Maybe<TimeSeries>;
  /** Time series signal representing water mass flow rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterMassFlowRateSC?: Maybe<TimeSeries>;
  /** Time series signal representing water rate lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterRateLC?: Maybe<TimeSeries>;
  /** Time series signal representing water rate sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterRateSC?: Maybe<TimeSeries>;
  /** Time series signal representing water volume fraction lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  waterVolumeFractionLC?: Maybe<TimeSeries>;
  /** Time series signal representing well test end date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEndDate?: Maybe<TimeSeries>;
  /** Time series signal representing well test start date for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestStartDate?: Maybe<TimeSeries>;
  /** Time series signal representing well test start date dh for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestStartDateDH?: Maybe<TimeSeries>;
  /** Time series signal representing wgr lc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wgrLC?: Maybe<TimeSeries>;
  /** Time series signal representing wgr sc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wgrSC?: Maybe<TimeSeries>;
  /** Time series signal representing whp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  whp?: Maybe<TimeSeries>;
  /** Time series signal representing wht for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wht?: Maybe<TimeSeries>;
};

/**
 * Prosper model tuning parameters from well test analysis including VLP, IPR,
 * and ESP wear.
 *
 * Contains detailed parameters derived from well test analysis, focusing on the
 * tuning of Prosper models for various well types, including vertical lift
 * performance (VLP), inflow performance relationship (IPR), and electrical
 * submersible pump (ESP) wear factors. Sourced from well test results and model
 * calibration processes, enabling production specialists to assess and optimize
 * well performance. It answers specific questions regarding the correlations and
 * parameters used in VLP and IPR models, as well as the wear factors for ESP
 * systems, while it excludes raw test data or historical performance metrics
 * found in other views. Use cases: quality control of models, trend analysis for
 * performance optimization, and tracking pump degradation over time.
 *
 * @name Well Test Model Parameters (Agent)
 */
export type WellTestModelParametersAgent = {
  /**
   * Flag indicating this string has an active Prosper model. True = model exists and
   * calibration outputs are available.
   */
  hasProsperModel?: Maybe<Scalars['Boolean']['output']>;
  /**
   *   ESP pump wear factor (TS). 1.0 = new pump performance.
   *   < 0.7 indicates significant pump degradation - consider workover.
   *   Track trend over time for predictive maintenance.
   *
   * @name espWearFactor
   */
  modelEspWf?: Maybe<TimeSeries>;
  /**
   *   Percent change in ESP wear factor (%, TS). Declining WF = pump wearing.
   *
   * @name espWearFactorChange
   */
  modelEspWfPercentChange?: Maybe<TimeSeries>;
  /**
   *   Gas lift orifice size from model (inches, TS). Should match actual installed size.
   *
   * @name glOrificeSize
   */
  modelGlOrificeSize?: Maybe<TimeSeries>;
  /**
   *   Percent change in orifice size (%, TS). Large change may indicate multipoint issue.
   *
   * @name glOrificeSizeChange
   */
  modelGlOrificeSizePercentChange?: Maybe<TimeSeries>;
  /**
   *   IPR C coefficient (TS). From backpressure equation: Q = C * (PrÂ² - PwfÂ²)^n.
   *   Related to deliverability - higher C = better inflow.
   *
   * @name iprCoefficientC
   */
  modelIprC?: Maybe<TimeSeries>;
  /**
   *   IPR n exponent (TS). Typically 0.5 to 1.0.
   *   n=1 = Darcy flow (linear). n<1 = non-Darcy/turbulent near wellbore.
   *
   * @name iprExponentN
   */
  modelIprN?: Maybe<TimeSeries>;
  /**
   *   Indicates whether the well test rate was matched during the WF03 calibration process (TS).
   *   Values: MATCHED, FAILED, MANUAL. Use to filter for successfully calibrated well tests.
   *
   * @name matchStatus
   */
  modelMatchStatus?: Maybe<TimeSeries>;
  /**
   *   Reservoir model type used (TS). E.g., 'Vogel', 'Fetkovitch', 'Jones'.
   *
   * @name reservoirModelType
   */
  modelReservoirModel?: Maybe<TimeSeries>;
  /**
   *   Prosper model revision number (TS). Track model updates.
   *
   * @name modelRevision
   */
  modelRevisionNumber?: Maybe<TimeSeries>;
  /**
   *   Overall heat transfer coefficient U-value (BTU/hr/ft2/degF, TS). Affects
   *   temperature profile and flow assurance calculations.
   *
   * @name overallHeatTransferCoeff
   */
  modelUval?: Maybe<TimeSeries>;
  /**
   *   VLP correlation used (TS). E.g., 'Beggs and Brill', 'Hagedorn Brown', 'Petroleum Experts'.
   *   Different correlations work better for different conditions.
   *
   * @name vlpCorrelation
   */
  modelVlpCorrelation?: Maybe<TimeSeries>;
  /**
   *   VLP tuning parameter 1 (TS). Typically friction factor multiplier.
   *   Together with modelMatchStatus, indicates whether the well test rate was successfully
   *   matched during WF03 calibration. Values > 1.5 or < 0.5 may indicate model issues.
   *
   * @name vlpParameter1
   */
  modelVlpParameter1?: Maybe<TimeSeries>;
  /**
   *   Percent change in VLP parameter 1 (%, TS). Large changes may indicate tubing issues.
   *
   * @name vlpParam1Change
   */
  modelVlpParameter1PercentChange?: Maybe<TimeSeries>;
  /**
   *   VLP tuning parameter 2 (TS). Typically holdup factor multiplier.
   *
   * @name vlpParameter2
   */
  modelVlpParameter2?: Maybe<TimeSeries>;
  /**
   *   Percent change in VLP parameter 2 (%, TS).
   *
   * @name vlpParam2Change
   */
  modelVlpParameter2PercentChange?: Maybe<TimeSeries>;
  /**
   *   ESP frequency during model match (Hz, TS). Reference point for analysis.
   *
   * @name espTestFrequency
   */
  modelWellTestEspFrequency?: Maybe<TimeSeries>;
  /**
   *   Gas lift injection rate used in model (MMscfd, TS).
   *
   * @name glInjectionRate
   */
  modelWellTestGlInjection?: Maybe<TimeSeries>;
  /**
   * External ID of the associated ProsperModel instance. Use to cross-reference with
   * ProsperModel_Agent for model metadata.
   */
  prosperModelExternalId?: Maybe<Scalars['String']['output']>;
  /** Reference to well string. Join to FlatHierarchy_Agent for field/reservoir context. */
  wellString?: Maybe<StringAsset>;
};

/** Well Test Raw view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type WellTestRaw = {
  /** Free-text comments field capturing operator or engineer notes related to this measurement, configuration, or event. */
  comments?: Maybe<TimeSeries>;
  /** Time series signal representing composition for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  composition?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Time series signal representing fluid properties for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  fluidProperties?: Maybe<TimeSeries>;
  /** Time series signal representing model composition for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelComposition?: Maybe<TimeSeries>;
  /** Time series signal representing pts date time for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  ptsDateTime?: Maybe<TimeSeries>;
  /** Time series signal representing sample date time for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  sampleDateTime?: Maybe<TimeSeries>;
  /** Time series signal representing stable period end date for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  stablePeriodEndDate?: Maybe<TimeSeries>;
  /** Time series signal representing stable period start date for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  stablePeriodStartDate?: Maybe<TimeSeries>;
  /** Time series signal representing validated by for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  validatedBy?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  wellTestApprovedAllocationFlag?: Maybe<TimeSeries>;
  /** Time series signal representing well test artificial lift type for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestArtificialLiftType?: Maybe<TimeSeries>;
  /** Time series signal representing well test bottom hole pressure for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestBottomHolePressure?: Maybe<TimeSeries>;
  /** Time series signal representing well test bottom hole temperature for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestBottomHoleTemperature?: Maybe<TimeSeries>;
  /** Time series signal representing well test cgr for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestCGR?: Maybe<TimeSeries>;
  /** Time series signal representing well test casing head pressure for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestCasingHeadPressure?: Maybe<TimeSeries>;
  /** Time series signal representing well test casing head temperature for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestCasingHeadTemperature?: Maybe<TimeSeries>;
  /** Time series signal representing well test choke opening for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestChokeOpening?: Maybe<TimeSeries>;
  /** Time series signal representing well test choke size for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestChokeSize?: Maybe<TimeSeries>;
  /** Time series signal representing well test duration for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestDuration?: Maybe<TimeSeries>;
  /** Time series signal representing well test egor vendor std gas rate for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEgorVendorStdGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing well test egor vendor std oil rate for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEgorVendorStdOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing well test egor vendor std water rate for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEgorVendorStdWaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing well test end date for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEndDate?: Maybe<TimeSeries>;
  /** Time series signal representing well test esp motor current for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEspMotorCurrent?: Maybe<TimeSeries>;
  /** Time series signal representing well test esp motor power for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEspMotorPower?: Maybe<TimeSeries>;
  /** Time series signal representing well test esp motor voltage for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEspMotorVoltage?: Maybe<TimeSeries>;
  /** Time series signal representing well test esp pump discharge pressure for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEspPumpDischargePressure?: Maybe<TimeSeries>;
  /** Time series signal representing well test esp pump frequency for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEspPumpFrequency?: Maybe<TimeSeries>;
  /** Time series signal representing well test esp pump intake pressure for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEspPumpIntakePressure?: Maybe<TimeSeries>;
  /** Time series signal representing well test esp pump intake temperature for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestEspPumpIntakeTemperature?: Maybe<TimeSeries>;
  /** Time series signal representing well test flowline pressure for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestFlowlinePressure?: Maybe<TimeSeries>;
  /** Time series signal representing well test flowline temperature for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestFlowlineTemperature?: Maybe<TimeSeries>;
  /** Time series signal representing well test gor for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGOR?: Maybe<TimeSeries>;
  /** Time series signal representing well test gas density in situ for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGasDensityInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing well test gas lift volume for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGasLiftVolume?: Maybe<TimeSeries>;
  /** Time series signal representing well test gas rate insitu for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGasRateInsitu?: Maybe<TimeSeries>;
  /** Time series signal representing well test gas rate pts for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGasRatePts?: Maybe<TimeSeries>;
  /** Time series signal representing well test gas rate std for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGasRateStd?: Maybe<TimeSeries>;
  /** Time series signal representing well test gl fl control valv outlet pres for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGlFlControlValvOutletPres?: Maybe<TimeSeries>;
  /** Time series signal representing well test gl fl control valve inlet pres for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGlFlControlValveInletPres?: Maybe<TimeSeries>;
  /** Time series signal representing well test gl fl control valve inlet temp for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGlFlControlValveInletTemp?: Maybe<TimeSeries>;
  /** Time series signal representing well test gl injection choke opening for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGlInjectionChokeOpening?: Maybe<TimeSeries>;
  /** Time series signal representing well test gor insitu for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGorInsitu?: Maybe<TimeSeries>;
  /** Time series signal representing well test gor pts for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestGorPts?: Maybe<TimeSeries>;
  /** Time series signal representing well test liquid rate pts for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestLiquidRatePts?: Maybe<TimeSeries>;
  /** Name or label for this well, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  wellTestMpfmName?: Maybe<TimeSeries>;
  /** Time series signal representing well test oil density in situ for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestOilDensityInSitu?: Maybe<TimeSeries>;
  /** Time series signal representing well test oil rate insitu for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestOilRateInsitu?: Maybe<TimeSeries>;
  /** Time series signal representing well test oil rate pts for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestOilRatePts?: Maybe<TimeSeries>;
  /** Time series signal representing well test oil rate std for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestOilRateStd?: Maybe<TimeSeries>;
  /** Time series signal representing well test start date for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestStartDate?: Maybe<TimeSeries>;
  /** Text describing the functional role of the production string (for example main producer, backup, injector, idle), used in surveillance and planning. */
  wellTestStringFunction?: Maybe<TimeSeries>;
  /** Time series signal representing well test test method for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTestMethod?: Maybe<TimeSeries>;
  /** Time series signal representing well test test separator line pressure for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTestSeparatorLinePressure?: Maybe<TimeSeries>;
  /** Time series signal representing well test test separator line temperature for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTestSeparatorLineTemperature?: Maybe<TimeSeries>;
  /** Time series signal representing well test test type for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTestType?: Maybe<TimeSeries>;
  /** Time series signal representing well test test type desc for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTestTypeDesc?: Maybe<TimeSeries>;
  /** Time series signal representing well test total gor std for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTotalGorStd?: Maybe<TimeSeries>;
  /** Time series signal representing well test total mass flow rate gas for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTotalMassFlowRateGas?: Maybe<TimeSeries>;
  /** Time series signal representing well test total mass flow rate oil for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTotalMassFlowRateOil?: Maybe<TimeSeries>;
  /** Time series signal representing well test total mass flow rate water for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestTotalMassFlowRateWater?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  wellTestValidationFlag?: Maybe<TimeSeries>;
  /** Time series signal representing well test wgr for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWGR?: Maybe<TimeSeries>;
  /** Time series signal representing well test water cut for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterCut?: Maybe<TimeSeries>;
  /** Time series signal representing well test water cut insitu for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterCutInsitu?: Maybe<TimeSeries>;
  /** Time series signal representing well test water cut pts for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterCutPts?: Maybe<TimeSeries>;
  /** Time series signal representing well test water rate insitu for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterRateInsitu?: Maybe<TimeSeries>;
  /** Time series signal representing well test water rate pts for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterRatePts?: Maybe<TimeSeries>;
  /** Time series signal representing well test water rate std for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWaterRateStd?: Maybe<TimeSeries>;
  /** Time series signal representing well test wellhead pressure for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWellheadPressure?: Maybe<TimeSeries>;
  /** Time series signal representing well test wellhead temperature for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  wellTestWellheadTemperature?: Maybe<TimeSeries>;
};

/**
 * Reservoir performance from well test analysis including PI, II, and reservoir
 * pressure.
 *
 * Contains data derived from well test analyses, focusing on key performance
 * indicators such as the Productivity Index (PI), Injectivity Index (II), and
 * reservoir pressure metrics. Sourced from field tests conducted on production
 * and injection wells, allowing for the assessment of reservoir deliverability
 * and performance over time. It answers critical questions regarding changes in
 * PI, reservoir pressure trends, and the efficiency of reservoir depletion, but
 * excludes detailed geological data or historical production rates found in
 * other views. Use cases: monitoring reservoir performance, identifying wells
 * with declining efficiency, and comparing performance across different fields.
 *
 * @name Well Test Reservoir Analysis (Agent)
 */
export type WellTestReservoirAnalysisAgent = {
  /**
   *   Injectivity Index - II (bbl/d/psi, TS). For water/gas injectors.
   *   II = Qinj / (Pwf - Pr). HIGHER II = better injection efficiency.
   *
   * @name injectivityIndex
   */
  modelInjectivityIndex?: Maybe<TimeSeries>;
  /**
   *   Percent change in II from previous test (%, TS).
   *   Declining II may indicate: formation damage, scale, or plugging.
   *
   * @name iiPercentChange
   */
  modelInjectivityIndexPercentChange?: Maybe<TimeSeries>;
  /**
   *   Minimum rate for stable flow (stb/d, TS). Below this = slugging risk.
   *
   * @name minimumStableRate
   */
  modelMinStableRate?: Maybe<TimeSeries>;
  /**
   *   Productivity Index - PI (stb/d/psi, TS).
   *   PI = Q / (Pr - Pwf) where Q=liquid rate, Pr=reservoir pressure, Pwf=flowing BHP.
   *   HIGHER PI = better reservoir deliverability.
   *   Compare across wells in same reservoir for benchmarking.
   *
   * @name productivityIndex
   */
  modelProductivityIndex?: Maybe<TimeSeries>;
  /**
   *   Percent change in PI from previous accepted test (%, TS).
   *   NEGATIVE = PI declined (possible causes: scale, skin, depletion).
   *   > -20% decline warrants investigation.
   *
   * @name piPercentChange
   */
  modelProductivityIndexPercentChange?: Maybe<TimeSeries>;
  /**
   *   Static reservoir pressure from analysis (psia, TS).
   *   Declining Pres = depletion. Compare to neighboring wells for aquifer/pressure support.
   *
   * @name reservoirPressure
   */
  modelReservoirPressure?: Maybe<TimeSeries>;
  /**
   *   Percent change in reservoir pressure (%, TS).
   *   Rapid decline may indicate: poor sweep, inadequate injection support.
   *
   * @name reservoirPressureChange
   */
  modelReservoirPressurePercentChange?: Maybe<TimeSeries>;
  /**
   *   Is well operating in stable regime? (TS). STABLE, UNSTABLE, TRANSIENT.
   *   Unstable wells may have PI calculation issues.
   *
   * @name stabilityFlag
   */
  modelStabilityFlag?: Maybe<TimeSeries>;
  /**
   *   Status of analysis result (TS). ACCEPTED, PENDING, REJECTED.
   *   Only use ACCEPTED results for reservoir surveillance.
   *
   * @name analysisStatus
   */
  modelStatus?: Maybe<TimeSeries>;
  /**
   *   When this analysis was performed (TS). Use to check analysis freshness.
   *
   * @name analysisTimestamp
   */
  modelWellTestTimestamp?: Maybe<TimeSeries>;
  /** Reference to well string. Join to FlatHierarchy_Agent for reservoir grouping. */
  wellString?: Maybe<StringAsset>;
};

/** Well Choke Mapping view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type WellChokeMapping = {
  /** Time series signal representing choketype for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  choketype?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Time series signal representing gas lift choke type for this well, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  gasLiftChokeType?: Maybe<TimeSeries>;
};

/** WF3 well string model outputs and configuration identifiers, including productivity and injectivity indices, modelled reservoir pressures, minimum stable rates and links to the underlying reservoir and VLP model versions used for simulation and calibration. */
export type Wf3OutputsString = {
  /** Time series signal representing choke best gor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  chokeBestGor?: Maybe<TimeSeries>;
  /** Time series signal representing choke best wc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  chokeBestWc?: Maybe<TimeSeries>;
  /** Time series signal representing choke best wgr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  chokeBestWgr?: Maybe<TimeSeries>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Time series signal representing model esp wf for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelEspWf?: Maybe<TimeSeries>;
  /** Time series signal representing model esp wf percent change for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelEspWfPercentChange?: Maybe<TimeSeries>;
  /** Time series signal representing model estimated fbhp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelEstimatedFbhp?: Maybe<TimeSeries>;
  /** Time series signal representing model estimated gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelEstimatedGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing model estimated liquid rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelEstimatedLiquidRate?: Maybe<TimeSeries>;
  /** Time series signal representing model estimated oil rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelEstimatedOilRate?: Maybe<TimeSeries>;
  /** Time series signal representing model estimated pdg press for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelEstimatedPdgPress?: Maybe<TimeSeries>;
  /** Time series signal representing model estimated pdp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelEstimatedPdp?: Maybe<TimeSeries>;
  /** Time series signal representing model estimated pip for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelEstimatedPip?: Maybe<TimeSeries>;
  /** Time series signal representing model estimated water rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelEstimatedWaterRate?: Maybe<TimeSeries>;
  /** Time series signal representing model gl orifice size for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelGlOrificeSize?: Maybe<TimeSeries>;
  /** Time series signal representing model gl orifice size percent change for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelGlOrificeSizePercentChange?: Maybe<TimeSeries>;
  /** Time series signal representing model injectivity index for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelInjectivityIndex?: Maybe<TimeSeries>;
  /** Time series signal representing model injectivity index percent change for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelInjectivityIndexPercentChange?: Maybe<TimeSeries>;
  /** Time series signal representing model ipr c for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelIprC?: Maybe<TimeSeries>;
  /** Time series signal representing model ipr n for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelIprN?: Maybe<TimeSeries>;
  /** Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  modelMatchStatus?: Maybe<TimeSeries>;
  /** Time series signal representing model min stable rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelMinStableRate?: Maybe<TimeSeries>;
  /** Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  modelNewFileId?: Maybe<Scalars['Int64']['output']>;
  /** Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  modelOriginalFileId?: Maybe<Scalars['Int64']['output']>;
  /** Time series signal representing model productivity index for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelProductivityIndex?: Maybe<TimeSeries>;
  /** Time series signal representing model productivity index percent change for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelProductivityIndexPercentChange?: Maybe<TimeSeries>;
  /** Time series signal representing model reservoir model for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelReservoirModel?: Maybe<TimeSeries>;
  /** Time series signal representing model reservoir pressure for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelReservoirPressure?: Maybe<TimeSeries>;
  /** Time series signal representing model reservoir pressure percent change for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelReservoirPressurePercentChange?: Maybe<TimeSeries>;
  /** Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  modelRevisionExternalId?: Maybe<TimeSeries>;
  /** Time series signal representing model revision number for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelRevisionNumber?: Maybe<TimeSeries>;
  /** Boolean flag indicating whether a particular condition, quality, or classification is true for this record (1 = true/active, 0 = false/inactive). */
  modelStabilityFlag?: Maybe<TimeSeries>;
  /** Operational status for this production string (for example onstream, shut-in, test, unstable), used to qualify production data and drive surveillance logic. */
  modelStatus?: Maybe<TimeSeries>;
  /** Time series signal representing model uval for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelUval?: Maybe<TimeSeries>;
  /** Time series signal representing model vlp correlation for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelVlpCorrelation?: Maybe<TimeSeries>;
  /** Attribute capturing model vlp model for this production string in the production optimization context. */
  modelVlpModel?: Maybe<Scalars['Timestamp']['output']>;
  /** Time series signal representing model vlp parameter1 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelVlpParameter1?: Maybe<TimeSeries>;
  /** Time series signal representing model vlp parameter1 percent change for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelVlpParameter1PercentChange?: Maybe<TimeSeries>;
  /** Time series signal representing model vlp parameter2 for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelVlpParameter2?: Maybe<TimeSeries>;
  /** Time series signal representing model vlp parameter2 percent change for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelVlpParameter2PercentChange?: Maybe<TimeSeries>;
  /** Time series signal representing model well test chp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelWellTestChp?: Maybe<TimeSeries>;
  /** Time series signal representing model well test esp frequency for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelWellTestEspFrequency?: Maybe<TimeSeries>;
  /** Time series signal representing model well test gas rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelWellTestGasRate?: Maybe<TimeSeries>;
  /** Time series signal representing model well test gl injection for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelWellTestGlInjection?: Maybe<TimeSeries>;
  /** Time series signal representing model well test gor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelWellTestGor?: Maybe<TimeSeries>;
  /** Time series signal representing model well test liquid rate for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelWellTestLiquidRate?: Maybe<TimeSeries>;
  /** Time series signal representing model well test pdg press for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelWellTestPdgPress?: Maybe<TimeSeries>;
  /** Time series signal representing model well test timestamp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelWellTestTimestamp?: Maybe<TimeSeries>;
  /** Time series signal representing model well test wc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelWellTestWc?: Maybe<TimeSeries>;
  /** Time series signal representing model well test whp for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  modelWellTestWhp?: Maybe<TimeSeries>;
  /** Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  newFileId?: Maybe<TimeSeries>;
  /** Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  originalFileId?: Maybe<TimeSeries>;
  /** Time series signal representing vlp best gor for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vlpBestGor?: Maybe<TimeSeries>;
  /** Time series signal representing vlp best wc for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vlpBestWc?: Maybe<TimeSeries>;
  /** Time series signal representing vlp best wgr for this production string, typically sourced from SCADA, historians, or models and used in surveillance, diagnostics, and optimization. */
  vlpBestWgr?: Maybe<TimeSeries>;
};

/** Wf Alarms view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type WfAlarms = {
  /** Attribute capturing additional information for this entity in the production optimization context. */
  additionalInformation?: Maybe<Scalars['JSONObject']['output']>;
  /** Alarm Code attribute describing this entity in more detail, often derived from master data or configuration tables. */
  alarmCode?: Maybe<AlarmDefinition>;
  /** Numeric value storing alarm counter for this entity, used in calculations, reporting, or model configuration. */
  alarmCounter: Scalars['Int']['output'];
  /** Alarm Flags attribute describing this entity in more detail, often derived from master data or configuration tables. */
  alarmFlags?: Maybe<Scalars['String']['output']>;
  /** Custom Workflow Alarm Message attribute describing this entity in more detail, often derived from master data or configuration tables. */
  customWorkflowAlarmMessage: Scalars['String']['output'];
  /** Attribute capturing end date time for this entity in the production optimization context. */
  endDateTime: Scalars['Timestamp']['output'];
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  entityExternalId: Scalars['String']['output'];
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName: Scalars['String']['output'];
  /** Entity Type attribute describing this entity in more detail, often derived from master data or configuration tables. */
  entityType: Scalars['String']['output'];
  /** Attribute capturing mark as read for this entity in the production optimization context. */
  markAsRead?: Maybe<Scalars['JSONObject']['output']>;
  /** Operation Type attribute describing this entity in more detail, often derived from master data or configuration tables. */
  operationType?: Maybe<Scalars['String']['output']>;
  /** Related Entity attribute describing this entity in more detail, often derived from master data or configuration tables. */
  relatedEntity?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  relatedEntityExternalId?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing remove alaram for user for this entity in the production optimization context. */
  removeAlaramForUser?: Maybe<Scalars['JSONObject']['output']>;
  /** Ss Workflow Alarm Message attribute describing this entity in more detail, often derived from master data or configuration tables. */
  ssWorkflowAlarmMessage?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing start date time for this entity in the production optimization context. */
  startDateTime: Scalars['Timestamp']['output'];
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  ticketId?: Maybe<Scalars['String']['output']>;
};

/**
 * Denormalized alarms with alarm-definition properties inlined; retention is
 * about 48 hours by alarm start (see delete job).
 *
 * The Workflow Alarms (Agent) view holds recent denormalized alarm data,
 * including properties such as alarmPriority,
 * alarmCriticality, and workflow details. This view facilitates analysis of
 * alarm occurrences and their characteristics, to address questions related to
 * alarm frequency, severity, and workflow impact. Sourced from real-time alarm
 * systems, ensuring that it reflects the most current operational status.
 * Excludes pre-filtered alarms for WF12/WF14 (use ESPAlarms_Agent, GasLiftAlarms_Agent).
 *
 * Use for: Real-Time Surveillance (WF18), cross-workflow alarm rollup.
 *
 * @name Workflow Alarms (Agent)
 */
export type WfAlarmsAgent = {
  /** Alarm category from AlarmDefinition (e.g., ESP, Gas Lift, Production). */
  alarmCategory?: Maybe<Scalars['String']['output']>;
  /** Reference to AlarmDefinition node. */
  alarmCode?: Maybe<Scalars['JSONObject']['output']>;
  /** External ID of the alarm code (e.g., WF12-001) for easy filtering. */
  alarmCodeExternalId?: Maybe<Scalars['String']['output']>;
  /** Count of how many times this alarm has occurred. */
  alarmCounter?: Maybe<Scalars['Int']['output']>;
  /** Alarm criticality level from AlarmDefinition. */
  alarmCriticality?: Maybe<Scalars['String']['output']>;
  /** Alarm validity flag (Valid, Invalid, etc.). */
  alarmFlags?: Maybe<Scalars['String']['output']>;
  /** Standard alarm message template from AlarmDefinition. */
  alarmMessage?: Maybe<Scalars['String']['output']>;
  /** Human-readable alarm name from AlarmDefinition. */
  alarmName?: Maybe<Scalars['String']['output']>;
  /** Alarm priority level from AlarmDefinition (e.g., HIGH, MEDIUM, LOW). */
  alarmPriority?: Maybe<Scalars['String']['output']>;
  /** Detailed alarm message with specific conditions that triggered it. */
  customWorkflowAlarmMessage?: Maybe<Scalars['String']['output']>;
  /** When the alarm was cleared. Null means alarm is still active. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** External ID of the entity for joining to other views. */
  entityExternalId: Scalars['String']['output'];
  /** Display name of the entity (well, string) with the alarm. */
  entityName: Scalars['String']['output'];
  /** Type of entity (string, well, field). */
  entityType: Scalars['String']['output'];
  /** When the alarm was triggered. */
  startDateTime: Scalars['Timestamp']['output'];
  /** Sub-category from AlarmDefinition. */
  subCategory?: Maybe<Scalars['String']['output']>;
  /** Sub-workflow name from AlarmDefinition. */
  subWorkflowName?: Maybe<Scalars['String']['output']>;
  /** Associated troubleshooting ticket ID if one was created. */
  ticketId?: Maybe<Scalars['String']['output']>;
  /**
   * Direct relation to String_asset (when entityType = 'string').
   * Navigate to string properties like lift type, status, field hierarchy.
   */
  wellString?: Maybe<StringAsset>;
  /** Workflow code from AlarmDefinition (e.g., WF12). */
  workflowCode?: Maybe<Scalars['String']['output']>;
  /** Workflow name from AlarmDefinition. */
  workflowName?: Maybe<Scalars['String']['output']>;
};

/** Wf Field Alarms view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type WfFieldAlarms = {
  /** Numeric value storing alarm counter for this field, used in calculations, reporting, or model configuration. */
  alarmCounter?: Maybe<Scalars['Int']['output']>;
  /** Alarm Flags attribute describing this field in more detail, often derived from master data or configuration tables. */
  alarmFlags?: Maybe<Scalars['String']['output']>;
  /** Alarm Level attribute describing this field in more detail, often derived from master data or configuration tables. */
  alarmLevel?: Maybe<Scalars['String']['output']>;
  /** Alarm Message attribute describing this field in more detail, often derived from master data or configuration tables. */
  alarmMessage?: Maybe<Scalars['String']['output']>;
  /** Name or label for this field, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  alarmName?: Maybe<Scalars['String']['output']>;
  /** Alarm Type attribute describing this field in more detail, often derived from master data or configuration tables. */
  alarmType?: Maybe<Scalars['String']['output']>;
  /** Configuration attribute describing this field in more detail, often derived from master data or configuration tables. */
  configuration?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing end date time for this field in the production optimization context. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Field>;
  /** Operation Type attribute describing this field in more detail, often derived from master data or configuration tables. */
  operationType?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing start date time for this field in the production optimization context. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Unique identifier for this field, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  ticketId?: Maybe<Scalars['String']['output']>;
  /** Name or label for this field, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  workflowName?: Maybe<Scalars['String']['output']>;
};

/** Wf Reservoir Alarms view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type WfReservoirAlarms = {
  /** Numeric value storing alarm counter for this reservoir, used in calculations, reporting, or model configuration. */
  alarmCounter?: Maybe<Scalars['Int']['output']>;
  /** Alarm Flags attribute describing this reservoir in more detail, often derived from master data or configuration tables. */
  alarmFlags?: Maybe<Scalars['String']['output']>;
  /** Alarm Level attribute describing this reservoir in more detail, often derived from master data or configuration tables. */
  alarmLevel?: Maybe<Scalars['String']['output']>;
  /** Alarm Message attribute describing this reservoir in more detail, often derived from master data or configuration tables. */
  alarmMessage?: Maybe<Scalars['String']['output']>;
  /** Name or label for this reservoir, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  alarmName?: Maybe<Scalars['String']['output']>;
  /** Alarm Type attribute describing this reservoir in more detail, often derived from master data or configuration tables. */
  alarmType?: Maybe<Scalars['String']['output']>;
  /** Configuration attribute describing this reservoir in more detail, often derived from master data or configuration tables. */
  configuration?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing end date time for this reservoir in the production optimization context. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Reservoir>;
  /** Operation Type attribute describing this reservoir in more detail, often derived from master data or configuration tables. */
  operationType?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing start date time for this reservoir in the production optimization context. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Unique identifier for this reservoir, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  ticketId?: Maybe<Scalars['String']['output']>;
  /** Name or label for this reservoir, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  workflowName?: Maybe<Scalars['String']['output']>;
};

/** Wf Sector Alarms view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type WfSectorAlarms = {
  /** Numeric value storing alarm counter for this entity, used in calculations, reporting, or model configuration. */
  alarmCounter?: Maybe<Scalars['Int']['output']>;
  /** Alarm Flags attribute describing this entity in more detail, often derived from master data or configuration tables. */
  alarmFlags?: Maybe<Scalars['String']['output']>;
  /** Alarm Level attribute describing this entity in more detail, often derived from master data or configuration tables. */
  alarmLevel?: Maybe<Scalars['String']['output']>;
  /** Alarm Message attribute describing this entity in more detail, often derived from master data or configuration tables. */
  alarmMessage?: Maybe<Scalars['String']['output']>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  alarmName?: Maybe<Scalars['String']['output']>;
  /** Alarm Type attribute describing this entity in more detail, often derived from master data or configuration tables. */
  alarmType?: Maybe<Scalars['String']['output']>;
  /** Configuration attribute describing this entity in more detail, often derived from master data or configuration tables. */
  configuration?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing end date time for this entity in the production optimization context. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Sector>;
  /** Operation Type attribute describing this entity in more detail, often derived from master data or configuration tables. */
  operationType?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing start date time for this entity in the production optimization context. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Unique identifier for this entity, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  ticketId?: Maybe<Scalars['String']['output']>;
  /** Name or label for this entity, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  workflowName?: Maybe<Scalars['String']['output']>;
};

/** Wf String Alarms view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type WfStringAlarms = {
  /** Numeric value storing alarm counter for this production string, used in calculations, reporting, or model configuration. */
  alarmCounter?: Maybe<Scalars['Int']['output']>;
  /** Alarm Flags attribute describing this production string in more detail, often derived from master data or configuration tables. */
  alarmFlags?: Maybe<Scalars['String']['output']>;
  /** Alarm Level attribute describing this production string in more detail, often derived from master data or configuration tables. */
  alarmLevel?: Maybe<Scalars['String']['output']>;
  /** Alarm Message attribute describing this production string in more detail, often derived from master data or configuration tables. */
  alarmMessage?: Maybe<Scalars['String']['output']>;
  /** Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  alarmName?: Maybe<Scalars['String']['output']>;
  /** Alarm Type attribute describing this production string in more detail, often derived from master data or configuration tables. */
  alarmType?: Maybe<Scalars['String']['output']>;
  /** Configuration attribute describing this production string in more detail, often derived from master data or configuration tables. */
  configuration?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing end date time for this production string in the production optimization context. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<StringAsset>;
  /** Operation Type attribute describing this production string in more detail, often derived from master data or configuration tables. */
  operationType?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing start date time for this production string in the production optimization context. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Unique identifier for this production string, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  ticketId?: Maybe<Scalars['String']['output']>;
  /** Name or label for this production string, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  workflowName?: Maybe<Scalars['String']['output']>;
};

/** Wf Well Alarms view representing key attributes, configuration, and time-series references for this concept in the iPSO production optimization data model, used in surveillance, diagnostics, planning, and optimization workflows. */
export type WfWellAlarms = {
  /** Numeric value storing alarm counter for this well, used in calculations, reporting, or model configuration. */
  alarmCounter?: Maybe<Scalars['Int']['output']>;
  /** Alarm Flags attribute describing this well in more detail, often derived from master data or configuration tables. */
  alarmFlags?: Maybe<Scalars['String']['output']>;
  /** Alarm Level attribute describing this well in more detail, often derived from master data or configuration tables. */
  alarmLevel?: Maybe<Scalars['String']['output']>;
  /** Alarm Message attribute describing this well in more detail, often derived from master data or configuration tables. */
  alarmMessage?: Maybe<Scalars['String']['output']>;
  /** Name or label for this well, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  alarmName?: Maybe<Scalars['String']['output']>;
  /** Alarm Type attribute describing this well in more detail, often derived from master data or configuration tables. */
  alarmType?: Maybe<Scalars['String']['output']>;
  /** Configuration attribute describing this well in more detail, often derived from master data or configuration tables. */
  configuration?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing end date time for this well in the production optimization context. */
  endDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Display name of the entity (well, field, string, or facility) as it appears in iPSO and source systems, used as the primary label in dashboards and reports. */
  entityName?: Maybe<Well>;
  /** Operation Type attribute describing this well in more detail, often derived from master data or configuration tables. */
  operationType?: Maybe<Scalars['String']['output']>;
  /** Attribute capturing start date time for this well in the production optimization context. */
  startDateTime?: Maybe<Scalars['Timestamp']['output']>;
  /** Unique identifier for this well, used to consistently link data for the same physical object across allocation, network modeling, and external source systems. */
  ticketId?: Maybe<Scalars['String']['output']>;
  /** Name or label for this well, chosen to be meaningful for operators and engineers when browsing or searching in the solution. */
  workflowName?: Maybe<Scalars['String']['output']>;
};
